webpackJsonp([1],[
/* 0 */,
/* 1 */
/*!****************************!*\
  !*** ./src/store/types.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var types = {
  getters: {},
  actions: {},
  mutations: {},
  fields: {}
};

/**
 * Loader
 */
types.getters.isLoading = "isLoading";
types.getters.loadingText = "loadingText";
types.actions.setIsLoading = "setIsLoading";
types.mutations.setIsLoading = "setIsLoading";
types.mutations.setLoadingText = "setLoadingText";

/**
 * Dialog save and exit
 */
types.getters.isVisibleDialogSaveAndExit = "isVisibleDialogSaveAndExit";
types.actions.setIsVisibleDialogSaveAndExit = "setIsVisibleDialogSaveAndExit";
types.mutations.setIsVisibleDialogSaveAndExit = "setIsVisibleDialogSaveAndExit";

/**
 * Contacts
 */
types.getters.contacts = "contacts";
types.getters.contact = "contact";
types.getters.primaryContact = "primaryContact";
types.actions.updateContactField = "updateContactField";
types.actions.updateContactsRemote = "updateContactsRemote";
types.mutations.setContacts = "setContacts";
types.mutations.updateContactField = "updateContactField";
types.mutations.resetContactsDirtyFlag = "resetContactsDirtyFlag";

/**
 * Contact Bookings
 */
types.getters.contactBookings = "contactBookings";
types.getters.contactBooking = "contactBooking";
types.actions.updateContactBookingField = "updateContactBookingField";
types.mutations.setContactBookings = "setContactBookings";
types.mutations.updateContactBookingField = "updateContactBookingField";
types.mutations.resetContactBookingsDirtyFlag = "resetContactBookingsDirtyFlag";

/**
 * Bookings
 */
types.getters.booking = "booking";
types.getters.cruiseTicketURL = "cruiseTicketURL";
types.actions.searchBooking = "searchBooking";
types.actions.updateBookingField = "updateBookingField";
types.actions.updateBookingRemote = "updateBookingRemote";
types.actions.confirmBookingRemote = "confirmBookingRemote";
types.actions.sendCruiseTicketEmailRemote = "sendCruiseTicketEmailRemote";
types.mutations.setBooking = "setBooking";
types.mutations.updateBookingField = "updateBookingField";
types.mutations.resetBookingDirtyFlag = "resetBookingDirtyFlag";
types.mutations.setCruiseTicketURL = "setCruiseTicketURL";

/**
 * Cabin configurations
 */
types.getters.cabinConfigurations = "cabinConfigurations";
types.actions.updateCabinConfigurationField = "updateCabinConfigurationField";
types.actions.updateCabinConfigurationRemote = "updateCabinConfigurationRemote";
types.mutations.setCabinConfigurations = "setCabinConfigurations";
types.mutations.updateCabinConfigurationField = "updateCabinConfigurationField";
types.mutations.resetCabinConfigurationsDirtyFlag = "resetCabinConfigurationsDirtyFlag";

/**
 * Visa requirements
 */
types.getters.visaRequirements = "visaRequirements";
types.getters.visaRequirement = "visaRequirement";
types.getters.visaRequirementByContactID = "visaRequirementByContactID";
types.actions.updateVisaRequirementField = "updateVisaRequirementField";
types.actions.updateVisaRequirementsRemote = "updateVisaRequirementsRemote";
types.mutations.setVisaRequirements = "setVisaRequirements";
types.mutations.updateVisaRequirementField = "updateVisaRequirementField";
types.mutations.updateVisaRequirementEntity = "updateVisaRequirementEntity";
types.mutations.resetVisaRequirementsDirtyFlag = "resetVisaRequirementsDirtyFlag";

/**
 * Pre-arrangements
 */
types.getters.preArrangements = "preArrangements";
types.getters.preArrangement = "preArrangement";
types.getters.preArrangementByContactID = "preArrangementByContactID";
types.getters.preArrangementByContactIDAndCategory = "preArrangementByContactIDAndCategory";
types.actions.updatePreArrangementField = "updatePreArrangementField";
types.mutations.setPreArrangements = "setPreArrangements";
types.mutations.updatePreArrangementField = "updatePreArrangementField";
types.mutations.copyPreArrangement = "copyPreArrangement";

/**
 * Post-arrangements
 */
types.getters.postArrangements = "postArrangements";
types.getters.postArrangement = "postArrangement";
types.getters.postArrangementByContactID = "postArrangementByContactID";
types.getters.postArrangementByContactIDAndCategory = "postArrangementByContactIDAndCategory";
types.actions.updatePostArrangementField = "updatePostArrangementField";
types.mutations.resetPostArrangementAccommodationDetail = "resetPostArrangementAccommodationDetail";
types.mutations.resetPostArrangementFlightDetail = "resetPostArrangementFlightDetail";
types.mutations.resetPostArrangementPortToLocationDetail = "resetPostArrangementPortToLocationDetail";
types.mutations.setPostArrangements = "setPostArrangements";
types.mutations.updatePostArrangementField = "updatePostArrangementField";
types.mutations.copyPostArrangement = "copyPostArrangement";

/**
 * Passport Data
 */
types.getters.passports = "passports";
types.getters.passport = "passport";
types.getters.passportByContactID = "passportByContactID";
types.actions.updatePassportField = "updatePassportField";
types.actions.updatePassportsRemote = "updatePassportsRemote";
types.mutations.setPassports = "setPassports";
types.mutations.updatePassportField = "updatePassportField";
types.mutations.updatePassportEntity = "updatePassportEntity";
types.mutations.resetPassportsDirtyFlag = "resetPassportsDirtyFlag";

/**
 * Common
 */
types.getters.accessToken = "accessToken";
types.getters.expiryTime = "expiryTime";
types.getters.lastSaveTime = "lastSaveTime";
types.getters.isSaving = "isSaving";
types.getters.dietaryAllergies = "dietaryAllergies";
types.actions.updateContactsAndVisaRequirementsRemote = "updateContactsAndVisaRequirementsRemote";
types.actions.updateContactsAndBookingRemote = "updateContactsAndBookingRemote";
types.actions.updatePrePostArrangementsRemote = "updatePrePostArrangementsRemote";
types.actions.copyPrePostArrangement = "copyPrePostArrangement";
types.actions.setAccessToken = "setAccessToken";
types.actions.setLastSaveTime = "setLastSaveTime";
types.actions.setIsSaving = "setIsSaving";
types.actions.refreshAccessToken = "refreshAccessToken";
types.actions.logout = "logout";
types.actions.getDietaryAllergies = "getDietaryAllergies";
types.mutations.setExpiryTime = "setExpiryTime";
types.mutations.setAccessToken = "setAccessToken";
types.mutations.setLastSaveTime = "setLastSaveTime";
types.mutations.setIsSaving = "setIsSaving";
types.mutations.removeAccessToken = "removeAccessToken";
types.mutations.setDietaryAllergies = "setDietaryAllergies";

/**
 * Fields
 */
types.fields.pastTravelPeriod = {
  Amazon: "pastTravelPeriodForAmazon",
  Mekong: "pastTravelPeriodForMekong",
  Indonesia: "pastTravelPeriodForIndonesia"
};

/* harmony default export */ __webpack_exports__["a"] = (types);

/***/ }),
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/*!**************************!*\
  !*** ./src/constants.js ***!
  \**************************/
/*! exports provided: NAV_STEPS, BED_CONFIGURATIONS_FOR_BALCONY, BED_CONFIGURATIONS_FOR_NON_BALCONY, BED_CONFIGURATIONS_FOR_AQUA_LARES, COUNTRIES, STATES, GENDERS, TITLES, DESTINATIONS, LAST_DESTINATIONS, FACILITY_CODES, PORTS, GALAPAGOS_FLIGHT_DESTINATION, EMERGENCY_CONTACT_RELATIONS, DIETARY_PREFERENCES, DIETARY_ALLERGIES, DIVING_WETSUIT, DIVING_FINS, DIVING_MASK, DIVING_EXPERIENCE_LEVEL, DIVING_ASSOCIATIONS, TYPE_OF_ARRANGEMENTS, TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI, TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY, TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER, TYPE_OF_ARRANGEMENTS_PRIVATE_AND_SHARED_TRANSFER, TYPE_OF_ARRANGEMENTS_WITHOUT_PRIVATE_TRANSFER, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY, TYPE_OF_ARRANGEMENTS_THIRD_PARTY_ONLY, TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI, TYPE_OF_ARRANGEMENTS_THIRD_PARTY_TAXI_AND_OTHER, POST_ARRANGEMENT_ACTIONS, POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER, TYPE_OF_ROUTE_TO_GALAPAGOS, TYPE_OF_ROUTE_FROM_GALAPAGOS, ARRIVAL_CITY_CAMBODIA, ARRIVAL_CITY_AMAZON, DATE_DAYS, DATE_MONTHS, DATE_YEARS, DATE_EXPIRY_YEARS, DATE_SHIP_START_YEARS, ADULT_WETSUIT_SIZE_DATA, CHILD_WETSUIT_SIZE_DATA, FIN_SIZE_DATA, VISA_TYPE_REQUIRING_ATTACHMENTS, UNHANDLED_ERROR_MESSAGE, ACCEPTED_UPLOAD_MIMETYPES, ACCEPTED_UPLOAD_MIMETYPES_PASSPORT */
/*! exports used: ACCEPTED_UPLOAD_MIMETYPES_PASSPORT, ADULT_WETSUIT_SIZE_DATA, BED_CONFIGURATIONS_FOR_AQUA_LARES, BED_CONFIGURATIONS_FOR_BALCONY, BED_CONFIGURATIONS_FOR_NON_BALCONY, CHILD_WETSUIT_SIZE_DATA, COUNTRIES, DATE_DAYS, DATE_EXPIRY_YEARS, DATE_MONTHS, DATE_SHIP_START_YEARS, DATE_YEARS, DESTINATIONS, DIETARY_ALLERGIES, DIVING_ASSOCIATIONS, DIVING_EXPERIENCE_LEVEL, DIVING_FINS, DIVING_MASK, DIVING_WETSUIT, EMERGENCY_CONTACT_RELATIONS, FACILITY_CODES, FIN_SIZE_DATA, GALAPAGOS_FLIGHT_DESTINATION, GENDERS, LAST_DESTINATIONS, NAV_STEPS, PORTS, POST_ARRANGEMENT_ACTIONS, POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER, STATES, TITLES, TYPE_OF_ARRANGEMENTS, TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY, TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI, TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI, TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER, TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI, TYPE_OF_ROUTE_FROM_GALAPAGOS, TYPE_OF_ROUTE_TO_GALAPAGOS, UNHANDLED_ERROR_MESSAGE, VISA_TYPE_REQUIRING_ATTACHMENTS */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return NAV_STEPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BED_CONFIGURATIONS_FOR_BALCONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BED_CONFIGURATIONS_FOR_NON_BALCONY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BED_CONFIGURATIONS_FOR_AQUA_LARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COUNTRIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return STATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GENDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return TITLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return LAST_DESTINATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return FACILITY_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return PORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GALAPAGOS_FLIGHT_DESTINATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return EMERGENCY_CONTACT_RELATIONS; });
/* unused harmony export DIETARY_PREFERENCES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return DIETARY_ALLERGIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return DIVING_WETSUIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return DIVING_FINS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return DIVING_MASK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return DIVING_EXPERIENCE_LEVEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return DIVING_ASSOCIATIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return TYPE_OF_ARRANGEMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER; });
/* unused harmony export TYPE_OF_ARRANGEMENTS_PRIVATE_AND_SHARED_TRANSFER */
/* unused harmony export TYPE_OF_ARRANGEMENTS_WITHOUT_PRIVATE_TRANSFER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY; });
/* unused harmony export TYPE_OF_ARRANGEMENTS_THIRD_PARTY_ONLY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI; });
/* unused harmony export TYPE_OF_ARRANGEMENTS_THIRD_PARTY_TAXI_AND_OTHER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return POST_ARRANGEMENT_ACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return TYPE_OF_ROUTE_TO_GALAPAGOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return TYPE_OF_ROUTE_FROM_GALAPAGOS; });
/* unused harmony export ARRIVAL_CITY_CAMBODIA */
/* unused harmony export ARRIVAL_CITY_AMAZON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DATE_DAYS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return DATE_MONTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return DATE_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return DATE_EXPIRY_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return DATE_SHIP_START_YEARS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ADULT_WETSUIT_SIZE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return CHILD_WETSUIT_SIZE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return FIN_SIZE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return VISA_TYPE_REQUIRING_ATTACHMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return UNHANDLED_ERROR_MESSAGE; });
/* unused harmony export ACCEPTED_UPLOAD_MIMETYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCEPTED_UPLOAD_MIMETYPES_PASSPORT; });
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var NAV_STEPS = {
  BookingSummary: "BookingSummary",
  PersonalDetails: "PersonalDetails",
  DietaryPreferences: "DietaryPreferences",
  WetsuitDiving: "WetsuitDiving",
  PrePostCruise: "PrePostCruise",
  Confirmation: "Confirmation",
  Success: "Success",
  Incomplete: "Incomplete"
};

// 20251010: Update bedding configuration for "Twin Bed" to "Twin Beds" for FE display to guests. Apply to labels only.
var BED_CONFIGURATIONS_FOR_BALCONY = [{ value: "King Size Bed", label: "King Size Bed" }, { value: "Twin Bed", label: "Twin Beds" }];

var BED_CONFIGURATIONS_FOR_NON_BALCONY = [{ value: "King Size Bed", label: "King Size Bed" }, { value: "Twin Bed", label: "Twin Beds" }, {
  value: "King Size Bed + Extra Single Bed",
  label: "King Size Bed + Extra Single Bed"
}, {
  value: "Twin Bed + Extra Single Bed",
  label: "Twin Beds + Extra Single Bed"
}];

var BED_CONFIGURATIONS_FOR_AQUA_LARES = {
  104: [{ value: "Double Bed", label: "Double Bed" }, { value: "Double Murphy Bed", label: "Double Murphy Beds" }],
  105: [{ value: "Double Bed", label: "Double Bed" }, { value: "Double Murphy Bed", label: "Double Murphy Beds" }],
  301: [{ value: "Double Bed", label: "Double Bed" }, { value: "Twin Bed", label: "Twin Beds" }],
  302: [{ value: "Double Bed", label: "Double Bed" }, { value: "Twin Bed", label: "Twin Beds" }]
};

var COUNTRIES = [{
  value: "AF - Afghanistan",
  label: "Afghanistan"
}, {
  value: "AX - Aland Islands",
  label: "Aland Islands"
}, {
  value: "AL - Albania",
  label: "Albania"
}, {
  value: "DZ - Algeria",
  label: "Algeria"
}, {
  value: "AS - American Samoa",
  label: "American Samoa"
}, {
  value: "AD - Andorra",
  label: "Andorra"
}, {
  value: "AO - Angola",
  label: "Angola"
}, {
  value: "AI - Anguilla",
  label: "Anguilla"
}, {
  value: "AQ - Antarctica",
  label: "Antarctica"
}, {
  value: "AG - Antigua and Barbuda",
  label: "Antigua and Barbuda"
}, {
  value: "AR - Argentina",
  label: "Argentina"
}, {
  value: "AM - Armenia",
  label: "Armenia"
}, {
  value: "AW - Aruba",
  label: "Aruba"
}, {
  value: "AU - Australia",
  label: "Australia"
}, {
  value: "AT - Austria",
  label: "Austria"
}, {
  value: "AZ - Azerbaijan",
  label: "Azerbaijan"
}, {
  value: "BS - Bahamas",
  label: "Bahamas"
}, {
  value: "BH - Bahrain",
  label: "Bahrain"
}, {
  value: "BD - Bangladesh",
  label: "Bangladesh"
}, {
  value: "BB - Barbados",
  label: "Barbados"
}, {
  value: "BY - Belarus",
  label: "Belarus"
}, {
  value: "BE - Belgium",
  label: "Belgium"
}, {
  value: "BZ - Belize",
  label: "Belize"
}, {
  value: "BJ - Benin",
  label: "Benin"
}, {
  value: "BM - Bermuda",
  label: "Bermuda"
}, {
  value: "BT - Bhutan",
  label: "Bhutan"
}, {
  value: "BO - Bolivia",
  label: "Bolivia"
}, {
  value: "BA - Bosnia Hercegovina",
  label: "Bosnia Hercegovina"
}, {
  value: "BW - Botswana",
  label: "Botswana"
}, {
  value: "BV - Bouvet Island",
  label: "Bouvet Island"
}, {
  value: "BR - Brazil",
  label: "Brazil"
}, {
  value: "IO - British Indian Ocean Territory",
  label: "British Indian Ocean Territory"
}, {
  value: "BN - Brunei Darussalam",
  label: "Brunei Darussalam"
}, {
  value: "BG - Bulgaria",
  label: "Bulgaria"
}, {
  value: "BF - Burkina Faso",
  label: "Burkina Faso"
}, {
  value: "BI - Burundi",
  label: "Burundi"
}, {
  value: "KH - Cambodia",
  label: "Cambodia"
}, {
  value: "CM - Cameroon",
  label: "Cameroon"
}, {
  value: "CA - Canada",
  label: "Canada"
}, {
  value: "CV - Cape Verde",
  label: "Cape Verde"
}, {
  value: "KY - Cayman Islands",
  label: "Cayman Islands"
}, {
  value: "CF - Central African Republic",
  label: "Central African Republic"
}, {
  value: "TD - Chad",
  label: "Chad"
}, {
  value: "CL - Chile",
  label: "Chile"
}, {
  value: "CN - China",
  label: "China"
}, {
  value: "CX - Christmas Island",
  label: "Christmas Island"
}, {
  value: "CC - Cocos (Keeling) Islands",
  label: "Cocos (Keeling) Islands"
}, {
  value: "CO - Colombia",
  label: "Colombia"
}, {
  value: "KM - Comoros",
  label: "Comoros"
}, {
  value: "CG - Congo",
  label: "Congo"
}, {
  value: "CK - Cook Islands",
  label: "Cook Islands"
}, {
  value: "CR - Costa Rica",
  label: "Costa Rica"
}, {
  value: "CI - Cote D'Ivoire",
  label: "Cote D'Ivoire"
}, {
  value: "HR - Croatia",
  label: "Croatia"
}, {
  value: "CU - Cuba",
  label: "Cuba"
}, {
  value: "CY - Cyprus",
  label: "Cyprus"
}, {
  value: "CZ - Czech Republic",
  label: "Czech Republic"
}, {
  value: "CS - Czechoslovakia",
  label: "Czechoslovakia"
}, {
  value: "DK - Denmark",
  label: "Denmark"
}, {
  value: "DJ - Djibouti",
  label: "Djibouti"
}, {
  value: "DM - Dominica",
  label: "Dominica"
}, {
  value: "DO - Dominican Republic",
  label: "Dominican Republic"
}, {
  value: "TP - East Timor",
  label: "East Timor"
}, {
  value: "EC - Ecuador",
  label: "Ecuador"
}, {
  value: "EG - Egypt",
  label: "Egypt"
}, {
  value: "SV - El Salvador",
  label: "El Salvador"
}, {
  value: "GQ - Equatorial Guinea",
  label: "Equatorial Guinea"
}, {
  value: "ER - Eritrea",
  label: "Eritrea"
}, {
  value: "EE - Estonia",
  label: "Estonia"
}, {
  value: "ET - Ethiopia",
  label: "Ethiopia"
}, {
  value: "FK - Falkland Islands (Malvinas)",
  label: "Falkland Islands (Malvinas)"
}, {
  value: "FO - Faroe Islands",
  label: "Faroe Islands"
}, {
  value: "FJ - Fiji",
  label: "Fiji"
}, {
  value: "FI - Finland",
  label: "Finland"
}, {
  value: "FR - France",
  label: "France"
}, {
  value: "GF - French Guiana",
  label: "French Guiana"
}, {
  value: "PF - French Polynesia",
  label: "French Polynesia"
}, {
  value: "TF - French Southern Territories",
  label: "French Southern Territories"
}, {
  value: "GA - Gabon",
  label: "Gabon"
}, {
  value: "GM - Gambia",
  label: "Gambia"
}, {
  value: "GE - Georgia",
  label: "Georgia"
}, {
  value: "DE - Germany",
  label: "Germany"
}, {
  value: "GH - Ghana",
  label: "Ghana"
}, {
  value: "GI - Gibraltar",
  label: "Gibraltar"
}, {
  value: "GR - Greece",
  label: "Greece"
}, {
  value: "GL - Greenland",
  label: "Greenland"
}, {
  value: "GD - Grenada",
  label: "Grenada"
}, {
  value: "GP - Guadeloupe",
  label: "Guadeloupe"
}, {
  value: "GU - Guam",
  label: "Guam"
}, {
  value: "GT - Guatemala",
  label: "Guatemala"
}, {
  value: "GG - Guernsey",
  label: "Guernsey"
}, {
  value: "GN - Guinea",
  label: "Guinea"
}, {
  value: "GW - Guinea-Bissau",
  label: "Guinea-Bissau"
}, {
  value: "GY - Guyana",
  label: "Guyana"
}, {
  value: "HT - Haiti",
  label: "Haiti"
}, {
  value: "HM - Heard and Mc Donald Islands",
  label: "Heard and Mc Donald Islands"
}, {
  value: "HN - Honduras",
  label: "Honduras"
}, {
  value: "HK - Hong Kong",
  label: "Hong Kong"
}, {
  value: "HU - Hungary",
  label: "Hungary"
}, {
  value: "IS - Iceland",
  label: "Iceland"
}, {
  value: "IN - India",
  label: "India"
}, {
  value: "ID - Indonesia",
  label: "Indonesia"
}, {
  value: "IR - Iran (Islamic Republic of)",
  label: "Iran (Islamic Republic of)"
}, {
  value: "IQ - Iraq",
  label: "Iraq"
}, {
  value: "IE - Ireland",
  label: "Ireland"
}, {
  value: "IL - Israel",
  label: "Israel"
}, {
  value: "IT - Italy",
  label: "Italy"
}, {
  value: "JM - Jamaica",
  label: "Jamaica"
}, {
  value: "JP - Japan",
  label: "Japan"
}, {
  value: "JE - Jersey",
  label: "Jersey"
}, {
  value: "JO - Jordan",
  label: "Jordan"
}, {
  value: "KZ - Kazakhstan",
  label: "Kazakhstan"
}, {
  value: "KE - Kenya",
  label: "Kenya"
}, {
  value: "KI - Kiribati",
  label: "Kiribati"
}, {
  value: "KP - Korea, Democratic People's Republic of",
  label: "Korea, Democratic People's Republic of"
}, {
  value: "KR - Korea, Republic of",
  label: "Korea, Republic of"
}, {
  value: "XK - Kosovo",
  label: "Kosovo"
}, {
  value: "KW - Kuwait",
  label: "Kuwait"
}, {
  value: "KG - Kyrgyzstan",
  label: "Kyrgyzstan"
}, {
  value: "LA - Lao People's Democratic Republic",
  label: "Lao People's Democratic Republic"
}, {
  value: "LV - Latvia",
  label: "Latvia"
}, {
  value: "LB - Lebanon",
  label: "Lebanon"
}, {
  value: "LS - Lesotho",
  label: "Lesotho"
}, {
  value: "LR - Liberia",
  label: "Liberia"
}, {
  value: "LY - Libyan Arab Jamahiriya",
  label: "Libyan Arab Jamahiriya"
}, {
  value: "LI - Liechtenstein",
  label: "Liechtenstein"
}, {
  value: "LT - Lithuania",
  label: "Lithuania"
}, {
  value: "LU - Luxembourg",
  label: "Luxembourg"
}, {
  value: "MO - Macau",
  label: "Macau"
}, {
  value: "MK - Macedonia, Republic of",
  label: "Macedonia, Republic of"
}, {
  value: "MG - Madagascar",
  label: "Madagascar"
}, {
  value: "MW - Malawi",
  label: "Malawi"
}, {
  value: "MY - Malaysia",
  label: "Malaysia"
}, {
  value: "MV - Maldives",
  label: "Maldives"
}, {
  value: "ML - Mali",
  label: "Mali"
}, {
  value: "MT - Malta",
  label: "Malta"
}, {
  value: "MH - Marshall Islands",
  label: "Marshall Islands"
}, {
  value: "MQ - Martinique",
  label: "Martinique"
}, {
  value: "MR - Mauritania",
  label: "Mauritania"
}, {
  value: "MU - Mauritius",
  label: "Mauritius"
}, {
  value: "YT - Mayotte",
  label: "Mayotte"
}, {
  value: "MX - Mexico",
  label: "Mexico"
}, {
  value: "FM - Micronesia",
  label: "Micronesia"
}, {
  value: "MD - Moldova, Republic of",
  label: "Moldova, Republic of"
}, {
  value: "MC - Monaco",
  label: "Monaco"
}, {
  value: "MN - Mongolia",
  label: "Mongolia"
}, {
  value: "ME - Montenegro",
  label: "Montenegro"
}, {
  value: "MS - Montserrat",
  label: "Montserrat"
}, {
  value: "MA - Morocco",
  label: "Morocco"
}, {
  value: "MZ - Mozambique",
  label: "Mozambique"
}, {
  value: "MM - Myanmar",
  label: "Myanmar"
}, {
  value: "NA - Namibia",
  label: "Namibia"
}, {
  value: "NR - Nauru",
  label: "Nauru"
}, {
  value: "NP - Nepal",
  label: "Nepal"
}, {
  value: "NL - Netherlands",
  label: "Netherlands"
}, {
  value: "AN - Netherlands Antilles",
  label: "Netherlands Antilles"
}, {
  value: "NT - Neutral Zone",
  label: "Neutral Zone"
}, {
  value: "NC - New Caledonia",
  label: "New Caledonia"
}, {
  value: "NZ - New Zealand",
  label: "New Zealand"
}, {
  value: "NI - Nicaragua",
  label: "Nicaragua"
}, {
  value: "NE - Niger",
  label: "Niger"
}, {
  value: "NG - Nigeria",
  label: "Nigeria"
}, {
  value: "NU - Niue",
  label: "Niue"
}, {
  value: "NF - Norfolk Island",
  label: "Norfolk Island"
}, {
  value: "MP - Northern Mariana Islands",
  label: "Northern Mariana Islands"
}, {
  value: "NO - Norway",
  label: "Norway"
}, {
  value: "OM - Oman",
  label: "Oman"
}, {
  value: "PK - Pakistan",
  label: "Pakistan"
}, {
  value: "PW - Palau",
  label: "Palau"
}, {
  value: "PS - Palestine",
  label: "Palestine"
}, {
  value: "PA - Panama",
  label: "Panama"
}, {
  value: "PG - Papua New Guinea",
  label: "Papua New Guinea"
}, {
  value: "PY - Paraguay",
  label: "Paraguay"
}, {
  value: "PE - Peru",
  label: "Peru"
}, {
  value: "PH - Philippines",
  label: "Philippines"
}, {
  value: "PN - Pitcairn",
  label: "Pitcairn"
}, {
  value: "PL - Poland",
  label: "Poland"
}, {
  value: "PT - Portugal",
  label: "Portugal"
}, {
  value: "PR - Puerto Rico",
  label: "Puerto Rico"
}, {
  value: "QA - Qatar",
  label: "Qatar"
}, {
  value: "RE - Reunion",
  label: "Reunion"
}, {
  value: "RO - Romania",
  label: "Romania"
}, {
  value: "RU - Russian Federation",
  label: "Russian Federation"
}, {
  value: "RW - Rwanda",
  label: "Rwanda"
}, {
  value: "KN - Saint Kitts and Nevis",
  label: "Saint Kitts and Nevis"
}, {
  value: "LC - Saint Lucia",
  label: "Saint Lucia"
}, {
  value: "VC - Saint Vincent and The Grenadines",
  label: "Saint Vincent and The Grenadines"
}, {
  value: "WS - Samoa",
  label: "Samoa"
}, {
  value: "SM - San Marino",
  label: "San Marino"
}, {
  value: "ST - Sao Tome and Principe",
  label: "Sao Tome and Principe"
}, {
  value: "SA - Saudi Arabia",
  label: "Saudi Arabia"
}, {
  value: "SN - Senegal",
  label: "Senegal"
}, {
  value: "RS - Serbia",
  label: "Serbia"
}, {
  value: "SC - Seychelles",
  label: "Seychelles"
}, {
  value: "SL - Sierra Leone",
  label: "Sierra Leone"
}, {
  value: "SG - Singapore",
  label: "Singapore"
}, {
  value: "SK - Slovakia",
  label: "Slovakia"
}, {
  value: "SI - Slovenia",
  label: "Slovenia"
}, {
  value: "SB - Solomon Islands",
  label: "Solomon Islands"
}, {
  value: "SO - Somalia",
  label: "Somalia"
}, {
  value: "ZA - South Africa",
  label: "South Africa"
}, {
  value: "ES - Spain",
  label: "Spain"
}, {
  value: "LK - Sri Lanka",
  label: "Sri Lanka"
}, {
  value: "SH - St. Helena",
  label: "St. Helena"
}, {
  value: "PM - St. Pierre and Miquelon",
  label: "St. Pierre and Miquelon"
}, {
  value: "SD - Sudan",
  label: "Sudan"
}, {
  value: "SR - Suriname",
  label: "Suriname"
}, {
  value: "SJ - Svalbard and Jan Mayen Islands",
  label: "Svalbard and Jan Mayen Islands"
}, {
  value: "SZ - Swaziland",
  label: "Swaziland"
}, {
  value: "SE - Sweden",
  label: "Sweden"
}, {
  value: "CH - Switzerland",
  label: "Switzerland"
}, {
  value: "SY - Syrian Arab Republic",
  label: "Syrian Arab Republic"
}, {
  value: "TW - Taiwan, Province of China",
  label: "Taiwan, Province of China"
}, {
  value: "TJ - Tajikistan",
  label: "Tajikistan"
}, {
  value: "TZ - Tanzania, United Republic of",
  label: "Tanzania, United Republic of"
}, {
  value: "TH - Thailand",
  label: "Thailand"
}, {
  value: "TG - Togo",
  label: "Togo"
}, {
  value: "TK - Tokelau",
  label: "Tokelau"
}, {
  value: "TO - Tonga",
  label: "Tonga"
}, {
  value: "TT - Trinidad and Tobago",
  label: "Trinidad and Tobago"
}, {
  value: "TN - Tunisia",
  label: "Tunisia"
}, {
  value: "TR - Turkey",
  label: "Turkey"
}, {
  value: "TM - Turkmenistan",
  label: "Turkmenistan"
}, {
  value: "TC - Turks and Caicos Islands",
  label: "Turks and Caicos Islands"
}, {
  value: "TV - Tuvalu",
  label: "Tuvalu"
}, {
  value: "UG - Uganda",
  label: "Uganda"
}, {
  value: "UA - Ukraine",
  label: "Ukraine"
}, {
  value: "AE - United Arab Emirates",
  label: "United Arab Emirates"
}, {
  value: "GB - United Kingdom",
  label: "United Kingdom"
}, {
  value: "US - United States",
  label: "United States"
}, {
  value: "UM - United States Minor Outlying Islands",
  label: "United States Minor Outlying Islands"
}, {
  value: "UY - Uruguay",
  label: "Uruguay"
}, {
  value: "SU - Ussr",
  label: "Ussr"
}, {
  value: "UZ - Uzbekistan",
  label: "Uzbekistan"
}, {
  value: "VU - Vanuatu",
  label: "Vanuatu"
}, {
  value: "VA - Vatican City State (Holy See)",
  label: "Vatican City State (Holy See)"
}, {
  value: "VE - Venezuela",
  label: "Venezuela"
}, {
  value: "VN - Viet Nam",
  label: "Viet Nam"
}, {
  value: "VG - Virgin Islands (British)",
  label: "Virgin Islands (British)"
}, {
  value: "VI - Virgin Islands (U.S.)",
  label: "Virgin Islands (U.S.)"
}, {
  value: "WF - Wallis And Futuna Islands",
  label: "Wallis And Futuna Islands"
}, {
  value: "EH - Western Sahara",
  label: "Western Sahara"
}, {
  value: "YE - Yemen, Republic of",
  label: "Yemen, Republic of"
}, {
  value: "YU - Yugoslavia",
  label: "Yugoslavia"
}, {
  value: "ZR - Zaire",
  label: "Zaire"
}, {
  value: "ZM - Zambia",
  label: "Zambia"
}, {
  value: "ZW - Zimbabwe",
  label: "Zimbabwe"
}];

var STATES = [{
  value: "US-AL - Alabama",
  label: "Alabama"
}, {
  value: "CA-AB - Alberta",
  label: "Alberta"
}, {
  value: "PE-AMA - Amazonas",
  label: "Amazonas"
}, {
  value: "PE-ANC - Ancash",
  label: "Ancash"
}, {
  value: "PE-APU - Apurimac",
  label: "Apurimac"
}, {
  value: "PE-ARE - Arequipa",
  label: "Arequipa"
}, {
  value: "US-AZ - Arizona",
  label: "Arizona"
}, {
  value: "US-AR - Arkansas",
  label: "Arkansas"
}, {
  value: "NZ-AUK - Auckland",
  label: "Auckland"
}, {
  value: "AU-ACT - Australian Capital Territory",
  label: "Australian Capital Territory"
}, {
  value: "PE-AYA - Ayacucho",
  label: "Ayacucho"
}, {
  value: "BR-BS - Brasilia",
  label: "Brasilia"
}, {
  value: "CA-BC - British Columbia",
  label: "British Columbia"
}, {
  value: "PE-CAJ - Cajamarca",
  label: "Cajamarca"
}, {
  value: "US-CA - California",
  label: "California"
}, {
  value: "NZ-CHC - Christchurch",
  label: "Christchurch"
}, {
  value: "US-CO - Colorado",
  label: "Colorado"
}, {
  value: "US-CT - Connecticut",
  label: "Connecticut"
}, {
  value: "PE-CUS - Cusco",
  label: "Cusco"
}, {
  value: "US-DE - Delaware",
  label: "Delaware"
}, {
  value: "CO-DC - Distrito Capital de Bogotá",
  label: "Distrito Capital de Bogotá"
}, {
  value: "MX-DIS - Distrito Federal",
  label: "Distrito Federal"
}, {
  value: "MX-NL - Distrito Federal",
  label: "Distrito Federal"
}, {
  value: "PE-CAL - El Callao",
  label: "El Callao"
}, {
  value: "US-FL - Florida",
  label: "Florida"
}, {
  value: "US-GA - Georgia",
  label: "Georgia"
}, {
  value: "US-HI - Hawaii",
  label: "Hawaii"
}, {
  value: "PE-HUV - Huancavelica",
  label: "Huancavelica"
}, {
  value: "PE-HUC - Huánuco",
  label: "Huánuco"
}, {
  value: "PE-ICA - Ica",
  label: "Ica"
}, {
  value: "US-ID - Idaho",
  label: "Idaho"
}, {
  value: "US-IL - Illinois",
  label: "Illinois"
}, {
  value: "US-IN - Indiana",
  label: "Indiana"
}, {
  value: "US-IA - Iowa",
  label: "Iowa"
}, {
  value: "PE-JUN - Junín",
  label: "Junín"
}, {
  value: "US-KS - Kansas",
  label: "Kansas"
}, {
  value: "US-KY - Kentucky",
  label: "Kentucky"
}, {
  value: "PE-LAL - La Libertad",
  label: "La Libertad"
}, {
  value: "PE-LAM - Lambayeque",
  label: "Lambayeque"
}, {
  value: "PE-LIM - Lima",
  label: "Lima"
}, {
  value: "PE-LOR - Loreto",
  label: "Loreto"
}, {
  value: "US-LA - Louisiana",
  label: "Louisiana"
}, {
  value: "PE-MDD - Madre de Dios",
  label: "Madre de Dios"
}, {
  value: "US-ME - Maine",
  label: "Maine"
}, {
  value: "CA-MB - Manitoba",
  label: "Manitoba"
}, {
  value: "US-MD - Maryland",
  label: "Maryland"
}, {
  value: "US-MA - Massachusetts",
  label: "Massachusetts"
}, {
  value: "MAY - Maynas",
  label: "Maynas"
}, {
  value: "US-MI - Michigan",
  label: "Michigan"
}, {
  value: "US-MN - Minnesota",
  label: "Minnesota"
}, {
  value: "US-MS - Mississippi",
  label: "Mississippi"
}, {
  value: "US-MO - Missouri",
  label: "Missouri"
}, {
  value: "US-MT - Montana",
  label: "Montana"
}, {
  value: "PE-MOQ - Moquegua",
  label: "Moquegua"
}, {
  value: "MX-MOR - Morelos",
  label: "Morelos"
}, {
  value: "PE-LMA - Municipalidad Metropolitana de Lima",
  label: "Municipalidad Metropolitana de Lima"
}, {
  value: "US-NE - Nebraska",
  label: "Nebraska"
}, {
  value: "US-NV - Nevada",
  label: "Nevada"
}, {
  value: "CA-NB - New Brunswick",
  label: "New Brunswick"
}, {
  value: "US-NH - New Hampshire",
  label: "New Hampshire"
}, {
  value: "US-NJ - New Jersey",
  label: "New Jersey"
}, {
  value: "US-NM - New Mexico",
  label: "New Mexico"
}, {
  value: "AU-NSW - New South Wales",
  label: "New South Wales"
}, {
  value: "US-NY - New York",
  label: "New York"
}, {
  value: "CA-NL - Newfoundland and Labrador",
  label: "Newfoundland and Labrador"
}, {
  value: "US-NC - North Carolina",
  label: "North Carolina"
}, {
  value: "AU-NT - Northern Territory",
  label: "Northern Territory"
}, {
  value: "CA-NT - Northwest Territories",
  label: "Northwest Territories"
}, {
  value: "CA-NS - Nova Scotia",
  label: "Nova Scotia"
}, {
  value: "CA-NU - Nunavut",
  label: "Nunavut"
}, {
  value: "US-OH - Ohio",
  label: "Ohio"
}, {
  value: "CA-ON - Ontario",
  label: "Ontario"
}, {
  value: "US-OR - Oregon",
  label: "Oregon"
}, {
  value: "PE-PAS - Pasco",
  label: "Pasco"
}, {
  value: "US-PA - Pennsylvania",
  label: "Pennsylvania"
}, {
  value: "PE-PIU - Piura",
  label: "Piura"
}, {
  value: "CA-PE - Prince Edward Island",
  label: "Prince Edward Island"
}, {
  value: "PE-PUN - Puno",
  label: "Puno"
}, {
  value: "CA-QC - Quebec",
  label: "Quebec"
}, {
  value: "AU-QLD - Queensland",
  label: "Queensland"
}, {
  value: "US-RI - Rhode Island",
  label: "Rhode Island"
}, {
  value: "BR-RJ - Rio de Janeiro",
  label: "Rio de Janeiro"
}, {
  value: "PE-SAM - San Martin",
  label: "San Martin"
}, {
  value: "CA-SK - Saskatchewan",
  label: "Saskatchewan"
}, {
  value: "AU-SA - South Australia",
  label: "South Australia"
}, {
  value: "US-SC - South Carolina",
  label: "South Carolina"
}, {
  value: "US-SD - South Dakota",
  label: "South Dakota"
}, {
  value: "BR-SP - São Paulo",
  label: "São Paulo"
}, {
  value: "PE-TAC - Tacna",
  label: "Tacna"
}, {
  value: "AU-TAS - Tasmania",
  label: "Tasmania"
}, {
  value: "US-TN - Tennessee",
  label: "Tennessee"
}, {
  value: "US-TX - Texas",
  label: "Texas"
}, {
  value: "JP-13 - Tokyo",
  label: "Tokyo"
}, {
  value: "PE-TUM - Tumbes",
  label: "Tumbes"
}, {
  value: "PE-UCA - Ucayali",
  label: "Ucayali"
}, {
  value: "US-UT - Utah",
  label: "Utah"
}, {
  value: "US-VT - Vermont",
  label: "Vermont"
}, {
  value: "AU-VIC - Victoria",
  label: "Victoria"
}, {
  value: "US-VA - Virginia",
  label: "Virginia"
}, {
  value: "US-WA - Washington",
  label: "Washington"
}, {
  value: "NZ-WLG - Wellington",
  label: "Wellington"
}, {
  value: "US-WV - West Virginia",
  label: "West Virginia"
}, {
  value: "AU-WA - Western Australia",
  label: "Western Australia"
}, {
  value: "US-WI - Wisconsin",
  label: "Wisconsin"
}, {
  value: "US-WY - Wyoming",
  label: "Wyoming"
}, {
  value: "CA-YT - Yukon Territory",
  label: "Yukon Territory"
}];

var GENDERS = [{
  value: "M - Male",
  label: "Male"
}, {
  value: "F - Female",
  label: "Female"
}];

var TITLES = [{
  value: "MR - Mr",
  label: "Mr"
}, {
  value: "MRS - Mrs",
  label: "Mrs"
}, {
  value: "MS - Ms",
  label: "Ms"
}, {
  value: "NA - Prefer not to say",
  label: "Prefer not to say"
}];

var DESTINATIONS = {
  Amazon: "Amazon",
  Mekong: "Mekong",
  Indonesia: "Indonesia",
  Ecuador: "Ecuador",
  EastAfrica: "East Africa",
  Arctic: "Arctic"
};

var LAST_DESTINATIONS = [{ value: DESTINATIONS.Mekong, label: DESTINATIONS.Mekong }, { value: DESTINATIONS.Amazon, label: DESTINATIONS.Amazon }, { value: DESTINATIONS.Indonesia, label: DESTINATIONS.Indonesia }, { value: DESTINATIONS.Ecuador, label: DESTINATIONS.Ecuador }, { value: DESTINATIONS.EastAfrica, label: DESTINATIONS.EastAfrica }, { value: DESTINATIONS.Arctic, label: DESTINATIONS.Arctic }];

var FACILITY_CODES = {
  AriaAmazon: "AAR",
  AquaMekong: "MAQ",
  AquaNera: "AQN",
  AquaBlu: "AQB",
  AquaMare: "AQM",
  AquaLares: "AQL"
};

var PORTS = {
  HoChiMinh: "Ho Chi Minh",
  PhnomPenh: "Phnom Penh",
  SiemReap: "Siem Reap",
  Iquitos: "Iquitos",
  Bali: "Bali",
  Komodo: "Komodo National Park",
  RajaAmpat: "Raja Ampat",
  SpiceIslands: "Spice Islands",
  Flores: "Flores",
  Seychelles: "Seychelles",
  Tanzania: "Tanzania",
  Madagascar: "Madagascar",
  Longyearbyen: "Longyearbyen",
  Tromso: "Tromso",
  Glasgow: "Glasgow"
};

var GALAPAGOS_FLIGHT_DESTINATION = {
  UIO: "Quito",
  GYE: "Guayaquil",
  GPS: "Baltra Island"
};

var EMERGENCY_CONTACT_RELATIONS = [{ value: "Son", label: "Son" }, { value: "Daughter", label: "Daughter" }, { value: "Father", label: "Father" }, { value: "Mother", label: "Mother" }, { value: "Spouse", label: "Spouse" }, { value: "Agent", label: "Agent" }, { value: "Other", label: "Other" }];

//region DIETARY
var DIETARY_PREFERENCES = [{ value: "Gluten Free", label: "Gluten Free" }, { value: "Halal", label: "Halal" }, { value: "Kosher", label: "Kosher" }, { value: "Pescatarian", label: "Pescatarian" }, { value: "Vegan", label: "Vegan" }, { value: "Vegetarian", label: "Vegetarian" }, { value: "No pork", label: "No pork" }, { value: "Other", label: "Others" }, { value: "None", label: "None" }];

// export const DIETARY_ALLERGIES = [
//   { value: "Dairy/Lactose", label: "Dairy/Lactose" },
//   { value: "Gluten", label: "Gluten" },
//   { value: "Mushrooms", label: "Mushrooms" },
//   { value: "Nuts", label: "Nuts" },
//   { value: "Seafood", label: "Seafood" },
//   { value: "Soy", label: "Soy" },
//   { value: "Wheat", label: "Wheat" },
//   { value: "Other", label: "Others" },
//   { value: "None", label: "None" },
//   // { value: "Check on board", label: "Check on board" },
// ];

// NEW Values as of 24 Jun 24
var DIETARY_ALLERGIES = [{ value: "Eggs", label: "Eggs" }, { value: "Fish", label: "Fish" }, { value: "Garlic", label: "Garlic" }, { value: "Gluten - Intolerant", label: "Gluten - Intolerant" }, { value: "Gluten - Coeliac", label: "Gluten - Coeliac" }, { value: "Lactose - Dairy", label: "Lactose - Dairy" }, { value: "Nightshade", label: "Nightshade family" }, { value: "Onions", label: "Onions" }, { value: "Peanuts", label: "Peanuts" }, { value: "Sesame", label: "Sesame" }, { value: "Shellfish", label: "Shellfish" }, { value: "Soy", label: "Soy" }, { value: "Sulphites", label: "Sulphites" }, { value: "Tree nuts", label: "Tree nuts" }, {
  value: "Others (Please specify in 'Dietary preference notes')",
  label: "Others (Please specify in 'Dietary preference notes')"
}, { value: "None", label: "None" }];

//endregion

//region DIVING
var DIVING_WETSUIT = [{
  value: "I will bring my own wetsuit",
  label: "I will bring my own wetsuit"
}, { value: "Child - M", label: "Child - M" }, { value: "Child - L", label: "Child - L" }, { value: "Child - XL", label: "Child - XL" }, { value: "XS", label: "XS" }, { value: "S", label: "S" }, { value: "M", label: "M" }, { value: "L", label: "L" }, { value: "XL", label: "XL" }, { value: "XXL", label: "XXL" }, { value: "Other", label: "Other" }];

var DIVING_FINS = [{ value: "I will bring my own fins", label: "I will bring my own fins" }, { value: "XXXS", label: "XXXS" }, { value: "XXS", label: "XXS" }, { value: "XS - S", label: "XS - S" }, { value: "M - L", label: "M - L" }, { value: "XL", label: "XL" }, { value: "XXL", label: "XXL" }, { value: "Other", label: "Other" }];

var DIVING_MASK = [{ value: "I will bring my own mask", label: "I will bring my own mask" }, { value: "Full face", label: "Full face" }, { value: "Two glass", label: "Two glass" }];

var DIVING_EXPERIENCE_LEVEL = [{
  value: "Novice – 4 to 30 logged dives",
  label: "Novice – 4 to 30 logged dives"
}, {
  value: "Proficient – 30 to 60 logged dives",
  label: "Proficient – 30 to 60 logged dives"
}, {
  value: "Advanced –  60 to 120 logged dives",
  label: "Advanced –  60 to 120 logged dives"
}, {
  value: "Expert – Over 120 logged dives",
  label: "Expert – Over 120 logged dives"
}];

var DIVING_ASSOCIATIONS = [{ value: "PADI", label: "PADI" }, { value: "SSI", label: "SSI" }, { value: "NAUI", label: "NAUI" }, { value: "BSAC", label: "BSAC" }, { value: "CMAS", label: "CMAS" }, { value: "Other", label: "Other" }];

//endregion

//region TYPE OF ARRANGEMENT

var TYPE_OF_ARRANGEMENTS = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "AE Private transfer (pending)",
  label: "Aqua Expeditions' private transfer"
},
// { value: "AE Private transfer (prepaid)", label: "Aqua Expeditions' private transfer
// (Prepaid)" }, { value: "AE Private transfer (pay on board)", label: "Aqua Expeditions' private
// transfer (Pay on board)" },
{
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "AE Private transfer (pending)",
  label: "Aqua Expeditions' private transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}];

var TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY = [{
  value: "AE Private transfer (pending)",
  label: "Aqua Expeditions' private transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}];

var TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER = [{
  value: "AE Private transfer (pending)",
  label: "Aqua Expeditions' private transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_PRIVATE_AND_SHARED_TRANSFER = [{
  value: "AE Private transfer (pending)",
  label: "Aqua Expeditions' private transfer"
}, {
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}];

var TYPE_OF_ARRANGEMENTS_WITHOUT_PRIVATE_TRANSFER = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}];

var TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}, {
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY = [{
  value: "AE Shared transfer",
  label: "Aqua Expeditions' shared transfer"
}];

var TYPE_OF_ARRANGEMENTS_THIRD_PARTY_ONLY = [{
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}];

var TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI = [{
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}];

var TYPE_OF_ARRANGEMENTS_THIRD_PARTY_TAXI_AND_OTHER = [{
  value: "By 3rd party",
  label: "local ground handler / tour operator"
}, {
  value: "Taxi",
  label: "taxi"
}, {
  value: "Other",
  label: "Other"
}];

//endregion

//region POST ARRANGEMENT
var POST_ARRANGEMENT_ACTIONS = [{
  value: "hotel",
  label: "go back to my accommodation"
}, {
  value: "airport",
  label: "go to airport"
}, {
  value: "sharedTransfer",
  label: "go to the meeting point with Aqua Expeditions' shared transfer"
}];

var POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER = [{
  value: "hotel",
  label: "go back to my accommodation"
}, {
  value: "airport",
  label: "go to airport"
}];

//endregion

//region ROUTE
var TYPE_OF_ROUTE_TO_GALAPAGOS = [{
  value: "UIO to GYE",
  label: "Quito (UIO) to Guayaquil (GYE)"
}, {
  value: "GYE to GPS",
  label: "Guayaquil (GYE) to Baltra Island (GPS)"
}, {
  value: "UIO to GPS",
  label: "Quito (UIO) to Baltra Island (GPS)"
}];

var TYPE_OF_ROUTE_FROM_GALAPAGOS = [{
  value: "GPS to GYE",
  label: "Baltra Island to Guayaquil (GYE)"
}, {
  value: "GYE to UIO",
  label: "Guayaquil (GYE) to Quito (UIO)"
}, {
  value: "GPS to UIO",
  label: "Baltra Island (GPS) to Quito (UIO)"
}];

var ARRIVAL_CITY_CAMBODIA = [{ value: "Phnom Penh (PHN)", label: "Phnom Penh (PHN)" }, { value: "Ho Chi Minh (SGN)", label: "Ho Chi Minh (SGN)" }, { value: "Siem Reap (SAI)", label: "Siem Reap (SAI)" }];

var ARRIVAL_CITY_AMAZON = [{ value: "Iquitos (IQT)", label: "Iquitos (IQT)" }];
//endregion

var DATE_DAYS = range(1, 31).map(function (number) {
  return { label: "" + ("0" + number).slice(-2), value: "" + number };
});

var DATE_MONTHS = [{ value: "01", label: "January" }, { value: "02", label: "February" }, { value: "03", label: "March" }, { value: "04", label: "April" }, { value: "05", label: "May" }, { value: "06", label: "June" }, { value: "07", label: "July" }, { value: "08", label: "August" }, { value: "09", label: "September" }, { value: "10", label: "October" }, { value: "11", label: "November" }, { value: "12", label: "December" }];

var DATE_YEARS = range(new Date().getFullYear(), 1900, -1).map(function (number) {
  return { label: number, value: number };
});

var DATE_EXPIRY_YEARS = range(new Date().getFullYear(), new Date().getFullYear() + 50).map(function (number) {
  return { label: number, value: number };
});

// 2007 is the year where Aqua Expeditions first started
var DATE_SHIP_START_YEARS = range(new Date().getFullYear(), 2007, -1).map(function (number) {
  return { label: number, value: number };
});

var ADULT_WETSUIT_SIZE_DATA = [{
  size: "XS",
  chest: "86-91",
  waist: "69-74",
  hip: "82-87",
  height: "150-172",
  heightFt: "4.9-5.6",
  weightKg: "45-64"
}, {
  size: "S",
  chest: "91-97",
  waist: "74-79",
  hip: "86-91",
  height: "173-179",
  heightFt: "5.6-5.8",
  weightKg: "61-70"
}, {
  size: "M",
  chest: "97-102",
  waist: "79-84",
  hip: "90-95",
  height: "179-180",
  heightFt: "5.8-5.9",
  weightKg: "68-77"
}, {
  size: "L",
  chest: "102-107",
  waist: "84-89",
  hip: "98-105",
  height: "180-185",
  heightFt: "5.9-6",
  weightKg: "77-86"
}, {
  size: "XL",
  chest: "107-112",
  waist: "89-94",
  hip: "102-110",
  height: "182-188",
  heightFt: "5.9-6.1",
  weightKg: "86-95"
}, {
  size: "XXL",
  chest: "112-117",
  waist: "94-99",
  hip: "108-114",
  height: "185-192",
  heightFt: "6-6.2",
  weightKg: "95-104"
}];

var CHILD_WETSUIT_SIZE_DATA = [{
  size: "M",
  chest: "62-65",
  waist: "56-60",
  hip: "66-69",
  height: "130-151",
  heightFt: "4.2-4.9"
}, {
  size: "L",
  chest: "66-70",
  waist: "61-63",
  hip: "70-74",
  height: "152-163",
  heightFt: "4.9-5.3"
}, {
  size: "XL",
  chest: "71-74",
  waist: "63-66",
  hip: "74-76",
  height: "164-169",
  heightFt: "5.3-5.5"
}];

var FIN_SIZE_DATA = [{
  size: "XXXS",
  us: "0 - 1",
  uk: "0 - 1",
  euro: "32 - 33",
  inches: '7.75" - 8"',
  cm: "19.7 - 20.6"
}, {
  size: "XXS",
  us: "2 - 3",
  uk: "2 - 3",
  euro: "34 - 35",
  inches: '8.25" - 8.625"',
  cm: "21 - 21.9"
}, {
  size: "XS - S",
  us: "4 - 6.5",
  uk: "4 - 6",
  euro: "36 - 39",
  inches: '8.75" - 9.75"',
  cm: "22.2 - 24.1"
}, {
  size: "M - L",
  us: "7 - 9.5",
  uk: "7 - 9.5",
  euro: "40 - 43",
  inches: '9.625" - 10.75"',
  cm: "24.4 - 27.3"
}, {
  size: "XL",
  us: "10 - 11.5",
  uk: "10 - 11",
  euro: "44 - 45",
  inches: '10.9375" - 11.25"',
  cm: "27.9 - 28.6"
}, {
  size: "XXL",
  us: "12 - 14",
  uk: "11.5 - 12.5",
  euro: "46 - 47",
  inches: '11.5625" - 11.875"',
  cm: "29 - 30.2"
}];

var VISA_TYPE_REQUIRING_ATTACHMENTS = ["Physical Visa (Cross border)", "E Visa"];

var UNHANDLED_ERROR_MESSAGE = "Opps! It appears that we have encountered an issue, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

var ACCEPTED_UPLOAD_MIMETYPES = ["image/jpeg", "image/png"];

var ACCEPTED_UPLOAD_MIMETYPES_PASSPORT = ["image/jpeg", "image/png", "application/pdf"];

function range(start, end) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (start === end) {
    return [start];
  }

  return [start].concat(_toConsumableArray(range(start + step, end, step)));
}

/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/*!********************************!*\
  !*** ./src/api/http-common.js ***!
  \********************************/
/*! exports provided: baseURL, baseAPIURL, marketingBackendURL, maintenance, HTTP, HTTPMarketing */
/*! exports used: HTTP, HTTPMarketing, baseURL, maintenance */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return baseURL; });
/* unused harmony export baseAPIURL */
/* unused harmony export marketingBackendURL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return maintenance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HTTP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HTTPMarketing; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(/*! axios */ 357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var debug = "false," === "true";

var baseURL = debug ? "http://localhost:8083" :  true ? "/ae-online-check-in" : "/ae-online-check-in";
var baseAPIURL = baseURL + "/api/v0";
var marketingBackendURL = undefined;
var maintenance = "false" === "true";

// A shared instance with configs
var HTTP = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: baseAPIURL,
  headers: {
    "content-type": "application/json"
    //   Authorization: 'Bearer {token}'
  }
});

// A shared instance with configs
var HTTPMarketing = __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
  baseURL: marketingBackendURL,
  headers: {
    "content-type": "application/json"
  }
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */
/*!*******************************!*\
  !*** ./src/mixins/contact.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(/*! ../utils */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(/*! ../store */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(/*! ../constants */ 13);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }







/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.cabinConfigurations, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.visaRequirementByContactID, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.passportByContactID, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.preArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.postArrangementByContactIDAndCategory])),
  methods: {
    getFullName: function getFullName(contact) {
      return "" + contact.firstName + (contact.middleName ? " " + contact.middleName : "") + (contact.lastName ? " " + contact.lastName : "");
    },
    getFullNameByContactId: function getFullNameByContactId(contactId) {
      var contact = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contact](contactId);
      return this.getFullName(contact);
    },
    getEmergencyFullName: function getEmergencyFullName(contact) {
      return "" + (contact.emergencyContactFirstName ? contact.emergencyContactFirstName : "") + (contact.emergencyContactMiddleName ? " " + contact.emergencyContactMiddleName : "") + (contact.emergencyContactLastName ? " " + contact.emergencyContactLastName : "");
    },
    getPastTravelPeriodField: function getPastTravelPeriodField(pastGuestLocation) {
      switch (pastGuestLocation) {
        case __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* DESTINATIONS */].Amazon:
          return __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod.Amazon;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* DESTINATIONS */].Mekong:
          return __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod.Mekong;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* DESTINATIONS */].Indonesia:
          return __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod.Indonesia;
        case __WEBPACK_IMPORTED_MODULE_4__constants__["m" /* DESTINATIONS */].Ecuador:
          return __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod.Ecuador;
      }
      return "";
    },
    getContactMandatoryFields: function getContactMandatoryFields() {
      var booking = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters["booking"];
      var mandatoryFields = ["title", "firstName", "lastName", "dateOfBirth",
      // 'email', // Email is meant to be optional now
      "mainMailingCountry", "nationality", "gender", "emergencyContactFirstName", "emergencyContactLastName", "emergencyContactPhone", "emergencyContactRelation", "dietaryAllergies", "medicalNotes"];

      if (booking && !booking.isAmazonCruise) {
        mandatoryFields.push("passportIssueDate");
      }

      // if (
      //   booking &&
      //   (!booking.isAmazonCruise ||
      //     !booking.facilityCode == FACILITY_CODES.AquaBlu)
      // ) {
      //   mandatoryFields.push("dietaryPreferences");
      // }
      return mandatoryFields;
    },
    getContactBookingMandatoryFields: function getContactBookingMandatoryFields() {
      var mandatoryFields = [];
      return mandatoryFields;
    },
    isBedConfigurable: function isBedConfigurable(cabinConfiguration) {
      if (this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaLares) {
        return true;
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu) {
        if (["202", "204"].indexOf(cabinConfiguration.cabin) >= 0) {
          return false;
        }
        var aquaBluConfigurableCabins = ["202", "204"];
        return aquaBluConfigurableCabins.indexOf(cabinConfiguration.cabin) >= 0;
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaLares) {
        var aquaLaresConfigurableCabins = ["104", "105", "301", "302"];
        return aquaLaresConfigurableCabins.indexOf(cabinConfiguration.cabin) >= 0;
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare) {
        return false;
      }
    },
    isAquaLares: function isAquaLares() {
      return this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaLares;
    },
    hasDiving: function hasDiving() {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu || this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaLares && !this.booking.isArcticCruise;
    },
    canDive: function canDive(contact) {
      var age = Object(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* getAge */])(new Date(contact.dateOfBirth));
      return age >= 8;
    },
    hasWetsuit: function hasWetsuit() {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare;
    },
    isPostArrangementDriverFieldMandatory: function isPostArrangementDriverFieldMandatory(contact) {
      var portToLocationArrangement = this.postArrangementByContactIDAndCategory(contact.contactID, "Port to location");
      if (!portToLocationArrangement) {
        return false;
      }
      if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].SiemReap || this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].HoChiMinh) {
        if (portToLocationArrangement.postArrangementAction === "sharedTransfer" && portToLocationArrangement.typeOfArrangement === "AE Shared transfer") {
          return true;
        }
      }
      return false;
    },
    isPostArrangementFlightFieldMandatory: function isPostArrangementFlightFieldMandatory(contact) {
      var portToLocationArrangement = this.postArrangementByContactIDAndCategory(contact.contactID, "Port to location");
      if (!portToLocationArrangement) {
        return false;
      }
      if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].SiemReap || this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].HoChiMinh) {
        if (portToLocationArrangement.postArrangementAction === "sharedTransfer" && portToLocationArrangement.typeOfArrangement === "AE Shared transfer") {
          return true;
        }
      }
      return false;
    },
    isPostArrangementAccommodationFieldMandatory: function isPostArrangementAccommodationFieldMandatory(contact) {
      var portToLocationArrangement = this.postArrangementByContactIDAndCategory(contact.contactID, "Port to location");
      if (!portToLocationArrangement) {
        return false;
      }
      if (portToLocationArrangement.postArrangementAction === "hotel") {
        return true;
      }
      if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].SiemReap || this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_4__constants__["A" /* PORTS */].HoChiMinh) {
        if (portToLocationArrangement.postArrangementAction === "sharedTransfer" && portToLocationArrangement.typeOfArrangement === "AE Shared transfer") {
          return true;
        }
      }
      return false;
    },
    isPreArrangementAccommodationFieldMandatory: function isPreArrangementAccommodationFieldMandatory(contact) {
      var accommodationArrangement = this.preArrangementByContactIDAndCategory(contact.contactID, "Accommodation");
      if (!accommodationArrangement) {
        return false;
      }
      // 20250408: Request by client to include accommodation for AQM and AQB
      // if (this.booking.facilityCode === FACILITY_CODES.AquaBlu) {
      //   return false;
      // }
      // if (this.booking.facilityCode === FACILITY_CODES.AquaMare) {
      //   return false;
      // }
      if (!accommodationArrangement.arrivePriorToCruise) {
        return false;
      }
      return true;
      // return this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
      //   && !this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight').takingRecommendedFlight
    },
    getTotalProgressData: function getTotalProgressData() {
      var _this = this;

      var basicMandatoryFields = this.getContactMandatoryFields();
      var basicContactBookingMandatoryFields = this.getContactBookingMandatoryFields();
      var totalMandatoryFields = 0;
      var totalCompletedFields = 0;
      var emptyFields = [];
      var fieldDisplayName = {
        nameOfPerson: "driverName",
        from: "pickUpLocation",
        contactNo: "contactNumber",
        pastGuest: "previousAquaCruisePeriod"
      };

      this.contacts.forEach(function (contact) {
        var contactID = contact.contactID;

        var mandatoryFields = basicMandatoryFields.slice();

        // for amazon cruise, if guest in Peruvian - we only collect the national ID
        if (_this.booking.isAmazonCruise) {
          if (contact.nationality === "PE - Peru" && contact.mainMailingCountry === "PE - Peru") {
            mandatoryFields.push("nationalIdNumber");
          }
        } else {
          //'passportNumber', 'passportIssuingCountry', 'passportExpiryDate',
          mandatoryFields.push("passportNumber");
          mandatoryFields.push("passportIssuingCountry");
          mandatoryFields.push("passportExpiryDate");
        }

        // Diving checks
        var contactBookingMandatoryFields = basicContactBookingMandatoryFields.slice();
        var contactBooking = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contactBooking](contactID);

        if (_this.hasWetsuit() && (contactBooking.needWetsuit === true || contactBooking.needWetsuit === "true")) {
          contactBookingMandatoryFields.push("wetsuit");
          if (contactBooking.wetsuit === "Other") {
            contactBookingMandatoryFields.push("wetsuitOther");
          }
        }

        if (_this.hasDiving() && _this.canDive(contact) && (contactBooking.planningToDive === true || contactBooking.planningToDive === "true")) {
          contactBookingMandatoryFields.push("dateOfLastDive", "divingExperienceLevel", "divingFins", "divingAssociation", "divingCertificationNumber", "divingWetsuit");
          if (contactBooking.divingAssociation === "Other") {
            contactBookingMandatoryFields.push("divingAssociationOther");
          }
          if (contactBooking.divingWetsuit === "Other") {
            contactBookingMandatoryFields.push("divingWetsuitOther");
          }
          if (contactBooking.divingFins === "Other") {
            contactBookingMandatoryFields.push("divingFinsOther");
          }
        }

        var completedFields = mandatoryFields.filter(function (field) {
          if (!contact[field] || Array.isArray(contact[field]) && contact[field].length <= 0) {
            emptyFields.push({ field: field, contactID: contactID });
          }

          return contact[field];
        });
        completedFields.push.apply(completedFields, _toConsumableArray(contactBookingMandatoryFields.filter(function (field) {
          if (!contactBooking[field] || Array.isArray(contactBooking[field]) && contactBooking[field].length <= 0) {
            emptyFields.push({ field: field, contactID: contactID });
          }

          return contactBooking[field];
        })));

        var numMandatoryFields = mandatoryFields.length + contactBookingMandatoryFields.length;
        var numCompletedFields = completedFields.length;

        if (contact.hasPastGuest) {
          numMandatoryFields++;
          numCompletedFields += contact.pastGuest[0] ? 1 : 0;

          if (contact.pastGuest.length === 0 || contact.pastGuest[0] === "") {
            emptyFields.push({ field: "pastGuest", contactID: contactID });
          }
        }

        var visaRequirement = _this.visaRequirementByContactID(contactID);
        if (visaRequirement && __WEBPACK_IMPORTED_MODULE_4__constants__["R" /* VISA_TYPE_REQUIRING_ATTACHMENTS */].indexOf(visaRequirement.visaType) >= 0) {
          numMandatoryFields++;

          if (visaRequirement._relativePath || visaRequirement.attachmentID && !visaRequirement._removeUploadedVisa) {
            numCompletedFields++;
          } else {
            emptyFields.push({ field: "visaImage", contactID: contactID });
          }
        }

        // Passport image is mandatory
        var passport = _this.passportByContactID(contactID);
        numMandatoryFields++;
        if (passport._relativePath || passport.attachmentID && !passport._removeUploadedPassport) {
          numCompletedFields++;
        } else {
          emptyFields.push({ field: "passportImage", contactID: contactID });
        }

        var preArrangementFlight = _this.preArrangementByContactIDAndCategory(contactID, "Flight");
        var preArrangementAccommodation = _this.preArrangementByContactIDAndCategory(contactID, "Accommodation");
        var preArrangementLocationToPort = _this.preArrangementByContactIDAndCategory(contactID, "Location to port");

        if (preArrangementFlight && !preArrangementFlight.notTakingAFlight && !preArrangementFlight.flightBookedByAqua) {
          // Taking a flight
          var flightFields = ["flightNumber", "arrivalDate", "arrivalTime"];
          // const accommodationFields = ['accommodationName']
          var locationToPortFields = []; // ['typeOfArrangement'] handled in the next section
          numMandatoryFields += flightFields.length;
          numCompletedFields += flightFields.reduce(function (accumulate, current) {
            if (!preArrangementFlight[current]) {
              emptyFields.push({
                field: current,
                contactID: contactID,
                preArrangementID: preArrangementFlight.preArrangementID
              });
              return accumulate;
            }
            accumulate++;
            return accumulate;
          }, 0);
          // if (preArrangementAccommodation && this.booking.isAmazonCruise) {
          //   // Accommodation is mandatory for Amazon cruise only
          //   numMandatoryFields += accommodationFields.length
          //   numCompletedFields += accommodationFields.reduce((accumulate, current) => {
          //     if (!preArrangementAccommodation[current]) {
          //       emptyFields.push({ field: current, contactID, preArrangementID: preArrangementAccommodation.preArrangementID })
          //       return accumulate
          //     }
          //     accumulate++
          //     return accumulate
          //   }, 0)
          // }
          if (_this.booking.isGalapagosCruise) {
            numMandatoryFields++;
            if (!preArrangementFlight["galapagosRouteInfo"]) {
              emptyFields.push({
                field: "EmbarkingFrom",
                contactID: contactID,
                preArrangementID: preArrangementAccommodation.preArrangementID
              });
            } else {
              numCompletedFields++;
            }
          }
          if (preArrangementLocationToPort) {
            numMandatoryFields += locationToPortFields.length;
            numCompletedFields += locationToPortFields.reduce(function (accumulate, current) {
              if (!preArrangementLocationToPort[current]) {
                emptyFields.push({
                  field: current,
                  contactID: contactID,
                  preArrangementID: preArrangementLocationToPort.preArrangementID
                });
                return accumulate;
              }
              accumulate++;
              return accumulate;
            }, 0);
          }
        }
        // else if (preArrangementFlight && preArrangementFlight.notTakingAFlight && this.booking.isAmazonCruise) {
        if (_this.isPreArrangementAccommodationFieldMandatory(contact)) {
          var accommodationFields = ["accommodationName"];
          numMandatoryFields += accommodationFields.length;
          numCompletedFields += accommodationFields.reduce(function (accumulate, current) {
            if (!preArrangementAccommodation[current]) {
              emptyFields.push({
                field: current,
                contactID: contactID,
                preArrangementID: preArrangementAccommodation.preArrangementID
              });
              return accumulate;
            }
            accumulate++;
            return accumulate;
          }, 0);
        }

        // preArrangementLocationToPort
        if (preArrangementLocationToPort && !preArrangementLocationToPort.typeOfArrangement && !_this.booking.isGalapagosCruise) {
          numMandatoryFields++;
          emptyFields.push({
            field: "typeOfPreCruiseArrangement",
            contactID: contactID,
            preArrangementID: preArrangementLocationToPort.preArrangementID
          });
        }

        if (preArrangementLocationToPort && (!preArrangementLocationToPort.dateOfEntryToPeru || !preArrangementLocationToPort.entryToPeruFrom) && _this.booking.isAmazonCruise && contact.mainMailingCountry !== "PE - Peru") {
          if (!preArrangementLocationToPort.dateOfEntryToPeru) {
            numMandatoryFields++;
            emptyFields.push({
              field: "dateOfEntryToPeru",
              contactID: contactID,
              preArrangementID: preArrangementLocationToPort.preArrangementID
            });
          }

          if (!preArrangementLocationToPort.entryToPeruFrom) {
            numMandatoryFields++;
            emptyFields.push({
              field: "entryToPeruFrom",
              contactID: contactID,
              preArrangementID: preArrangementLocationToPort.preArrangementID
            });
          }
        }

        if (preArrangementLocationToPort && preArrangementLocationToPort.typeOfArrangement === "By 3rd party") {
          var fields = ["localHandler", "nameOfPerson", "contactNo", "from"];
          numMandatoryFields += fields.length;
          numCompletedFields += fields.reduce(function (accumulate, current) {
            if (!preArrangementLocationToPort[current]) {
              emptyFields.push({
                field: current,
                contactID: contactID,
                preArrangementID: preArrangementLocationToPort.preArrangementID
              });
              return accumulate;
            }

            accumulate++;
            return accumulate;
          }, 0);
        }

        // postArrangementPortToLocation
        var postArrangementPortToLocation = _this.postArrangementByContactIDAndCategory(contactID, "Port to location");
        if (postArrangementPortToLocation && !postArrangementPortToLocation.typeOfArrangement && !_this.booking.isGalapagosCruise) {
          numMandatoryFields++;
          emptyFields.push({
            field: "typeOfPostCruiseArrangement",
            contactID: contactID,
            postArrangementID: postArrangementPortToLocation.postArrangementID
          });
        }

        if (postArrangementPortToLocation && postArrangementPortToLocation.typeOfArrangement === "By 3rd party") {
          var _fields = ["localHandler", "nameOfPerson", "contactNo"];
          numMandatoryFields += _fields.length;
          numCompletedFields += _fields.reduce(function (accumulate, current) {
            if (!postArrangementPortToLocation[current]) {
              emptyFields.push({
                field: current,
                contactID: contactID,
                postArrangementID: postArrangementPortToLocation.postArrangementID
              });
              return accumulate;
            }

            accumulate++;
            return accumulate;
          }, 0);
        }

        if (postArrangementPortToLocation && (postArrangementPortToLocation.postArrangementAction === "airport" || _this.booking.isGalapagosCruise)) {
          var postArrangementFlight = _this.postArrangementByContactIDAndCategory(contactID, "Flight");
          if (postArrangementFlight && !postArrangementFlight.notTakingAFlight && !postArrangementFlight.flightBookedByAqua) {
            var _fields2 = ["flightNumber", "departureDate", "departureTime"];
            numMandatoryFields += _fields2.length;
            numCompletedFields += _fields2.reduce(function (accumulate, current) {
              if (!postArrangementFlight[current]) {
                emptyFields.push({
                  field: current,
                  contactID: contactID,
                  postArrangementID: postArrangementFlight.postArrangementID
                });
                return accumulate;
              }

              accumulate++;
              return accumulate;
            }, 0);

            if (_this.booking.isGalapagosCruise) {
              if (!postArrangementFlight["galapagosRouteInfo"]) {
                emptyFields.push({
                  field: "DisembarkingFrom",
                  contactID: contactID,
                  preArrangementID: postArrangementFlight.preArrangementID
                });
              }
            }
          }

          if (postArrangementFlight && postArrangementFlight.takingRecommendedFlight && !postArrangementFlight.flightBookedByAqua) {
            var _fields3 = ["referenceNumber"];
            numMandatoryFields += _fields3.length;
            numCompletedFields += _fields3.reduce(function (accumulate, current) {
              if (!postArrangementFlight[current]) {
                emptyFields.push({
                  field: current,
                  contactID: contactID,
                  postArrangementID: postArrangementFlight.postArrangementID
                });
                return accumulate;
              }

              accumulate++;
              return accumulate;
            }, 0);
          }
        }
        if (_this.isPostArrangementAccommodationFieldMandatory(contact)) {
          var _accommodationFields = ["accommodationName"];
          var postArrangementAccommodation = _this.postArrangementByContactIDAndCategory(contactID, "Accommodation");
          if (postArrangementAccommodation) {
            numMandatoryFields += _accommodationFields.length;
            numCompletedFields += _accommodationFields.reduce(function (accumulate, current) {
              if (!postArrangementAccommodation[current]) {
                emptyFields.push({
                  field: current,
                  contactID: contactID,
                  postArrangementID: postArrangementAccommodation.postArrangementID
                });
                return accumulate;
              }
              accumulate++;
              return accumulate;
            }, 0);
          }
        }

        totalMandatoryFields += numMandatoryFields;
        totalCompletedFields += numCompletedFields;
      });

      this.cabinConfigurations.forEach(function (cabinConfiguration) {
        var cabinBedding = cabinConfiguration.cabinBedding,
            cabinConfigurationID = cabinConfiguration.cabinConfigurationID;
        // Only add cabin configuration as mandatory if it is configurable

        if (!_this.isBedConfigurable(cabinConfiguration)) {
          return;
        }
        totalMandatoryFields++;
        totalCompletedFields += cabinBedding ? 1 : 0;

        if (!cabinBedding) {
          emptyFields.push({ field: "cabinBedding", cabinConfigurationID: cabinConfigurationID });
        }
      });

      // Replace fields with easier to understand display names if available
      emptyFields = emptyFields.map(function (emptyField) {
        emptyField.field = fieldDisplayName[emptyField.field] ? fieldDisplayName[emptyField.field] : emptyField.field;
        return emptyField;
      });

      console.log("emptyFields:", emptyFields);
      var percentage = Math.round(totalCompletedFields / totalMandatoryFields * 100);

      return {
        percentage: percentage,
        emptyFields: emptyFields
      };
    }
  }
});

/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */
/*!**********************!*\
  !*** ./src/utils.js ***!
  \**********************/
/*! exports provided: find, deepCopy, forEachValue, isObject, isPromise, assert, mapSetter, daysDiff, getAge, padTime, getOffset, positionDropdown, delay, waitUntil, isCurrentDateBefore */
/*! exports used: deepCopy, delay, getAge, isCurrentDateBefore, padTime, positionDropdown, waitUntil */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export find */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepCopy;
/* unused harmony export forEachValue */
/* unused harmony export isObject */
/* unused harmony export isPromise */
/* unused harmony export assert */
/* unused harmony export mapSetter */
/* unused harmony export daysDiff */
/* harmony export (immutable) */ __webpack_exports__["c"] = getAge;
/* harmony export (immutable) */ __webpack_exports__["e"] = padTime;
/* unused harmony export getOffset */
/* harmony export (immutable) */ __webpack_exports__["f"] = positionDropdown;
/* harmony export (immutable) */ __webpack_exports__["b"] = delay;
/* harmony export (immutable) */ __webpack_exports__["g"] = waitUntil;
/* harmony export (immutable) */ __webpack_exports__["d"] = isCurrentDateBefore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find(list, f) {
  return list.filter(f)[0];
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy(obj) {
  var cache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // just return if obj is immutable value
  if (obj === null || (typeof obj === "undefined" ? "undefined" : _typeof(obj)) !== "object") {
    return obj;
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) {
    return c.original === obj;
  });
  if (hit) {
    return hit.copy;
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy;
}

/**
 * forEach for object
 */
function forEachValue(obj, fn) {
  Object.keys(obj).forEach(function (key) {
    return fn(obj[key], key);
  });
}

function isObject(obj) {
  return obj !== null && (typeof obj === "undefined" ? "undefined" : _typeof(obj)) === "object";
}

function isPromise(val) {
  return val && typeof val.then === "function";
}

function assert(condition, msg) {
  if (!condition) throw new Error("[vuex] " + msg);
}

var mapSetter = function mapSetter(state) {
  var setters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(state).reduce(function (accumulate, stateName) {
    accumulate[stateName] = {
      get: state[stateName]
    };
    // check if setter exists
    if (setters[stateName]) {
      accumulate[stateName].set = setters[stateName];
    }

    return accumulate;
  }, {});
};

function daysDiff(date1, date2) {
  var oneDay = 24 * 60 * 60 * 1000;
  return Math.round(Math.abs((date1.getTime() - date2.getTime()) / oneDay));
}

function getAge(date) {
  return Math.floor((new Date() - new Date(date).getTime()) / 3.15576e10);
}

function padTime(n) {
  return ("0" + n).slice(-2);
}

/**
 * Adapted from fix for vue-select dropdown being hidden by parent with overflow hidden
 * here: https://github.com/Lexxus/vue-select/blob/4fb9f1b11403b4db9636d58be5ce49852362be09/src/mixins/domHelpers.js
 * @param baseElement
 * @param targetElement
 * @param aboveCssClass
 */

function getOffset(element) {
  var DROPDOWN_EDGE_MARGIN = 30;
  var el = element.offsetParent;
  var parentEl = element.parentElement;
  var top = element.offsetTop;
  var left = element.offsetLeft;
  var maxHeight = void 0;

  while (parentEl) {
    if (el === parentEl) {
      top += el.offsetTop - el.scrollTop;
      left += el.offsetLeft;
      el = el.offsetParent;
    } else {
      top -= parentEl.scrollTop;
    }
    parentEl = parentEl.parentElement;
  }

  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === "object") {
    maxHeight = window.innerHeight - top - DROPDOWN_EDGE_MARGIN;
  }
  top = element.getBoundingClientRect().top - document.body.getBoundingClientRect().top;

  return { top: top, left: left, maxHeight: maxHeight };
}

function positionDropdown(baseElement, targetElement) {
  var aboveCssClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "above";

  var offset = baseElement && getOffset(baseElement);
  if (baseElement && targetElement) {
    var targetHeight = targetElement.offsetHeight;

    // move it to the <body> to avoid glitches in IE
    document.body.appendChild(targetElement);

    targetElement.style.minWidth = baseElement.offsetWidth + "px";
    targetElement.style.left = offset.left + "px";

    if (offset.maxHeight < targetHeight && offset.top > targetHeight / 2) {
      var top = offset.top - targetHeight + 1;

      if (top < 0) {
        top = 0;
        targetElement.style.maxHeight = offset.top + "px";
      }
      targetElement.style.top = top + "px";
      // baseElement.classList.add(aboveCssClass)
      targetElement.classList.add(aboveCssClass);
    } else {
      if (offset.maxHeight < targetHeight) {
        targetElement.style.maxHeight = offset.maxHeight + "px";
      }
      targetElement.style.top = offset.top + baseElement.offsetHeight - 1 + "px";
      // baseElement.classList.remove(aboveCssClass)
      targetElement.classList.remove(aboveCssClass);
    }
  }
}

function delay(timeMilliseconds) {
  return new Promise(function (resolve) {
    setTimeout(function () {
      resolve();
    }, timeMilliseconds);
  });
}

function waitUntil(conditionFunction) {
  var _this = this;

  return new Promise(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(resolve) {
      var i;
      return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              i = 0;

            case 1:
              if (!(i < 1000)) {
                _context.next = 9;
                break;
              }

              if (!conditionFunction()) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("break", 9);

            case 4:
              _context.next = 6;
              return delay(100);

            case 6:
              i++;
              _context.next = 1;
              break;

            case 9:
              resolve();

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }());
}

/**
 * Check if the current date is before the given date
 *
 * @param year - four-digit year eg. 2026
 * @param month - zero-indexed eg. 0 for January, 1 for February, etc.
 * @param date - day of the month eg. 15
 * @returns {boolean}
 */
function isCurrentDateBefore(year, month, date) {
  var today = new Date();
  var cutoff = new Date(year, month, date);
  return today < cutoff;
}

/***/ }),
/* 35 */
/*!*********************************!*\
  !*** ./src/mixins/timeTrack.js ***!
  \*********************************/
/*! exports provided: timeTrack */
/*! exports used: timeTrack */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return timeTrack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);



var timeTrack = {
  data: function data() {
    return {
      sessionTimeoutWarning: 0,
      sessionTimeout: 0
    };
  },
  created: function created() {
    if (this.expiryTime !== "") {
      this.spawnTimeoutWarning();
      this.spawnTimeout();
    }
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.expiryTime])),
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.sessionTimeoutWarning);
    clearTimeout(this.sessionTimeout);
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.refreshAccessToken, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.logout]), {
    spawnTimeoutWarning: function spawnTimeoutWarning() {
      var _this = this;

      var warningTime = this.expiryTime - 10 * 60 * 1000;
      this.sessionTimeoutWarning = setTimeout(function () {
        _this.$confirm("Your session will expire in 10 minutes. Would you like to continue your booking?", "Session Expiration Warning", {
          confirmButtonText: "CONTINUE MY BOOKING",
          cancelButtonText: "EXIT",
          customClass: "session-expiry-box",
          showClose: false,
          type: "warning",
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        }).then(function () {
          console.log("Continue checking in pressed");
          _this[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.refreshAccessToken]().then(function () {
            clearTimeout(_this.sessionTimeout);
            clearTimeout(_this.sessionTimeoutWarning);
            _this.spawnTimeout();
            _this.spawnTimeoutWarning();
          });
        }).catch(function () {});
      }, warningTime);
    },
    spawnTimeout: function spawnTimeout() {
      var _this2 = this;

      this.sessionTimeout = setTimeout(function () {
        _this2[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.logout]().then(function () {
          _this2.$router.push({ path: "/checkin-suspended" });
        });
      }, this.expiryTime);
    }
  })
};

/***/ }),
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */
/*!********************************!*\
  !*** ./src/mixins/autosave.js ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce__ = __webpack_require__(/*! debounce */ 398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_debounce__);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      autosaveTimeoutWarning: 0,
      autosaveTimeout: 0,
      autosaveCheckInterval: 20000,
      // Autosave timing defaults can be overridden temporarily by components
      defaultAutosaveIdleDelay: 4000, // baseline idle delay used for most fields
      autosaveIdleDelay: 4000, // wait this long after last keystroke before saving
      defaultMinAutosaveGap: 10000, // baseline minimum time between consecutive saves
      minAutosaveGap: 10000, // enforce minimum time between save attempts
      lastAutosaveAt: 0, // track when the last autosave completed
      hasPendingAutosave: false, // toggle so we do not save when no edits were made
      saveFunction: null,
      debouncedOnBlur: null,
      isFieldFocused: false
    };
  },
  created: function created() {},

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.expiryTime, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.lastSaveTime, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isLoading])),
  beforeDestroy: function beforeDestroy() {
    clearTimeout(this.autosaveTimeoutWarning);
    clearTimeout(this.autosaveTimeout);
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.refreshAccessToken, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.logout, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setLastSaveTime, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]), {
    initializeAutosave: function initializeAutosave(saveFunction, formRoot) {
      var _this = this;

      // TODO remove to allow autosave
      // return;
      this.saveFunction = saveFunction;
      this.scheduleAutosave(); // kick off initial timer so edits are eventually captured
      var rootElement = formRoot.$el || formRoot; // To allow formRoot to be set on VueComponents and normal DOM elements
      var textInputs = Array.from(rootElement.querySelectorAll('input[type="text"],input[type="email"],input[type="date"],input[type="datetime"],input[type="month"],input[type="number"],input[type="tel"],input[type="url"],input[type="time"],input[type="search"],textarea'));
      var otherInputs = Array.from(rootElement.querySelectorAll('input:not([type="text"]),select'));
      this.debouncedOnChange = Object(__WEBPACK_IMPORTED_MODULE_3_debounce__["debounce"])(this.onChange, 1000);
      textInputs.forEach(function (input) {
        input.addEventListener("input", _this.debouncedOnChange);
        input.addEventListener("blur", _this.debouncedOnChange);
      });
      otherInputs.forEach(function (input) {
        input.addEventListener("change", _this.debouncedOnChange);
      });
    },

    /**
     * Clear the pending autosave timer and schedule the next attempt.
     * Components can pass a custom delay (in ms) to debounce aggressive saves.
     */
    scheduleAutosave: function scheduleAutosave() {
      var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.autosaveCheckInterval;

      clearTimeout(this.autosaveTimeout);
      this.autosaveTimeout = setTimeout(this.attemptAutosave.bind(this), delay);
    },
    onChange: function onChange() {
      this.isFieldFocused = false;
      this.hasPendingAutosave = true; // mark form dirty so the next idle window saves it
      this.scheduleAutosave(this.autosaveIdleDelay);
    },

    /**
     * Start autosave if possible
     */
    attemptAutosave: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var now, nextDelay, saveCallSuccess, currentTime;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.saveFunction) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return");

              case 2:
                if (this.hasPendingAutosave) {
                  _context.next = 5;
                  break;
                }

                this.scheduleAutosave();
                return _context.abrupt("return");

              case 5:
                now = Date.now();

                if (!(now - this.lastAutosaveAt < this.minAutosaveGap)) {
                  _context.next = 10;
                  break;
                }

                nextDelay = Math.max(this.minAutosaveGap - (now - this.lastAutosaveAt), this.autosaveIdleDelay);

                this.scheduleAutosave(nextDelay);
                return _context.abrupt("return");

              case 10:

                clearTimeout(this.autosaveTimeout);

                if (!(this.isSaving || this.isLoading)) {
                  _context.next = 15;
                  break;
                }

                // Currently saving already, no need to autosave
                console.log("Currently saving, skipping autosave");
                this.scheduleAutosave(this.autosaveIdleDelay);
                return _context.abrupt("return");

              case 15:
                console.log("Autosaving...");
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: true });

                if (!this.saveFunction) {
                  _context.next = 22;
                  break;
                }

                _context.next = 20;
                return this.saveFunction(true);

              case 20:
                saveCallSuccess = _context.sent;

                if (saveCallSuccess) {
                  currentTime = new Date();

                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setLastSaveTime]({ lastSaveTime: currentTime });
                }

              case 22:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: false });
                this.lastAutosaveAt = Date.now();
                this.hasPendingAutosave = false;
                this.scheduleAutosave();

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function attemptAutosave() {
        return _ref.apply(this, arguments);
      }

      return attemptAutosave;
    }()
  })
});

/***/ }),
/* 46 */
/*!**********************************************!*\
  !*** ./src/components/AutosaveIndicator.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AutosaveIndicator_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AutosaveIndicator.vue */ 180);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b43bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutosaveIndicator_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-299b43bc","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AutosaveIndicator.vue */ 400);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-299b43bc","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AutosaveIndicator.vue */ 399)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AutosaveIndicator_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_299b43bc_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AutosaveIndicator_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */
/*!****************************!*\
  !*** ./src/store/index.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_loader__ = __webpack_require__(/*! ./modules/loader */ 354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_dialogSaveAndExit__ = __webpack_require__(/*! ./modules/dialogSaveAndExit */ 355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_booking__ = __webpack_require__(/*! ./modules/booking */ 356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_cabinConfiguration__ = __webpack_require__(/*! ./modules/cabinConfiguration */ 376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_contact__ = __webpack_require__(/*! ./modules/contact */ 377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_contactBooking__ = __webpack_require__(/*! ./modules/contactBooking */ 379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_preArrangement__ = __webpack_require__(/*! ./modules/preArrangement */ 380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_postArrangement__ = __webpack_require__(/*! ./modules/postArrangement */ 381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_visaRequirement__ = __webpack_require__(/*! ./modules/visaRequirement */ 382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_passport__ = __webpack_require__(/*! ./modules/passport */ 384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_common__ = __webpack_require__(/*! ./modules/common */ 386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__plugins_logger__ = __webpack_require__(/*! ../plugins/logger */ 389);

















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "false," === "true";

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  modules: {
    loader: __WEBPACK_IMPORTED_MODULE_2__modules_loader__["a" /* default */],
    dialogSaveAndExit: __WEBPACK_IMPORTED_MODULE_3__modules_dialogSaveAndExit__["a" /* default */],
    booking: __WEBPACK_IMPORTED_MODULE_4__modules_booking__["a" /* default */],
    cabinConfiguration: __WEBPACK_IMPORTED_MODULE_5__modules_cabinConfiguration__["a" /* default */],
    contact: __WEBPACK_IMPORTED_MODULE_6__modules_contact__["a" /* default */],
    contactBooking: __WEBPACK_IMPORTED_MODULE_7__modules_contactBooking__["a" /* default */],
    preArrangement: __WEBPACK_IMPORTED_MODULE_8__modules_preArrangement__["a" /* default */],
    postArrangement: __WEBPACK_IMPORTED_MODULE_9__modules_postArrangement__["a" /* default */],
    visaRequirement: __WEBPACK_IMPORTED_MODULE_10__modules_visaRequirement__["a" /* default */],
    passport: __WEBPACK_IMPORTED_MODULE_11__modules_passport__["a" /* default */],
    common: __WEBPACK_IMPORTED_MODULE_12__modules_common__["a" /* default */]
  },
  strict: debug,
  plugins: debug ? [Object(__WEBPACK_IMPORTED_MODULE_13__plugins_logger__["a" /* default */])()] : []
});

/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/App.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_logout__ = __webpack_require__(/*! ../mixins/logout */ 167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__layouts_Navbar_vue__ = __webpack_require__(/*! ./layouts/Navbar.vue */ 337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ui_Footer_vue__ = __webpack_require__(/*! ./ui/Footer.vue */ 342);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_logout__["a" /* default */]],
  components: { Footer: __WEBPACK_IMPORTED_MODULE_4__ui_Footer_vue__["a" /* default */], Navbar: __WEBPACK_IMPORTED_MODULE_3__layouts_Navbar_vue__["a" /* default */] },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.isLoading, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.loadingText, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.accessToken])),
  methods: {}
});

/***/ }),
/* 167 */
/*!******************************!*\
  !*** ./src/mixins/logout.js ***!
  \******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);



/* harmony default export */ __webpack_exports__["a"] = ({
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.logout]), {
    onClickLogout: function onClickLogout() {
      var _this = this;

      this[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.logout]().then(function () {
        window.onbeforeunload = null;
        _this.$router.go("/");
      });
    }
  })
});

/***/ }),
/* 168 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/layouts/Navbar.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(/*! lodash */ 339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../../store/types */ 1);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Navbar",
  props: {
    isSolidBackground: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {};
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])(["userDisplay", "isAgent", "isPressAccount", "isLoadingUser", "userData", __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking]), {
    hasValidUserData: function hasValidUserData() {
      console.log("[Navbar.userDataEmpty] this.agentDetails:", this.userData);
      if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash__["isEmpty"])(this.userData)) {
        return false;
      }
      return this.isAgent || this.isPressAccount;
    },
    portalHeader: function portalHeader() {
      if (this.isAgent) {
        return "AGENT PORTAL";
      }
      return "ONLINE CHECK IN";
    }
  }),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(["logout", "clearAll", "toggleMobileMenu"]), {
    updateHref: function updateHref(url) {
      window.open(url, "_blank");
    },
    login: function login() {
      this.$auth.loginWithRedirect();
    },
    handleCommand: function handleCommand(command) {
      var _this = this;

      switch (command) {
        case "logout":
          this.logout().then(function () {
            _this.$router.push({ path: "/" });
          });
          break;
        case "settings":
          this.$router.push({ path: "/account-settings" });
      }
    },
    toggleMobileMenuDialog: function toggleMobileMenuDialog() {
      this.toggleMobileMenu();
    }
  })
});

/***/ }),
/* 169 */
/*!************************************!*\
  !*** ./src/assets/images/logo.svg ***!
  \************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo.c59cb9d1.svg";

/***/ }),
/* 170 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/Footer.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FooterSocialMedia_vue__ = __webpack_require__(/*! ./FooterSocialMedia.vue */ 344);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Footer",
  components: { FooterSocialMedia: __WEBPACK_IMPORTED_MODULE_0__FooterSocialMedia_vue__["a" /* default */] },
  props: {
    showLinks: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var marketingSiteUrl = undefined;
    return {
      logo: __webpack_require__(/*! ../../assets/images/logo.svg */ 169),
      footerLinks: [{
        title: "Destinations",
        children: [{
          label: "Vietnam and Cambodia: Mekong River",
          href: marketingSiteUrl + "/destinations/mekong-river-cruise"
        }, {
          label: "Peru: Amazon River",
          href: marketingSiteUrl + "/destinations/amazon-river-cruise"
        }, {
          label: "Galapagos Islands",
          href: marketingSiteUrl + "/destinations/galapagos-cruise"
        }, {
          label: "Indonesia",
          href: marketingSiteUrl + "/multiple-destinations/indonesia-cruise"
        }, {
          label: "Bali - Komodo National Park",
          href: marketingSiteUrl + "/destinations/indonesia-cruise/bali-komodo-national-park"
        }, {
          label: "Ambon & Spice Islands",
          href: marketingSiteUrl + "/destinations/indonesia-cruise/ambon-and-spice-islands"
        }, {
          label: "Raja Ampat",
          href: marketingSiteUrl + "/destinations/indonesia-cruise/raja-ampat-cruise"
        }, {
          label: "Asmat & New Guinea",
          href: marketingSiteUrl + "/destinations/indonesia-cruise/asmat-new-guinea"
        }, {
          label: "Dual Destination",
          href: marketingSiteUrl + "/destinations/indonesia-cruise/dual-destinations"
        }]
      }, {
        title: "Cruise ships",
        children: [{
          label: "Aqua Mekong",
          href: marketingSiteUrl + "/cruise-ships/aqua-mekong"
        }, {
          label: "Aria Amazon",
          href: marketingSiteUrl + "/cruise-ships/aria-amazon"
        }, {
          label: "Aqua Nera",
          href: marketingSiteUrl + "/cruise-ships/aqua-nera"
        }, {
          label: "Aqua Blu",
          href: marketingSiteUrl + "/cruise-ships/aqua-blu"
        }, {
          label: "Aqua Mare",
          href: marketingSiteUrl + "/cruise-ships/aqua-mare"
        }, {
          label: "Private charters",
          href: marketingSiteUrl + "/private-charter-cruises"
        }]
      }, {
        title: "Offers & Events",
        children: [
        // {
        //   label: '20% Indonesia Summer Special',
        //   href: `${marketingSiteUrl}/events/indonesia-summar-special`,
        // },
        {
          label: "20-30% Early Bird Bonus",
          href: marketingSiteUrl + "/offers/early-bird-bonus"
        }, {
          label: "25% Local Resident Offer",
          href: marketingSiteUrl + "/offers/local-resident"
        }, {
          label: "Solo Traveler Special",
          href: marketingSiteUrl + "/offers/solo-traveler-special"
        }, {
          label: "Aqua Blu - Chef Benjamin Cross",
          href: marketingSiteUrl + "/offers/chef-hosted-cruise-benjamin-cross"
        }, {
          label: "Aqua Nera - Chef Pedro Miguel Schiaffino",
          href: marketingSiteUrl + "/offers/chef-hosted-cruises-pedro-miguel-schiaffino"
        }]
      }, {
        title: "Company",
        children: [{
          label: "Our Experience",
          href: marketingSiteUrl + "/aqua-experience"
        }, { label: "Blog", href: marketingSiteUrl + "/blog" }, { label: "Brochure", href: marketingSiteUrl + "/brochures" }, { label: "Contact Us", href: marketingSiteUrl + "/contact-us" }, { label: "Career", href: marketingSiteUrl + "/careers" }]
      }],
      marketingSiteUrl: marketingSiteUrl
    };
  }
});

/***/ }),
/* 171 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/FooterSocialMedia.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "FooterSocialMedia",
  props: {
    title: {
      type: String,
      default: "Follow us on social media"
    },
    instagramUrl: {
      type: String
    },
    twitterUrl: {
      type: String
    },
    facebookUrl: {
      type: String
    },
    pinterestUrl: {
      type: String
    }
  },
  data: function data() {
    return {
      instagramIcon: __webpack_require__(/*! ../../assets/images/social-media/instagram.svg */ 346),
      twitterIcon: __webpack_require__(/*! ../../assets/images/social-media/twitter.svg */ 347),
      facebookIcon: __webpack_require__(/*! ../../assets/images/social-media/facebook.svg */ 348)
    };
  }
});

/***/ }),
/* 172 */
/*!****************************!*\
  !*** ./src/api/booking.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);


var bookingAPI = {
  searchBooking: function searchBooking(bookingCode, lastName) {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].get("/booking/search", {
      params: {
        bookingCode: bookingCode,
        lastName: lastName
      }
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      console.log("[/booking/search] error:", error);

      var message = "[CB1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

      if (error.response && error.response.data) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log("data:", error.response.data);
        console.log("status:", error.response.status);
        // console.log(error.response.headers)

        if (error.response.status !== 500) {
          message = error.response.data.message || error.response.data.error;
        }

        throw Object.assign({}, error, {
          message: message
        });
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
        // http.ClientRequest in node.js
        console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log("Error", error.message);
      }
      console.log(error.config);
      throw error;
    });
  },
  updateBooking: function updateBooking(booking) {
    console.log("[API updateBooking] booking:", booking);

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].patch("/booking/" + booking.bookingID, {
      booking: booking
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CB2] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  updateCabinConfiguration: function updateCabinConfiguration(cabinConfigurations) {
    console.log("[API updateCabinConfiguration] cabinConfigurations:", cabinConfigurations);

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/cabin-configuration", { cabinConfigurations: cabinConfigurations }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CB3] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  confirmBooking: function confirmBooking(booking) {
    console.log("[API confirmBooking] booking:", booking);

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].post("/booking/confirm", { booking: booking }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CB4] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  sendCruiseTicketEmail: function sendCruiseTicketEmail(cabinConfigurations, email, name) {
    console.log("[API sendCruiseTicketEmail] cabinConfigurations, email, name:", cabinConfigurations, email, name);

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].post("/booking/email-ticket", {
      cabinConfigurations: cabinConfigurations,
      email: email,
      name: name
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CB5] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (bookingAPI);

/***/ }),
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LoginPage.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_http_common__ = __webpack_require__(/*! ../api/http-common */ 20);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Useful reference:
// https://vuex.vuejs.org/en/forms.html
// https://forum.vuejs.org/t/error-form-binding-with-vuex-do-not-mutate-vuex-store-state-outside-mutation-handlers/11941/8






/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    gtag("set", "page_path", "/login");
    gtag("event", "page_path", {
      path: "/login"
    });
  },
  mounted: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
      var params, token, result, bookingCode, lastName;
      return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              params = new URLSearchParams(window.location.search);
              token = params.get("token");

              if (!token) {
                _context.next = 7;
                break;
              }

              _context.next = 5;
              return this.getBookingDetails(token);

            case 5:
              result = _context.sent;

              if (result) {
                bookingCode = result.bookingCode, lastName = result.lastName;

                if (bookingCode && lastName) {
                  this.formValidate.bookingCode = bookingCode;
                  this.formValidate.lastName = lastName;
                  this.handleSubmit("formValidate");
                }
              } else {
                console.log("Unable to get booking details from token " + token);
              }

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function mounted() {
      return _ref.apply(this, arguments);
    }

    return mounted;
  }(),
  data: function data() {
    return {
      formValidate: {
        bookingCode: "",
        lastName: ""
      },
      ruleValidate: {
        bookingCode: [{
          required: true,
          message: "Please enter your booking number",
          trigger: "change keyup"
        }],
        lastName: [{
          required: true,
          message: "Please enter your last / family name",
          trigger: "change keyup"
        }]
      }
    };
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.searchBooking]), {
    appendMarketingSiteUrl: function appendMarketingSiteUrl(path) {
      return "" + undefined + (path || "");
    },
    handleSubmit: function handleSubmit(name) {
      var _this = this;

      this.$refs[name].validate(function (valid) {
        if (valid) {
          var _formValidate = _this.formValidate,
              bookingCode = _formValidate.bookingCode,
              lastName = _formValidate.lastName;

          _this.searchBooking({ bookingCode: bookingCode, lastName: lastName }).then(function () {
            _this.$router.push("step-1");
          }).catch(function (error) {
            _this.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
          });
        }
      });
    },
    getBookingDetails: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(token) {
        var _ref3, data;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_4__api_http_common__["b" /* HTTPMarketing */].post("/api/v0/check-in/token/exchange", {
                  token: token
                });

              case 3:
                _ref3 = _context2.sent;
                data = _ref3.data;

                console.log("data", data);

                if (!data.success) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt("return", {
                  bookingCode: data.data.booking_code,
                  lastName: data.data.last_name
                });

              case 10:
                console.log("Unable to retrieve booking details from token, error:", data.message);
                return _context2.abrupt("return", {
                  bookingCode: "",
                  lastName: ""
                });

              case 12:
                _context2.next = 18;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2["catch"](0);

                console.log("Unable to retrieve booking details from token, error:", _context2.t0);
                this.error = _context2.t0.message;

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 14]]);
      }));

      function getBookingDetails(_x) {
        return _ref2.apply(this, arguments);
      }

      return getBookingDetails;
    }(),
    isSiteOnMaintenance: function isSiteOnMaintenance() {
      return __WEBPACK_IMPORTED_MODULE_4__api_http_common__["d" /* maintenance */];
    }
  })
});

/***/ }),
/* 179 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BookingSummaryPage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_6__mixins_autosave__["a" /* default */]],
  components: { AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__["a" /* default */] },
  mounted: function mounted() {
    this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
  },
  created: function created() {
    gtag("set", "page_path", "/step-1");
    gtag("event", "page_path", {
      path: "/step-1"
    });
    gtag("event", "vessel_type", {
      vessel: this.cabinConfigurations[0] ? this.cabinConfigurations[0].ship : ""
    });
  },
  data: function data() {
    var validateConfigs = function validateConfigs(rule, value, callback) {
      if (!value) {
        callback(new Error("Please specify the desired bed configuration for your stay."));
      } else {
        callback();
      }
    };

    var dynamicRules = {};
    var dynamicConfigs = {};

    var cabinConfigurations = this.$store.getters["cabinConfigurations"];
    cabinConfigurations.forEach(function (cabinConfig, index) {
      dynamicRules["cabinInput" + index] = {
        validator: validateConfigs,
        trigger: "blur"
      };
      dynamicConfigs["cabinInput" + index] = cabinConfig.cabinBedding;
    });

    return {
      selectBedConfigurationsForNonBalcony: __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* BED_CONFIGURATIONS_FOR_NON_BALCONY */],
      selectBedConfigurationsForBalcony: __WEBPACK_IMPORTED_MODULE_4__constants__["d" /* BED_CONFIGURATIONS_FOR_BALCONY */],
      selectBedConfigurationsForAquaLares: __WEBPACK_IMPORTED_MODULE_4__constants__["c" /* BED_CONFIGURATIONS_FOR_AQUA_LARES */],
      ruleForm: dynamicConfigs,
      rules: dynamicRules
      // formValidate: {
      //   bookingCode: '324137',
      //   contactName: 'Test Agency Lee',
      // },
      // ruleValidate: {
      //   'bookingCode': [
      //     { required: true, message: 'Please enter your booking number', trigger: 'change keyup' }
      //   ],
      //   'contactName': [
      //     { required: true, message: 'Please enter your last / family name', trigger: 'change keyup' },
      //   ],
      // }
    };
  },

  // computed: (() => (
  //   mapSetter(
  //     mapState('login', {
  //       bookingCode: state => state.bookingCode,
  //       contactName: state => state.contactName,
  //     }),
  //     {
  //       bookingCode: function(bookingCode) { this.setBookingCode({ bookingCode })},
  //       contactName: function(contactName) { this.setContactName({ contactName })}
  //     }
  //   )
  // ))(),
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.cabinConfigurations, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving]), {
    cruiseBannerUrl: function cruiseBannerUrl() {
      return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/cruise-banner/cruise-banner-" + this.booking.facilityCode + ".jpg.webp";
    },

    bookingSummary: function bookingSummary() {
      return [{
        iconClass: "icon-departure",
        label: "Departure date",
        value: this.booking.eventStartDateDisplay
      }, {
        iconClass: "icon-arrival",
        label: "Arrival date",
        value: this.booking.eventEndDateDisplay
      }, {
        iconClass: "icon-night",
        label: "Nights",
        value: this.booking.eventDurationNumberDays
      }, {
        iconClass: "icon-suite",
        label: "No. of suites",
        value: this.cabinConfigurations.length
      }, {
        iconClass: "icon-port",
        label: "Departure port",
        value: this.booking.departurePort
      }, {
        iconClass: "icon-port",
        label: "Arrival port",
        value: this.booking.arrivalPort
      }];
    }
  }),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateCabinConfigurationField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateCabinConfigurationRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    appendMarketingSiteUrl: function appendMarketingSiteUrl(path) {
      return "" + undefined + (path || "");
    },

    canShowBalconyType: function canShowBalconyType() {
      return !this.booking.isAmazonCruise && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare;
    },
    canShowInterconnectingCabin: function canShowInterconnectingCabin() {
      return this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare || this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu;
    },
    canShowDeck: function canShowDeck(deck) {
      return deck && deck !== "";
    },
    getCabinCategory: function getCabinCategory(cabinConfiguration) {
      if (this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare) {
        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AriaAmazon || this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMekong) {
          if (cabinConfiguration.category && cabinConfiguration.category === "TOURESCORT") {
            return "Tour Escort";
          }
        }

        return "";
      }
      if (cabinConfiguration.category) {
        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare) {
          if (cabinConfiguration.category === "CTGOS") {
            return "(" + cabinConfiguration.category.replace(/CTGOS/g, "Cat I") + ")";
          }
          return "(" + cabinConfiguration.category.replace(/CTG/g, "Cat ") + ")";
        }
        return "(" + cabinConfiguration.category.replace(/Category/g, "Cat") + ")";
      }
      return "";
    },
    getFixedCabinBedding: function getFixedCabinBedding(cabinConfiguration) {
      var cabinCategory = this.getCabinCategory(cabinConfiguration);
      var cabinNumber = cabinConfiguration.cabin;
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaBlu) {
        if (["202", "204"].indexOf(cabinNumber) >= 0) {
          return "Twin Bed";
        }

        switch (cabinCategory) {
          case "Cat I":
          case "(Cat I)":
          case "Category I":
            return "King Size Bed";
          case "Cat II":
          case "(Cat II)":
          case "Category II":
            return "King Size Bed";
          case "Cat III":
          case "(Cat III)":
          case "Category III":
            return "Twin Bed";
        }
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare) {
        switch (cabinCategory) {
          case "Cat I":
          case "(Cat I)":
          case "Category I":
            return "King Bed";
          case "Cat II":
          case "(Cat II)":
          case "Category II":
            return "King Bed";
          case "Cat III":
          case "(Cat III)":
          case "Category III":
            return "Double Bed";
          case "Cat IV":
          case "(Cat IV)":
          case "Category IV":
            switch (cabinNumber) {
              case "103":
                return "Twin Bed";
              case "104":
                return "Double Bed";
            }
          case "Cat V":
          case "(Cat V)":
          case "Category V":
            return "Double Bed";
        }
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaLares) {
        switch (cabinNumber) {
          case "303":
            return "King Size Bed + Sofa Bed";
          case "101":
          case "401":
          case "201":
            return "King Size Bed";
          case "203":
          case "204":
          case "205":
          case "206":
            return "Double Bed";
          case "102":
          case "202":
            return "Twin Bed";
          case "103":
            return "Twin Bed + Bunk Bed";
        }
      }
      return "King Bed";
    },
    getFixedCabinBeddingSize: function getFixedCabinBeddingSize(cabinConfiguration) {
      var cabinCategory = this.getCabinCategory(cabinConfiguration);
      var cabinNumber = cabinConfiguration.cabin;
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_4__constants__["u" /* FACILITY_CODES */].AquaMare) {
        switch (cabinCategory) {
          case "Cat I":
          case "(Cat I)":
          case "Category I":
            return "(200cm x 200cm)";
          case "Cat II":
          case "(Cat II)":
          case "Category II":
            return "(200cm x 200cm)";
          case "Cat III":
          case "(Cat III)":
          case "Category III":
            switch (cabinNumber) {
              case "101":
                return "(160cm x 200cm)";
              case "102":
                return "(170cm x 200cm)";
            }
          case "Cat IV":
          case "(Cat IV)":
          case "Category IV":
            switch (cabinNumber) {
              case "103":
                return "(100cm x 200cm)";
              case "104":
                return "(150cm x 200cm)";
            }
          case "Cat V":
          case "(Cat V)":
          case "Category V":
            return "(140cm x 190cm)";
        }
      }
      return "";
    },
    getGuestNameList: function getGuestNameList(cabinConfiguration) {
      return [cabinConfiguration.guest1Name, cabinConfiguration.guest2Name, cabinConfiguration.guest3Name, cabinConfiguration.guest4Name].filter(function (guestName) {
        return guestName;
      });
    },

    onCabinConfigurationInputChange: function onCabinConfigurationInputChange(cabinConfigurationID, fieldName, event, index) {
      console.log("[cabinConfigurationID, fieldName, event]", cabinConfigurationID, fieldName, event);

      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateCabinConfigurationField]({
        cabinConfigurationID: cabinConfigurationID,
        fieldName: fieldName,
        value: event
      });

      // Manually set form for dynamic validation
      this.ruleForm["cabinInput" + index] = event;
    },

    onClickSaveAndExit: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.saveDataToRemote(isAutosaving);

              case 3:
                res = _context.sent;

                if (!isAutosaving) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return", res);

              case 8:
                this.setIsVisibleDialogSaveAndExit(true);

              case 9:
                _context.next = 15;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](0);

                this.$message.error(_context.t0.message || __WEBPACK_IMPORTED_MODULE_4__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                return _context.abrupt("return", false);

              case 15:
                return _context.abrupt("return", true);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 11]]);
      }));

      function onClickSaveAndExit() {
        return _ref.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),


    onClickNext: function onClickNext() {
      var _this = this;

      this.saveDataToRemote().then(function () {
        _this.$router.push("step-2");
      }).catch(function (error) {
        _this.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_4__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    saveDataToRemote: function saveDataToRemote() {
      var _this2 = this;

      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var cabinConfigurations = this.cabinConfigurations;


      var emptyCabinConfigurations = cabinConfigurations.filter(function (cabinConfiguration) {
        return _this2.isBedConfigurable(cabinConfiguration) && !cabinConfiguration.cabinBedding;
      });

      if (emptyCabinConfigurations.length) {
        if (!isAutosave) {
          // run validate on each cabin configuration form
          this.$refs.ruleFormCabinConfig.forEach(function (form) {
            form.validate();
          });
        }
        return false;
      }

      // Update bed configurations for cabins without configurable beds
      cabinConfigurations.forEach(function (cabinConfiguration) {
        if (!_this2.isBedConfigurable(cabinConfiguration)) {
          _this2[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateCabinConfigurationField]({
            cabinConfigurationID: cabinConfiguration.cabinConfigurationID,
            fieldName: "cabinBedding",
            value: _this2.getFixedCabinBedding(cabinConfiguration)
          });
        }
      });

      return this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateCabinConfigurationRemote]({
        cabinConfigurations: cabinConfigurations,
        showLoader: !isAutosave
      });
    }
  })
});

/***/ }),
/* 180 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AutosaveIndicator.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(/*! ../utils */ 34);
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasPerformedAutosave: false
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.isSaving, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.lastSaveTime])),
  filters: {
    saveTimeFilter: function saveTimeFilter(date) {
      return "";
      if (date) {
        return "at " + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* padTime */])(date.getHours()) + ":" + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* padTime */])(date.getMinutes()) + ":" + Object(__WEBPACK_IMPORTED_MODULE_2__utils__["e" /* padTime */])(date.getSeconds());
      }
      return "";
    }
  },
  mounted: function mounted() {},

  watch: {
    isSaving: function isSaving(newValue, oldValue) {
      // console.log('Is saving value changed');
      this.hasPerformedAutosave = true;
    }
  }
});

/***/ }),
/* 181 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuestListingPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_http_common__ = __webpack_require__(/*! ../api/http-common */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(/*! ../utils */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png__ = __webpack_require__(/*! ../assets/images/icon-pdf.png */ 405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ProgressBar__ = __webpack_require__(/*! ./ProgressBar */ 182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PassportUploadPrompt_vue__ = __webpack_require__(/*! ./PassportUploadPrompt.vue */ 408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AeErrorWrapper_vue__ = __webpack_require__(/*! ./AeErrorWrapper.vue */ 185);


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















// Fields whose changes must run through Zoho/Resco once the user finishes typing
var WORKFLOW_TRIGGER_FIELDS = ["mainMailingCountry", "email", "firstName", "lastName", "phone", "dateOfBirth"];
var WORKFLOW_TRIGGER_AUTOSAVE_DELAY = 15000; // allow extra time for new value before the workflow fires
var WORKFLOW_TRIGGER_AUTOSAVE_GAP = 45000; // prevent another autosave while Zoho/Resco sync is still running

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_8__mixins_autosave__["a" /* default */]],
  components: {
    ProgressBar: __WEBPACK_IMPORTED_MODULE_9__ProgressBar__["a" /* default */],
    AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_10__AutosaveIndicator__["a" /* default */],
    PassportUploadPrompt: __WEBPACK_IMPORTED_MODULE_12__PassportUploadPrompt_vue__["a" /* default */],
    AeErrorWrapper: __WEBPACK_IMPORTED_MODULE_13__AeErrorWrapper_vue__["a" /* default */]
  },
  mounted: function mounted() {
    this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
  },
  created: function created() {
    this.getDietaryAllergiesData();
    gtag("set", "page_path", "/step-2");
    gtag("event", "page_path", {
      path: "/step-2"
    });
  },
  data: function data() {
    var _this = this;

    var contacts = this.$store.getters["contacts"];
    var booking = this.$store.getters["booking"];

    var validateReleaseOfLiability = function validateReleaseOfLiability(rule, value, callback) {
      if (value !== true) {
        callback(new Error("Please ensure that the release of liability checkbox is filled"));
      } else {
        callback();
      }
    };

    var validatePastGuest = function validatePastGuest(rule, value, callback) {
      if (Array.isArray(value) && value.length === 0 || !value) {
        callback(new Error("This field is required"));
      } else {
        callback();
      }
    };

    var validationConfig = function validationConfig(message, trigger) {
      return {
        required: true,
        message: message || "Required",
        trigger: trigger || "change blur"
      };
    };
    var ruleValidate = {
      title: [validationConfig()],
      firstName: [validationConfig("Please enter your first name.")],
      lastName: [validationConfig("Please enter your last/family name.")],
      dateOfBirth: [validationConfig("Please provide your date of birth")],
      email: [{
        type: "email",
        message: "Please input correct email address",
        trigger: ["blur", "change", "input"]
      }],
      mainMailingCountry: [validationConfig()],
      nationality: [validationConfig("Please enter your nationality.")],
      gender: [validationConfig("Please indicate your gender (e.g. Male, Female).")],
      passportNumber: [validationConfig("Please enter your passport number.")],
      passportIssuingCountry: [validationConfig("Please specify the country that issued your passport.")],
      nationalIdNumber: [validationConfig()],
      passportExpiryDate: [validationConfig("Please enter the date your passport will expire ")],
      emergencyContactFirstName: [validationConfig()],
      emergencyContactLastName: [validationConfig()],
      emergencyContactPhone: [validationConfig()],
      emergencyContactRelation: [validationConfig()],
      pastGuest: [{
        validator: validatePastGuest,
        trigger: "change blur"
      }],
      HasSignedReleaseOfLiability: [{
        validator: validateReleaseOfLiability,
        trigger: "change blur"
      }]
    };

    if (!booking.isAmazonCruise) {
      ruleValidate.passportIssueDate = [validationConfig()];
    }

    // Quick fix workaround to apply validation for passport field
    // TODO: Revamp validation approach for all steps.
    var validateModel = {
      passportImage: false,
      visaImage: false
    };

    var validateConfigs = {};
    contacts.forEach(function (contact) {
      validateConfigs[contact.contactID] = structuredClone(validateModel);
    });

    return {
      fileType: "picture",
      iconPdf: __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png___default.a,
      activeCollapseIndexes: this.index ? [this.index] : contacts.map(function (contact, index) {
        return index;
      }),
      uploadFileEndpoint: __WEBPACK_IMPORTED_MODULE_3__api_http_common__["a" /* HTTP */].defaults.baseURL + "/upload",
      uploadFileHeaders: {
        Authorization: this.$store.getters["accessToken"]
      },
      isVisibleDialogVisaRequirement: false,
      nextSaveRequiresWorkflowTrigger: false, // flags autosave to trigger Zoho workflow for specific field changes
      selectCountries: __WEBPACK_IMPORTED_MODULE_6__constants__["g" /* COUNTRIES */],
      selectStates: __WEBPACK_IMPORTED_MODULE_6__constants__["D" /* STATES */],
      selectGenders: __WEBPACK_IMPORTED_MODULE_6__constants__["x" /* GENDERS */],
      selectTitles: __WEBPACK_IMPORTED_MODULE_6__constants__["E" /* TITLES */],
      selectLastDestinations: __WEBPACK_IMPORTED_MODULE_6__constants__["y" /* LAST_DESTINATIONS */],
      selectEmergencyContactRelations: __WEBPACK_IMPORTED_MODULE_6__constants__["t" /* EMERGENCY_CONTACT_RELATIONS */],
      selectDateDays: __WEBPACK_IMPORTED_MODULE_6__constants__["h" /* DATE_DAYS */],
      selectDateMonths: __WEBPACK_IMPORTED_MODULE_6__constants__["j" /* DATE_MONTHS */],
      selectDateYears: __WEBPACK_IMPORTED_MODULE_6__constants__["l" /* DATE_YEARS */],
      selectDateExpiryYears: __WEBPACK_IMPORTED_MODULE_6__constants__["i" /* DATE_EXPIRY_YEARS */],
      selectDateShipStartYears: __WEBPACK_IMPORTED_MODULE_6__constants__["k" /* DATE_SHIP_START_YEARS */],
      ruleValidate: ruleValidate,
      validateConfigs: validateConfigs,
      saveContactLoadings: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = false;
        return accumulator;
      }, {}),
      modelDateOfBirthDays: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.dateOfBirth ? current.dateOfBirth.split("-")[2] : "";
        return accumulator;
      }, {}),
      modelDateOfBirthMonths: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.dateOfBirth ? current.dateOfBirth.split("-")[1] : "";
        return accumulator;
      }, {}),
      modelDateOfBirthYears: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.dateOfBirth ? current.dateOfBirth.split("-")[0] : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateDays: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportExpiryDate ? current.passportExpiryDate.split("-")[2] : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateMonths: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportExpiryDate ? current.passportExpiryDate.split("-")[1] : "";
        return accumulator;
      }, {}),
      modelPassportExpiryDateYears: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportExpiryDate ? current.passportExpiryDate.split("-")[0] : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateDays: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportIssueDate ? current.passportIssueDate.split("-")[2] : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateMonths: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportIssueDate ? current.passportIssueDate.split("-")[1] : "";
        return accumulator;
      }, {}),
      modelPassportIssueDateYears: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.passportIssueDate ? current.passportIssueDate.split("-")[0] : "";
        return accumulator;
      }, {}),
      modelPastTravelPeriodMonth: contacts.reduce(function (accumulator, current) {
        var fieldName = _this.getPastTravelPeriodField(current.pastGuest);
        accumulator[current.contactID] = current[fieldName] ? current[fieldName].split(" ")[0] : "";
        return accumulator;
      }, {}),
      modelPastTravelPeriodYear: contacts.reduce(function (accumulator, current) {
        var fieldName = _this.getPastTravelPeriodField(current.pastGuest);
        accumulator[current.contactID] = current[fieldName] ? current[fieldName].split(" ")[1] : "";
        return accumulator;
      }, {})
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contact, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.visaRequirements, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.visaRequirement, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.visaRequirementByContactID, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.passports, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.passport, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.passportByContactID, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.primaryContact, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.dietaryAllergies]), {
    getProgressedPercentage: function getProgressedPercentage() {
      return function (contact) {
        var mandatoryFields = this.getContactMandatoryFields();
        var completedFields = mandatoryFields.filter(function (field) {
          return contact[field];
        });
        var visaRequirement = this.visaRequirementByContactID(contact.contactID);
        var passport = this.passportByContactID(contact.contactID);

        var numMandatoryFields = mandatoryFields.length;
        var numCompletedFields = completedFields.length;

        if (contact.hasPastGuest) {
          numMandatoryFields++;
          numCompletedFields += contact.pastGuest ? 1 : 0;
        }

        if (visaRequirement && __WEBPACK_IMPORTED_MODULE_6__constants__["R" /* VISA_TYPE_REQUIRING_ATTACHMENTS */].indexOf(visaRequirement.visaType) >= 0) {
          numMandatoryFields++;

          if (visaRequirement._relativePath || visaRequirement.attachmentID && !visaRequirement._removeUploadedVisa) {
            numCompletedFields++;
          }
        }

        // Add passport image
        if (passport) {
          numMandatoryFields++;
          console.log("passport: ", passport);
          if (passport.file && passport.file.name.includes(".pdf")) {
            passport.file.url = __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png___default.a;
          }
          if (passport._relativePath || passport.attachmentID && passport._removeUploadedPassport) {
            numCompletedFields++;
          }
        }

        return Math.round(numCompletedFields / numMandatoryFields * 100);
      };
    },
    formElements: function formElements() {
      var forms = Object.keys(this.$refs).filter(function (key) {
        return key.startsWith("formValidate");
      });
      var results = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = forms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var formKey = _step.value;

          results.push(this.$refs[formKey][0]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    }
  }),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsAndVisaRequirementsRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.getDietaryAllergies]), {
    getDietaryAllergiesData: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.getDietaryAllergies();

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context["catch"](0);

                console.error("Unable to retrieve dietary allergies from API:", _context.t0);

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 5]]);
      }));

      function getDietaryAllergiesData() {
        return _ref.apply(this, arguments);
      }

      return getDietaryAllergiesData;
    }(),
    appendMarketingSiteUrl: function appendMarketingSiteUrl(path) {
      return "" + undefined + (path || "");
    },
    filterCountry: function filterCountry(option, country, query) {
      var index = country.toLowerCase().indexOf(query.toLowerCase());
      if (index === -1) {
        return false;
      }

      if (index === 0) {
        return true;
      }

      var prevChar = country.toLowerCase()[index - 1];
      return prevChar === " ";
    },
    resetFilterCountry: function resetFilterCountry(showHide) {
      this.selectCountries = __WEBPACK_IMPORTED_MODULE_6__constants__["g" /* COUNTRIES */];
    },
    canShowPeruvianNationalIDField: function canShowPeruvianNationalIDField(contact) {
      return this.booking.isAmazonCruise && contact.nationality === "PE - Peru" && contact.mainMailingCountry === "PE - Peru";
    },
    onInputDateChange: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(contactID, fieldName, event, contactFieldName) {
        var _this2 = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);

                value = "";
                _context2.t0 = contactFieldName;
                _context2.next = _context2.t0 === "dateOfBirth" ? 5 : _context2.t0 === "passportExpiryDate" ? 7 : _context2.t0 === "passportIssueDate" ? 9 : 11;
                break;

              case 5:
                value = this.modelDateOfBirthDays[contactID] && this.modelDateOfBirthMonths[contactID] && this.modelDateOfBirthYears[contactID] ? this.modelDateOfBirthYears[contactID] + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelDateOfBirthMonths[contactID]) + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelDateOfBirthDays[contactID]) : "";
                return _context2.abrupt("break", 13);

              case 7:
                value = this.modelPassportExpiryDateYears[contactID] && this.modelPassportExpiryDateMonths[contactID] && this.modelPassportExpiryDateDays[contactID] ? this.modelPassportExpiryDateYears[contactID] + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelPassportExpiryDateMonths[contactID]) + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelPassportExpiryDateDays[contactID]) : "";
                return _context2.abrupt("break", 13);

              case 9:
                value = this.modelPassportIssueDateYears[contactID] && this.modelPassportIssueDateMonths[contactID] && this.modelPassportIssueDateDays[contactID] ? this.modelPassportIssueDateYears[contactID] + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelPassportIssueDateMonths[contactID]) + "-" + Object(__WEBPACK_IMPORTED_MODULE_4__utils__["e" /* padTime */])(this.modelPassportIssueDateDays[contactID]) : "";
                return _context2.abrupt("break", 13);

              case 11:
                console.warn("Invalid contactFieldName:", contactFieldName);
                return _context2.abrupt("return");

              case 13:
                _context2.next = 15;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this2.isSaving;
                });

              case 15:
                if (contactFieldName === "dateOfBirth") {
                  this.nextSaveRequiresWorkflowTrigger = true; // birthdate adjustments should immediately flow to Zoho/Resco
                  this.autosaveIdleDelay = Math.max(this.autosaveIdleDelay, WORKFLOW_TRIGGER_AUTOSAVE_DELAY);
                  this.minAutosaveGap = Math.max(this.minAutosaveGap, WORKFLOW_TRIGGER_AUTOSAVE_GAP);
                  this.scheduleAutosave(this.autosaveIdleDelay); // extend autosave window for workflow-triggering fields
                }
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: contactFieldName,
                  value: value
                });

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onInputDateChange(_x, _x2, _x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return onInputDateChange;
    }(),
    onVisaRequirementInputChange: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(visaRequirementID, fieldName, event, contactID) {
        var _this3 = this;

        var visaRequirement;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("[visaRequirementID, fieldName, event, contactID]", visaRequirementID, fieldName, event, contactID);
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this3.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                  visaRequirementID: visaRequirementID,
                  fieldName: fieldName,
                  value: event
                });

                if (fieldName === "visaType") {
                  if (event === "Apply Onboard") {
                    // Set default payment status to 'Charge on board' if visaType is 'Apply Onboard' and payment status is empty
                    visaRequirement = this.visaRequirement(visaRequirementID);

                    if (visaRequirement && !visaRequirement.paymentStatus) {
                      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                        visaRequirementID: visaRequirementID,
                        fieldName: "paymentStatus",
                        value: "Charge on board"
                      });
                    }
                  } else {
                    // paymentStatus is not applicable if visaType is not 'Apply Onboard', so set it to empty here
                    this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                      visaRequirementID: visaRequirementID,
                      fieldName: "paymentStatus",
                      value: ""
                    });
                  }
                }

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onVisaRequirementInputChange(_x5, _x6, _x7, _x8) {
        return _ref3.apply(this, arguments);
      }

      return onVisaRequirementInputChange;
    }(),
    onInputPastTravelPeriodChange: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(contactID, fieldName, event) {
        var _this4 = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log("[contactID, fieldName, event]:", contactID, fieldName, event);
                _context4.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this4.isSaving;
                });

              case 3:
                value = [this.modelPastTravelPeriodMonth[contactID], this.modelPastTravelPeriodYear[contactID]].join(" ");

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onInputPastTravelPeriodChange(_x9, _x10, _x11) {
        return _ref4.apply(this, arguments);
      }

      return onInputPastTravelPeriodChange;
    }(),
    onEmergencyRelationFocus: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(contactID) {
        var select, dropdown;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                select = this.$refs["emergencyRelationSelect" + contactID][0];
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["b" /* delay */])(1);

              case 3:
                dropdown = select.$el.querySelector(".vs__dropdown-menu") || document.querySelector("body > .vs__dropdown-menu:not(.vs__fade-leave-active)");
                // console.log('onEmergencyRelationFocus focused', select, dropdown);

                if (dropdown) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                Object(__WEBPACK_IMPORTED_MODULE_4__utils__["f" /* positionDropdown */])(select.$el, dropdown);
                dropdown.style.width = "inherit";

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onEmergencyRelationFocus(_x12) {
        return _ref5.apply(this, arguments);
      }

      return onEmergencyRelationFocus;
    }(),
    onInputChange: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6(contactID, fieldName, event) {
        var _this5 = this;

        var contact, emergencyContactFields, contactsToUpdate, residentialAddressFields, _contactsToUpdate;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);
                _context6.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this5.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: event
                });
                if (WORKFLOW_TRIGGER_FIELDS.indexOf(fieldName) > -1) {
                  this.nextSaveRequiresWorkflowTrigger = true; // ensure key personal details reach downstream systems immediately
                  this.autosaveIdleDelay = Math.max(this.autosaveIdleDelay, WORKFLOW_TRIGGER_AUTOSAVE_DELAY);
                  this.minAutosaveGap = Math.max(this.minAutosaveGap, WORKFLOW_TRIGGER_AUTOSAVE_GAP);
                  this.scheduleAutosave(this.autosaveIdleDelay); // push autosave window so user can finish editing before workflow fires
                }
                contact = this.contact(contactID);

                // If user selects 'No' for 'Have you traveled with us before',
                // need to reset the value for pastGuest, pastTravelPeriodForAmazon and pastTravelPeriodForMekong

                if (fieldName === "hasPastGuest" && !event) {
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "pastGuest",
                    value: ""
                  });
                  // Reset each pastTravelPeriod[*] field for each destination
                  Object.keys(__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod).forEach(function (destination) {
                    _this5[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                      contactID: contactID,
                      fieldName: __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod[destination],
                      value: ""
                    });
                  });
                  this.modelPastTravelPeriodMonth[contactID] = "";
                  this.modelPastTravelPeriodYear[contactID] = "";
                }

                // If user changes 'pastGuest' (e.g. from 'Amazon' to 'Mekong' or vice versa)
                // clear the value for all past travel period fields (pastTravelPeriodForMekong and pastTravelPeriodForAmazon)
                else if (fieldName === "pastGuest") {
                    // Reset each pastTravelPeriod[*] field for each destination
                    Object.keys(__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod).forEach(function (destination) {
                      _this5[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contactID,
                        fieldName: __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].fields.pastTravelPeriod[destination],
                        value: ""
                      });
                    });
                    this.modelPastTravelPeriodMonth[contactID] = "";
                    this.modelPastTravelPeriodYear[contactID] = "";
                  }

                // Handle remove "Same as Guest 1" check for emergency contact fields
                // If the emergency contact field of primary contact is changed, uncheck hasSameEmergencyContact for all other contacts.
                // If the emergency contact field of non-primary contact is changed, uncheck hasSameEmergencyContact for the particular contact.
                emergencyContactFields = ["emergencyContactFirstName", "emergencyContactMiddleName", "emergencyContactLastName", "emergencyContactPhone", "emergencyContactRelation", "emergencyContactEmail"];


                if (emergencyContactFields.indexOf(fieldName) > -1) {
                  if (contact.isPrimaryContact) {
                    contactsToUpdate = this.contacts.filter(function (contact) {
                      return !contact.isPrimaryContact && contact.hasSameEmergencyContact;
                    });

                    contactsToUpdate.forEach(function (contact) {
                      _this5[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSameEmergencyContact",
                        value: false
                      });
                    });
                  } else {
                    if (contact.hasSameEmergencyContact) {
                      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSameEmergencyContact",
                        value: false
                      });
                    }
                  }
                }

                // Handle remove "Same as Guest 1" check for residential address fields
                // If the residential address field of primary contact is changed, uncheck hasSameResidentialAddress for all other contacts.
                // If the residential address field of non-primary contact is changed, uncheck hasSameResidentialAddress for the particular contact.
                residentialAddressFields = ["mainMailingStreet", "mainMailingCountry", "mainMailingCity", "mainMailingState", "mainMailingZip"];


                if (residentialAddressFields.indexOf(fieldName) > -1) {
                  if (contact.isPrimaryContact) {
                    _contactsToUpdate = this.contacts.filter(function (contact) {
                      return !contact.isPrimaryContact && contact.hasSameResidentialAddress;
                    });

                    _contactsToUpdate.forEach(function (contact) {
                      _this5[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSameResidentialAddress",
                        value: false
                      });
                    });
                  } else {
                    if (contact.hasSameResidentialAddress) {
                      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSameResidentialAddress",
                        value: false
                      });
                    }
                  }
                }
                _context6.next = 13;
                return this.validateIndividualFields(contactID, fieldName);

              case 13:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onInputChange(_x13, _x14, _x15) {
        return _ref6.apply(this, arguments);
      }

      return onInputChange;
    }(),
    beforeUpload: function beforeUpload(file) {
      console.log("uploadfile: ", file);
      if (file.type && __WEBPACK_IMPORTED_MODULE_6__constants__["a" /* ACCEPTED_UPLOAD_MIMETYPES_PASSPORT */].indexOf(file.type) < 0) {
        this.$message.error("Please upload a jpg/png/pdf file!");
        return false;
      }
      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: true });
      this.fileType = file.type;
    },
    onUploadError: function onUploadError() {
      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: false });
    },
    onSuccessUploadVisa: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee7(response, file, fileList) {
        var _this6 = this;

        var bookingID, contactID, visaRequirementID, relativePath;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                // console.log("[onSuccessUploadVisa]:", response, file, fileList);
                bookingID = response.bookingID, contactID = response.contactID, visaRequirementID = response.visaRequirementID, relativePath = response.relativePath;
                // console.log("bookingID, contactID, visaRequirementID, relativePath:", bookingID, contactID, visaRequirementID, relativePath);
                // console.log("file:", file);

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: false });
                _context7.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this6.isSaving;
                });

              case 4:
                // uploadVisaUID is an identifier to inform server to update new visa
                // and to allow onRemoveUploadVisa to identify which visaRequirement
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                  visaRequirementID: visaRequirementID,
                  fieldName: "_uploadVisaUID",
                  value: file.uid
                });

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                  visaRequirementID: visaRequirementID,
                  fieldName: "_relativePath",
                  value: relativePath
                });

              case 6:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onSuccessUploadVisa(_x16, _x17, _x18) {
        return _ref7.apply(this, arguments);
      }

      return onSuccessUploadVisa;
    }(),
    onRemoveUploadVisa: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee8(file, fileList) {
        var _this7 = this;

        var visaRequirement, visaRequirementID;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                console.log("[onRemoveUploadVisa]:", file, fileList);
                _context8.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this7.isSaving;
                });

              case 3:
                visaRequirement = file.visaRequirementID ? // If the file is pre-populated from server, we can retrieve the visaRequirementID directly
                this.visaRequirement(file.visaRequirementID) : // If the file is uploaded by user, we can find the matching visaRequirement by file.uid
                this.visaRequirements.find(function (visaRequirement) {
                  return visaRequirement._uploadVisaUID === file.uid;
                });

                if (visaRequirement) {
                  _context8.next = 7;
                  break;
                }

                console.log("error: Cannot find visaRequirementID");
                return _context8.abrupt("return");

              case 7:
                visaRequirementID = visaRequirement.visaRequirementID;


                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                  visaRequirementID: visaRequirementID,
                  fieldName: "_uploadVisaUID",
                  value: undefined
                });

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                  visaRequirementID: visaRequirementID,
                  fieldName: "_relativePath",
                  value: undefined
                });

                // removeUploadedVisa is a flag to indicate server to remove existing visa
                // Set it to true if there is existing file on the server (ie. visaRequirement.file is truthy)
                if (visaRequirement.file) {
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                    visaRequirementID: visaRequirementID,
                    fieldName: "_removeUploadedVisa",
                    value: true
                  });

                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateVisaRequirementField]({
                    visaRequirementID: visaRequirementID,
                    fieldName: "file",
                    value: null
                  });
                }

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function onRemoveUploadVisa(_x19, _x20) {
        return _ref8.apply(this, arguments);
      }

      return onRemoveUploadVisa;
    }(),
    onSuccessUploadPassport: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee9(response, file, fileList) {
        var _this8 = this;

        var bookingID, contactID, passportID, relativePath;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                console.log("[onSuccessUploadPassport]:", response, file, fileList);
                if (this.fileType === "application/pdf") {
                  file.url = __WEBPACK_IMPORTED_MODULE_5__assets_images_icon_pdf_png___default.a;
                }
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: false });
                _context9.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this8.isSaving;
                });

              case 5:
                bookingID = response.bookingID, contactID = response.contactID, passportID = response.passportID, relativePath = response.relativePath;
                // return;
                // console.log("bookingID, contactID, passportID, relativePath:", bookingID, contactID, passportID, relativePath);
                // console.log("file:", file);

                // uploadPassportUID is an identifier to inform server to update new passport
                // and to allow onRemoveUploadPassport to identify which passport

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                  passportID: passportID,
                  fieldName: "_uploadPassportUID",
                  value: file.uid
                });

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                  passportID: passportID,
                  fieldName: "_relativePath",
                  value: relativePath
                });
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsSaving]({ isSaving: false });

              case 9:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function onSuccessUploadPassport(_x21, _x22, _x23) {
        return _ref9.apply(this, arguments);
      }

      return onSuccessUploadPassport;
    }(),
    onRemoveUploadPassport: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee10(file, fileList) {
        var _this9 = this;

        var passport, passportID;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                console.log("[onRemoveUploadPassport]:", file, fileList);
                _context10.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this9.isSaving;
                });

              case 3:
                passport = file.passportID ? // If the file is pre-populated from server, we can retrieve the passportID directly
                this.passport(file.passportID) : // If the file is uploaded by user, we can find the matching passport by file.uid
                this.passports.find(function (passport) {
                  return passport._uploadPassportUID === file.uid;
                });

                if (passport) {
                  _context10.next = 7;
                  break;
                }

                console.log("error: Cannot find passportID");
                return _context10.abrupt("return");

              case 7:
                passportID = passport.passportID;


                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                  passportID: passportID,
                  fieldName: "_uploadPassportUID",
                  value: undefined
                });

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                  passportID: passportID,
                  fieldName: "_relativePath",
                  value: undefined
                });

                // removeUploadedPassport is a flag to indicate server to remove existing passport
                // Set it to true if there is existing file on the server (ie. passport.file is truthy)
                if (passport.file) {
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                    passportID: passportID,
                    fieldName: "_removeUploadedPassport",
                    value: true
                  });

                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updatePassportField]({
                    passportID: passportID,
                    fieldName: "file",
                    value: null
                  });
                }

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function onRemoveUploadPassport(_x24, _x25) {
        return _ref10.apply(this, arguments);
      }

      return onRemoveUploadPassport;
    }(),


    onCheckHasSameResidentialAddress: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee11(contactID, fieldName, value) {
        var _this10 = this;

        var _primaryContact, mainMailingStreet, mainMailingCountry, mainMailingCity, mainMailingState, mainMailingZip;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                console.log("onCheckHasSameResidentialAddress [contactID, fieldName, value]", contactID, fieldName, value);
                _context11.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this10.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

                if (value) {
                  _primaryContact = this.primaryContact, mainMailingStreet = _primaryContact.mainMailingStreet, mainMailingCountry = _primaryContact.mainMailingCountry, mainMailingCity = _primaryContact.mainMailingCity, mainMailingState = _primaryContact.mainMailingState, mainMailingZip = _primaryContact.mainMailingZip;


                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "mainMailingStreet",
                    value: mainMailingStreet
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "mainMailingCountry",
                    value: mainMailingCountry
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "mainMailingCity",
                    value: mainMailingCity
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "mainMailingState",
                    value: mainMailingState
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "mainMailingZip",
                    value: mainMailingZip
                  });
                }

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onCheckHasSameResidentialAddress(_x26, _x27, _x28) {
        return _ref11.apply(this, arguments);
      }

      return onCheckHasSameResidentialAddress;
    }(),
    onCheckHasSameEmergencyContact: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee12(contactID, fieldName, value) {
        var _this11 = this;

        var _primaryContact2, emergencyContactFirstName, emergencyContactMiddleName, emergencyContactLastName, emergencyContactPhone, emergencyContactRelation, emergencyContactEmail;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                console.log("onCheckHasSameEmergencyContact [contactID, fieldName, value]", contactID, fieldName, value);
                _context12.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_4__utils__["g" /* waitUntil */])(function () {
                  return !_this11.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

                if (value) {
                  _primaryContact2 = this.primaryContact, emergencyContactFirstName = _primaryContact2.emergencyContactFirstName, emergencyContactMiddleName = _primaryContact2.emergencyContactMiddleName, emergencyContactLastName = _primaryContact2.emergencyContactLastName, emergencyContactPhone = _primaryContact2.emergencyContactPhone, emergencyContactRelation = _primaryContact2.emergencyContactRelation, emergencyContactEmail = _primaryContact2.emergencyContactEmail;


                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "emergencyContactFirstName",
                    value: emergencyContactFirstName
                  });
                  // this[types.actions.updateContactField]({ contactID, fieldName: 'emergencyContactMiddleName', value: emergencyContactMiddleName })
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "emergencyContactLastName",
                    value: emergencyContactLastName
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "emergencyContactPhone",
                    value: emergencyContactPhone
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "emergencyContactRelation",
                    value: emergencyContactRelation
                  });
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                    contactID: contactID,
                    fieldName: "emergencyContactEmail",
                    value: emergencyContactEmail
                  });
                }

              case 5:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function onCheckHasSameEmergencyContact(_x29, _x30, _x31) {
        return _ref12.apply(this, arguments);
      }

      return onCheckHasSameEmergencyContact;
    }(),
    isAquaBlu: function isAquaBlu() {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaBlu;
    },
    isAquaNeraOrAriaAmazon: function isAquaNeraOrAriaAmazon() {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaNera || this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AriaAmazon) {
        return true;
      }
      return false;
    },
    handleClickROL: function handleClickROL() {
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaBlu) {
        window.open("/AQB-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaMare) {
        window.open("/AQM-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaMekong) {
        window.open("/MAQ-releaseForm.pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AriaAmazon) {
        window.open("/AAR-releaseForm(English).pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaNera) {
        window.open("/AQN-releaseForm(English).pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaLares) {
        window.open("/AQL-releaseForm.pdf", "_blank");
      }
      return;
    },
    handleClickROLSpanish: function handleClickROLSpanish() {
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AquaNera) {
        window.open("/AQN-releaseForm(Spanish).pdf", "_blank");
      }
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_6__constants__["u" /* FACILITY_CODES */].AriaAmazon) {
        window.open("/AAR-releaseForm(Spanish).pdf", "_blank");
      }
      return;
    },

    // checkAllSignedROL: function(contacts){
    //   return (contacts.some(contact => contact.HasSignedReleaseOfLiability === false))
    // },

    // onClickSave(name, contact, index) {
    //   this.$refs[name][index].validate().catch(error => {
    //     console.log('validate error:', error)
    //   })
    //   this.saveContactLoadings[contact.contactID] = true
    //   this.updateContactsAndVisaRequirementsRemote({
    //     contacts: [contact],
    //     visaRequirements: [this.visaRequirementByContactID(contact.contactID)],
    //     showLoader: false,
    //   })
    //     .then(res => {
    //       this.$notify({
    //         title: 'Updated successfully!',
    //         type: 'success',
    //         // desc: nodesc ? '' : 'Here is the notification description. Here is the notification description. '
    //       });
    //     })
    //     .catch(error => {
    //       this.$notify.error({
    //         title: `${error}`,
    //         type: 'error',
    //       });
    //     })
    //     .finally(() => {
    //       this.saveContactLoadings[contact.contactID] = false
    //     })
    // },
    onClickSaveAndExit: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee13() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var self, res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                self = this;
                // Workaround to unknown issue where form.validate doesn't detect invalid form items in production build for some reason.

                if (!(document.querySelectorAll(".is-error").length === 0)) {
                  _context13.next = 20;
                  break;
                }

                _context13.prev = 2;
                _context13.next = 5;
                return self.saveDataToRemote(isAutosaving);

              case 5:
                res = _context13.sent;

                if (!isAutosaving) {
                  _context13.next = 10;
                  break;
                }

                return _context13.abrupt("return", res);

              case 10:
                self.setIsVisibleDialogSaveAndExit(true);

              case 11:
                _context13.next = 17;
                break;

              case 13:
                _context13.prev = 13;
                _context13.t0 = _context13["catch"](2);

                self.$message({
                  message: _context13.t0.message || __WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */],
                  type: "error",
                  duration: 5000
                });
                // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
                return _context13.abrupt("return", false);

              case 17:
                return _context13.abrupt("return", true);

              case 20:
                console.log("Invalid field found in form(s)");
                return _context13.abrupt("return", false);

              case 22:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[2, 13]]);
      }));

      function onClickSaveAndExit() {
        return _ref13.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),
    scrollToFirstError: function scrollToFirstError() {
      var _this12 = this;

      this.$nextTick(function () {
        // Quick fix workaround to apply error anchoring for passport field
        // TODO: Revamp error anchoring approach for all steps.
        var errorWrapperFields = _this12.$refs["ae-error-wrapper-field"];

        var errorFields = [];
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = _this12.formElements[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var form = _step2.value;

            var fields = form.fields.filter(function (field) {
              return field.validateState === "error";
            });
            errorFields = errorFields.concat(fields);
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (errorWrapperFields.length > 0) {
          var errorWrapperFieldsWithErrors = errorWrapperFields.filter(function (errorWrapperFields) {
            return errorWrapperFields.$refs["isErrorElement"] !== undefined;
          });

          if (errorWrapperFieldsWithErrors === undefined) {
            return; // Return when no errors found
          }

          if (errorFields.length > 0) {
            errorWrapperFieldsWithErrors = errorWrapperFieldsWithErrors.concat(errorFields);
          }

          var sortedByHighestErrorWrapperFieldsWithErrors = errorWrapperFieldsWithErrors.sort(function (a, b) {
            if (a === undefined || b === undefined) {
              return 0; // Silently throw error since no DOM element present
            }

            var domElementA = a.$el.getBoundingClientRect();
            var domElementB = b.$el.getBoundingClientRect();
            return domElementA.top - domElementB.top;
          });

          var topMostErrorField = sortedByHighestErrorWrapperFieldsWithErrors[0];
          if (topMostErrorField !== undefined) {
            topMostErrorField.$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }
      });
    },
    validateForm: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee14() {
        var hasErrors, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item, hasOtherErrors;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                hasErrors = false;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context14.prev = 4;
                _iterator3 = this.formElements[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context14.next = 20;
                  break;
                }

                item = _step3.value;
                _context14.prev = 8;
                _context14.next = 11;
                return item.validate(function (isValid) {
                  if (!isValid) {
                    hasErrors = true;
                  }
                });

              case 11:
                _context14.next = 17;
                break;

              case 13:
                _context14.prev = 13;
                _context14.t0 = _context14["catch"](8);

                // Catch validation errors if they occur
                console.log(item);
                hasErrors = true;

              case 17:
                _iteratorNormalCompletion3 = true;
                _context14.next = 6;
                break;

              case 20:
                _context14.next = 26;
                break;

              case 22:
                _context14.prev = 22;
                _context14.t1 = _context14["catch"](4);
                _didIteratorError3 = true;
                _iteratorError3 = _context14.t1;

              case 26:
                _context14.prev = 26;
                _context14.prev = 27;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 29:
                _context14.prev = 29;

                if (!_didIteratorError3) {
                  _context14.next = 32;
                  break;
                }

                throw _iteratorError3;

              case 32:
                return _context14.finish(29);

              case 33:
                return _context14.finish(26);

              case 34:
                hasOtherErrors = this.validateWorkAround();
                return _context14.abrupt("return", hasErrors || !hasOtherErrors);

              case 36:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[4, 22, 26, 34], [8, 13], [27,, 29, 33]]);
      }));

      function validateForm() {
        return _ref14.apply(this, arguments);
      }

      return validateForm;
    }(),
    validateIndividualFields: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee15(contactID, fieldName) {
        var forms, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, form, formElement;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return console.log("this.$refs.formValidate", this.$refs.formValidate);

              case 2:
                forms = Object.keys(this.$refs).filter(function (key) {
                  return key === "formValidate" + contactID;
                });
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context15.prev = 6;

                for (_iterator4 = forms[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  form = _step4.value;
                  formElement = this.$refs[form][0];

                  formElement.validateField(fieldName, function (response) {
                    console.log("Validated " + fieldName, response);
                  });
                }
                _context15.next = 14;
                break;

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](6);
                _didIteratorError4 = true;
                _iteratorError4 = _context15.t0;

              case 14:
                _context15.prev = 14;
                _context15.prev = 15;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 17:
                _context15.prev = 17;

                if (!_didIteratorError4) {
                  _context15.next = 20;
                  break;
                }

                throw _iteratorError4;

              case 20:
                return _context15.finish(17);

              case 21:
                return _context15.finish(14);

              case 22:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[6, 10, 14, 22], [15,, 17, 21]]);
      }));

      function validateIndividualFields(_x33, _x34) {
        return _ref15.apply(this, arguments);
      }

      return validateIndividualFields;
    }(),
    onClickNext: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee16() {
        var hasErrors, self;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.validateForm();

              case 2:
                hasErrors = _context16.sent;

                if (!hasErrors) {
                  _context16.next = 6;
                  break;
                }

                this.scrollToFirstError();
                return _context16.abrupt("return");

              case 6:
                self = this;

                // Workaround to unknown issue where form.validate doesn't detect invalid form items in production build for some reason.

                self.saveDataToRemote().then(function (res) {
                  self.$router.push("step-3");
                }).catch(function (error) {
                  self.$message({
                    message: error.message || __WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */],
                    type: "error",
                    duration: 5000
                  });
                  // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
                });
                // if (document.querySelectorAll('.is-error').length === 0) {
                //
                // } else {
                //   console.log('Invalid field found in form(s)');
                //   self.$message.error(`Please fill in the required fields.`);
                // }

                // Validates each guest forms and check to see if anything fails validation (specifically for email)
                // this.$refs['formValidate'].forEach(function (form, index, array){
                //   form.validate((valid) => {
                //     formsProcessed++;
                //     if (!valid) {
                //       formsValidated = false;
                //     }
                //     if(formsProcessed === array.length && formsValidated) {
                //       self.saveDataToRemote()
                //         .then(res => {
                //           self.$router.push('step-3')
                //         })
                //         .catch(error => {
                //           self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
                //         })
                //     }
                //   })
                // })

              case 8:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function onClickNext() {
        return _ref16.apply(this, arguments);
      }

      return onClickNext;
    }(),
    onClickBack: function onClickBack() {
      // let formsValidated = true;
      // let formsProcessed = 0;
      var self = this;

      if (document.querySelectorAll(".is-error").length === 0) {
        self.saveDataToRemote().then(function () {
          self.$router.back();
        }).catch(function (error) {
          self.$message({
            message: error.message || __WEBPACK_IMPORTED_MODULE_6__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */],
            type: "error",
            duration: 5000
          });
          // self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
        });
      } else {
        console.log("Invalid field found in form(s)");
      }

      // // Validates each guest forms and check to see if anything fails validation (specifically for email)
      // this.$refs['formValidate'].forEach(function (form, index, array){
      //   form.validate((valid) => {
      //     formsProcessed++;
      //     if (!valid) {
      //       formsValidated = false;
      //     }
      //     if(formsProcessed === array.length && formsValidated) {
      //       self.saveDataToRemote()
      //         .then(() => {
      //           self.$router.back()
      //         })
      //         .catch(error => {
      //           self.$message.error(error.message || UNHANDLED_ERROR_MESSAGE)
      //         })
      //     }
      //   })
      // })
    },
    saveDataToRemote: function saveDataToRemote() {
      var _this13 = this;

      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var contacts = this.contacts,
          visaRequirements = this.visaRequirements,
          passports = this.passports;


      var emptyContactIndices = contacts.map(function (contact, index) {
        var hasPassportNumber = !_this13.canShowPeruvianNationalIDField(contact);
        return !contact.firstName || !contact.lastName || !contact.passportNumber && hasPassportNumber ? index : null;
      }).filter(function (index) {
        return index !== null;
      });

      if (emptyContactIndices.length) {
        var guests = emptyContactIndices.map(function (index) {
          return "Guest " + (index + 1);
        });
        var guestsText = guests.length <= 1 ? guests[0] : guests.slice(0, -1).join(", ") + " and " + guests.slice(-1); /* convert [a,b,c] to 'a, b and c' */

        if (!isAutosave) {
          return Promise.reject({
            message: "Please fill in both first name, last name, passport number, and ensure that the release of liability checkbox is filled for " + guestsText + "."
          });
        }
        return false;
      }

      // Validate passport expiry dates so that they are after the event start date
      var invalidExpiryDateContactNames = contacts.filter(function (contact) {
        if (!contact.passportExpiryDate) {
          return false;
        }

        var _contact$passportExpi = contact.passportExpiryDate.split("-"),
            _contact$passportExpi2 = _slicedToArray(_contact$passportExpi, 3),
            year = _contact$passportExpi2[0],
            month = _contact$passportExpi2[1],
            date = _contact$passportExpi2[2];

        var expiryDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(date));
        var eventStartDate = new Date(_this13.booking.eventStartDate);

        // Passport expiry date is invalid if it is less than eventStartDate
        return expiryDate <= eventStartDate;
      }).map(function (contact) {
        return _this13.getFullName(contact);
      });

      if (invalidExpiryDateContactNames.length) {
        var _guestsText = invalidExpiryDateContactNames.length <= 1 ? invalidExpiryDateContactNames[0] : invalidExpiryDateContactNames.slice(0, -1).join(", ") + " and " + invalidExpiryDateContactNames.slice(-1); /* convert [a,b,c] to 'a, b and c' */
        return Promise.reject({
          message: "Passport Eligibility Error for " + _guestsText + ": Your passport(s) will expire within 6 months prior to the departure date. Kindly check in again with your updated passport details as soon as possible."
        });
      }

      // Validate passport issue date so that they are before current date
      if (!this.booking.isAmazonCruise) {
        var invalidIssueDateContactNames = contacts.filter(function (contact) {
          if (!contact.passportIssueDate) {
            return false;
          }

          var _contact$passportIssu = contact.passportIssueDate.split("-"),
              _contact$passportIssu2 = _slicedToArray(_contact$passportIssu, 3),
              year = _contact$passportIssu2[0],
              month = _contact$passportIssu2[1],
              date = _contact$passportIssu2[2];

          var passportIssueDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(date));

          // Passport issued date is invalid if it is after today
          return passportIssueDate > new Date();
        }).map(function (contact) {
          return _this13.getFullName(contact);
        });

        if (invalidIssueDateContactNames.length) {
          var _guestsText2 = invalidIssueDateContactNames.length <= 1 ? invalidIssueDateContactNames[0] : invalidIssueDateContactNames.slice(0, -1).join(", ") + " and " + invalidIssueDateContactNames.slice(-1); /* convert [a,b,c] to 'a, b and c' */
          return Promise.reject({
            message: "Passport issued date for " + _guestsText2 + " " + (invalidIssueDateContactNames.length <= 1 ? "is" : "are") + " invalid."
          });
        }
      }

      var shouldTriggerWorkflow = !isAutosave || this.nextSaveRequiresWorkflowTrigger; // fire workflow if user saved or flagged field changed
      var shouldResetOverride = this.nextSaveRequiresWorkflowTrigger && shouldTriggerWorkflow;

      return this.updateContactsAndVisaRequirementsRemote({
        contacts: contacts,
        visaRequirements: isAutosave ? [] : visaRequirements, // TODO Don't autosave fields with attachments until we find out why attachments are being uploaded repeatedly
        passports: isAutosave ? [] : passports,
        showLoader: !isAutosave,
        workflowTrigger: shouldTriggerWorkflow
      }).then(function (result) {
        if (shouldResetOverride) {
          _this13.nextSaveRequiresWorkflowTrigger = false;
          _this13.autosaveIdleDelay = _this13.defaultAutosaveIdleDelay;
          _this13.minAutosaveGap = _this13.defaultMinAutosaveGap;
        }
        return result;
      });
    },

    // Quick fix workaround to apply validation for passport field
    // TODO: Revamp validation approach for all steps.
    validateWorkAround: function validateWorkAround() {
      var _this14 = this;

      var isValid = true;
      var emptyFieldsFromValidation = this.getTotalProgressData().emptyFields;

      // Reset model
      this.resetForm();

      emptyFieldsFromValidation.forEach(function (emptyField) {
        if (emptyField.field === "passportImage") {
          _this14.validateConfigs[emptyField.contactID].passportImage = true;
          isValid = false;
        }

        if (emptyField.field === "visaImage") {
          _this14.validateConfigs[emptyField.contactID].visaImage = true;
          isValid = false;
        }
      });

      return isValid;
    },
    resetForm: function resetForm() {
      this.resetFields(this.validateConfigs);
    },
    resetFields: function resetFields(form) {
      var _this15 = this;

      var topLevelKeys = Object.keys(form);
      topLevelKeys.forEach(function (topLevelKey) {
        if (typeof form[topLevelKey] !== "boolean") {
          _this15.resetChildFields(form[topLevelKey]);
        } else {
          form[topLevelKey] = false;
        }
      });
    },
    resetChildFields: function resetChildFields(form) {
      this.resetFields(form);
    }
  })
});

/***/ }),
/* 182 */
/*!****************************************!*\
  !*** ./src/components/ProgressBar.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ProgressBar.vue */ 183);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2fa304_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1c2fa304","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ProgressBar.vue */ 407);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1c2fa304","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ProgressBar.vue */ 406)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c2fa304"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ProgressBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c2fa304_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProgressBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 183 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ProgressBar.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    percentage: Number,
    isMini: Boolean
  }
});

/***/ }),
/* 184 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PassportUploadPrompt.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "PassportUploadPrompt",
  data: function data() {
    return {
      showPassportImage: false
    };
  }
});

/***/ }),
/* 185 */
/*!*******************************************!*\
  !*** ./src/components/AeErrorWrapper.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AeErrorWrapper_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./AeErrorWrapper.vue */ 186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a057a74c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AeErrorWrapper_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-a057a74c","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./AeErrorWrapper.vue */ 413);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-a057a74c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AeErrorWrapper.vue */ 412)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a057a74c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_AeErrorWrapper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a057a74c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AeErrorWrapper_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 186 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AeErrorWrapper.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    errorMessage: {
      type: String,
      default: 'Error'
    },
    isError: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),
/* 187 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DietaryPreferenceAndSpecialRequestPage.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_booking__ = __webpack_require__(/*! ../mixins/booking */ 418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(/*! ../utils */ 34);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_booking__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__["a" /* default */]],
  components: { AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_8__AutosaveIndicator__["a" /* default */] },
  mounted: function mounted() {
    this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
  },
  created: function created() {
    var storeDietaryAllergies = this.dietaryAllergiesFromStore;
    if (!storeDietaryAllergies || storeDietaryAllergies.length === 0) {
      this.getDietaryAllergiesData();
    } else {
      this.dietaryAllergiesLoaded = true;
    }

    gtag("set", "page_path", "/step-3");
    gtag("event", "page_path", {
      path: "/step-3"
    });

    // Initialize oldDietaryAllergies with the initial values
    this.oldDietaryAllergies = JSON.parse(JSON.stringify(this.modelSelectedDietaryAllergies));
  },
  data: function data() {
    var contacts = this.$store.getters["contacts"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    // const modelSelectedDietaryPreferences = contacts.reduce(
    //     (accumulate, current) => {
    //       accumulate[current.contactID] = current.dietaryPreferences
    //           ? current.dietaryPreferences
    //           : [];
    //       return accumulate;
    //     },
    //     {},
    // );

    var modelSelectedDietaryAllergies = contacts.reduce(function (accumulate, current) {
      accumulate[current.contactID] = current.dietaryAllergies ? current.dietaryAllergies : [];
      return accumulate;
    }, {});

    var validationConfig = function validationConfig(message) {
      return {
        required: true,
        message: message || "Required",
        trigger: "change blur"
      };
    };
    var ruleValidate = {
      dietaryAllergies: [validationConfig()],
      // dietaryPreferences: [
      //   validationConfig(
      //     "Please select a Dietary Preference or None if not applicable.",
      //   ),
      // ],
      medicalNotes: [validationConfig('Please provide any relevant Medical and Health Notes or write "Not applicable" above.')]
    };

    return {
      activeCollapseIndexes: this.index ? [this.index] : contacts.map(function (contact, index) {
        return index;
      }),
      //selectDietaryPreferences: DIETARY_PREFERENCES,
      saveDietaryPreferenceLoadings: contacts.reduce(function (accumulator, current) {
        accumulator[current.contactID] = false;
        return accumulator;
      }, {}),
      //modelSelectedDietaryPreferences,
      modelSelectedDietaryAllergies: modelSelectedDietaryAllergies,
      ruleValidate: ruleValidate,
      dietaryAllergiesLoaded: false,
      isUpdating: false, // Flag to prevent re-entry into the watcher
      oldDietaryAllergies: {} // Global variable to store old values
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.dietaryAllergies]), {
    formElements: function formElements() {
      var forms = Object.keys(this.$refs).filter(function (key) {
        return key.startsWith('formValidate');
      });
      var results = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = forms[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var formKey = _step.value;

          results.push(this.$refs[formKey][0]);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return results;
    },
    dietaryAllergiesFromStore: function dietaryAllergiesFromStore() {
      return this.$store.getters["dietaryAllergies"];
    }
  }),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsAndBookingRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.getDietaryAllergies]), {
    getDietaryAllergiesData: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return this.getDietaryAllergies();

              case 3:
                this.dietaryAllergiesLoaded = true;
                this.dietaryAllergies = this.dietaryAllergiesFromStore;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log("Unable to retrieve dietary allergies from API:", _context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 7]]);
      }));

      function getDietaryAllergiesData() {
        return _ref.apply(this, arguments);
      }

      return getDietaryAllergiesData;
    }(),


    canShowDietaryPreferenceField: function canShowDietaryPreferenceField() {
      // Note: 12 July 2024 - Do not need to check for ship as we will
      // show the field in all ships to be consistent
      // As requested in the enhancements
      // return (
      //   !this.booking.isAmazonCruise &&
      //   this.booking.facilityCode !== FACILITY_CODES.AquaBlu
      // );
      return true;
    },
    handleDietaryAllergiesChange: function handleDietaryAllergiesChange(contactID, newSelections) {
      // Convert newSelections to an array of strings if it contains objects
      var newSelectionValues = newSelections.map(function (item) {
        return typeof item === 'string' ? item : item.value;
      });
      // Get old selections and convert to array of strings
      var oldSelections = this.oldDietaryAllergies[contactID] || [];
      var oldSelectionValues = oldSelections.map(function (item) {
        return typeof item === 'string' ? item : item.value;
      });

      // Determine the added value
      var addedValues = newSelectionValues.filter(function (val) {
        return !oldSelectionValues.includes(val);
      });
      var addedValue = addedValues.length > 0 ? addedValues[0] : null;
      //console.log(`[${contactID}] ADDED VALUE: `, addedValue);

      var updatedSelections = [];

      if (addedValue === 'None') {
        //console.log(`'None' added for contactID ${contactID}, retaining only 'None'.`);
        updatedSelections = ['None'];
      } else {
        updatedSelections = newSelectionValues.filter(function (val) {
          return val !== 'None';
        });
      }

      // Update old selections
      this.$set(this.oldDietaryAllergies, contactID, updatedSelections);
      this.$set(this.modelSelectedDietaryAllergies, contactID, updatedSelections);

      return updatedSelections;
    },


    onContactInputChange: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(contactID, fieldName, event) {
        var _this = this;

        var dietaryAllergiesValues, value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* waitUntil */])(function () {
                  return !_this.isSaving;
                });

              case 3:
                dietaryAllergiesValues = event || [];


                if (fieldName === "dietaryAllergies") {
                  dietaryAllergiesValues = this.handleDietaryAllergiesChange(contactID, dietaryAllergiesValues);
                }

                value = fieldName === "dietaryAllergies" ? dietaryAllergiesValues : event; // With Zoho API 2.0, we can send arrays directly

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

                _context2.next = 9;
                return this.validateIndividualFields(contactID, fieldName);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onContactInputChange(_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return onContactInputChange;
    }(),
    onBookingInputChange: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(fieldName, event) {
        var _this2 = this;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("[fieldName, event]", fieldName, event);
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_9__utils__["g" /* waitUntil */])(function () {
                  return !_this2.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField]({
                  fieldName: fieldName,
                  value: event
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onBookingInputChange(_x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return onBookingInputChange;
    }(),
    // onClickSave: function(contact) {
    //   this.saveDietaryPreferenceLoadings[contact.contactID] = true
    //   this.updateContactsRemote({ contacts: [contact], showLoader: false })
    //     .then(res => {
    //       this.$notify({
    //         title: 'Updated successfully!',
    //         type: 'success',
    //       });
    //     })
    //     .catch(error => {
    //       this.$notify.error(`${error}`);
    //     })
    //     .finally(() => {
    //       this.saveDietaryPreferenceLoadings[contact.contactID] = false
    //     })
    // },
    onClickSaveAndExit: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.saveDataToRemote(isAutosaving);

              case 3:
                res = _context4.sent;

                if (!isAutosaving) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", res);

              case 8:
                this.setIsVisibleDialogSaveAndExit(true);

              case 9:
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                this.$message.error(_context4.t0.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                return _context4.abrupt("return", false);

              case 15:
                return _context4.abrupt("return", true);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 11]]);
      }));

      function onClickSaveAndExit() {
        return _ref4.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),
    validateIndividualFields: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(contactID, fieldName) {
        var forms, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, form, formElement;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                forms = Object.keys(this.$refs).filter(function (key) {
                  return key === 'formValidate' + contactID;
                });
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context5.prev = 4;

                for (_iterator2 = forms[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  form = _step2.value;
                  formElement = this.$refs[form][0];

                  formElement.validateField(fieldName, function (response) {
                    console.log("Validated " + fieldName, response);
                  });
                }
                _context5.next = 12;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5["catch"](4);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 12:
                _context5.prev = 12;
                _context5.prev = 13;

                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }

              case 15:
                _context5.prev = 15;

                if (!_didIteratorError2) {
                  _context5.next = 18;
                  break;
                }

                throw _iteratorError2;

              case 18:
                return _context5.finish(15);

              case 19:
                return _context5.finish(12);

              case 20:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 8, 12, 20], [13,, 15, 19]]);
      }));

      function validateIndividualFields(_x7, _x8) {
        return _ref5.apply(this, arguments);
      }

      return validateIndividualFields;
    }(),
    validateForm: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var hasErrors, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, item;

        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                hasErrors = false;
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context6.prev = 4;
                _iterator3 = this.formElements[Symbol.iterator]();

              case 6:
                if (_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done) {
                  _context6.next = 19;
                  break;
                }

                item = _step3.value;
                _context6.prev = 8;
                _context6.next = 11;
                return item.validate();

              case 11:
                _context6.next = 16;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6["catch"](8);

                // Catch validation errors if they occur
                hasErrors = true;

              case 16:
                _iteratorNormalCompletion3 = true;
                _context6.next = 6;
                break;

              case 19:
                _context6.next = 25;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t1 = _context6["catch"](4);
                _didIteratorError3 = true;
                _iteratorError3 = _context6.t1;

              case 25:
                _context6.prev = 25;
                _context6.prev = 26;

                if (!_iteratorNormalCompletion3 && _iterator3.return) {
                  _iterator3.return();
                }

              case 28:
                _context6.prev = 28;

                if (!_didIteratorError3) {
                  _context6.next = 31;
                  break;
                }

                throw _iteratorError3;

              case 31:
                return _context6.finish(28);

              case 32:
                return _context6.finish(25);

              case 33:
                return _context6.abrupt("return", hasErrors);

              case 34:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 21, 25, 33], [8, 13], [26,, 28, 32]]);
      }));

      function validateForm() {
        return _ref6.apply(this, arguments);
      }

      return validateForm;
    }(),
    scrollToFirstError: function scrollToFirstError() {
      var _this3 = this;

      this.$nextTick(function () {
        var errorFields = [];
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = _this3.formElements[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var form = _step4.value;

            var fields = form.fields.filter(function (field) {
              return field.validateState === "error";
            });
            errorFields = errorFields.concat(fields);
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        if (errorFields.length > 0) {
          var firstErrorField = errorFields[0].$el;
          firstErrorField.scrollIntoView({ behavior: "smooth" });
          firstErrorField.querySelector("input").focus();
        }
      });
    },
    onClickNext: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var _this4 = this;

        var hasErrors;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.validateForm();

              case 2:
                hasErrors = _context7.sent;

                if (!hasErrors) {
                  _context7.next = 6;
                  break;
                }

                this.scrollToFirstError();
                return _context7.abrupt("return");

              case 6:

                this.saveDataToRemote().then(function (res) {
                  if (_this4.hasDiving()) {
                    _this4.$router.push("step-3b");
                  } else if (_this4.hasWetsuit()) {
                    _this4.$router.push("step-3c");
                  } else {
                    _this4.$router.push("step-4");
                  }
                }).catch(function (error) {
                  _this4.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                });

              case 7:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onClickNext() {
        return _ref7.apply(this, arguments);
      }

      return onClickNext;
    }(),

    onClickBack: function onClickBack() {
      var _this5 = this;

      this.saveDataToRemote().then(function (res) {
        _this5.$router.back();
      }).catch(function (error) {
        _this5.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    saveDataToRemote: function saveDataToRemote() {
      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var contacts = this.contacts,
          booking = this.booking;

      // // Update contacts with the latest dietary allergies selections
      // contacts.forEach(contact => {
      //   const contactID = contact.contactID;
      //   if (this.modelSelectedDietaryAllergies[contactID]) {
      //     contact.dietaryAllergies = this.modelSelectedDietaryAllergies[contactID];
      //   }
      // });

      var emptyContactIndices = contacts.map(function (contact, index) {
        return !contact.medicalNotes || contact.medicalNotes && contact.medicalNotes.trim().length === 0 ? index : null;
      }).filter(function (index) {
        return index !== null;
      });

      if (emptyContactIndices.length) {
        var guests = emptyContactIndices.map(function (index) {
          return "Guest " + (index + 1);
        });
        var guestsText = guests.length <= 1 ? guests[0] : guests.slice(0, -1).join(", ") + " and " + guests.slice(-1); /* convert [a,b,c] to 'a, b and c' */
        //console.log("[GUEST TEXT]", guestsText);

        if (!isAutosave) {
          console.log("PROMISE REJECTED");
          return Promise.reject({
            message: "Please select a Dietary Preference and provide Medical and Health Notes for " + guestsText + "."
          });
        }
        return false;
      }

      return this.updateContactsAndBookingRemote({
        contacts: contacts,
        booking: booking,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave // let autosave push data without firing Zoho workflows
      });
    }
  })
});

/***/ }),
/* 188 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DivingPage.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(/*! ../utils */ 34);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var DELIMITER = ";";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__["a" /* default */]],
  components: { AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__["a" /* default */] },
  mounted: function mounted() {
    this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
  },
  created: function created() {
    gtag("set", "page_path", "/step-3b");
    gtag("event", "page_path", {
      path: "/step-3b"
    });
  },
  data: function data() {
    var contacts = this.$store.getters["contacts"];
    var contactBookings = this.$store.getters["contactBookings"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    var validationConfig = {
      required: true,
      message: "Required",
      trigger: "change blur"
    };
    var ruleValidate = {};

    return {
      activeCollapseIndexes: this.index ? [this.index] : contacts.map(function (contact, index) {
        return index;
      }),
      wetSuitSizeDialogVisible: false,
      finSizeDialogVisible: false,
      selectDivingWetsuit: __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* DIVING_WETSUIT */],
      selectDivingFins: __WEBPACK_IMPORTED_MODULE_3__constants__["q" /* DIVING_FINS */],
      selectDivingMask: __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* DIVING_MASK */],
      selectDateMonths: __WEBPACK_IMPORTED_MODULE_3__constants__["j" /* DATE_MONTHS */],
      selectDateYears: __WEBPACK_IMPORTED_MODULE_3__constants__["l" /* DATE_YEARS */],
      selectDivingAssociation: __WEBPACK_IMPORTED_MODULE_3__constants__["o" /* DIVING_ASSOCIATIONS */],
      modelDateOfLastDiveMonths: contactBookings.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.dateOfLastDive ? current.dateOfLastDive.split("-")[1] : "";
        return accumulator;
      }, {}),
      modelDateOfLastDiveYears: contactBookings.reduce(function (accumulator, current) {
        accumulator[current.contactID] = current.dateOfLastDive ? current.dateOfLastDive.split("-")[0] : "";
        return accumulator;
      }, {}),
      selectDivingExperienceLevel: __WEBPACK_IMPORTED_MODULE_3__constants__["p" /* DIVING_EXPERIENCE_LEVEL */],
      adultWetSuitSizeData: __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ADULT_WETSUIT_SIZE_DATA */],
      childWetSuitSizeData: __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CHILD_WETSUIT_SIZE_DATA */],
      finSizeData: __WEBPACK_IMPORTED_MODULE_3__constants__["v" /* FIN_SIZE_DATA */],
      ruleValidate: ruleValidate
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contact, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contactBookings, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving])),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsAndBookingRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    getContactByContactId: function getContactByContactId(contactID) {
      return this.contact(contactID);
    },
    retrieveDivingAssociationValue: function retrieveDivingAssociationValue(contactBooking) {
      if (contactBooking.divingAssociation) {
        return contactBooking.divingAssociation;
      }
      this.onContactBookingInputChange(contactBooking.contactID, "divingAssociation", "PADI");
      return "PADI";
    },

    onContactInputChange: function onContactInputChange(contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      var value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
        contactID: contactID,
        fieldName: fieldName,
        value: value
      });
    },
    handleClickROL: function handleClickROL() {
      if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* FACILITY_CODES */].AquaLares) {
        window.open("/AQL-PADI-Release.pdf", "_blank");
        return;
      }
      window.open("/AQB-PADI-Release.pdf", "_blank");
    },
    checkAllSignedPADI: function checkAllSignedPADI(contactBookings) {
      var isDiving = contactBookings.filter(function (contact) {
        return contact.planningToDive;
      });
      return isDiving.some(function (contact) {
        return contact.HasSignedPADIReleaseOfLiability === false;
      });
    },

    onContactBookingInputChange: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(contactID, fieldName, event) {
        var _this = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);

                value = Array.isArray(event) ? event.join(DELIMITER) : event;
                // The user can still edit the field while an autosave is happening,
                // so we should wait until the saving has completed before updating the field again

                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this.isSaving;
                });

              case 4:
                if (fieldName === "divingAssociation" && event !== "Other") {
                  // Clear the Diving Association Other field
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                    contactID: contactID,
                    fieldName: "divingAssociationOther",
                    value: ""
                  });
                } else if (fieldName === "divingWetsuit" && event !== "Other") {
                  // Clear the Diving Wetsuit Other field
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                    contactID: contactID,
                    fieldName: "divingWetsuitOther",
                    value: ""
                  });
                } else if (fieldName === "divingFins" && event !== "Other") {
                  // Clear the Diving Fins Other field
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                    contactID: contactID,
                    fieldName: "divingFinsOther",
                    value: ""
                  });
                }

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onContactBookingInputChange(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return onContactBookingInputChange;
    }(),

    onBookingInputChange: function onBookingInputChange(fieldName, event) {
      console.log("[fieldName, event]", fieldName, event);

      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField]({
        fieldName: fieldName,
        value: event
      });
    },
    onInputDateChange: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(contactID, fieldName, event, contactBookingFieldName) {
        var _this2 = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);

                value = "";
                _context2.t0 = contactBookingFieldName;
                _context2.next = _context2.t0 === "dateOfLastDive" ? 5 : 7;
                break;

              case 5:
                value = this.modelDateOfLastDiveYears[contactID] && this.modelDateOfLastDiveMonths[contactID] ? this.modelDateOfLastDiveYears[contactID] + "-" + Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* padTime */])(this.modelDateOfLastDiveMonths[contactID]) + "-01" : "";
                return _context2.abrupt("break", 9);

              case 7:
                console.warn("Invalid contactBookingFieldName:", contactBookingFieldName);
                return _context2.abrupt("return");

              case 9:
                _context2.next = 11;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this2.isSaving;
                });

              case 11:
                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                  contactID: contactID,
                  fieldName: contactBookingFieldName,
                  value: value
                });

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onInputDateChange(_x4, _x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return onInputDateChange;
    }(),
    onDivingAssociationFocus: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(contactID) {
        var select, dropdown;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                select = this.$refs["divingAssociationSelect" + contactID][0];
                _context3.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* delay */])(1);

              case 3:
                dropdown = select.$el.querySelector(".vs__dropdown-menu") || document.querySelector("body > .vs__dropdown-menu:not(.vs__fade-leave-active)");

                if (dropdown) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return");

              case 6:
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* positionDropdown */])(select.$el, dropdown);
                dropdown.style.width = "inherit";

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onDivingAssociationFocus(_x8) {
        return _ref3.apply(this, arguments);
      }

      return onDivingAssociationFocus;
    }(),
    onClickSaveAndExit: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return this.saveDataToRemote(isAutosaving);

              case 3:
                res = _context4.sent;

                if (!isAutosaving) {
                  _context4.next = 8;
                  break;
                }

                return _context4.abrupt("return", res);

              case 8:
                this.setIsVisibleDialogSaveAndExit(true);

              case 9:
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4["catch"](0);

                this.$message.error(_context4.t0.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                return _context4.abrupt("return", false);

              case 15:
                return _context4.abrupt("return", true);

              case 16:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 11]]);
      }));

      function onClickSaveAndExit() {
        return _ref4.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),

    onClickNext: function onClickNext() {
      var _this3 = this;

      this.saveDataToRemote().then(function (res) {
        _this3.$router.push("step-4");
      }).catch(function (error) {
        _this3.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    onClickBack: function onClickBack() {
      var _this4 = this;

      this.saveDataToRemote().then(function (res) {
        _this4.$router.back();
      }).catch(function (error) {
        _this4.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    saveDataToRemote: function saveDataToRemote() {
      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var contacts = this.contacts,
          booking = this.booking,
          contactBookings = this.contactBookings;

      return this.updateContactsAndBookingRemote({
        contacts: contacts,
        booking: booking,
        contactBookings: contactBookings,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave // autosave keeps data fresh without firing Zoho triggers
      });
    }
  })
});

/***/ }),
/* 189 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/WetsuitPage.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(/*! ../utils */ 34);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var DELIMITER = ";";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_5__mixins_autosave__["a" /* default */]],
  components: { AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__["a" /* default */] },
  mounted: function mounted() {
    this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
  },
  created: function created() {
    gtag("set", "page_path", "/step-3c");
    gtag("event", "page_path", {
      path: "/step-3c"
    });
  },
  data: function data() {
    var contacts = this.$store.getters["contacts"];
    var contactBookings = this.$store.getters["contactBookings"];

    // Creates a local model in order for Select multiple component to work
    // actual update state is done in onContactInputChange
    var validationConfig = {
      required: true,
      message: "Required",
      trigger: "change blur"
    };
    var ruleValidate = {};

    return {
      activeCollapseIndexes: this.index ? [this.index] : contacts.map(function (contact, index) {
        return index;
      }),
      wetSuitSizeDialogVisible: false,
      selectWetsuit: __WEBPACK_IMPORTED_MODULE_3__constants__["s" /* DIVING_WETSUIT */],
      adultWetSuitSizeData: __WEBPACK_IMPORTED_MODULE_3__constants__["b" /* ADULT_WETSUIT_SIZE_DATA */],
      childWetSuitSizeData: __WEBPACK_IMPORTED_MODULE_3__constants__["f" /* CHILD_WETSUIT_SIZE_DATA */],
      ruleValidate: ruleValidate
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contact, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.contactBookings, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].getters.isSaving])),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactsAndBookingRemote, __WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    getContactByContactId: function getContactByContactId(contactID) {
      return this.contact(contactID);
    },

    onContactInputChange: function onContactInputChange(contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      var value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactField]({
        contactID: contactID,
        fieldName: fieldName,
        value: value
      });
    },
    onContactBookingInputChange: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(contactID, fieldName, event) {
        var _this = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);

                value = Array.isArray(event) ? event.join(DELIMITER) : event;
                // The user can still edit the field while an autosave is happening,
                // so we should wait until the saving has completed before updating the field again

                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this.isSaving;
                });

              case 4:
                if (fieldName === "wetsuit" && event !== "Other") {
                  // Clear the Diving Wetsuit Other field
                  this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                    contactID: contactID,
                    fieldName: "wetsuitOther",
                    value: ""
                  });
                }

                this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateContactBookingField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onContactBookingInputChange(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return onContactBookingInputChange;
    }(),

    onBookingInputChange: function onBookingInputChange(fieldName, event) {
      console.log("[fieldName, event]", fieldName, event);

      this[__WEBPACK_IMPORTED_MODULE_2__store_types__["a" /* default */].actions.updateBookingField]({
        fieldName: fieldName,
        value: event
      });
    },
    //prevents dropdown from getting cut off
    onWetsuitFocus: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(contactID) {
        var select, dropdown;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                select = this.$refs["wetsuitSelect" + contactID][0];
                _context2.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* delay */])(1);

              case 3:
                dropdown = select.$el.querySelector(".vs__dropdown-menu") || document.querySelector("body > .vs__dropdown-menu:not(.vs__fade-leave-active)");

                if (dropdown) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt("return");

              case 6:
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* positionDropdown */])(select.$el, dropdown);
                dropdown.style.width = "inherit";

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onWetsuitFocus(_x4) {
        return _ref2.apply(this, arguments);
      }

      return onWetsuitFocus;
    }(),
    onClickSaveAndExit: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return this.saveDataToRemote(isAutosaving);

              case 3:
                res = _context3.sent;

                if (!isAutosaving) {
                  _context3.next = 8;
                  break;
                }

                return _context3.abrupt("return", res);

              case 8:
                this.setIsVisibleDialogSaveAndExit(true);

              case 9:
                _context3.next = 15;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3["catch"](0);

                this.$message.error(_context3.t0.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                return _context3.abrupt("return", false);

              case 15:
                return _context3.abrupt("return", true);

              case 16:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 11]]);
      }));

      function onClickSaveAndExit() {
        return _ref3.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),

    onClickNext: function onClickNext() {
      var _this2 = this;

      this.saveDataToRemote().then(function (res) {
        _this2.$router.push("step-4");
      }).catch(function (error) {
        _this2.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    onClickBack: function onClickBack() {
      var _this3 = this;

      this.saveDataToRemote().then(function (res) {
        _this3.$router.back();
      }).catch(function (error) {
        _this3.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    saveDataToRemote: function saveDataToRemote() {
      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var contacts = this.contacts,
          booking = this.booking,
          contactBookings = this.contactBookings;

      return this.updateContactsAndBookingRemote({
        contacts: contacts,
        booking: booking,
        contactBookings: contactBookings,
        showLoader: !isAutosave,
        workflowTrigger: !isAutosave // defer Zoho workflows until user explicitly saves
      });
    }
  })
});

/***/ }),
/* 190 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PrePostArrangementPage.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__ = __webpack_require__(/*! ./node_modules/babel-runtime/regenerator */ 29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(/*! ../utils */ 34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AeErrorWrapper_vue__ = __webpack_require__(/*! ./AeErrorWrapper.vue */ 185);


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    index: Number
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_6__mixins_autosave__["a" /* default */]],
  components: { AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_7__AutosaveIndicator__["a" /* default */], AeErrorWrapper: __WEBPACK_IMPORTED_MODULE_9__AeErrorWrapper_vue__["a" /* default */] },
  mounted: function mounted() {
    // TODO Reenable autosave when repeated flightstats triggering issue is fixed 03/01/2020
    // this.initializeAutosave(this.onClickSaveAndExit.bind(this), this.$refs.formRoot);
    this.clearInvalidArrangementTypes();
  },
  created: function created() {
    gtag("set", "page_path", "/step-4");
    gtag("event", "page_path", {
      path: "/step-4"
    });
  },
  data: function data() {
    var contacts = this.$store.getters["contacts"];
    var booking = this.$store.getters["booking"];
    var contactBookings = this.$store.getters["contactBookings"];

    var formModel = {
      preArrangements: {
        takingRecommendedFlight: false,
        notTakingAFlight: false,
        zanzibarAirport: true,
        otherAirport: false,
        arrivalDate: false,
        arrivalTime: false,
        flightNumber: false,
        from: false,
        airline: false,
        galapagosRouteInfo: false,
        typeOfPreCruiseArrangement: false,
        localHandler: false,
        nameOfPerson: false,
        contactNo: false,
        dateOfEntryToPeru: false,
        entryToPeruFrom: false,
        arrivePriorToCruise: false,
        accommodationName: false,
        daysBefore: false,
        otherMode: false
      },
      postArrangements: {
        postArrangementAction: false,
        takingRecommendedFlight: false,
        referenceNumber: false,
        flightNumber: false,
        departureDate: false,
        departureTime: false,
        to: false,
        accommodationName: false,
        localHandler: false,
        nameOfPerson: false,
        contactNo: false,
        galapagosRouteInfo: false,
        typeOfPostCruiseArrangement: false,
        optOutSiemReapExtensionFlight: false
      },
      hasSamePrePostArrangement: false
    };
    var contactForms = {};
    contacts.forEach(function (contact) {
      contactForms[contact.contactID] = structuredClone(formModel);
    });

    return {
      activeCollapseIndexes: this.index ? [this.index] : contacts.map(function (contact, index) {
        return index;
      }),
      selectCountries: __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* COUNTRIES */],
      preCruiseAccommodation: "false",
      forms: contactForms
      // selectTypeOfArrangementsForPreCruise: booking.isFromPhnomPenh ? TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER : TYPE_OF_ARRANGEMENTS,
      // selectTypeOfArrangementsForPostCruise: TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER,
      // selectPostArrangementActions: booking.isAmazonCruise || booking.isToPhnomPenh ? POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER : POST_ARRANGEMENT_ACTIONS,
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.preArrangements, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.preArrangement, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.preArrangementByContactID, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.preArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.postArrangements, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.postArrangement, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.postArrangementByContactID, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.postArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.contact, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.contactBooking, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.contactBookings, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.primaryContact, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.isSaving]), {
    selectTypeOfRouteToGalapagos: function selectTypeOfRouteToGalapagos() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["P" /* TYPE_OF_ROUTE_TO_GALAPAGOS */];
    },
    selectTypeOfRouteFromGalapagos: function selectTypeOfRouteFromGalapagos() {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["O" /* TYPE_OF_ROUTE_FROM_GALAPAGOS */];
    },
    selectTypeOfArrangementsForPreCruise: function selectTypeOfArrangementsForPreCruise() {
      return function (contact) {
        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaMekong) {
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].PhnomPenh) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["G" /* TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY */];
          }
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].SiemReap) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["I" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY */];
          }
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].HoChiMinh) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["I" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY */];
          }
          return __WEBPACK_IMPORTED_MODULE_5__constants__["F" /* TYPE_OF_ARRANGEMENTS */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaBlu) {
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Bali) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["M" /* TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER */];
          }
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Komodo) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["H" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_TAXI */];
          }
          return __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaMare) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AriaAmazon) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaNera) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaLares) {
          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Seychelles) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Tanzania) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Longyearbyen) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["K" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Tromso) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.departurePort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Glasgow) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }
        }

        return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];

        // The following code allows shared transfer for aria amazon cruise only when user select recommended flight
        // if (!this.booking.isAmazonCruise) {
        //   return TYPE_OF_ARRANGEMENTS
        // }
        //
        // const preArrangementFlight = this.preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
        // return preArrangementFlight.takingRecommendedFlight ? TYPE_OF_ARRANGEMENTS : TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
      };
    },
    selectTypeOfArrangementsForPostCruise: function selectTypeOfArrangementsForPostCruise() {
      return function (contact) {
        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaMekong) {
          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].PhnomPenh) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI */];
          }
          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].SiemReap || this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].HoChiMinh) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["I" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY */];
          }
          return __WEBPACK_IMPORTED_MODULE_5__constants__["F" /* TYPE_OF_ARRANGEMENTS */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaBlu) {
          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Bali) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["G" /* TYPE_OF_ARRANGEMENTS_PRIVATE_AND_THIRD_PARTY */];
          }
          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Komodo) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["I" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_AND_THIRD_PARTY */];
          }
          return __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaMare) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["J" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_ONLY */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AriaAmazon) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaNera) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["N" /* TYPE_OF_ARRANGEMENTS_WITHOUT_TAXI */];
        }

        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaLares) {
          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Seychelles) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Tanzania) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Longyearbyen) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["K" /* TYPE_OF_ARRANGEMENTS_SHARED_TRANSFER_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Tromso) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          if (this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].Glasgow) {
            return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
          }

          return __WEBPACK_IMPORTED_MODULE_5__constants__["L" /* TYPE_OF_ARRANGEMENTS_THIRD_PARTY_AND_TAXI */];
        }

        return __WEBPACK_IMPORTED_MODULE_5__constants__["F" /* TYPE_OF_ARRANGEMENTS */];

        // The following code allows shared transfer for aria amazon cruise only when user select recommended flight
        // if (!this.booking.isAmazonCruise) {
        //   return TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
        // }
        //
        // const postArrangementFlight = this.postArrangementByContactIDAndCategory(contact.contactID, 'Flight')
        // return postArrangementFlight.takingRecommendedFlight ? TYPE_OF_ARRANGEMENTS : TYPE_OF_ARRANGEMENTS_WITHOUT_SHARED_TRANSFER
      };
    },
    selectPostArrangementActions: function selectPostArrangementActions() {
      return function () {
        if (this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaBlu || this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaLares || this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_5__constants__["u" /* FACILITY_CODES */].AquaMekong && this.booking.arrivalPort === __WEBPACK_IMPORTED_MODULE_5__constants__["A" /* PORTS */].PhnomPenh) {
          return __WEBPACK_IMPORTED_MODULE_5__constants__["C" /* POST_ARRANGEMENT_ACTIONS_WITHOUT_SHARED_TRANSFER */];
        }
        return __WEBPACK_IMPORTED_MODULE_5__constants__["B" /* POST_ARRANGEMENT_ACTIONS */];
      };
    }
  }),
  methods: Object.assign({
    isCurrentDateBefore: __WEBPACK_IMPORTED_MODULE_8__utils__["d" /* isCurrentDateBefore */]
  }, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePrePostArrangementsRemote, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactBookingField, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactsAndBookingRemote, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.copyPrePostArrangement, __WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    // Clears any saved typeOfArrangement values that are no longer in the available
    // options for this ship. This can happen when an option is removed from the
    // arrangement lists (e.g. private transfer removed for AquaLares) but existing
    // bookings still have the old value persisted in the DB. Without this, vue-select
    // would display the stale value on load even though it's not selectable.
    clearInvalidArrangementTypes: function clearInvalidArrangementTypes() {
      var _this = this;

      var validPreValues = this.selectTypeOfArrangementsForPreCruise.call(this, null).map(function (o) {
        return o.value;
      });
      var validPostValues = this.selectTypeOfArrangementsForPostCruise.call(this, null).map(function (o) {
        return o.value;
      });

      this.preArrangements.forEach(function (preArrangement) {
        if (preArrangement.typeOfArrangement && !validPreValues.includes(preArrangement.typeOfArrangement)) {
          _this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
            preArrangementID: preArrangement.preArrangementID,
            fieldName: "typeOfArrangement",
            value: null,
            triggerReset: true
          });
        }
      });

      this.postArrangements.forEach(function (postArrangement) {
        if (postArrangement.typeOfArrangement && !validPostValues.includes(postArrangement.typeOfArrangement)) {
          _this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
            postArrangementID: postArrangement.postArrangementID,
            fieldName: "typeOfArrangement",
            value: null,
            triggerReset: true
          });
        }
      });
    },
    getGalapagosFlightDestination: function getGalapagosFlightDestination(from) {
      return __WEBPACK_IMPORTED_MODULE_5__constants__["w" /* GALAPAGOS_FLIGHT_DESTINATION */][from];
    },
    formatTransferNote: function formatTransferNote(note) {
      if (!note) {
        return "";
      }

      var emails = ["reservations@aquaexpeditions.com"];
      var escapedNote = String(note).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\"/g, "&quot;").replace(/'/g, "&#39;");

      var formattedNote = escapedNote;
      emails.forEach(function (email) {
        formattedNote = formattedNote.split(email).join("<a href=\"mailto:" + email + "\" target=\"_blank\" rel=\"noopener noreferrer\">" + email + "</a>");
      });

      return formattedNote;
    },
    filterCountry: function filterCountry(option, country, query) {
      var index = country.toLowerCase().indexOf(query.toLowerCase());
      if (index === -1) {
        return false;
      }

      if (index === 0) {
        return true;
      }

      var prevChar = country.toLowerCase()[index - 1];
      return prevChar === " ";
    },
    resetFilterCountry: function resetFilterCountry(showHide) {
      this.selectCountries = __WEBPACK_IMPORTED_MODULE_5__constants__["g" /* COUNTRIES */];
    },
    isSiemReapExtensionBooking: function isSiemReapExtensionBooking() {
      return this.booking.isToPhnomPenh && this.booking.name.indexOf("(ext)") >= 0;
    },
    getContactBookingByContactId: function getContactBookingByContactId(contactID) {
      return this.contactBooking(contactID);
    },

    canShowDriverDetailsField: function canShowDriverDetailsField(contact) {
      return this.isPostArrangementDriverFieldMandatory(contact);
    },
    canShowPostArrangementFlightField: function canShowPostArrangementFlightField(contact) {
      return this.isPostArrangementFlightFieldMandatory(contact);
    },
    canShowPostArrangementAccommodationField: function canShowPostArrangementAccommodationField(contact) {
      return this.isPostArrangementAccommodationFieldMandatory(contact);
    },
    canShowPreArrangementAccommodationField: function canShowPreArrangementAccommodationField(contact) {
      return this.isPreArrangementAccommodationFieldMandatory(contact);
      // booking.isAmazonCruise
      // && preArrangementByContactIDAndCategory(contact.contactID, 'Flight')
      // && !preArrangementByContactIDAndCategory(contact.contactID, 'Flight').takingRecommendedFlight;
    },
    canShowDateOfEntryToPeruField: function canShowDateOfEntryToPeruField(contact) {
      return this.booking.isAmazonCruise && contact.mainMailingCountry !== "PE - Peru";
    },
    onCheckHasSamePlan: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee(contactID, primaryContactID, fieldName, value) {
        var _this2 = this;

        var preArrangements, postArrangements;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                console.log("onCheckHasSamePlan [contactID, fieldName, value]", contactID, fieldName, value);
                _context.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this2.isSaving;
                });

              case 3:
                this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

                if (value) {
                  preArrangements = this.preArrangementByContactID(contactID);
                  postArrangements = this.postArrangementByContactID(contactID);

                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.copyPrePostArrangement]({
                    preArrangements: preArrangements,
                    postArrangements: postArrangements
                  });

                  // TODO Remove this part after this issue has been fixed in vue-select: https://github.com/sagalbot/vue-select/pull/914
                  // Manually update the value in the target vue-selects since there is a bug that prevents the displayed value
                  // from being updated when :reduce is used in v-select.
                  // if (this.$refs[`preArrangementTypeSelect${primaryContactID}`] && this.$refs[`preArrangementTypeSelect${contactID}`]) {
                  //   const preArrangementTypeSourceSelect =  this.$refs[`preArrangementTypeSelect${primaryContactID}`][0];
                  //   const preArrangementTypeTargetSelect =  this.$refs[`preArrangementTypeSelect${contactID}`][0];
                  //   const option = preArrangementTypeSourceSelect.findOptionFromReducedValue(preArrangementTypeSourceSelect.value)
                  //   preArrangementTypeTargetSelect.updateValue(option || null)
                  // }
                  // if (this.$refs[`postArrangementActionSelect${primaryContactID}`] && this.$refs[`postArrangementActionSelect${contactID}`]) {
                  //   const postArrangementActionSourceSelect =  this.$refs[`postArrangementActionSelect${primaryContactID}`][0];
                  //   const preArrangementActionTargetSelect =  this.$refs[`postArrangementActionSelect${contactID}`][0];
                  //   const option = postArrangementActionSourceSelect.findOptionFromReducedValue(postArrangementActionSourceSelect.value)
                  //   preArrangementActionTargetSelect.updateValue(option || null)
                  // }
                  // if (this.$refs[`postArrangementTypeSelect${primaryContactID}`] && this.$refs[`postArrangementTypeSelect${contactID}`]) {
                  //   const postArrangementSourceSelect =  this.$refs[`postArrangementTypeSelect${primaryContactID}`][0];
                  //   const postArrangementTargetSelect =  this.$refs[`postArrangementTypeSelect${contactID}`][0];
                  //   const option = postArrangementSourceSelect.findOptionFromReducedValue(postArrangementSourceSelect.value)
                  //   postArrangementTargetSelect.updateValue(option || null)
                  // }
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onCheckHasSamePlan(_x, _x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return onCheckHasSamePlan;
    }(),
    onPreArrangementInputChange: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee2(preArrangementID, fieldName, value) {
        var _this3 = this;

        var preArrangement, previousValue, contact, contactsToUpdate;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                console.log("[preArrangementID, fieldName, value]", preArrangementID, fieldName, value);
                preArrangement = this.preArrangement(preArrangementID);
                previousValue = preArrangement ? preArrangement[fieldName] : null;
                _context2.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this3.isSaving;
                });

              case 5:
                this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                  preArrangementID: preArrangementID,
                  fieldName: fieldName,
                  value: value
                });

                if (fieldName === "takingRecommendedFlight") {
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                    preArrangementID: preArrangementID,
                    fieldName: "flightNumber",
                    value: value ? this.booking.recommendedFlight.outboundFlightCode : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                    preArrangementID: preArrangementID,
                    fieldName: "arrivalDate", // arrivalDate of the outbound flight which is the departureDate of the cruise
                    value: value ? this.booking.recommendedFlight.departureDate : "" // this departureDate refers to cruise's departureDate, which is start of the cruise trip
                    // recommendedFlight.departureDate refers to preArrangement's arrivalDate
                    // recommendedFlight.arrivalDate refers to postArrangement's arrivalDate
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                    preArrangementID: preArrangementID,
                    fieldName: "arrivalTime",
                    value: value ? this.booking.recommendedFlight.outboundFlightArrivalTime : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                    preArrangementID: preArrangementID,
                    fieldName: "from",
                    value: value ? this.booking.recommendedFlight.outboundFlightFrom : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePreArrangementField]({
                    preArrangementID: preArrangementID,
                    fieldName: "to",
                    value: value ? this.booking.recommendedFlight.outboundFlightTo : ""
                  });

                  // ******
                  // * This is no longer applicable as we allow shared transfer even if user unchecks recommended flight for AriaAmazon cruise.
                  // ******

                  // Special handling for the case where user selects shared transfer and then unchecks recommended flight
                  // as shared transfer is only available when taking recommended flight
                  // When user does this, unset the shared transfer selection.
                  // if (!value) {
                  //   const preArrangement = this.preArrangement(preArrangementID)
                  //   const contact = this.contact(preArrangement.contactID)
                  //   const preArrangementLocationToPort = this.preArrangementByContactIDAndCategory(contact.contactID, 'Location to port')
                  //
                  //   if (preArrangementLocationToPort && preArrangementLocationToPort.typeOfArrangement === 'AE Shared transfer') {
                  //     this[types.actions.updatePreArrangementField]({
                  //       preArrangementID: preArrangementLocationToPort.preArrangementID,
                  //       fieldName: 'typeOfArrangement',
                  //       value: '',
                  //     })
                  //   }
                  // }
                }

                // Compare previous and current value to prevent non-updates from clearing the same prepost arrangement value
                if (value !== previousValue) {
                  contact = this.contact(preArrangement.contactID);

                  if (contact.isPrimaryContact) {
                    if (fieldName !== "hasSamePrePostArrangement") {
                      contactsToUpdate = this.contacts.filter(function (contact) {
                        return !contact.isPrimaryContact && contact.hasSamePrePostArrangement;
                      });

                      contactsToUpdate.forEach(function (contact) {
                        _this3[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField]({
                          contactID: contact.contactID,
                          fieldName: "hasSamePrePostArrangement",
                          value: false
                        });
                      });
                    }
                  } else {
                    if (fieldName !== "hasSamePrePostArrangement" && contact.hasSamePrePostArrangement) {
                      this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSamePrePostArrangement",
                        value: false
                      });
                    }
                  }
                }

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onPreArrangementInputChange(_x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return onPreArrangementInputChange;
    }(),
    onContactBookingInputChange: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee3(contactID, fieldName, event) {
        var _this4 = this;

        var value;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("[contactID, fieldName, event]", contactID, fieldName, event);

                value = Array.isArray(event) ? event.join(DELIMITER) : event;
                // The user can still edit the field while an autosave is happening,
                // so we should wait until the saving has completed before updating the field again

                _context3.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this4.isSaving;
                });

              case 4:

                this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactBookingField]({
                  contactID: contactID,
                  fieldName: fieldName,
                  value: value
                });

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onContactBookingInputChange(_x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return onContactBookingInputChange;
    }(),
    onPostArrangementInputChange: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee4(postArrangementID, fieldName, value) {
        var _this5 = this;

        var postArrangement, previousValue, contact, contactsToUpdate;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log("onPostArrangementInputChange [postArrangementID, fieldName, value]", postArrangementID, fieldName, value);
                postArrangement = this.postArrangement(postArrangementID);
                previousValue = postArrangement ? postArrangement[fieldName] : null;
                _context4.next = 5;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["g" /* waitUntil */])(function () {
                  return !_this5.isSaving;
                });

              case 5:
                this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                  postArrangementID: postArrangementID,
                  fieldName: fieldName,
                  value: value,
                  triggerReset: true
                });

                if (fieldName === "takingRecommendedFlight") {
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                    postArrangementID: postArrangementID,
                    fieldName: "flightNumber",
                    value: value ? this.booking.recommendedFlight.returnFlightCode : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                    postArrangementID: postArrangementID,
                    fieldName: "departureDate", // departure date of the return flight which is the arrivalDate of the cruise
                    value: value ? this.booking.recommendedFlight.arrivalDate : "" // this arrivalDate refers to cruise's arrivalDate which is end of the cruise trip
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                    postArrangementID: postArrangementID,
                    fieldName: "departureTime",
                    value: value ? this.booking.recommendedFlight.returnFlightDepartureTime : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                    postArrangementID: postArrangementID,
                    fieldName: "from",
                    value: value ? this.booking.recommendedFlight.returnFlightFrom : ""
                  });
                  this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updatePostArrangementField]({
                    postArrangementID: postArrangementID,
                    fieldName: "to",
                    value: value ? this.booking.recommendedFlight.returnFlightTo : ""
                  });

                  // ******
                  // * This is no longer applicable as we allow shared transfer even if user unchecks recommended flight for AriaAmazon cruise.
                  // ******

                  // Special handling for the case where user selects shared transfer and then unchecks recommended flight
                  // as shared transfer is only available when taking recommended flight
                  // When user does this, unset the shared transfer selection.
                  // if (!value) {
                  //   const postArrangement = this.postArrangement(postArrangementID)
                  //   const contact = this.contact(postArrangement.contactID)
                  //   const postArrangementLocationToPort = this.postArrangementByContactIDAndCategory(contact.contactID, 'Port to location')
                  //
                  //   if (postArrangementLocationToPort && postArrangementLocationToPort.typeOfArrangement === 'AE Shared transfer') {
                  //     this[types.actions.updatePostArrangementField]({
                  //       postArrangementID: postArrangementLocationToPort.postArrangementID,
                  //       fieldName: 'typeOfArrangement',
                  //       value: '',
                  //     })
                  //   }
                  // }
                }

                // TODO Remove when vue-select bug is patched (see onCheckHasSamePlan)
                // if (fieldName === 'postArrangementAction') {
                //   // When post arrangement action is changed, the post arrangement type value might be reset.
                //   // We need the v-select to reflect this.
                //   const postArrangementTargetSelect =  this.$refs[`postArrangementTypeSelect${postArrangement.contactID}`][0];
                //   const option = postArrangementTargetSelect.findOptionFromReducedValue(postArrangement.typeOfArrangement)
                //   postArrangementTargetSelect.updateValue(option || null)
                // }

                contact = this.contact(postArrangement.contactID);
                // Compare previous and current value to prevent non-updates from clearing the same prepost arrangement value

                if (value !== previousValue) {
                  if (contact.isPrimaryContact) {
                    if (fieldName !== "hasSamePrePostArrangement") {
                      contactsToUpdate = this.contacts.filter(function (contact) {
                        return !contact.isPrimaryContact && contact.hasSamePrePostArrangement;
                      });

                      contactsToUpdate.forEach(function (contact) {
                        _this5[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField]({
                          contactID: contact.contactID,
                          fieldName: "hasSamePrePostArrangement",
                          value: false
                        });
                      });
                    }
                  } else {
                    if (fieldName !== "hasSamePrePostArrangement" && contact.hasSamePrePostArrangement) {
                      this[__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].actions.updateContactField]({
                        contactID: contact.contactID,
                        fieldName: "hasSamePrePostArrangement",
                        value: false
                      });
                    }
                  }
                }

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function onPostArrangementInputChange(_x11, _x12, _x13) {
        return _ref4.apply(this, arguments);
      }

      return onPostArrangementInputChange;
    }(),
    onPostArrangementTypeFocus: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee5(contactID) {
        var select, dropdown;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                select = this.$refs["postArrangementTypeSelect" + contactID][0];
                _context5.next = 3;
                return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* delay */])(1);

              case 3:
                dropdown = select.$el.querySelector(".vs__dropdown-menu") || document.querySelector("body > .vs__dropdown-menu:not(.vs__fade-leave-active)");

                if (dropdown) {
                  _context5.next = 6;
                  break;
                }

                return _context5.abrupt("return");

              case 6:
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* positionDropdown */])(select.$el, dropdown);
                dropdown.style.width = "inherit";

              case 8:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function onPostArrangementTypeFocus(_x14) {
        return _ref5.apply(this, arguments);
      }

      return onPostArrangementTypeFocus;
    }(),
    onClickSaveAndExit: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var isAutosaving = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var res;
        return __WEBPACK_IMPORTED_MODULE_0__home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                _context6.next = 3;
                return this.saveDataToRemote(isAutosaving);

              case 3:
                res = _context6.sent;

                if (!isAutosaving) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt("return", res);

              case 8:
                this.setIsVisibleDialogSaveAndExit(true);

              case 9:
                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6["catch"](0);

                this.$message.error(_context6.t0.message || __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
                return _context6.abrupt("return", false);

              case 15:
                return _context6.abrupt("return", true);

              case 16:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 11]]);
      }));

      function onClickSaveAndExit() {
        return _ref6.apply(this, arguments);
      }

      return onClickSaveAndExit;
    }(),

    onClickNext: function onClickNext() {
      var _this6 = this;

      this.saveDataToRemote().then(function (res) {
        _this6.$router.push("step-5");
      }).catch(function (error) {
        _this6.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    onClickBack: function onClickBack() {
      var _this7 = this;

      this.saveDataToRemote().then(function (res) {
        _this7.$router.back();
      }).catch(function (error) {
        _this7.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_5__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
      });
    },
    saveDataToRemote: function saveDataToRemote() {
      var _this8 = this;

      var isAutosave = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var prePostArrangements = [];
      var contactBookings = this.contactBookings;


      this.contacts.forEach(function (contact) {
        var preFlight = Object.assign({}, _this8.preArrangementByContactIDAndCategory(contact.contactID, "Flight"));
        var preAccommodation = Object.assign({}, _this8.preArrangementByContactIDAndCategory(contact.contactID, "Accommodation"));
        var preLocationToPort = Object.assign({}, _this8.preArrangementByContactIDAndCategory(contact.contactID, "Location to port"));

        if (preFlight.takingRecommendedFlight) {
          preFlight.from = _this8.booking.recommendedFlight && _this8.booking.recommendedFlight.outboundFlightFrom ? _this8.booking.recommendedFlight.outboundFlightFrom : "";
          preFlight.to = _this8.booking.recommendedFlight && _this8.booking.recommendedFlight.outboundFlightTo ? _this8.booking.recommendedFlight.outboundFlightTo : "";
          preLocationToPort.from = "Airport";
          preLocationToPort.to = "Port";
        }

        if (preLocationToPort.typeOfArrangement === "AE Shared transfer") {
          if (_this8.booking.isAmazonCruise) {
            preLocationToPort.from = "Airport";
            preLocationToPort.to = "Port";
          } else if (_this8.booking.isFromVietnamToCambodia) {
            preLocationToPort.from = "The Reverie Hotel";
            preLocationToPort.to = "Port";
          } else if (_this8.booking.isFromCambodiaToVietnam) {
            preLocationToPort.from = "Park Hyatt Siem Reap Hotel";
            preLocationToPort.to = "Port";
          }
        } else if (preLocationToPort.typeOfArrangement === "By 3rd party") {
          preLocationToPort.to = "Port";
        } else if (preAccommodation.accommodationName) {
          preLocationToPort.from = preAccommodation.accommodationName;
          preLocationToPort.to = "Port";
        }

        var postFlight = Object.assign({}, _this8.postArrangementByContactIDAndCategory(contact.contactID, "Flight"));
        var postAccommodation = Object.assign({}, _this8.postArrangementByContactIDAndCategory(contact.contactID, "Accommodation"));
        var postPortToLocation = Object.assign({}, _this8.postArrangementByContactIDAndCategory(contact.contactID, "Port to location"));

        if (postFlight.takingRecommendedFlight) {
          postFlight.from = _this8.booking.recommendedFlight && _this8.booking.recommendedFlight.returnFlightFrom ? _this8.booking.recommendedFlight.returnFlightFrom : "";
          postFlight.to = _this8.booking.recommendedFlight && _this8.booking.recommendedFlight.returnFlightTo ? _this8.booking.recommendedFlight.returnFlightTo : "";
        }

        if (postPortToLocation.postArrangementAction === "airport") {
          postPortToLocation.from = "Port";
          postPortToLocation.to = "Airport";
        } else if (postPortToLocation.postArrangementAction === "hotel") {
          postPortToLocation.from = "Port";
          postPortToLocation.to = "Accommodation";
        } else if (postPortToLocation.postArrangementAction === "sharedTransfer") {
          if (_this8.booking.isAmazonCruise) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "Airport";
          } else if (_this8.booking.isFromVietnamToCambodia) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "Park Hyatt Siem Reap Hotel";
          } else if (_this8.booking.isFromCambodiaToVietnam) {
            postPortToLocation.from = "Port";
            postPortToLocation.to = "The Reverie Hotel";
          }
        }

        prePostArrangements.push(preFlight, preAccommodation, preLocationToPort, postFlight, postAccommodation, postPortToLocation);
      });

      var valid = this.validateForm();
      if (!valid) {
        return Promise.reject({
          message: "Please fill up mandatory fields"
        });
      }

      // await this.updateContactsAndBookingRemote({contacts: [], booking: {isDirty: false}, contactBookings, showLoader: !isAutosave}); // We only want to update the contact booking
      return this.updatePrePostArrangementsRemote({
        prePostArrangements: prePostArrangements,
        showLoader: !isAutosave
      });
    },
    resetForm: function resetForm() {
      this.resetFields(this.forms);
    },
    resetFields: function resetFields(form) {
      var _this9 = this;

      var topLevelKeys = Object.keys(form);
      topLevelKeys.forEach(function (topLevelKey) {
        if (typeof form[topLevelKey] !== "boolean") {
          _this9.resetChildFields(form[topLevelKey]);
        } else {
          form[topLevelKey] = false;
        }
      });
    },
    resetChildFields: function resetChildFields(form) {
      this.resetFields(form);
    },
    validateForm: function validateForm() {
      var _this10 = this;

      var isValid = true;
      var emptyFieldsFromValidation = this.getTotalProgressData().emptyFields;
      this.resetForm();

      emptyFieldsFromValidation.forEach(function (emptyFields) {
        var fieldMap = {
          driverName: "nameOfPerson",
          contactNumber: "contactNo"
        };

        // Remove non step-4 fields
        if (emptyFields.preArrangementID === undefined && emptyFields.postArrangementID === undefined) {
          return;
        }

        // Clean the fields
        if (Object.keys(fieldMap).includes(emptyFields.field)) {
          emptyFields.field = fieldMap[emptyFields.field];
        }

        if (emptyFields.preArrangementID && _this10.forms[emptyFields.contactID].preArrangements[emptyFields.field] !== undefined) {
          _this10.forms[emptyFields.contactID].preArrangements[emptyFields.field] = true;
          isValid = false;
        } else if (emptyFields.postArrangementID && _this10.forms[emptyFields.contactID].postArrangements[emptyFields.field] !== undefined) {
          _this10.forms[emptyFields.contactID].postArrangements[emptyFields.field] = true;
          isValid = false;
        }
      });

      this.scrollToFirstError();

      return isValid;
    },
    scrollToFirstError: function scrollToFirstError() {
      var _this11 = this;

      // TODO: Might also need to consider unfolding contact collapsable sections if error exist in section
      this.$nextTick(function () {
        // TODO: Edge case not handled
        // Page will scroll to contact 2 empty arrivalTime pre field instead of contact 1 empty flightNumber post field
        var errorWrapperFields = _this11.$refs["ae-error-wrapper-field"];
        if (errorWrapperFields.length > 0) {
          var errorWrapperFieldsWithErrors = errorWrapperFields.filter(function (errorWrapperFields) {
            return errorWrapperFields.$refs["isErrorElement"] !== undefined;
          });

          if (errorWrapperFieldsWithErrors === undefined) {
            return; // Return when no errors found
          }

          var sortedByHighestErrorWrapperFieldsWithErrors = errorWrapperFieldsWithErrors.sort(function (a, b) {
            if (a === undefined || b === undefined) {
              return 0; // Silently throw error since no DOM element present
            }

            var domElementA = a.$el.getBoundingClientRect();
            var domElementB = b.$el.getBoundingClientRect();
            return domElementA.top - domElementB.top;
          });

          var topMostErrorField = sortedByHighestErrorWrapperFieldsWithErrors[0];
          if (topMostErrorField !== undefined) {
            topMostErrorField.$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }
        }
      });
    }
  })
});

/***/ }),
/* 191 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ConfirmationPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto__ = __webpack_require__(/*! vue-scrollto */ 435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_scrollto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContactSummary__ = __webpack_require__(/*! ./ContactSummary */ 436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_autosave__ = __webpack_require__(/*! ../mixins/autosave */ 45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AutosaveIndicator__ = __webpack_require__(/*! ./AutosaveIndicator */ 46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_startcase__ = __webpack_require__(/*! lodash.startcase */ 439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_startcase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_startcase__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var DELIMITER = ";";
var typeOfArrangementMap = __WEBPACK_IMPORTED_MODULE_3__constants__["F" /* TYPE_OF_ARRANGEMENTS */].reduce(function (accumulate, current) {
  accumulate[current.value] = current.label;
  return accumulate;
}, {});

/* harmony default export */ __webpack_exports__["a"] = ({
  components: { VueScrollTo: __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default.a, ContactSummary: __WEBPACK_IMPORTED_MODULE_5__ContactSummary__["a" /* default */], AutosaveIndicator: __WEBPACK_IMPORTED_MODULE_8__AutosaveIndicator__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_timeTrack__["a" /* timeTrack */], __WEBPACK_IMPORTED_MODULE_7__mixins_autosave__["a" /* default */]],
  created: function created() {
    gtag("set", "page_path", "/step-5");
    gtag("event", "page_path", {
      path: "/step-5"
    });
  },
  data: function data() {
    var _this = this;

    var contacts = this.$store.getters["contacts"];
    var booking = this.$store.getters["booking"];
    booking['termsChecked'] = false;
    //
    // // Creates a local model in order for Select multiple component to work
    // // actual update state is done in onContactInputChange
    // const modelSelectedDietaryPreferences = contacts.reduce((accumulate, current) => {
    //   accumulate[current.contactID] = current.dietaryPreferences ? current.dietaryPreferences.split(DELIMITER) : []
    //   return accumulate
    // }, {})
    //
    // const modelSelectedDietaryAllergies = contacts.reduce((accumulate, current) => {
    //   accumulate[current.contactID] = current.dietaryAllergies ? current.dietaryAllergies.split(DELIMITER) : []
    //   return accumulate
    // }, {})

    var validateTrueOnly = function validateTrueOnly(rule, value, callback) {
      if (_this.termsChecked !== 'true') {
        callback(new Error("Please ensure that the you have read and accepted the terms and conditions"));
      } else {
        callback();
      }
    };

    var validationConfig = function validationConfig() {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blur';

      return {
        required: true,
        message: message || "Required",
        trigger: trigger
      };
    };

    return {
      activeTabName: 0,
      activeContactID: contacts[0].contactID,
      typeOfArrangementMap: typeOfArrangementMap,
      ruleValidate: {
        checkedInConfirmedBy: [validationConfig()],
        termsChecked: [{
          validator: validateTrueOnly
        }]
      },
      // collapseIndex: '0',
      // selectDietaryPreferences: DIETARY_PREFERENCES,
      // selectDietaryAllergies: DIETARY_ALLERGIES,
      // modelSelectedDietaryPreferences,
      // modelSelectedDietaryAllergies,

      selectContainer: null,
      selectContainerOffsetTop: 0,
      isStickySelectContainer: false,

      isVisibleDialogError: false,
      contactNamesWithEmptyFields: [],
      defaultTreeProps: {
        children: "children",
        label: "label"
      },
      termsChecked: "false",
      booking: booking
    };
  },
  mounted: function mounted() {
    this.initializeAutosave(undefined, this.$refs.formRoot);
    if (this.contacts.length > 3) {
      this.selectContainer = document.querySelector(".select-container");
      this.selectContainerOffsetTop = this.selectContainer && this.selectContainer.offsetTop;
      window.addEventListener("scroll", this.handleScroll);
    }
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.cabinConfigurations, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contactBookings, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contactBooking, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contact, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.visaRequirements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.passports, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.preArrangements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.postArrangements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.visaRequirementByContactID, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.preArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.postArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.isSaving]), {
    cruiseBannerUrl: function cruiseBannerUrl() {
      return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/cruise-banner/cruise-banner-" + this.booking.facilityCode + ".jpg.webp";
    }
  }),
  filters: {
    formatDisplay: function formatDisplay(value) {
      return value || "-";
    },
    formatDisplayMandatory: function formatDisplayMandatory(value) {
      return value || "This is required.";
    },
    formatMultipleDisplay: function formatMultipleDisplay(value) {
      if (value) {
        return Array.isArray(value) ? value.join(", ") : value;
      }
      return "-";
    },
    formatKeyValue: function formatKeyValue(keyValue) {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1 ? keyValue.split(" - ")[1] : "-";
    },
    formatKeyValueMandatory: function formatKeyValueMandatory(keyValue) {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1 ? keyValue.split(" - ")[1] : "This is required.";
    },
    formatTypeOfArrangement: function formatTypeOfArrangement(value) {
      return typeOfArrangementMap[value] || "This is required.";
    }
  },
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.confirmBookingRemote, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.updateBookingField, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    onClickTab: function onClickTab(tab, event) {
      this.activeTabName = parseInt(tab.name);
      this.activeContactID = this.contacts[this.activeTabName].contactID;
    },
    onSelectContact: function onSelectContact(selectedContact) {
      var index = this.contacts.findIndex(function (contact) {
        return contact === selectedContact;
      });
      if (index < 0) {
        return;
      }
      console.log("onSelectContact index:", index);
      this.activeTabName = index;
      this.activeContactID = this.contacts[this.activeTabName].contactID;
    },
    onContactInputChange: function onContactInputChange(contactID, fieldName, event) {
      console.log("[contactID, fieldName, event]", contactID, fieldName, event);

      var value = Array.isArray(event) ? event.join(DELIMITER) : event;
      this[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.updateContactField]({
        contactID: contactID,
        fieldName: fieldName,
        value: value
      });
    },

    // onClickSave: function(contact) {
    //   this.updateContactRemote({ contact })
    //     .then(res => {
    //       this.$message.success(`Guest's details have been updated successfully!`);
    //     })
    //     .catch(error => {
    //       this.$message.error(`${error}`);
    //     })
    // },

    onClickNextGuest: function onClickNextGuest() {
      this.activeTabName++;
      __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default.a.scrollTo("#confirmation-summary", 500);
    },
    onCheckedConfirmedBy: function onCheckedConfirmedBy(checkedInConfirmedBy) {
      this[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.updateBookingField]({
        fieldName: "checkedInConfirmedBy",
        value: checkedInConfirmedBy
      });
    },
    checkGuestOrAgent: function checkGuestOrAgent(radioButton) {
      if (radioButton === "Agent") {
        return "<a href=\"https://www.aquaexpeditions.com/travel-professionals/agency-booking-policies/\" target=\"_blank\">terms and conditions (for agents)</a>";
      }
      return "<a href=\"https://www.aquaexpeditions.com/booking-policies/\" target=\"_blank\">terms and conditions</a>";
    },
    onClickNext: function onClickNext() {
      var _this2 = this;

      this.$refs.formValidate.validate().then(function () {
        console.log("this.getTotalProgressData():", _this2.getTotalProgressData());

        var totalProgressData = _this2.getTotalProgressData();
        if (totalProgressData.percentage !== 100) {
          _this2.contactNamesWithEmptyFields = totalProgressData.emptyFields.map(function (emptyField) {
            return emptyField.contactID;
          }).filter(function (a) {
            return a;
          }).filter(function (elem, index, arr) {
            return arr.indexOf(elem) === index;
          }).map(function (contactID) {
            // Collect all empty fields under their respective contacts
            var fields = totalProgressData.emptyFields.filter(function (emptyField) {
              return emptyField.contactID === contactID;
            }).map(function (emptyField) {
              return { label: __WEBPACK_IMPORTED_MODULE_9_lodash_startcase___default()(emptyField.field), children: [] };
            });
            return {
              label: _this2.getFullName(_this2.contact(contactID)),
              children: fields
            };
          });
          _this2.isVisibleDialogError = true;

          // this.contactNamesWithEmptyFields = contactNamesWithEmptyFields
          // const contactFullNamesDisplay = `${contactFullNamesWithEmptyField.slice(0, -1).join(', ')}${contactFullNamesWithEmptyField.length > 1 ? ' and ' : ''}${contactFullNamesWithEmptyField.slice(-1)}` /* convert [a,b,c] to 'a, b and c' */
          // this.$message.error(`Please note that one or more required fields for guest ${contactFullNamesDisplay} are missing. Please select the guest's name(s) to fill in all the required information.`)

          return;
        }

        var contacts = _this2.contacts,
            visaRequirements = _this2.visaRequirements,
            passports = _this2.passports,
            cabinConfigurations = _this2.cabinConfigurations,
            booking = _this2.booking,
            preArrangements = _this2.preArrangements,
            postArrangements = _this2.postArrangements;


        _this2[__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.confirmBookingRemote]({
          contacts: contacts,
          visaRequirements: visaRequirements,
          passports: passports,
          cabinConfigurations: cabinConfigurations,
          booking: booking,
          preArrangements: preArrangements,
          postArrangements: postArrangements
        }).then(function (res) {
          _this2.$router.push("completed");
        }).catch(function (error) {
          _this2.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_3__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
        });

        // return Promise.all([
        //   this[types.actions.updateCabinConfigurationRemote]({ cabinConfigurations }),
        //   this[types.actions.updateContactsAndVisaRequirementsRemote]({ contacts, visaRequirements }),
        //   this[types.actions.updatePrePostArrangementsRemote]({ prePostArrangements: preArrangements.concat(postArrangements) }),
        //   this[types.actions.updateBookingRemote]({ booking }),
        // ]).then((data) => {
        //   console.log("data:", data);
        //
        //   this[types.actions.confirmBookingRemote]({ booking })
        //     .then(res => {
        //       this.$router.push('completed')
        //     })
        //     .catch(error => {
        //       this.$message.error(`${error}`);
        //     })
        // })
      }).catch(function (error) {
        console.log("validate error:", error);
        __WEBPACK_IMPORTED_MODULE_4_vue_scrollto___default.a.scrollTo("#confirm-details-radio", 500);
        _this2.$message.error("Please confirm that the details are correct");
      });

      // const booking = this.booking
      // console.log("booking:", booking);
      // this.updateBookingRemote({ booking })
      //   .then(res => {
      // this.$message.success(`Booking's details have been updated successfully!`);
      // })
      // .catch(error => {
      //   this.$message.error(`${error}`);
      // })
    },
    onClickBack: function onClickBack() {
      this.$router.back();
    },
    handleScroll: function handleScroll() {
      this.isStickySelectContainer = window.pageYOffset > this.selectContainerOffsetTop;
    }
  }),
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  }
});

/***/ }),
/* 192 */
/*!*********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContactSummary.vue ***!
  \*********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_timeTrack__ = __webpack_require__(/*! ../mixins/timeTrack */ 35);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var typeOfArrangementMap = __WEBPACK_IMPORTED_MODULE_3__constants__["F" /* TYPE_OF_ARRANGEMENTS */].reduce(function (accumulate, current) {
  accumulate[current.value] = current.label;
  return accumulate;
}, {});

var typeOfRouteToGalapagos = __WEBPACK_IMPORTED_MODULE_3__constants__["P" /* TYPE_OF_ROUTE_TO_GALAPAGOS */].reduce(function (accumulate, current) {
  accumulate[current.value] = current.label;
  return accumulate;
}, {});

var typeOfRouteFromGalapagos = __WEBPACK_IMPORTED_MODULE_3__constants__["O" /* TYPE_OF_ROUTE_FROM_GALAPAGOS */].reduce(function (accumulate, current) {
  accumulate[current.value] = current.label;
  return accumulate;
}, {});

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contact: Object,
    contactBooking: Object,
    index: Number,
    isLastContact: Boolean,
    onClickNextGuest: Function
  },
  methods: {
    canShowDietaryPreferenceField: function canShowDietaryPreferenceField() {
      return !this.booking.isAmazonCruise && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* FACILITY_CODES */].AquaBlu;
    },
    isPeruvianContactBooking: function isPeruvianContactBooking(contact) {
      return contact.nationality === "PE - Peru" && contact.mainMailingCountry === "PE - Peru";
    },

    getGalapagosFlightDestination: function getGalapagosFlightDestination(from) {
      return __WEBPACK_IMPORTED_MODULE_3__constants__["w" /* GALAPAGOS_FLIGHT_DESTINATION */][from];
    },
    isAquaBlu: function isAquaBlu() {
      if (!this.booking || !this.booking.facilityCode) {
        return false;
      }
      return this.booking.facilityCode === __WEBPACK_IMPORTED_MODULE_3__constants__["u" /* FACILITY_CODES */].AquaBlu;
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_timeTrack__["a" /* timeTrack */]],
  data: function data() {
    return {
      typeOfArrangementMap: typeOfArrangementMap
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.cabinConfigurations, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.passports, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.passportByContactID, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.visaRequirements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.preArrangements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.postArrangements, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.visaRequirementByContactID, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.preArrangementByContactIDAndCategory, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.postArrangementByContactIDAndCategory])),
  filters: {
    formatDisplay: function formatDisplay(value) {
      return value || "-";
    },
    formatDisplayMandatory: function formatDisplayMandatory(value) {
      return value || "This is required.";
    },
    formatMultipleDisplayMandatory: function formatMultipleDisplayMandatory(value) {
      if (value) {
        if (Array.isArray(value)) {
          return value[0] === "" ? "This is required." : value.join(", ");
        }
        return value;
      }
      return "This is required.";
    },
    formatKeyValue: function formatKeyValue(keyValue) {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1 ? keyValue.split(" - ")[1] : "-";
    },
    formatKeyValueMandatory: function formatKeyValueMandatory(keyValue) {
      // keyValue is in the format "key - value"
      // this function convert keyValue to human-friendly display by showing value only or '-' if keyValue is null
      return keyValue && keyValue.split(" - ").length > 1 ? keyValue.split(" - ")[1] : "This is required.";
    },
    formatTypeOfArrangement: function formatTypeOfArrangement(value) {
      return typeOfArrangementMap[value] || "This is required.";
    },
    formatGalapagosRouteInfo: function formatGalapagosRouteInfo(value) {
      return typeOfRouteToGalapagos[value] || typeOfRouteFromGalapagos[value] || "This is required.";
    },
    formatDisplayLastTravelPeriod: function formatDisplayLastTravelPeriod(value) {
      if (!value) {
        return "-";
      }

      // Supposedly in the format 'MM YYYY'
      var monthYear = value.split(" ");

      // unknown format, just return original value
      if (monthYear.length !== 2) {
        return value;
      }

      var _monthYear = _slicedToArray(monthYear, 2),
          month = _monthYear[0],
          year = _monthYear[1];

      var monthMap = {
        "01": "Jan",
        "02": "Feb",
        "03": "Mar",
        "04": "Apr",
        "05": "May",
        "06": "Jun",
        "07": "Jul",
        "08": "Aug",
        "09": "Sep",
        10: "Oct",
        11: "Nov",
        12: "Dec"
      };

      return (monthMap[month] || month) + " " + year;
    },
    formatSignedROL: function formatSignedROL(value) {
      return value ? "Signed" : "This is required.";
    }
  }
});

/***/ }),
/* 193 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CruiseTicketPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(/*! ../constants */ 13);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    gtag("set", "page_path", "/completed");
    gtag("event", "page_path", {
      path: "/completed"
    });
  },
  data: function data() {
    return {
      dialogEmailVisible: false,
      showLoadingSendEmail: false,
      formData: {
        email: "",
        name: ""
      },
      rulesValidate: {
        email: [{
          required: true,
          message: "Required",
          trigger: "change blur"
        }, {
          type: "email",
          message: "Invalid email format",
          trigger: "blur"
        }],
        name: [{ required: true, message: "Required", trigger: "change blur" }]
      }
    };
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.cabinConfigurations, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.cruiseTicketURL, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contacts, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.contact])),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.sendCruiseTicketEmailRemote]), {
    appendMarketingSiteUrl: function appendMarketingSiteUrl(path) {
      return "" + undefined + (path || "");
    },

    canShowBalconyType: function canShowBalconyType() {
      return !this.booking.isAmazonCruise && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* FACILITY_CODES */].AquaBlu && this.booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_2__constants__["u" /* FACILITY_CODES */].AquaMare;
    },
    getGuestNameList: function getGuestNameList(cabinConfiguration) {
      var _this = this;

      // Search for contact's name under 'contacts' based on given contact id(s) in cabinConfiguration.
      var errorEncountered = false;
      var $this = this;

      // Get valid contact IDs.
      var contactIds = [cabinConfiguration.guest1ID, cabinConfiguration.guest2ID, cabinConfiguration.guest3ID, cabinConfiguration.guest4ID].filter(function (id) {
        return id;
      });

      var result = contactIds.map(function (contactId) {
        // Utilise getter to retrieve the cabin config's guest contact based on the contactId,
        // equivalent to: this.contacts.find(contact => contact.contactID === contactId);
        var currentContact = _this.contact(contactId);

        if (currentContact) {
          // use join with delimiter just in case firstName or lastName is an empty string
          return [currentContact.firstName, currentContact.lastName].join(" ");
        }

        // Unexpected error if can't find contact.
        errorEncountered = true;
        return null;
      });

      if (result.length && !errorEncountered) {
        return result;
      } else {
        // Name(s) found in cabinConfiguration MIGHT be outdated if it was fetched initially but was updated afterwards during check-in.
        // Only used as a failsafe now (since defaults to using names found in contacts instead).
        return [cabinConfiguration.guest1Name, cabinConfiguration.guest2Name, cabinConfiguration.guest3Name, cabinConfiguration.guest4Name].filter(function (guestName) {
          return guestName;
        });
      }
    },
    onClickPrintTicket: function onClickPrintTicket(cruiseTicketURL) {
      function getPrintHTML(source) {
        return "<html>\n  <head>\n    <script>\n      function step1() {\n        setTimeout('step2()', 10);\n      }\n      function step2(){\n        window.print();\n        window.close();\n      }\n    </scri" + ("pt>\n  </head>\n  <body onload='step1()'>\n    <img src=\"" + source + "\" style=\"width: 100%;\" />\n  </body>\n</html>");
      }

      var newPage = window.open("about:blank", "_new");
      newPage.document.open();
      newPage.document.write(getPrintHTML(cruiseTicketURL));
      newPage.document.close();
    },
    onClickSendEmail: function onClickSendEmail() {
      var _this2 = this;

      this.$refs.form.validate().then(function () {
        _this2.showLoadingSendEmail = true;
        _this2.sendCruiseTicketEmailRemote({
          cabinConfigurations: _this2.cabinConfigurations,
          email: _this2.formData.email,
          name: _this2.formData.name
        }).catch(function (error) {
          _this2.$message.error(error.message || __WEBPACK_IMPORTED_MODULE_2__constants__["Q" /* UNHANDLED_ERROR_MESSAGE */]);
        }).then(function () {
          _this2.dialogEmailVisible = true;
        }).finally(function () {
          _this2.showLoadingSendEmail = false;
        });
      }).catch(function (error) {
        console.log("error:", error);
      });
    },
    onClickBack: function onClickBack() {
      this.$router.back();
    },
    onClickExploreBenefits: function onClickExploreBenefits() {
      window.open(this.appendMarketingSiteUrl("/loyalty"), "_blank");
    }
  })
});

/***/ }),
/* 194 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CheckinSuspended.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CheckinSuspended",
  created: function created() {
    gtag("set", "page_path", "/checkin-suspended");
    gtag("event", "page_path", {
      path: "/checkin-suspended"
    });
  },
  data: function data() {
    return {
      suspendedHeaderLabel: "Check-in incomplete",
      suspendedInfoLabel: "The check-in process has been suspended because it took too long to complete. Please click below to continue checking in or contact the Aqua Expeditions' Reservations team for assistance.",
      contactUsLabel: "CONTACT US",
      startCheckingInLabel: "CHECK IN AGAIN"
    };
  },

  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])(["updateCurrentStep", "refreshToken"]), {
    onClickContact: function onClickContact() {
      location.href = undefined + "/contact-us/";
    },
    onClickStartCheckin: function onClickStartCheckin() {
      this.$router.push({ path: "/" });
    }
  })
});

/***/ }),
/* 195 */
/*!***************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavSteps.vue ***!
  \***************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ui_Masthead_vue__ = __webpack_require__(/*! ./ui/Masthead.vue */ 451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(/*! ../constants */ 13);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Masthead: __WEBPACK_IMPORTED_MODULE_1__ui_Masthead_vue__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contact__["a" /* default */]],
  data: function data() {
    return {
      // stepsData,
      currentStepIndex: -1
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.currentStepIndex = this.stepsData().findIndex(function (step) {
      return step.routeName === _this.$route.name;
    });
  },

  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_3__store_types__["a" /* default */].getters.booking]), {
    currentNavStep: function currentNavStep() {
      return this.stepsData()[this.currentStepIndex].navStep || __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Incomplete;
    }
  }),
  watch: {
    "$route.name": function $routeName(routeName) {
      this.currentStepIndex = this.stepsData().findIndex(function (step) {
        return step.routeName === routeName;
      });
    }
  },
  methods: {
    getMasthead: function getMasthead() {
      switch (this.currentNavStep) {
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].BookingSummary:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step1-" + this.booking.facilityCode + "_v2.jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].PersonalDetails:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step2-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].DietaryPreferences:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step3-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].WetsuitDiving:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step4-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].PrePostCruise:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step5-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Confirmation:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-step6-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Success:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-success-" + this.booking.facilityCode + ".jpg.webp";
        case __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Incomplete:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-incomplete-" + this.booking.facilityCode + ".jpg.webp";
        default:
          return "https://d20knvk822eu5a.cloudfront.net/s3fs-public-optimized/static-assets/online-check-in/mastheads/cropped/masthead-incomplete-" + this.booking.facilityCode + ".jpg.webp";
      }
    },
    getStepTitle: function getStepTitle(stepIndex) {
      var stepsData = this.stepsData();
      if (stepIndex === stepsData.length - 1) {
        return this.currentStepIndex === 5 ? "Completed" : "Confirmation";
      }
      return stepsData[stepIndex].stepTitle;
    },
    stepsData: function stepsData() {
      var steps = [{
        routeName: "step-1",
        title: "Booking Summary",
        stepTitle: "Summary",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].BookingSummary
      }, {
        routeName: "step-2",
        title: "Personal details",
        stepTitle: "Personal details",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].PersonalDetails
      }, {
        routeName: "step-3",
        title: "Dietary and special requests",
        stepTitle: "Dietary and special requests",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].DietaryPreferences
      }].concat(_toConsumableArray(this.hasDiving() ? [{
        routeName: "step-3b",
        title: "Diving option",
        stepTitle: "Diving option",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].WetsuitDiving
      }] : []), _toConsumableArray(this.hasWetsuit() ? [{
        routeName: "step-3c",
        title: "Wetsuit option",
        stepTitle: "Wetsuit option",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].WetsuitDiving
      }] : []), [{
        routeName: "step-4",
        title: "Your Pre and Post-cruise information",
        subtitle: "Your input will help us better coordinate your arrival & departure arrangements.",
        stepTitle: "Pre and Post-cruise information",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].PrePostCruise
      }, {
        routeName: "step-5",
        title: "Confirm your details",
        stepTitle: "Confirmation",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Confirmation
      }, {
        routeName: "completed",
        title: "Thank you for completing \n" + "the online check-in process",
        stepTitle: "Completed",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Success
      }, {
        routeName: "checkin-suspended",
        title: "",
        stepTitle: "Check in suspended",
        navStep: __WEBPACK_IMPORTED_MODULE_4__constants__["z" /* NAV_STEPS */].Incomplete
      }]);
      return steps;
    },
    isCompleted: function isCompleted() {
      return this.stepsData()[this.currentStepIndex].routeName === "completed";
    },
    isSuspended: function isSuspended() {
      return this.currentStepIndex === -1 || this.stepsData()[this.currentStepIndex].routeName === "checkin-suspended";
    }
  }
});

/***/ }),
/* 196 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ui/Masthead.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Masthead",
  props: {
    variant: {
      type: String
    },
    imageUrl: {
      type: String,
      default: "https://d20knvk822eu5a.cloudfront.net/static-assets/booking-portal/aqua-mare-beach-club.webp"
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    signature: {
      type: String
    },
    textAlign: {
      validator: function validator(value, props) {
        // The value must match one of these strings
        return ["center", "bottomLeft"].includes(value);
      },

      default: "center"
    },
    mastHeadType: {
      type: String,
      default: "default"
    },
    // If true, the text container's top will be adjusted so that it is vertically aligned center on the area without navbar
    hasNavbarOverlay: {
      type: Boolean
    }
  },
  computed: {
    mastHeadClassName: function mastHeadClassName() {
      return this.hasNavbarOverlay ? "masthead--" + this.mastHeadType + " masthead--navbar-overlay" : "masthead--" + this.mastHeadType;
    }
  },
  methods: {
    onScroll: function onScroll() {
      // const ref = this.$refs.mastheadRef;
      // const rect = ref.getBoundingClientRect();
      // const win = ref.ownerDocument.defaultView;
      // const offsetTop = rect.top + win.scrollY;

      var y = document.documentElement.scrollTop || document.body.scrollTop || 0;
      var mastheadHeight = document.body.clientWidth >= 768 ? 668 : 400;
      var scrollRatio = Math.min(y, mastheadHeight) / mastheadHeight;

      var min = 1.0;
      var max = 1.5;
      var interpolated = min + scrollRatio * (max - min);
      this.$refs.mastheadRef.style.transform = "scale(" + interpolated + ") translateZ(0px)";
    }
  },
  created: function created() {
    window.addEventListener("scroll", this.onScroll);
  },
  destroyed: function destroyed() {
    window.removeEventListener("scroll", this.onScroll);
  }
});

/***/ }),
/* 197 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/babel-loader/lib?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/DialogSaveAndExit.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_contact__ = __webpack_require__(/*! ../mixins/contact */ 24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_logout__ = __webpack_require__(/*! ../mixins/logout */ 167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProgressBar__ = __webpack_require__(/*! ./ProgressBar */ 182);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_contact__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_logout__["a" /* default */]],
  components: { ProgressBar: __WEBPACK_IMPORTED_MODULE_4__ProgressBar__["a" /* default */] },
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.booking, __WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.isVisibleDialogSaveAndExit])),
  methods: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["b" /* mapActions */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit]), {
    getTotalProgressPercentage: function getTotalProgressPercentage() {
      var data = this.getTotalProgressData();
      return data && data.percentage || 0;
    },
    appendMarketingSiteUrl: function appendMarketingSiteUrl(path) {
      return "" + undefined + (path || "");
    }
  })
});

/***/ }),
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/*!*******************!*\
  !*** multi ./src ***!
  \*******************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /home/staging-checkin/repos/ae-online-check-in-vue/src */221);


/***/ }),
/* 221 */
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! no exports provided */
/*! all exports used */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__ = __webpack_require__(/*! core-js/modules/es6.typed.array-buffer */ 222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_modules_es6_typed_array_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__ = __webpack_require__(/*! core-js/modules/es6.typed.data-view */ 224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_modules_es6_typed_data_view__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int8-array */ 225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_core_js_modules_es6_typed_int8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-array */ 230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_core_js_modules_es6_typed_uint8_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint8-clamped-array */ 231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_core_js_modules_es6_typed_uint8_clamped_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int16-array */ 232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_core_js_modules_es6_typed_int16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint16-array */ 233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_core_js_modules_es6_typed_uint16_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.int32-array */ 234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_core_js_modules_es6_typed_int32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.uint32-array */ 235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_core_js_modules_es6_typed_uint32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float32-array */ 236);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_core_js_modules_es6_typed_float32_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__ = __webpack_require__(/*! core-js/modules/es6.typed.float64-array */ 237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_core_js_modules_es6_typed_float64_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__ = __webpack_require__(/*! core-js/modules/es6.map */ 238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_core_js_modules_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__ = __webpack_require__(/*! core-js/modules/es6.set */ 240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_core_js_modules_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__ = __webpack_require__(/*! core-js/modules/es6.weak-map */ 241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_core_js_modules_es6_weak_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__ = __webpack_require__(/*! core-js/modules/es6.weak-set */ 242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_core_js_modules_es6_weak_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__ = __webpack_require__(/*! core-js/modules/es6.reflect.apply */ 243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_core_js_modules_es6_reflect_apply__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__ = __webpack_require__(/*! core-js/modules/es6.reflect.construct */ 244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_core_js_modules_es6_reflect_construct__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.define-property */ 246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_core_js_modules_es6_reflect_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__ = __webpack_require__(/*! core-js/modules/es6.reflect.delete-property */ 247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_core_js_modules_es6_reflect_delete_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__ = __webpack_require__(/*! core-js/modules/es6.reflect.get */ 248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_core_js_modules_es6_reflect_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-own-property-descriptor */ 249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_core_js_modules_es6_reflect_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.get-prototype-of */ 250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_core_js_modules_es6_reflect_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__ = __webpack_require__(/*! core-js/modules/es6.reflect.has */ 251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_core_js_modules_es6_reflect_has__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.reflect.is-extensible */ 252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_core_js_modules_es6_reflect_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__ = __webpack_require__(/*! core-js/modules/es6.reflect.own-keys */ 253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_core_js_modules_es6_reflect_own_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.reflect.prevent-extensions */ 254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_core_js_modules_es6_reflect_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__ = __webpack_require__(/*! core-js/modules/es6.reflect.set */ 255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_core_js_modules_es6_reflect_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.reflect.set-prototype-of */ 256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_core_js_modules_es6_reflect_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__ = __webpack_require__(/*! core-js/modules/es6.promise */ 257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_core_js_modules_es6_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__ = __webpack_require__(/*! core-js/modules/es6.symbol */ 261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29_core_js_modules_es6_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__ = __webpack_require__(/*! core-js/modules/es6.object.freeze */ 264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_core_js_modules_es6_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__ = __webpack_require__(/*! core-js/modules/es6.object.seal */ 265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_core_js_modules_es6_object_seal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__ = __webpack_require__(/*! core-js/modules/es6.object.prevent-extensions */ 266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_core_js_modules_es6_object_prevent_extensions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__ = __webpack_require__(/*! core-js/modules/es6.object.is-frozen */ 267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33_core_js_modules_es6_object_is_frozen__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__ = __webpack_require__(/*! core-js/modules/es6.object.is-sealed */ 268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34_core_js_modules_es6_object_is_sealed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__ = __webpack_require__(/*! core-js/modules/es6.object.is-extensible */ 269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_core_js_modules_es6_object_is_extensible__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-descriptor */ 270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_core_js_modules_es6_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.get-prototype-of */ 271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_core_js_modules_es6_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__ = __webpack_require__(/*! core-js/modules/es6.object.keys */ 272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_core_js_modules_es6_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__ = __webpack_require__(/*! core-js/modules/es6.object.get-own-property-names */ 273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_core_js_modules_es6_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__ = __webpack_require__(/*! core-js/modules/es6.object.assign */ 274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_core_js_modules_es6_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__ = __webpack_require__(/*! core-js/modules/es6.object.is */ 275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_core_js_modules_es6_object_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__ = __webpack_require__(/*! core-js/modules/es6.object.set-prototype-of */ 276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_core_js_modules_es6_object_set_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__ = __webpack_require__(/*! core-js/modules/es6.function.name */ 277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_core_js_modules_es6_function_name__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__ = __webpack_require__(/*! core-js/modules/es6.string.raw */ 278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_44_core_js_modules_es6_string_raw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__ = __webpack_require__(/*! core-js/modules/es6.string.from-code-point */ 279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_core_js_modules_es6_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__ = __webpack_require__(/*! core-js/modules/es6.string.code-point-at */ 280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_core_js_modules_es6_string_code_point_at__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__ = __webpack_require__(/*! core-js/modules/es6.string.repeat */ 281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_47_core_js_modules_es6_string_repeat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__ = __webpack_require__(/*! core-js/modules/es6.string.starts-with */ 282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_48_core_js_modules_es6_string_starts_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__ = __webpack_require__(/*! core-js/modules/es6.string.ends-with */ 283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_core_js_modules_es6_string_ends_with__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__ = __webpack_require__(/*! core-js/modules/es6.string.includes */ 284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_50_core_js_modules_es6_string_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__ = __webpack_require__(/*! core-js/modules/es6.regexp.flags */ 285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_51_core_js_modules_es6_regexp_flags__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__ = __webpack_require__(/*! core-js/modules/es6.regexp.match */ 286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_52_core_js_modules_es6_regexp_match__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__ = __webpack_require__(/*! core-js/modules/es6.regexp.replace */ 288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_core_js_modules_es6_regexp_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__ = __webpack_require__(/*! core-js/modules/es6.regexp.split */ 289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_core_js_modules_es6_regexp_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__ = __webpack_require__(/*! core-js/modules/es6.regexp.search */ 290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_core_js_modules_es6_regexp_search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__ = __webpack_require__(/*! core-js/modules/es6.array.from */ 291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_56_core_js_modules_es6_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__ = __webpack_require__(/*! core-js/modules/es6.array.of */ 292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_57_core_js_modules_es6_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__ = __webpack_require__(/*! core-js/modules/es6.array.copy-within */ 293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_58_core_js_modules_es6_array_copy_within__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__ = __webpack_require__(/*! core-js/modules/es6.array.find */ 294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_59_core_js_modules_es6_array_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__ = __webpack_require__(/*! core-js/modules/es6.array.find-index */ 295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_60_core_js_modules_es6_array_find_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__ = __webpack_require__(/*! core-js/modules/es6.array.fill */ 296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_61_core_js_modules_es6_array_fill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__ = __webpack_require__(/*! core-js/modules/es6.array.iterator */ 102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_62_core_js_modules_es6_array_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__ = __webpack_require__(/*! core-js/modules/es6.number.is-finite */ 297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_63_core_js_modules_es6_number_is_finite__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-integer */ 298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_64_core_js_modules_es6_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.is-safe-integer */ 299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_65_core_js_modules_es6_number_is_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__ = __webpack_require__(/*! core-js/modules/es6.number.is-nan */ 300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_66_core_js_modules_es6_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__ = __webpack_require__(/*! core-js/modules/es6.number.epsilon */ 301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_67_core_js_modules_es6_number_epsilon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.min-safe-integer */ 302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_68_core_js_modules_es6_number_min_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__ = __webpack_require__(/*! core-js/modules/es6.number.max-safe-integer */ 303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_69_core_js_modules_es6_number_max_safe_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__ = __webpack_require__(/*! core-js/modules/es6.math.acosh */ 304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_70_core_js_modules_es6_math_acosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__ = __webpack_require__(/*! core-js/modules/es6.math.asinh */ 305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_71_core_js_modules_es6_math_asinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__ = __webpack_require__(/*! core-js/modules/es6.math.atanh */ 306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_72_core_js_modules_es6_math_atanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__ = __webpack_require__(/*! core-js/modules/es6.math.cbrt */ 307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_73_core_js_modules_es6_math_cbrt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__ = __webpack_require__(/*! core-js/modules/es6.math.clz32 */ 308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_74_core_js_modules_es6_math_clz32__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__ = __webpack_require__(/*! core-js/modules/es6.math.cosh */ 309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_75_core_js_modules_es6_math_cosh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__ = __webpack_require__(/*! core-js/modules/es6.math.expm1 */ 310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_76_core_js_modules_es6_math_expm1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__ = __webpack_require__(/*! core-js/modules/es6.math.fround */ 311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_77_core_js_modules_es6_math_fround__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__ = __webpack_require__(/*! core-js/modules/es6.math.hypot */ 313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_78_core_js_modules_es6_math_hypot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__ = __webpack_require__(/*! core-js/modules/es6.math.imul */ 314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_79_core_js_modules_es6_math_imul__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__ = __webpack_require__(/*! core-js/modules/es6.math.log1p */ 315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_80_core_js_modules_es6_math_log1p__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__ = __webpack_require__(/*! core-js/modules/es6.math.log10 */ 316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_81_core_js_modules_es6_math_log10__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__ = __webpack_require__(/*! core-js/modules/es6.math.log2 */ 317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_82_core_js_modules_es6_math_log2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__ = __webpack_require__(/*! core-js/modules/es6.math.sign */ 318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_83_core_js_modules_es6_math_sign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__ = __webpack_require__(/*! core-js/modules/es6.math.sinh */ 319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_84_core_js_modules_es6_math_sinh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__ = __webpack_require__(/*! core-js/modules/es6.math.tanh */ 320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_85_core_js_modules_es6_math_tanh__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__ = __webpack_require__(/*! core-js/modules/es6.math.trunc */ 321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_86_core_js_modules_es6_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__ = __webpack_require__(/*! core-js/modules/es7.array.includes */ 322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_87_core_js_modules_es7_array_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__ = __webpack_require__(/*! core-js/modules/es7.object.values */ 323);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_88_core_js_modules_es7_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__ = __webpack_require__(/*! core-js/modules/es7.object.entries */ 324);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_89_core_js_modules_es7_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__ = __webpack_require__(/*! core-js/modules/es7.object.get-own-property-descriptors */ 325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_90_core_js_modules_es7_object_get_own_property_descriptors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__ = __webpack_require__(/*! core-js/modules/es7.string.pad-start */ 326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_91_core_js_modules_es7_string_pad_start__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__ = __webpack_require__(/*! core-js/modules/es7.string.pad-end */ 327);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_92_core_js_modules_es7_string_pad_end__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__ = __webpack_require__(/*! core-js/modules/web.timers */ 328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_93_core_js_modules_web_timers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__ = __webpack_require__(/*! core-js/modules/web.immediate */ 329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_94_core_js_modules_web_immediate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__ = __webpack_require__(/*! core-js/modules/web.dom.iterable */ 330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_95_core_js_modules_web_dom_iterable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__ = __webpack_require__(/*! regenerator-runtime/runtime */ 165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_96_regenerator_runtime_runtime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_es6_promise_auto__ = __webpack_require__(/*! es6-promise/auto */ 331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_97_es6_promise_auto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98_vue__ = __webpack_require__(/*! vue */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__components_App_vue__ = __webpack_require__(/*! ./components/App.vue */ 335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__router__ = __webpack_require__(/*! ./router */ 352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__store__ = __webpack_require__(/*! ./store */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__components_NavSteps__ = __webpack_require__(/*! ./components/NavSteps */ 449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__components_DialogSaveAndExit__ = __webpack_require__(/*! ./components/DialogSaveAndExit */ 455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_element_ui__ = __webpack_require__(/*! element-ui */ 458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_104_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_vue_select__ = __webpack_require__(/*! vue-select */ 540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_105_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_element_ui_lib_locale_lang_en__ = __webpack_require__(/*! element-ui/lib/locale/lang/en */ 541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106_element_ui_lib_locale_lang_en___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_106_element_ui_lib_locale_lang_en__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__scss_index_scss__ = __webpack_require__(/*! ./scss/index.scss */ 542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__scss_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_107__scss_index_scss__);














































































































var debug = "false," === "true";
__WEBPACK_IMPORTED_MODULE_98_vue__["default"].config.performance = debug;

// Add `finally()` to `Promise.prototype`
Promise.prototype.finally = function (onFinally) {
  return this.then(
  /* onFulfilled */
  function (res) {
    return Promise.resolve(onFinally()).then(function () {
      return res;
    });
  },
  /* onRejected */
  function (err) {
    return Promise.resolve(onFinally()).then(function () {
      throw err;
    });
  });
};

__WEBPACK_IMPORTED_MODULE_98_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_104_element_ui___default.a, { locale: __WEBPACK_IMPORTED_MODULE_106_element_ui_lib_locale_lang_en___default.a });

__WEBPACK_IMPORTED_MODULE_105_vue_select___default.a.props.components.default = function () {
  return {
    Deselect: {
      render: function render(createElement) {
        return createElement("i", {
          class: {
            "el-select__caret": true,
            "el-tag__close": true,
            "el-icon-close": true
          }
        });
      }
    },
    OpenIndicator: {
      render: function render(createElement) {
        var element = createElement("i", {
          class: {
            "el-select__caret": true,
            "el-input__icon": true,
            "el-icon-arrow-down": true
          }
        });
        return element;
      }
    }
  };
};

__WEBPACK_IMPORTED_MODULE_98_vue__["default"].component("v-select", __WEBPACK_IMPORTED_MODULE_105_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_98_vue__["default"].component("nav-steps", __WEBPACK_IMPORTED_MODULE_102__components_NavSteps__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_98_vue__["default"].component("dialog-save-and-exit", __WEBPACK_IMPORTED_MODULE_103__components_DialogSaveAndExit__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_98_vue__["default"].component("scope", {
  functional: true,
  props: ["tag"],
  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props;

    return h(props.tag, null, data.scopedSlots.default(data.attrs));
  }
});

new __WEBPACK_IMPORTED_MODULE_98_vue__["default"]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_100__router__["a" /* default */],
  // provide the store using the "store" option.
  // this will inject the store instance to all child components.
  store: __WEBPACK_IMPORTED_MODULE_101__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_99__components_App_vue__["a" /* default */]);
  }
});

/***/ }),
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */
/*!********************************!*\
  !*** ./src/components/App.vue ***!
  \********************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./App.vue */ 166);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b580460_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1b580460","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./App.vue */ 351);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1b580460","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./App.vue */ 336)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b580460"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b580460_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 336 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1b580460","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/App.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 337 */
/*!*******************************************!*\
  !*** ./src/components/layouts/Navbar.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Navbar.vue */ 168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3690f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ad3690f4","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Navbar.vue */ 340);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ad3690f4","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Navbar.vue */ 338)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad3690f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Navbar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad3690f4_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 338 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad3690f4","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/layouts/Navbar.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 339 */,
/* 340 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad3690f4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/Navbar.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"header",class:{ 'solid-background': _vm.isSolidBackground }},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"header__inner"},[_c('a',{staticClass:"logo-wrapper",attrs:{"href":"/"}},[_c('img',{staticClass:"desktop",attrs:{"src":__webpack_require__(/*! ../../assets/images/logo.svg */ 169),"alt":"Aqua Expeditions Logo"}}),_vm._v(" "),_c('img',{staticClass:"mobile",attrs:{"src":__webpack_require__(/*! ../../assets/images/logo-leaf.svg */ 341),"alt":"Aqua Expeditions Logo"}}),_vm._v(" "),_c('span',{staticClass:"header__divider"}),_vm._v(" "),_c('span',{staticClass:"header__text"},[_vm._v(_vm._s(_vm.portalHeader))])]),_vm._v(" "),(this.booking)?_c('a',{staticClass:"logout_btn",attrs:{"href":"/"}},[_vm._v("Logout")]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 341 */
/*!*****************************************!*\
  !*** ./src/assets/images/logo-leaf.svg ***!
  \*****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/logo-leaf.2ba7da97.svg";

/***/ }),
/* 342 */
/*!**************************************!*\
  !*** ./src/components/ui/Footer.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Footer.vue */ 170);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c354f1b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-1c354f1b","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Footer.vue */ 350);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-1c354f1b","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Footer.vue */ 343)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1c354f1b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1c354f1b_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 343 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c354f1b","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/Footer.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 344 */
/*!*************************************************!*\
  !*** ./src/components/ui/FooterSocialMedia.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSocialMedia_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./FooterSocialMedia.vue */ 171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f355be6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSocialMedia_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-f355be6c","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./FooterSocialMedia.vue */ 349);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-f355be6c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./FooterSocialMedia.vue */ 345)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f355be6c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_FooterSocialMedia_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f355be6c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FooterSocialMedia_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 345 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f355be6c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/FooterSocialMedia.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 346 */
/*!******************************************************!*\
  !*** ./src/assets/images/social-media/instagram.svg ***!
  \******************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/instagram.4686ab30.svg";

/***/ }),
/* 347 */
/*!****************************************************!*\
  !*** ./src/assets/images/social-media/twitter.svg ***!
  \****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/twitter.f92b452d.svg";

/***/ }),
/* 348 */
/*!*****************************************************!*\
  !*** ./src/assets/images/social-media/facebook.svg ***!
  \*****************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/facebook.e085e238.svg";

/***/ }),
/* 349 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f355be6c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/FooterSocialMedia.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-social-media"},[_c('div',{staticClass:"footer-social-media__label"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('div',{staticClass:"footer-social-media__buttons"},[(_vm.instagramUrl)?_c('a',{attrs:{"href":_vm.instagramUrl,"target":"_blank","rel":"noreferrer"}},[_c('img',{attrs:{"src":_vm.instagramIcon,"alt":"Instagram"}})]):_vm._e(),_vm._v(" "),(_vm.twitterUrl)?_c('a',{attrs:{"href":_vm.twitterUrl,"target":"_blank","rel":"noreferrer"}},[_c('img',{attrs:{"src":_vm.twitterIcon,"alt":"Twitter"}})]):_vm._e(),_vm._v(" "),(_vm.facebookUrl)?_c('a',{attrs:{"href":_vm.facebookUrl,"target":"_blank","rel":"noreferrer"}},[_c('img',{attrs:{"src":_vm.facebookIcon,"alt":"Facebook"}})]):_vm._e(),_vm._v(" "),(_vm.pinterestUrl)?_c('a',{attrs:{"href":_vm.pinterestUrl,"target":"_blank","rel":"noreferrer"}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 350 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c354f1b","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Footer.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"footer__logo",attrs:{"href":_vm.marketingSiteUrl}},[_c('img',{attrs:{"src":_vm.logo,"alt":"logo"}})]),_vm._v(" "),(_vm.showLinks)?_c('div',{staticClass:"footer__menu"},_vm._l((_vm.footerLinks),function(group){return _c('div',{key:group.title},[_c('div',{staticClass:"footer__menu__title"},[_vm._v(_vm._s(group.title))]),_vm._v(" "),_c('ul',_vm._l((group.children),function(link){return _c('li',{key:link.label},[_c('a',{attrs:{"href":link.href}},[_vm._v(_vm._s(link.label))])])}),0)])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"footer__links"},[_c('footer-social-media',{attrs:{"instagramUrl":"https://www.instagram.com/aqua_expeditions","twitterUrl":"https://www.twitter.com/AquaExpeditions","facebookUrl":"https://www.facebook.com/pages/Aqua-Expeditions/71422947695"}}),_vm._v(" "),_c('div',{staticClass:"footer__links-copyright"},[_c('a',{attrs:{"href":(_vm.marketingSiteUrl + "/copyright")}},[_vm._v("\n          Copyright © Aqua Expeditions")]),_vm._v(_vm._s(" ")+" · "),_c('span',[_vm._v("All Rights Reserved")]),_vm._v(" · "),_c('a',{attrs:{"href":(_vm.marketingSiteUrl + "/booking-policies")}},[_vm._v("Terms & Conditions")]),_vm._v("\n        · "),_c('a',{attrs:{"href":(_vm.marketingSiteUrl + "/privacy-policy")}},[_vm._v("Privacy Policy")])])],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 351 */
/*!********************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b580460","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/App.vue ***!
  \********************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('Navbar'),_vm._v(" "),_c('el-main',[_c('nav-steps'),_vm._v(" "),_c('router-view'),_vm._v(" "),_c('dialog-save-and-exit'),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(this.isLoading),expression:"this.isLoading",modifiers:{"fullscreen":true,"lock":true}}],attrs:{"element-loading-text":this.loadingText}}),_vm._v(" "),(!_vm.$route.meta.hideFooter)?_c('Footer',{attrs:{"show-links":""}}):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 352 */
/*!***********************!*\
  !*** ./src/router.js ***!
  \***********************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(/*! vue */ 11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(/*! vue-router */ 353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(/*! ./store */ 114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_StyleGuidePage__ = __webpack_require__(/*! ./components/StyleGuidePage */ 391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_LoginPage__ = __webpack_require__(/*! ./components/LoginPage */ 393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_BookingSummaryPage__ = __webpack_require__(/*! ./components/BookingSummaryPage */ 396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_GuestListingPage__ = __webpack_require__(/*! ./components/GuestListingPage */ 402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DietaryPreferenceAndSpecialRequestPage__ = __webpack_require__(/*! ./components/DietaryPreferenceAndSpecialRequestPage */ 415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_DivingPage__ = __webpack_require__(/*! ./components/DivingPage */ 420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_WetsuitPage__ = __webpack_require__(/*! ./components/WetsuitPage */ 424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_PrePostArrangementPage__ = __webpack_require__(/*! ./components/PrePostArrangementPage */ 428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ConfirmationPage__ = __webpack_require__(/*! ./components/ConfirmationPage */ 432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_CruiseTicketPage__ = __webpack_require__(/*! ./components/CruiseTicketPage */ 441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_CheckinSuspended__ = __webpack_require__(/*! ./components/CheckinSuspended */ 445);















__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// 1. Define route components.
// These can be imported from other files
// =====
// We imported the components on top.

// 2. Define some routes
// Each route should map to a component.
var routes = [{
  path: "/style-guide",
  name: "style-guide",
  component: __WEBPACK_IMPORTED_MODULE_3__components_StyleGuidePage__["a" /* default */]
}, {
  path: "/login",
  name: "login",
  component: __WEBPACK_IMPORTED_MODULE_4__components_LoginPage__["a" /* default */],
  alias: "/",
  meta: { hideFooter: true }
}, {
  path: "/checkin-suspended",
  name: "checkin-suspended",
  component: __WEBPACK_IMPORTED_MODULE_13__components_CheckinSuspended__["a" /* default */]
}, {
  path: "/step-1",
  name: "step-1",
  component: __WEBPACK_IMPORTED_MODULE_5__components_BookingSummaryPage__["a" /* default */]
}, {
  path: "/step-2",
  name: "step-2",
  component: __WEBPACK_IMPORTED_MODULE_6__components_GuestListingPage__["a" /* default */],
  props: function props(route) {
    return { index: route.query.index };
  }
}, {
  path: "/step-3",
  name: "step-3",
  component: __WEBPACK_IMPORTED_MODULE_7__components_DietaryPreferenceAndSpecialRequestPage__["a" /* default */],
  props: function props(route) {
    return { index: route.query.index };
  }
}, {
  path: "/step-3b",
  name: "step-3b",
  component: __WEBPACK_IMPORTED_MODULE_8__components_DivingPage__["a" /* default */],
  props: function props(route) {
    return { index: route.query.index };
  }
}, {
  path: "/step-3c",
  name: "step-3c",
  component: __WEBPACK_IMPORTED_MODULE_9__components_WetsuitPage__["a" /* default */],
  props: function props(route) {
    return { index: route.query.index };
  }
}, {
  path: "/step-4",
  name: "step-4",
  component: __WEBPACK_IMPORTED_MODULE_10__components_PrePostArrangementPage__["a" /* default */],
  props: function props(route) {
    return { index: route.query.index };
  }
}, {
  path: "/step-5",
  name: "step-5",
  component: __WEBPACK_IMPORTED_MODULE_11__components_ConfirmationPage__["a" /* default */]
}, {
  path: "/completed",
  name: "completed",
  component: __WEBPACK_IMPORTED_MODULE_12__components_CruiseTicketPage__["a" /* default */]
}];

// 3. Create the router instance and pass the `routes` option
// You can pass in additional options here, but let's
// keep it simple for now.
var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: routes, // short for `routes: routes`
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // Returning the savedPosition will result in a native-like behavior when navigating with back/forward buttons:
    return savedPosition || { x: 0, y: 0 };
  }
});

router.beforeEach(function (to, from, next) {
  if (to.name === "login" || to.name === "completed") {
    // Remove navigation prompt
    window.onbeforeunload = null;
  } else {
    // Enable navigation prompt
    window.onbeforeunload = function () {
      return true;
    };
  }

  if (to.name === "login") {
    return next();
  }

  // Redirects user to login page if booking in the store is empty (ie. user is not logged in).
  if (!(__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.booking && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.booking.booking)) {
    return next("/");
  }

  // Redirects user to completed page if user has completed the checked-in before (only applicable for non-test booking)
  if (to.name !== "completed" && __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.booking.booking.bookingCheckedIn && !__WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].state.booking.booking.isTestBooking) {
    return next("/completed");
  }

  next();
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 353 */,
/* 354 */
/*!*************************************!*\
  !*** ./src/store/modules/loader.js ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(/*! ../types */ 1);
var _getters;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// initial state
var state = {
  isLoading: false,
  loadingText: "Saving..."
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.isLoading, function (state) {
  return state.isLoading;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.loadingText, function (state) {
  return state.loadingText;
}), _getters);

// actions
var actions = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].actions.setIsLoading, function (_ref, _ref2) {
  var commit = _ref.commit;
  var isLoading = _ref2.isLoading,
      loadingText = _ref2.loadingText;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setIsLoading, { isLoading: isLoading, loadingText: loadingText });
});

// mutations
var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setIsLoading, function (state, _ref3) {
  var _ref3$isLoading = _ref3.isLoading,
      isLoading = _ref3$isLoading === undefined ? true : _ref3$isLoading,
      _ref3$loadingText = _ref3.loadingText,
      loadingText = _ref3$loadingText === undefined ? "Saving..." : _ref3$loadingText;

  state.isLoading = isLoading;
  state.loadingText = loadingText;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 355 */
/*!************************************************!*\
  !*** ./src/store/modules/dialogSaveAndExit.js ***!
  \************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(/*! ../types */ 1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// initial state
var state = {
  isVisibleDialogSaveAndExit: false
};

// getters
var getters = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.isVisibleDialogSaveAndExit, function (state) {
  return state.isVisibleDialogSaveAndExit;
});

// actions
var actions = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].actions.setIsVisibleDialogSaveAndExit, function (_ref, isVisibleDialogSaveAndExit) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setIsVisibleDialogSaveAndExit, isVisibleDialogSaveAndExit);
});

// mutations
var mutations = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setIsVisibleDialogSaveAndExit, function (state, isVisibleDialogSaveAndExit) {
  state.isVisibleDialogSaveAndExit = isVisibleDialogSaveAndExit;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 356 */
/*!**************************************!*\
  !*** ./src/store/modules/booking.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_booking__ = __webpack_require__(/*! @/api/booking */ 172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
var _getters, _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// initial state
var state = {
  booking: null,
  cruiseTicketURL: null
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.booking, function (state) {
  return state.booking;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.cruiseTicketURL, function (state) {
  return state.cruiseTicketURL;
}), _getters);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.searchBooking, function (_ref, _ref2) {
  var commit = _ref.commit;
  var bookingCode = _ref2.bookingCode,
      lastName = _ref2.lastName;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, {
    isLoading: true,
    loadingText: "Loading..."
  });

  return __WEBPACK_IMPORTED_MODULE_0__api_booking__["a" /* default */].searchBooking(bookingCode, lastName).then(function (result) {
    console.log("[actions.searchBooking] result:", result);

    var booking = result.booking,
        cabinConfigurations = result.cabinConfigurations,
        contacts = result.contacts,
        contactBookings = result.contactBookings,
        visaRequirements = result.visaRequirements,
        preArrangements = result.preArrangements,
        postArrangements = result.postArrangements,
        passports = result.passports,
        accessToken = result.accessToken,
        expiryTime = result.expiryTime;

    contacts.sort(function (a, b) {
      if (a.isPrimaryContact) {
        return -1;
      }

      if (b.isPrimaryContact) {
        return 1;
      }

      return 0;
    });
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setBooking, booking);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setCabinConfigurations, cabinConfigurations);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setContacts, contacts);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setContactBookings, contactBookings);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setVisaRequirements, visaRequirements);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setPassports, passports);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setPreArrangements, preArrangements);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setPostArrangements, {
      postArrangements: postArrangements,
      booking: booking
    });
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setAccessToken, accessToken);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setExpiryTime, expiryTime);

    if (booking.bookingCheckedIn && booking.ticketURLs) {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setCruiseTicketURL, booking.ticketURLs);
    }

    return result;
  }).finally(function () {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, {
      isLoading: false,
      loadingText: "Loading..."
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateBookingField, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var fieldName = _ref4.fieldName,
      value = _ref4.value;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateBookingField, { fieldName: fieldName, value: value });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateBookingRemote, function (_ref5, _ref6) {
  var commit = _ref5.commit;
  var booking = _ref6.booking,
      _ref6$showLoader = _ref6.showLoader,
      showLoader = _ref6$showLoader === undefined ? true : _ref6$showLoader;

  if (!booking.isDirty) {
    return Promise.resolve();
  }

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api_booking__["a" /* default */].updateBooking(booking).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetBookingDirtyFlag);
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.confirmBookingRemote, function (_ref7, _ref8) {
  var commit = _ref7.commit,
      dispatch = _ref7.dispatch;
  var contacts = _ref8.contacts,
      visaRequirements = _ref8.visaRequirements,
      passports = _ref8.passports,
      cabinConfigurations = _ref8.cabinConfigurations,
      booking = _ref8.booking,
      preArrangements = _ref8.preArrangements,
      postArrangements = _ref8.postArrangements;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, {
    isLoading: true,
    loadingText: "Please wait, this may take a little while..."
  });

  return Promise.all([dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateBookingRemote, {
    booking: booking,
    showLoader: false
  }), dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateContactsAndVisaRequirementsRemote, {
    contacts: contacts,
    visaRequirements: visaRequirements,
    passports: passports,
    showLoader: false
  }), dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateCabinConfigurationRemote, {
    cabinConfigurations: cabinConfigurations,
    showLoader: false
  }), dispatch(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updatePrePostArrangementsRemote, {
    prePostArrangements: preArrangements.concat(postArrangements),
    showLoader: false
  })]).then(function () {
    return __WEBPACK_IMPORTED_MODULE_0__api_booking__["a" /* default */].confirmBooking(booking).then(function (cruiseTicketURLByCabinConfigurations) {
      console.log("cruiseTicketURLByCabinConfigurations:", cruiseTicketURLByCabinConfigurations);
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setCruiseTicketURL, cruiseTicketURLByCabinConfigurations);
      return cruiseTicketURLByCabinConfigurations;
    }).finally(function () {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
    });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.sendCruiseTicketEmailRemote, function (_ref9, _ref10) {
  var commit = _ref9.commit;
  var cabinConfigurations = _ref10.cabinConfigurations,
      email = _ref10.email,
      name = _ref10.name;

  return __WEBPACK_IMPORTED_MODULE_0__api_booking__["a" /* default */].sendCruiseTicketEmail(cabinConfigurations, email, name);
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setBooking, function (state, booking) {
  state.booking = booking;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateBookingField, function (state, _ref11) {
  var fieldName = _ref11.fieldName,
      value = _ref11.value;

  state.booking[fieldName] = value;
  state.booking.isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetBookingDirtyFlag, function (state) {
  state.booking.isDirty = false;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */
/*!*************************************************!*\
  !*** ./src/store/modules/cabinConfiguration.js ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_booking__ = __webpack_require__(/*! @/api/booking */ 172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
var _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// initial state
var state = {
  // cabinConfigurationIDs: [],
  // cabinConfigurationEntities: [],
  ids: [],
  entities: {}
};

var getCabinConfigurations = function getCabinConfigurations(state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
};

// getters
var getters = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.cabinConfigurations, getCabinConfigurations);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateCabinConfigurationField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var cabinConfigurationID = _ref2.cabinConfigurationID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateCabinConfigurationField, {
    cabinConfigurationID: cabinConfigurationID,
    fieldName: fieldName,
    value: value
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateCabinConfigurationRemote, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var cabinConfigurations = _ref4.cabinConfigurations;

  var changedCabinConfigurations = cabinConfigurations.filter(function (cabinConfiguration) {
    return cabinConfiguration.isDirty;
  });
  if (!changedCabinConfigurations.length) {
    return Promise.resolve();
  }

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api_booking__["a" /* default */].updateCabinConfiguration(changedCabinConfigurations).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetCabinConfigurationsDirtyFlag);
    return res;
  }).finally(function () {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setCabinConfigurations, function (state, cabinConfigurations) {
  state.ids = cabinConfigurations.map(function (cabinConfiguration) {
    return cabinConfiguration.cabinConfigurationID;
  });
  state.entities = cabinConfigurations.reduce(function (accumulate, current) {
    accumulate[current.cabinConfigurationID] = current;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setCruiseTicketURL, function (state, cruiseTicketURLByCabinConfigurations) {
  getCabinConfigurations(state).forEach(function (entity) {
    var fileURL = cruiseTicketURLByCabinConfigurations[entity.cabinConfigurationID];
    if (fileURL) {
      entity.cruiseTicketURL = fileURL;
    }
  });
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateCabinConfigurationField, function (state, _ref5) {
  var cabinConfigurationID = _ref5.cabinConfigurationID,
      fieldName = _ref5.fieldName,
      value = _ref5.value;

  state.entities[cabinConfigurationID][fieldName] = value;
  state.entities[cabinConfigurationID].isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetCabinConfigurationsDirtyFlag, function (state) {
  getCabinConfigurations(state).forEach(function (entity) {
    return entity.isDirty = false;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 377 */
/*!**************************************!*\
  !*** ./src/store/modules/contact.js ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_contact__ = __webpack_require__(/*! ../../api/contact */ 378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
var _getters, _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// initial state
var state = {
  ids: [],
  entities: {}
};

var getContacts = function getContacts(state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.contacts, getContacts), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.contact, function (state) {
  return function (contactID) {
    return state.entities[contactID];
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.primaryContact, function (state) {
  return getContacts(state).find(function (contact) {
    return contact.isPrimaryContact;
  });
}), _getters);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateContactField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var contactID = _ref2.contactID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateContactField, { contactID: contactID, fieldName: fieldName, value: value });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateContactsRemote, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var contacts = _ref4.contacts,
      _ref4$showLoader = _ref4.showLoader,
      showLoader = _ref4$showLoader === undefined ? true : _ref4$showLoader;

  var changedContacts = contacts.filter(function (contact) {
    return contact.isDirty;
  });
  if (!changedContacts.length) {
    return Promise.resolve();
  }

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api_contact__["a" /* default */].updateContacts(changedContacts).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag);
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setContacts, function (state, contacts) {
  state.ids = contacts.map(function (contact) {
    return contact.contactID;
  });
  state.entities = contacts.map(function (contact) {
    if (contact.pastGuest && contact.pastGuest.length) {
      // pastGuest is an array now
      contact.hasPastGuest = contact.pastGuest.some(function (pastGuest) {
        return !!pastGuest;
      });
    } else {
      contact.hasPastGuest = false;
    }
    contact.hasSameResidentialAddress = !!contact.hasSameResidentialAddress;
    contact.hasSameEmergencyContact = !!contact.hasSameEmergencyContact;
    contact.hasSamePrePostArrangement = !!contact.hasSamePrePostArrangement;
    return contact;
  }).reduce(function (accumulate, contact) {
    accumulate[contact.contactID] = contact;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateContactField, function (state, _ref5) {
  var contactID = _ref5.contactID,
      fieldName = _ref5.fieldName,
      value = _ref5.value;

  state.entities[contactID][fieldName] = value;
  state.entities[contactID].isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag, function (state) {
  getContacts(state).forEach(function (entity) {
    return entity.isDirty = false;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 378 */
/*!****************************!*\
  !*** ./src/api/contact.js ***!
  \****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);


var contactAPI = {
  updateContacts: function updateContacts(contacts) {
    console.log("[API updateContacts] contacts:", contacts);

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/contact", {
      contacts: contacts
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CC1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (contactAPI);

/***/ }),
/* 379 */
/*!*********************************************!*\
  !*** ./src/store/modules/contactBooking.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(/*! ../types */ 1);
var _getters, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// initial state
var state = {
  ids: [],
  entities: {}
};

var getContactBookings = function getContactBookings(state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.contactBookings, getContactBookings), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.contactBooking, function (state) {
  return function (contactID) {
    return state.entities[contactID];
  };
}), _getters);

// actions
var actions = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].actions.updateContactBookingField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var contactID = _ref2.contactID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updateContactBookingField, {
    contactID: contactID,
    fieldName: fieldName,
    value: value
  });
});

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setContactBookings, function (state, contactBookings) {
  state.ids = contactBookings.map(function (contactBooking) {
    return contactBooking.contactID;
  });
  state.entities = contactBookings.map(function (contactBooking) {
    contactBooking.planningToDive = contactBooking.planningToDive === "true" || contactBooking.planningToDive === true;
    contactBooking.needAWetsuit = contactBookings.needAWetsuit === "true" || contactBooking.needAWetsuit === true;
    return contactBooking;
  }).reduce(function (accumulate, contactBooking) {
    accumulate[contactBooking.contactID] = contactBooking;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updateContactBookingField, function (state, _ref3) {
  var contactID = _ref3.contactID,
      fieldName = _ref3.fieldName,
      value = _ref3.value;

  state.entities[contactID][fieldName] = value;
  state.entities[contactID].isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetContactBookingsDirtyFlag, function (state) {
  getContactBookings(state).forEach(function (entity) {
    return entity.isDirty = false;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 380 */
/*!*********************************************!*\
  !*** ./src/store/modules/preArrangement.js ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(/*! ../types */ 1);
var _getters, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



// initial state
var state = {
  ids: [],
  entities: {}
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.preArrangements, function (state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.preArrangement, function (state) {
  return function (preArrangementID) {
    return state.entities[preArrangementID];
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.preArrangementByContactID, function (state) {
  return function (contactID) {
    return Object.values(state.entities).filter(function (preArrangement) {
      return preArrangement.contactID === contactID;
    });
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.preArrangementByContactIDAndCategory, function (state) {
  return function (contactID, category) {
    return Object.values(state.entities).find(function (preArrangement) {
      return preArrangement.contactID === contactID && preArrangement.category === category;
    });
  };
}), _getters);

// actions
var actions = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].actions.updatePreArrangementField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var preArrangementID = _ref2.preArrangementID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePreArrangementField, {
    preArrangementID: preArrangementID,
    fieldName: fieldName,
    value: value
  });
});

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setPreArrangements, function (state, preArrangements) {
  state.ids = preArrangements.map(function (preArrangement) {
    return preArrangement.preArrangementID;
  });
  state.entities = preArrangements.reduce(function (accumulate, current) {
    accumulate[current.preArrangementID] = current;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePreArrangementField, function (state, _ref3) {
  var preArrangementID = _ref3.preArrangementID,
      fieldName = _ref3.fieldName,
      value = _ref3.value;

  state.entities[preArrangementID][fieldName] = value;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.copyPreArrangement, function (state, _ref4) {
  var preArrangement = _ref4.preArrangement,
      preArrangementToCopyFrom = _ref4.preArrangementToCopyFrom;

  state.entities[preArrangement.preArrangementID] = Object.assign({}, preArrangementToCopyFrom, {
    preArrangementID: preArrangement.preArrangementID,
    contactID: preArrangement.contactID,
    title: preArrangement.title
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 381 */
/*!**********************************************!*\
  !*** ./src/store/modules/postArrangement.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(/*! ../types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../../constants */ 13);
var _getters, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




// initial state
var state = {
  ids: [],
  entities: {}
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangements, function (state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangement, function (state) {
  return function (postArrangementID) {
    return state.entities[postArrangementID];
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangementByContactID, function (state) {
  return function (contactID) {
    return Object.values(state.entities).filter(function (postArrangement) {
      return postArrangement.contactID === contactID;
    });
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangementByContactIDAndCategory, function (state) {
  return function (contactID, category) {
    return Object.values(state.entities).find(function (postArrangement) {
      return postArrangement.contactID === contactID && postArrangement.category === category;
    });
  };
}), _getters);

// actions
var actions = _defineProperty({}, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].actions.updatePostArrangementField, function (_ref, _ref2) {
  var commit = _ref.commit,
      getters = _ref.getters,
      state = _ref.state;
  var postArrangementID = _ref2.postArrangementID,
      fieldName = _ref2.fieldName,
      value = _ref2.value,
      _ref2$triggerReset = _ref2.triggerReset,
      triggerReset = _ref2$triggerReset === undefined ? true : _ref2$triggerReset;

  commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePostArrangementField, {
    postArrangementID: postArrangementID,
    fieldName: fieldName,
    value: value
  });

  if (fieldName === "postArrangementAction") {
    var _resetPostArrangementPortToLocation = function _resetPostArrangementPortToLocation(postArrangementPortToLocation) {
      if (postArrangementPortToLocation.typeOfArrangement === "AE Shared transfer") {
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementPortToLocationDetail, {
          postArrangementID: postArrangementPortToLocation.postArrangementID
        });
      }
    };

    var postArrangementPortToLocation = state.entities[postArrangementID];

    if (postArrangementPortToLocation.category !== "Port to location") {
      console.warn("Expected postArrangement's category to be 'Port to location' but is " + postArrangementPortToLocation.category);
      return;
    }

    var postArrangementAccommodation = getters[__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangementByContactIDAndCategory](postArrangementPortToLocation.contactID, "Accommodation");
    var postArrangementFlight = getters[__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].getters.postArrangementByContactIDAndCategory](postArrangementPortToLocation.contactID, "Flight");

    switch (value) {
      case "airport":
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePostArrangementField, {
          postArrangementID: postArrangementFlight.postArrangementID,
          fieldName: "notTakingAFlight",
          value: false
        });
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementAccommodationDetail, {
          postArrangementID: postArrangementAccommodation.postArrangementID
        });
        if (triggerReset) {
          _resetPostArrangementPortToLocation(postArrangementPortToLocation);
        }
        break;
      case "hotel":
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementFlightDetail, {
          postArrangementID: postArrangementFlight.postArrangementID
        });
        if (triggerReset) {
          _resetPostArrangementPortToLocation(postArrangementPortToLocation);
        }
        break;
      case "sharedTransfer":
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementAccommodationDetail, {
          postArrangementID: postArrangementAccommodation.postArrangementID
        });
        commit(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePostArrangementField, {
          postArrangementID: postArrangementPortToLocation.postArrangementID,
          fieldName: "typeOfArrangement",
          value: "AE Shared transfer"
        });
        break;
      default:
        break;
    }
  }
});

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.setPostArrangements, function (state, _ref3) {
  var postArrangements = _ref3.postArrangements,
      booking = _ref3.booking;

  state.ids = postArrangements.map(function (postArrangement) {
    return postArrangement.postArrangementID;
  });
  state.entities = postArrangements.reduce(function (accumulate, current) {
    if (current.category === "Port to location") {
      // For booking that isAmazonCruise or isToPhnomPenh or for Aqua Blu, there is no 'sharedTransfer' option in the select list.
      if (!booking.isAmazonCruise && !booking.isToPhnomPenh && booking.facilityCode !== __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* FACILITY_CODES */].AquaBlu && current.typeOfArrangement === "AE Shared transfer") {
        current.postArrangementAction = "sharedTransfer";
      } else {
        var postArrangementFlight = postArrangements.find(function (postArrangement) {
          return postArrangement.contactID === current.contactID && postArrangement.category === "Flight";
        });

        // assume action is airport if notTakingAFlight is false
        if (postArrangementFlight && !postArrangementFlight.notTakingAFlight) {
          current.postArrangementAction = "airport";
        }
        // defaults to hotel
        else {
            current.postArrangementAction = "hotel";
          }
      }
    }
    accumulate[current.postArrangementID] = current;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.updatePostArrangementField, function (state, _ref4) {
  var postArrangementID = _ref4.postArrangementID,
      fieldName = _ref4.fieldName,
      value = _ref4.value;

  state.entities[postArrangementID][fieldName] = value;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementAccommodationDetail, function (state, _ref5) {
  var postArrangementID = _ref5.postArrangementID;

  if (state.entities[postArrangementID].category !== "Accommodation") {
    console.warn("Expected category to be 'Accommodation' but is " + state.entities[postArrangementID].category + ", postArrangementID: " + state.entities[postArrangementID].postArrangementID);
    return;
  }

  state.entities[postArrangementID].accommodationName = "";
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementFlightDetail, function (state, _ref6) {
  var postArrangementID = _ref6.postArrangementID;

  if (state.entities[postArrangementID].category !== "Flight") {
    console.warn("Expected category to be 'Flight' but is " + state.entities[postArrangementID].category + ", postArrangementID: " + state.entities[postArrangementID].postArrangementID);
    return;
  }

  state.entities[postArrangementID].notTakingAFlight = true;
  state.entities[postArrangementID].takingRecommendedFlight = false;
  state.entities[postArrangementID].flightNumber = "";
  state.entities[postArrangementID].departureDate = null;
  state.entities[postArrangementID].departureTime = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.resetPostArrangementPortToLocationDetail, function (state, _ref7) {
  var postArrangementID = _ref7.postArrangementID;

  if (state.entities[postArrangementID].category !== "Port to location") {
    console.warn("Expected category to be 'Port to location' but is " + state.entities[postArrangementID].category + ", postArrangementID: " + state.entities[postArrangementID].postArrangementID);
    return;
  }

  state.entities[postArrangementID].typeOfArrangement = "";
  state.entities[postArrangementID].nameOfPerson = "";
  state.entities[postArrangementID].contactNo = "";
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_0__types__["a" /* default */].mutations.copyPostArrangement, function (state, _ref8) {
  var postArrangement = _ref8.postArrangement,
      postArrangementToCopyFrom = _ref8.postArrangementToCopyFrom;

  state.entities[postArrangement.postArrangementID] = Object.assign({}, postArrangementToCopyFrom, {
    postArrangementID: postArrangement.postArrangementID,
    contactID: postArrangement.contactID,
    title: postArrangement.title
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 382 */
/*!**********************************************!*\
  !*** ./src/store/modules/visaRequirement.js ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_visaRequirement__ = __webpack_require__(/*! @/api/visaRequirement */ 383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_http_common__ = __webpack_require__(/*! @/api/http-common */ 20);
var _getters, _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// initial state
var state = {
  ids: [],
  entities: []
};

var getVisaRequirements = function getVisaRequirements(state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.visaRequirements, getVisaRequirements), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.visaRequirement, function (state) {
  return function (visaRequirementID) {
    return state.entities[visaRequirementID];
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.visaRequirementByContactID, function (state) {
  return function (contactID) {
    var visaRequirement = Object.values(state.entities).find(function (visaRequirement) {
      return visaRequirement.contactID === contactID;
    });
    // console.log("visaRequirement:", visaRequirement)
    return visaRequirement;
  };
}), _getters);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateVisaRequirementField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var visaRequirementID = _ref2.visaRequirementID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateVisaRequirementField, {
    visaRequirementID: visaRequirementID,
    fieldName: fieldName,
    value: value
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateVisaRequirementsRemote, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var visaRequirements = _ref4.visaRequirements,
      _ref4$showLoader = _ref4.showLoader,
      showLoader = _ref4$showLoader === undefined ? true : _ref4$showLoader;

  var changedVisaRequirements = visaRequirements.filter(function (visaRequirement) {
    return visaRequirement.isDirty;
  });
  if (!changedVisaRequirements.length) {
    return Promise.resolve();
  }

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api_visaRequirement__["a" /* default */].updateVisaRequirements(visaRequirements).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag);
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setVisaRequirements, function (state, visaRequirements) {
  state.ids = visaRequirements.map(function (visaRequirement) {
    return visaRequirement.visaRequirementID;
  });
  state.entities = visaRequirements.reduce(function (accumulate, visaRequirement) {
    if (visaRequirement.file && visaRequirement.file.url) {
      visaRequirement.file.url = __WEBPACK_IMPORTED_MODULE_2__api_http_common__["c" /* baseURL */] + "/" + visaRequirement.file.url;
    }

    accumulate[visaRequirement.visaRequirementID] = visaRequirement;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateVisaRequirementField, function (state, _ref5) {
  var visaRequirementID = _ref5.visaRequirementID,
      fieldName = _ref5.fieldName,
      value = _ref5.value;

  state.entities[visaRequirementID][fieldName] = value;
  state.entities[visaRequirementID].isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateVisaRequirementEntity, function (state, _ref6) {
  var visaRequirement = _ref6.visaRequirement;

  if (visaRequirement.file && visaRequirement.file.url) {
    visaRequirement.file.url = __WEBPACK_IMPORTED_MODULE_2__api_http_common__["c" /* baseURL */] + "/" + visaRequirement.file.url;
  }

  state.entities[visaRequirement.visaRequirementID] = visaRequirement;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetVisaRequirementsDirtyFlag, function (state) {
  getVisaRequirements(state).forEach(function (entity) {
    return entity.isDirty = false;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 383 */
/*!************************************!*\
  !*** ./src/api/visaRequirement.js ***!
  \************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);


var visaRequirementAPI = {
  updateVisaRequirements: function updateVisaRequirements(visaRequirements) {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/visa-requirement", {
      visaRequirements: visaRequirements
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CV1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (visaRequirementAPI);

/***/ }),
/* 384 */
/*!***************************************!*\
  !*** ./src/store/modules/passport.js ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_passport__ = __webpack_require__(/*! @/api/passport */ 385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_http_common__ = __webpack_require__(/*! @/api/http-common */ 20);
var _getters, _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





// initial state
var state = {
  ids: [],
  entities: []
};

var getPassports = function getPassports(state) {
  return state.ids.map(function (id) {
    return state.entities[id];
  });
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.passports, getPassports), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.passport, function (state) {
  return function (passportID) {
    return state.entities[passportID];
  };
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.passportByContactID, function (state) {
  return function (contactID) {
    var passport = Object.values(state.entities).find(function (passport) {
      return passport.contactID === contactID;
    });
    // console.log("passport:", passport)
    return passport;
  };
}), _getters);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updatePassportField, function (_ref, _ref2) {
  var commit = _ref.commit;
  var passportID = _ref2.passportID,
      fieldName = _ref2.fieldName,
      value = _ref2.value;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updatePassportField, {
    passportID: passportID,
    fieldName: fieldName,
    value: value
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updatePassportsRemote, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var passports = _ref4.passports,
      _ref4$showLoader = _ref4.showLoader,
      showLoader = _ref4$showLoader === undefined ? true : _ref4$showLoader;

  var changedPassports = passports.filter(function (passport) {
    return passport.isDirty;
  });
  if (!changedPassports.length) {
    return Promise.resolve();
  }

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api_passport__["a" /* default */].updatePassports(passports).then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag);
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setPassports, function (state, passports) {
  state.ids = passports.map(function (passport) {
    return passport.passportID;
  });
  state.entities = passports.reduce(function (accumulate, passport) {
    if (passport.file && passport.file.url) {
      passport.file.url = __WEBPACK_IMPORTED_MODULE_2__api_http_common__["c" /* baseURL */] + "/" + passport.file.url;
    }

    accumulate[passport.passportID] = passport;
    return accumulate;
  }, {});
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updatePassportField, function (state, _ref5) {
  var passportID = _ref5.passportID,
      fieldName = _ref5.fieldName,
      value = _ref5.value;

  state.entities[passportID][fieldName] = value;
  state.entities[passportID].isDirty = true;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updatePassportEntity, function (state, _ref6) {
  var passport = _ref6.passport;

  if (passport.file && passport.file.url) {
    passport.file.url = __WEBPACK_IMPORTED_MODULE_2__api_http_common__["c" /* baseURL */] + "/" + passport.file.url;
  }

  state.entities[passport.passportID] = passport;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetPassportsDirtyFlag, function (state) {
  getPassports(state).forEach(function (entity) {
    return entity.isDirty = false;
  });
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 385 */
/*!*****************************!*\
  !*** ./src/api/passport.js ***!
  \*****************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);


var passportAPI = {
  updatePassports: function updatePassports(passports) {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/passport", {
      passports: passports
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CV1] Oops! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (passportAPI);

/***/ }),
/* 386 */
/*!*************************************!*\
  !*** ./src/store/modules/common.js ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(/*! ../../api */ 387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(/*! ../types */ 1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_http_common__ = __webpack_require__(/*! ../../api/http-common */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(/*! ../../constants */ 13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_common__ = __webpack_require__(/*! ../../api/common */ 388);
var _getters, _actions, _mutations;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







// initial state
var state = {
  accessToken: null,
  expiryTime: 0, // Duration before access token expires in milliseconds
  lastSaveTime: 0,
  isSaving: false,
  dietaryAllergies: __WEBPACK_IMPORTED_MODULE_3__constants__["n" /* DIETARY_ALLERGIES */]
};

// getters
var getters = (_getters = {}, _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.accessToken, function (state) {
  return state.accessToken;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.expiryTime, function (state) {
  return state.expiryTime;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.lastSaveTime, function (state) {
  return state.lastSaveTime;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.isSaving, function (state) {
  return state.isSaving;
}), _defineProperty(_getters, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.dietaryAllergies, function (state) {
  return state.dietaryAllergies;
}), _getters);

// actions
var actions = (_actions = {}, _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.setAccessToken, function (_ref, _ref2) {
  var commit = _ref.commit;
  var accessToken = _ref2.accessToken;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setAccessToken, accessToken);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.setLastSaveTime, function (_ref3, _ref4) {
  var commit = _ref3.commit;
  var lastSaveTime = _ref4.lastSaveTime;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setLastSaveTime, lastSaveTime);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.setIsSaving, function (_ref5, _ref6) {
  var commit = _ref5.commit;
  var isSaving = _ref6.isSaving;

  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsSaving, isSaving);
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.refreshAccessToken, function (_ref7) {
  var commit = _ref7.commit;

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].refreshAccessToken().then(function (res) {
    if (res.accessToken) {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setAccessToken, res.accessToken);
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setExpiryTime, res.expiryTime);
    }
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.logout, function (_ref8) {
  var commit = _ref8.commit;

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].logout().then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.removeAccessToken);
    return res;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.getDietaryAllergies, function (_ref9) {
  var commit = _ref9.commit;

  return __WEBPACK_IMPORTED_MODULE_4__api_common__["a" /* default */].fetchDietaryAllergies().then(function (res) {
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setDietaryAllergies, res);
    return res;
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateContactsAndVisaRequirementsRemote, function (_ref10, _ref11) {
  var commit = _ref10.commit;
  var contacts = _ref11.contacts,
      visaRequirements = _ref11.visaRequirements,
      passports = _ref11.passports,
      _ref11$showLoader = _ref11.showLoader,
      showLoader = _ref11$showLoader === undefined ? true : _ref11$showLoader,
      _ref11$workflowTrigge = _ref11.workflowTrigger,
      workflowTrigger = _ref11$workflowTrigge === undefined ? true : _ref11$workflowTrigge;

  var changedContacts = contacts.filter(function (contact) {
    return contact.isDirty;
  });
  var changedVisaRequirements = visaRequirements.filter(function (visaRequirement) {
    return visaRequirement.isDirty;
  });
  var changedPassports = passports.filter(function (passport) {
    return passport.isDirty;
  });
  if (!changedContacts.length && !changedVisaRequirements.length && !changedPassports.length) {
    return Promise.resolve(false);
  }

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });
  commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsSaving, true);

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].updateContactsAndVisaRequirements(changedContacts, changedVisaRequirements, changedPassports, workflowTrigger // tell backend whether Zoho automations should run
  ).then(function (res) {
    if (workflowTrigger && changedContacts.length) {
      // only clear dirty flags on the final, workflow-enabled save
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag);
    }
    if (workflowTrigger && changedVisaRequirements.length) {
      res.updatedVisaRequirements.forEach(function (updatedVisaRequirement) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updateVisaRequirementEntity, {
          visaRequirement: updatedVisaRequirement
        });
      });

      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetVisaRequirementsDirtyFlag);
    }
    if (workflowTrigger && changedPassports.length) {
      res.updatedPassports.forEach(function (updatedPassport) {
        commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.updatePassportEntity, {
          passport: updatedPassport
        });
      });
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetPassportsDirtyFlag);
    }
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsSaving, false);
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updateContactsAndBookingRemote, function (_ref12, _ref13) {
  var commit = _ref12.commit;
  var contacts = _ref13.contacts,
      booking = _ref13.booking,
      _ref13$contactBooking = _ref13.contactBookings,
      contactBookings = _ref13$contactBooking === undefined ? [] : _ref13$contactBooking,
      _ref13$showLoader = _ref13.showLoader,
      showLoader = _ref13$showLoader === undefined ? true : _ref13$showLoader,
      _ref13$workflowTrigge = _ref13.workflowTrigger,
      workflowTrigger = _ref13$workflowTrigge === undefined ? true : _ref13$workflowTrigge;

  console.log("[updateContactsAndBookingRemote] booking.isDirty:", booking && booking.isDirty);

  var changedContacts = contacts.filter(function (contact) {
    return contact.isDirty;
  });
  var changedContactBookings = contactBookings.filter(function (contactBooking) {
    return contactBooking.isDirty;
  });
  if (!changedContacts.length && !changedContactBookings.length && (booking && !booking.isDirty || !booking)) {
    return Promise.resolve(false);
  }
  var bookingPayload = booking && booking.isDirty ? booking : undefined;

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].updateContactsAndBooking(changedContacts, bookingPayload, changedContactBookings, workflowTrigger).then(function (res) {
    if (workflowTrigger && changedContacts.length) {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactsDirtyFlag);
    }
    if (workflowTrigger && changedContactBookings.length) {
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetContactBookingsDirtyFlag);
    }
    if (workflowTrigger && bookingPayload) {
      // only clear booking dirty state after the final workflow-enabled sync
      commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.resetBookingDirtyFlag);
    }
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.updatePrePostArrangementsRemote, function (_ref14, _ref15) {
  var commit = _ref14.commit;
  var prePostArrangements = _ref15.prePostArrangements,
      _ref15$showLoader = _ref15.showLoader,
      showLoader = _ref15$showLoader === undefined ? true : _ref15$showLoader;

  showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: true });

  return __WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */].updatePrePostArrangements(prePostArrangements).then(function (res) {
    // changedContacts.length && commit(types.mutations.resetContactsDirtyFlag)
    // if (changedVisaRequirements.length) {
    //   res.updatedVisaRequirements.forEach(updatedVisaRequirement => {
    //     commit(types.mutations.updateVisaRequirementEntity, { visaRequirement: updatedVisaRequirement })
    //   })
    //
    //   commit(types.mutations.resetVisaRequirementsDirtyFlag)
    // }
    return res;
  }).finally(function () {
    showLoader && commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsLoading, { isLoading: false });
  });
}), _defineProperty(_actions, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].actions.copyPrePostArrangement, function (_ref16, _ref17) {
  var commit = _ref16.commit,
      getters = _ref16.getters;
  var preArrangements = _ref17.preArrangements,
      postArrangements = _ref17.postArrangements;

  var primaryContact = getters[__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.primaryContact];

  preArrangements.forEach(function (preArrangement) {
    var preArrangementToCopyFrom = getters[__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.preArrangementByContactIDAndCategory](primaryContact.contactID, preArrangement.category);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.copyPreArrangement, {
      preArrangement: preArrangement,
      preArrangementToCopyFrom: preArrangementToCopyFrom
    });
  });

  postArrangements.forEach(function (postArrangement) {
    var postArrangementToCopyFrom = getters[__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].getters.postArrangementByContactIDAndCategory](primaryContact.contactID, postArrangement.category);
    commit(__WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.copyPostArrangement, {
      postArrangement: postArrangement,
      postArrangementToCopyFrom: postArrangementToCopyFrom
    });
  });
}), _actions);

// mutations
var mutations = (_mutations = {}, _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setExpiryTime, function (state, expiryTime) {
  state.expiryTime = expiryTime;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setAccessToken, function (state, accessToken) {
  __WEBPACK_IMPORTED_MODULE_2__api_http_common__["a" /* HTTP */].defaults.headers.common["Authorization"] = accessToken;
  state.accessToken = accessToken;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setLastSaveTime, function (state, lastSaveTime) {
  state.lastSaveTime = lastSaveTime;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setIsSaving, function (state, isSaving) {
  state.isSaving = isSaving;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.removeAccessToken, function (state) {
  // Remove Authorization header on successful logout
  delete __WEBPACK_IMPORTED_MODULE_2__api_http_common__["a" /* HTTP */].defaults.headers.common["Authorization"];

  state.accessToken = null;
}), _defineProperty(_mutations, __WEBPACK_IMPORTED_MODULE_1__types__["a" /* default */].mutations.setDietaryAllergies, function (state, dietaryAllergies) {
  state.dietaryAllergies = dietaryAllergies;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 387 */
/*!**************************!*\
  !*** ./src/api/index.js ***!
  \**************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);


var API = {
  updateContactsAndVisaRequirements: function updateContactsAndVisaRequirements(contacts, visaRequirements, passports) {
    var workflowTrigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    console.log("[API updateContactsAndVisaRequirements] contacts, visaRequirements, passports:", contacts, visaRequirements, passports);

    var postData = {};
    if (contacts && contacts.length) {
      postData.contacts = contacts;
    }

    if (visaRequirements && visaRequirements.length) {
      postData.visaRequirements = visaRequirements;
    }

    if (passports && passports.length) {
      postData.passports = passports;
    }

    postData.workflowTrigger = workflowTrigger; // backend uses this to toggle Zoho workflow triggers

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/contact-and-visa-requirement", postData).then(function (response) {
      return response.data;
    }).catch(function (error) {
      var message = "[CI1] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you.";

      if (error.response && error.response.data) {
        var isZohoError = error.response.data.data && error.response.data.data.isZohoAPI && error.response.data.data.zohoResponse;

        if (isZohoError) {
          var zohoResponse = error.response.data.data.zohoResponse.data;
          var errFieldName = zohoResponse[0].details.api_name.replaceAll("_", " ");

          if (errFieldName) {
            message = "[ " + errFieldName + "] You have entered an invalid data.";
          }
        } else {
          message = error.response.data.message || error.response.data.error;
        }
      }

      throw Object.assign({}, error, {
        message: message
      });
    });
  },
  updateContactsAndBooking: function updateContactsAndBooking(contacts, booking, contactBookings) {
    var workflowTrigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    console.log("[API updateContactsAndBooking] contacts, booking, contactBookings:", contacts, booking, contactBookings);

    var postData = {};
    if (contacts && contacts.length) {
      postData.contacts = contacts;
    }

    if (booking) {
      postData.booking = booking;
    }

    if (contactBookings && contactBookings.length) {
      postData.contactBookings = contactBookings;
    }

    postData.workflowTrigger = workflowTrigger; // backend mirrors this to Zoho to toggle workflows

    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/contact-and-booking", postData).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CI2] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  updatePrePostArrangements: function updatePrePostArrangements(prePostArrangements) {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].put("/pre-post-arrangement", {
      prePostArrangements: prePostArrangements
    }).then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CI3] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  logout: function logout() {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].post("/logout").then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CI4] Opps! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  },
  refreshAccessToken: function refreshAccessToken() {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].post("/refresh").then(function (response) {
      return response.data;
    }).catch(function (error) {
      throw Object.assign({}, error, {
        message: error.response && error.response.data && (error.response.data.message || error.response.data.error) || "[CI5] Oops! It appears that we have encountered an issue with the check-in, please contact reservations@aquaexpeditions.com and we will be glad to assist you."
      });
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (API);

/***/ }),
/* 388 */
/*!***************************!*\
  !*** ./src/api/common.js ***!
  \***************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__http_common__ = __webpack_require__(/*! ./http-common */ 20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(/*! ../constants */ 13);



var commonAPI = {
  fetchDietaryAllergies: function fetchDietaryAllergies() {
    return __WEBPACK_IMPORTED_MODULE_0__http_common__["a" /* HTTP */].get(undefined + "/api/v0/dietary-allergies").then(function (response) {
      return response.data.data;
    }).catch(function (error) {
      console.log("using fallback value due to unable to retrieve dietary allergies from api:", error);
      return __WEBPACK_IMPORTED_MODULE_1__constants__["n" /* DIETARY_ALLERGIES */];
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (commonAPI);

/***/ }),
/* 389 */
/*!*******************************!*\
  !*** ./src/plugins/logger.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLogger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(/*! ../utils */ 34);
// Credits: borrowed code from fcomb/redux-logger



function createLogger() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$collapsed = _ref.collapsed,
      collapsed = _ref$collapsed === undefined ? true : _ref$collapsed,
      _ref$filter = _ref.filter,
      filter = _ref$filter === undefined ? function (mutation, stateBefore, stateAfter) {
    return true;
  } : _ref$filter,
      _ref$transformer = _ref.transformer,
      transformer = _ref$transformer === undefined ? function (state) {
    return state;
  } : _ref$transformer,
      _ref$mutationTransfor = _ref.mutationTransformer,
      mutationTransformer = _ref$mutationTransfor === undefined ? function (mut) {
    return mut;
  } : _ref$mutationTransfor,
      _ref$logger = _ref.logger,
      logger = _ref$logger === undefined ? console : _ref$logger;

  return function (store) {
    var prevState = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* deepCopy */])(store.state);

    store.subscribe(function (mutation, state) {
      if (typeof logger === "undefined") {
        return;
      }
      var nextState = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* deepCopy */])(state);

      if (filter(mutation, prevState, nextState)) {
        var time = new Date();
        var formattedTime = " @ " + pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
        var formattedMutation = mutationTransformer(mutation);
        var message = "mutation " + mutation.type + formattedTime;
        var startMessage = collapsed ? logger.groupCollapsed : logger.group;

        // render
        try {
          startMessage.call(logger, message);
        } catch (e) {
          console.log(message);
        }

        logger.log("%c prev state", "color: #9E9E9E; font-weight: bold", transformer(prevState));
        logger.log("%c mutation", "color: #03A9F4; font-weight: bold", formattedMutation);
        logger.log("%c next state", "color: #4CAF50; font-weight: bold", transformer(nextState));

        try {
          logger.groupEnd();
        } catch (e) {
          logger.log("—— log end ——");
        }
      }

      prevState = nextState;
    });
  };
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num;
}

/***/ }),
/* 390 */,
/* 391 */
/*!*******************************************!*\
  !*** ./src/components/StyleGuidePage.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d6022e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleGuidePage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-37d6022e","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./StyleGuidePage.vue */ 392);
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37d6022e_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StyleGuidePage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 392 */
/*!********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37d6022e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/StyleGuidePage.vue ***!
  \********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-button',{attrs:{"type":"primary"}},[_vm._v("Primary")]),_vm._v(" "),_c('el-form',[_c('el-form-item',{attrs:{"label":"Booking number:"}},[_c('el-input')],1)],1),_vm._v(" "),_c('el-form',{attrs:{"label-position":"left","label-width":"144px"}},[_c('el-form-item',{attrs:{"label":"Booking number:"}},[_c('el-input')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 393 */
/*!**************************************!*\
  !*** ./src/components/LoginPage.vue ***!
  \**************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./LoginPage.vue */ 178);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab9f0d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-aab9f0d6","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./LoginPage.vue */ 395);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-aab9f0d6","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./LoginPage.vue */ 394)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-aab9f0d6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_LoginPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aab9f0d6_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 394 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aab9f0d6","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/LoginPage.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 395 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aab9f0d6","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginPage.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__login"},[_c('div',{staticClass:"main__login__shade"}),_vm._v(" "),_c('el-card',{staticStyle:{"width":"700px","z-index":"1"},attrs:{"body-style":{ padding: '80px 76px' },"dis-hover":""}},[_c('div',{staticClass:"main__login__title"},[_vm._v("Online check-in")]),_vm._v(" "),_c('div',{staticClass:"main__login__subtitle"},[_vm._v("Search for your booking below")]),_vm._v(" "),(_vm.isSiteOnMaintenance())?_c('div',{staticClass:"main__maintenance"},[_c('h2',[_vm._v("\n        We are upgrading our system to serve you better and will be back\n        shortly. Please check back later, or contact Aqua Expeditions for any\n        enquiries.\n      ")])]):_c('el-form',{ref:"formValidate",attrs:{"model":_vm.formValidate,"rules":_vm.ruleValidate}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticStyle:{"margin-bottom":"24px"},attrs:{"label":"Booking number","prop":"bookingCode"}},[_c('el-input',{model:{value:(_vm.formValidate.bookingCode),callback:function ($$v) {_vm.$set(_vm.formValidate, "bookingCode", $$v)},expression:"formValidate.bookingCode"}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('el-form-item',{staticStyle:{"margin-bottom":"0"},attrs:{"label":"Last / Family name of primary guest","prop":"lastName"}},[_c('el-input',{model:{value:(_vm.formValidate.lastName),callback:function ($$v) {_vm.$set(_vm.formValidate, "lastName", $$v)},expression:"formValidate.lastName"}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"24px"}},[_c('div',{staticClass:"main__login__link"},[_c('a',{staticClass:"link-guide",attrs:{"href":_vm.appendMarketingSiteUrl('/check-in-guide'),"target":"_blank"}},[_c('i',{staticClass:"icon icon-question-mark"}),_vm._v("Check-in guide")])]),_vm._v(" "),_c('el-button',{staticClass:"button--primary main__login__checkIn",attrs:{"type":"primary"},on:{"click":function($event){return _vm.handleSubmit('formValidate')}}},[_vm._v("Check in")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 396 */
/*!***********************************************!*\
  !*** ./src/components/BookingSummaryPage.vue ***!
  \***********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSummaryPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./BookingSummaryPage.vue */ 179);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca66efd2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingSummaryPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ca66efd2","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./BookingSummaryPage.vue */ 401);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ca66efd2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./BookingSummaryPage.vue */ 397)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ca66efd2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_BookingSummaryPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca66efd2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BookingSummaryPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 397 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ca66efd2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/BookingSummaryPage.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 398 */,
/* 399 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-299b43bc","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AutosaveIndicator.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 400 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-299b43bc","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AutosaveIndicator.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"autosave-indicator"},[_c('span',{staticClass:"autosave-indicator__circle",class:{ 'autosave-indicator__circle--saved': !_vm.isSaving }}),_vm._v(" "),(_vm.isSaving)?_c('span',{staticClass:"autosave-indicator__label"},[_vm._v(" Saving... ")]):_vm._e(),_vm._v(" "),(!_vm.isSaving)?_c('span',{staticClass:"autosave-indicator__label"},[_vm._v("\n    Saved "+_vm._s(_vm._f("saveTimeFilter")(_vm.lastSaveTime))+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 401 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca66efd2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BookingSummaryPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__booking-summary container"},[_c('div',{ref:"formRoot",staticClass:"summary"},[_c('div',{staticClass:"summary__header"},[_c('img',{attrs:{"src":this.cruiseBannerUrl}}),_vm._v(" "),_c('div',{staticClass:"summary__header__info"},[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"summary__cruise-name"},[_vm._v("\n            "+_vm._s(_vm.cabinConfigurations[0] ? _vm.cabinConfigurations[0].ship : "")+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"summary__booking-number"},[_c('div',{staticClass:"summary__booking-number__label"},[_vm._v("Booking number")]),_vm._v(" "),_c('div',{staticClass:"summary__booking-number__value"},[_vm._v("\n              "+_vm._s(_vm.booking.bookingCode)+"\n            ")])])]),_vm._v(" "),_c('el-row',{staticStyle:{"margin-top":"32px"},attrs:{"justify":"space-between","type":"flex"}},_vm._l((_vm.bookingSummary),function(summary){return _c('div',{staticClass:"summary__card"},[_c('i',{class:'icon ' + summary.iconClass}),_vm._v(" "),_c('div',{staticClass:"summary__card__label"},[_vm._v(_vm._s(summary.label))]),_vm._v(" "),_c('div',{staticClass:"summary__card__value"},[_vm._v(_vm._s(summary.value))])])}),0)],1)]),_vm._v(" "),_c('div',{staticClass:"summary__content"},[_c('div',{staticClass:"summary__content__title"},[_vm._v("Booking Details")]),_vm._v(" "),_vm._l((_vm.cabinConfigurations),function(cc,index){return _c('el-row',{key:cc.cabinConfigurationID,staticClass:"cabin-configuration"},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Guest(s)")]),_vm._v(" "),_vm._l((_vm.getGuestNameList(cc)),function(guestName){return _c('div',{staticClass:"cabin-configuration__guest"},[_vm._v("\n            "+_vm._s(guestName)+"\n          ")])})],2),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Suite")]),_vm._v(" "),_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-design-suite"}),_vm._v(_vm._s(cc.suite)+"\n            "+_vm._s(_vm.getCabinCategory(cc))+"\n          ")]),_vm._v(" "),(_vm.canShowDeck(cc.deck))?_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-deck"}),_vm._v(_vm._s(cc.deck)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.canShowBalconyType())?_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-balcony"}),_vm._v(_vm._s(cc.hasBalcony ? "Balcony" : "Non-balcony")+"\n          ")]):_vm._e(),_vm._v(" "),(cc.interconnectingCabin && _vm.canShowInterconnectingCabin())?_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-interconnecting"}),_vm._v("Interconnecting with Suite\n            "+_vm._s(cc.interconnectingCabin)+"\n          ")]):_vm._e()]),_vm._v(" "),(_vm.isBedConfigurable(cc))?_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Bed configuration")]),_vm._v(" "),_c('el-form',{ref:"ruleFormCabinConfig",refInFor:true,attrs:{"model":_vm.ruleForm,"rules":_vm.rules}},[_c('el-form-item',{attrs:{"prop":'cabinInput' + index}},[_c('v-select',{attrs:{"clearable":false,"options":cc.hasBalcony
                    ? _vm.selectBedConfigurationsForBalcony
                    : cc.ship === 'Aqua Lares'
                      ? _vm.selectBedConfigurationsForAquaLares[cc.cabin]
                      : _vm.selectBedConfigurationsForNonBalcony,"reduce":function (item) { return item.value; },"searchable":false,"value":_vm.ruleForm['cabinInput' + index],"filterable":"","label":"label"},on:{"input":function($event){return _vm.onCabinConfigurationInputChange(
                    cc.cabinConfigurationID,
                    'cabinBedding',
                    $event,
                    index
                  )}}})],1)],1)],1):_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Bed configuration")]),_vm._v(" "),_c('div',{staticClass:"cabin-configuration__guest"},[_vm._v("\n            "+_vm._s(_vm.getFixedCabinBedding(cc))+" "),_c('br'),_vm._v("\n            "+_vm._s(_vm.getFixedCabinBeddingSize(cc))+"\n          ")])])],1)})],2)]),_vm._v(" "),_c('div',{staticClass:"box-note"},[_vm._v("\n    Note: Please ensure that all guest(s) above are confirmed. If any of the\n    guest(s) are not able to take the cruise anymore, please\n    "),_c('a',{attrs:{"href":_vm.appendMarketingSiteUrl('/contact-us'),"target":"_blank"}},[_vm._v("contact us")]),_vm._v("\n    directly to make changes to your guest list.\n  ")]),_vm._v(" "),_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"end","type":"flex"}},[_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n    ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickNext()}}},[_vm._v("Next")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 402 */
/*!*********************************************!*\
  !*** ./src/components/GuestListingPage.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_GuestListingPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./GuestListingPage.vue */ 181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749f08f5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestListingPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-749f08f5","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./GuestListingPage.vue */ 414);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-749f08f5","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./GuestListingPage.vue */ 403)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-749f08f5","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./GuestListingPage.vue */ 404)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-749f08f5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_GuestListingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_749f08f5_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GuestListingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 403 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-749f08f5","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GuestListingPage.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 404 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-749f08f5","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/GuestListingPage.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 405 */
/*!****************************************!*\
  !*** ./src/assets/images/icon-pdf.png ***!
  \****************************************/
/*! dynamic exports provided */
/*! exports used: default */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABGCAYAAABxLuKEAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAARqADAAQAAAABAAAARgAAAABuJQAYAAADfklEQVR4Ae2aT0gVQRzH57erj6dpUNgfCIKihDLzKNIlqA6V/SF6HUroUlCntD8UCR0sn0hE6LVb+Cysk1GdOncIpIt57lCnIkIz0ff218w+N9bc39PZtzs48Vvw7bzvb2Z25jPf+e3uQ0BEV/CxjICzTGHBJ8BgCCMwGAZDECBkdgyDIQgQMjuGwRAECJkdw2AIAoTMjiHA1BC6lnysf6So1UCrMkxua2g89OTayW9azaqsbIFjsOXLzPS7y0PjTVXOVas5JPF2HTjmTW9XIg4MZhD0W/5u1jkWOEZhgUkhzDrHCjAqx5iGYwUYlXhNw7ECjNpMpuFYA8Y0HKvAmIRjHRhTcKwEYwKOtWDShpPok6oabBrH0ifgSlcoPwTKGm2Vaq0mZrVjoieILdG6nrqmHaP77rV6Z60M6T90zMqTXk0NBkNQYjAMhiBAyOwYBkMQIGTtnzaTvCUSY0pF1r3181YiliH2A57uChDXT12O63B2DLE0DIbBEAQIOXaOIfqLlE/kCwMeitMqiCCmXQETDdl1fc+un/ramS8MI4ojfkMQPwDEVH0282isJ/dJaZ0Do33oYc6PL34cbt7Z1pPrmA9rSZeNbCVPwBYUuFuAaAIh9pTQu/RzbmZMTQaF2KpiCLhRIDZ7Hl6cmZ2fyA0+b1dxQLH5b1w+XEhBNkn/MAImmIbjwFBdNntg8Xv74xfvM0HMBTd/q7drk+M4BYmrZrZYvB/E1FnqQ6/vdu1Vf2m7xb9e+OJpl+WW2Pd7bu6muo50wvd/J3hQEqmtcZ+WxwH7y+fyJ5Yw15kfHZFbbzCsp1U2kmOCwXuIZ/0yiAVw3NuBHj6jJ7OMPGQuWpJD5HZqlf+A0CqDUzIc2TbcT7Vlo2AEwLjriNH12boPhe4zn6MGXywtnPN1xI/huOs4D3Zs3/CwlKnzwnpaZaNgXAcmXt05/zJqMiUsXT3eX7jiJ2kBxYZs5l64nnLQ8IWjv8JammWjybfiRFDskhuoEQDe1te6HWM3ckscU7FtCsHYb9e2vSvpjnftOCaFVa+mSwZD0GMwBJjYd6W4v3MQ41hzMjuGWBLtu1JUP4F7dDN/VF/VaEmOgx1DrASDIcDETr5R/QVWjorZprFjiBVLJPkSfVsts2OI5WMwDIYgQMjsGAZDECBkdgyDIQgQMjuGwRAECJkdw2AIAoT8B20LPYa0rQb5AAAAAElFTkSuQmCC"

/***/ }),
/* 406 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c2fa304","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ProgressBar.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c2fa304","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProgressBar.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",class:{ 'progress--mini': _vm.isMini }},[(_vm.isMini)?_c('div',{staticClass:"progress__label"},[_vm._v("Your progress")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"progress__bar"},[_c('div',{staticClass:"progress__bar__filled",style:({ transform: ("translateX(" + (_vm.percentage - 100) + "%)") })})]),_vm._v(" "),_c('div',{staticClass:"progress__percentage",class:{ 'progress__percentage--icon': _vm.percentage === 100 }},[(_vm.percentage === 100)?_c('i',{staticClass:"icon icon-tick"}):_c('div',[_vm._v(_vm._s(_vm.percentage + "%"))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/*!*************************************************!*\
  !*** ./src/components/PassportUploadPrompt.vue ***!
  \*************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PassportUploadPrompt_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PassportUploadPrompt.vue */ 184);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f9dee7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassportUploadPrompt_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-68f9dee7","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PassportUploadPrompt.vue */ 410);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-68f9dee7","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PassportUploadPrompt.vue */ 409)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-68f9dee7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PassportUploadPrompt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_68f9dee7_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PassportUploadPrompt_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 409 */
/*!****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68f9dee7","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PassportUploadPrompt.vue ***!
  \****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 410 */
/*!*************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-68f9dee7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PassportUploadPrompt.vue ***!
  \*************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(_vm.showPassportImage)?_c('div',{staticClass:"overlay-image"},[_c('img',{attrs:{"src":__webpack_require__(/*! ../assets/svg/Passport@2x.svg */ 411),"alt":"Passport Image"}})]):_vm._e(),_vm._v(" "),_c('p',[_vm._v("\n    Please upload a clear image of the\n    "),_c('span',{staticClass:"blue-text",on:{"mouseover":function($event){_vm.showPassportImage = true},"mouseleave":function($event){_vm.showPassportImage = false}}},[_vm._v("first page of your passport")]),_vm._v("\n    in jpg/png files with a size less than 1Mb\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 411 */
/*!****************************************!*\
  !*** ./src/assets/svg/Passport@2x.svg ***!
  \****************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/Passport@2x.45ce2d94.svg";

/***/ }),
/* 412 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a057a74c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AeErrorWrapper.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 413 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a057a74c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AeErrorWrapper.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ae-component-error-wrapper"},[_vm._t("form-item"),_vm._v(" "),(_vm.isError)?_c('div',{ref:"isErrorElement",staticClass:"error-message"},[_vm._v("\n    "+_vm._s(_vm.errorMessage)+"\n  ")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 414 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-749f08f5","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuestListingPage.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__guest-listing container main--sticky-bottom"},[_c('el-collapse',{ref:"formRoot",model:{value:(_vm.activeCollapseIndexes),callback:function ($$v) {_vm.activeCollapseIndexes=$$v},expression:"activeCollapseIndexes"}},_vm._l((_vm.contacts),function(contact,index){return _c('el-collapse-item',{key:contact.contactID,staticClass:"el-collapse-item--guest",attrs:{"name":index}},[_c('template',{staticClass:"title",slot:"title"},[_c('span',{staticClass:"guest-number"},[_vm._v("GUEST "+_vm._s(index + 1)+" /")]),_vm._v("\n        "+_vm._s(_vm.getFullName(contact))+"\n\n        "),_c('progress-bar',{attrs:{"is-mini":true,"percentage":_vm.getProgressedPercentage(contact)}})],1),_vm._v(" "),_c('el-form',{ref:'formValidate' + contact.contactID,refInFor:true,attrs:{"model":contact,"rules":_vm.ruleValidate,"label-position":"top"}},[_c('section',[_c('div',{staticClass:"guest-helper"},[_vm._v("Fields marked with * are mandatory")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Title","prop":"title"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("Salutation")]),_vm._v(" "),_c('v-select',{ref:"salutation",refInFor:true,attrs:{"clearable":false,"options":_vm.selectTitles,"reduce":function (item) { return item.value; },"searchable":false,"value":contact.title,"label":"label"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'title', $event)}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('el-form-item',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("Prefer to be addressed as\n                  "),_c('i',{staticClass:"el-form-item--emphasis"},[_vm._v("(optional)")])]),_vm._v(" "),_c('el-input',{attrs:{"value":contact.nickname},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'nickname', $event)}}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"First name","prop":"firstName"}},[_c('el-input',{attrs:{"value":contact.firstName},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'firstName', $event)}}}),_vm._v(" "),_c('div',{staticClass:"small-note"},[_vm._v("as per passport")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("Middle name\n                  "),_c('i',{staticClass:"el-form-item--emphasis"},[_vm._v("(optional)")])]),_vm._v(" "),_c('el-input',{attrs:{"value":contact.middleName},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'middleName', $event)}}}),_vm._v(" "),_c('div',{staticClass:"small-note"},[_vm._v("as per passport")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Last / Family name","prop":"lastName"}},[_c('el-input',{attrs:{"value":contact.lastName},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'lastName', $event)}}}),_vm._v(" "),_c('div',{staticClass:"small-note"},[_vm._v("as per passport")])],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Date of birth","prop":"dateOfBirth"}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateDays,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          'dateOfBirthDate',
                          $event,
                          'dateOfBirth'
                        )}},model:{value:(_vm.modelDateOfBirthDays[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelDateOfBirthDays, contact.contactID, $$v)},expression:"modelDateOfBirthDays[contact.contactID]"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateMonths,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          'dateOfBirthMonth',
                          $event,
                          'dateOfBirth'
                        )}},model:{value:(_vm.modelDateOfBirthMonths[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelDateOfBirthMonths, contact.contactID, $$v)},expression:"modelDateOfBirthMonths[contact.contactID]"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateYears,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          'dateOfBirthYear',
                          $event,
                          'dateOfBirth'
                        )}},model:{value:(_vm.modelDateOfBirthYears[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelDateOfBirthYears, contact.contactID, $$v)},expression:"modelDateOfBirthYears[contact.contactID]"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"email"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("Email\n                  "),_c('i',{staticClass:"el-form-item--emphasis"},[_vm._v("(optional)")])]),_vm._v(" "),_c('el-input',{attrs:{"value":contact.email,"type":"email"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'email', $event)}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"prop":"phone"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("Contact number\n                  "),_c('i',{staticClass:"el-form-item--emphasis"},[_vm._v("(optional)")])]),_vm._v(" "),_c('el-input',{attrs:{"value":contact.phone,"placeholder":"eg: +1-234-457-8900"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'phone', $event)}}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Country of residence","prop":"mainMailingCountry"}},[_c('v-select',{attrs:{"clearable":false,"filter-by":_vm.filterCountry,"options":_vm.selectCountries,"reduce":function (item) { return item.value; },"value":contact.mainMailingCountry,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'mainMailingCountry',
                      $event
                    )},"visible-change":_vm.resetFilterCountry}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Nationality","prop":"nationality"}},[_c('v-select',{attrs:{"clearable":false,"filter-by":_vm.filterCountry,"options":_vm.selectCountries,"reduce":function (item) { return item.value; },"value":contact.nationality,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'nationality', $event)},"visible-change":_vm.resetFilterCountry}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Gender","prop":"gender"}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectGenders,"reduce":function (item) { return item.value; },"searchable":false,"value":contact.gender,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'gender', $event)}}})],1)],1)],1),_vm._v(" "),(!_vm.canShowPeruvianNationalIDField(contact))?_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Passport number","prop":"passportNumber"}},[_c('el-input',{attrs:{"value":contact.passportNumber},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'passportNumber', $event)}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Passport issuing country","prop":"passportIssuingCountry"}},[_c('v-select',{attrs:{"clearable":false,"filter-by":_vm.filterCountry,"options":_vm.selectCountries,"reduce":function (item) { return item.value; },"value":contact.passportIssuingCountry,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'passportIssuingCountry',
                      $event
                    )},"visible-change":_vm.resetFilterCountry}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Passport expiry date","prop":"passportExpiryDate"}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateDays,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportExpiryDateDate',
                          $event,
                          'passportExpiryDate'
                        )}},model:{value:(_vm.modelPassportExpiryDateDays[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelPassportExpiryDateDays, contact.contactID, $$v)},expression:"modelPassportExpiryDateDays[contact.contactID]"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateMonths,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportExpiryDateMonth',
                          $event,
                          'passportExpiryDate'
                        )}},model:{value:(
                        _vm.modelPassportExpiryDateMonths[contact.contactID]
                      ),callback:function ($$v) {_vm.$set(_vm.modelPassportExpiryDateMonths, contact.contactID, $$v)},expression:"\n                        modelPassportExpiryDateMonths[contact.contactID]\n                      "}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateExpiryYears,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportExpiryDateYear',
                          $event,
                          'passportExpiryDate'
                        )}},model:{value:(
                        _vm.modelPassportExpiryDateYears[contact.contactID]
                      ),callback:function ($$v) {_vm.$set(_vm.modelPassportExpiryDateYears, contact.contactID, $$v)},expression:"\n                        modelPassportExpiryDateYears[contact.contactID]\n                      "}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.canShowPeruvianNationalIDField(contact))?_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Peruvian National ID","prop":"nationalIdNumber"}},[_c('el-input',{attrs:{"value":contact.nationalIdNumber},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'nationalIdNumber',
                      $event
                    )}}})],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.booking.isAmazonCruise)?_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Passport issued date","prop":"passportIssueDate"}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateDays,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportIssueDateDate',
                          $event,
                          'passportIssueDate'
                        )}},model:{value:(_vm.modelPassportIssueDateDays[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelPassportIssueDateDays, contact.contactID, $$v)},expression:"modelPassportIssueDateDays[contact.contactID]"}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateMonths,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportIssueDateMonth',
                          $event,
                          'passportIssueDate'
                        )}},model:{value:(
                        _vm.modelPassportIssueDateMonths[contact.contactID]
                      ),callback:function ($$v) {_vm.$set(_vm.modelPassportIssueDateMonths, contact.contactID, $$v)},expression:"\n                        modelPassportIssueDateMonths[contact.contactID]\n                      "}})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectDateYears,"reduce":function (item) { return item.value; },"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputDateChange(
                          contact.contactID,
                          ' passportIssueDateYear',
                          $event,
                          'passportIssueDate'
                        )}},model:{value:(_vm.modelPassportIssueDateYears[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelPassportIssueDateYears, contact.contactID, $$v)},expression:"modelPassportIssueDateYears[contact.contactID]"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('section',[_c('scope',{attrs:{"passport":_vm.passportByContactID(contact.contactID),"tag":"el-row","validateConfigs":_vm.validateConfigs},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                        var passport = ref.passport;
return (passport)?[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"is-error":_vm.validateConfigs[contact.contactID].passportImage,"error-message":"Please upload a photo of your passport"},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-upload',{staticClass:"el-upload--passport",attrs:{"action":_vm.uploadFileEndpoint,"auto-upload":true,"before-upload":_vm.beforeUpload,"data":{
                        bookingID: _vm.booking.bookingID,
                        contactID: contact.contactID,
                        passportID: passport.passportID,
                      },"fileList":passport.file ? [passport.file] : undefined,"headers":_vm.uploadFileHeaders,"limit":1,"multiple":false,"on-error":_vm.onUploadError,"on-remove":_vm.onRemoveUploadPassport,"on-success":_vm.onSuccessUploadPassport,"accept":"image/*,.pdf","list-type":"picture","name":"passport"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Upload a photo of your passport\n                      ")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_c('PassportUploadPrompt')],1)],1)]},proxy:true}],null,true)})]:undefined}}],null,true)})],1),_vm._v(" "),_c('div',{staticClass:"residential-address-container"},[_c('div',[_c('span',[_vm._v("Residential address")]),_vm._v(" "),_c('i',[_vm._v("(optional)")]),_vm._v(" "),(contact.contactID !== _vm.primaryContact.contactID)?_c('el-checkbox',{staticClass:"checkbox--samePlan",attrs:{"value":contact.hasSameResidentialAddress},on:{"input":function($event){return _vm.onCheckHasSameResidentialAddress(
                    contact.contactID,
                    'hasSameResidentialAddress',
                    $event
                  )}}},[_vm._v("\n                Same as Guest 1\n              ")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"residential-address-container__notes"},[_vm._v("\n              Filling in your address will allow us to send you information\n              about Aqua Expeditions' next destinations. Your data will be\n              kept confidential.\n            ")])]),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Address"}},[_c('el-input',{attrs:{"value":contact.mainMailingStreet},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'mainMailingStreet',
                      $event
                    )}}})],1)],1)],1),_vm._v(" "),_c('el-row',{staticClass:"last-row",attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Country"}},[_c('v-select',{attrs:{"clearable":false,"filter-by":_vm.filterCountry,"options":_vm.selectCountries,"reduce":function (item) { return item.value; },"value":contact.mainMailingCountry,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'mainMailingCountry',
                      $event
                    )},"visible-change":_vm.resetFilterCountry}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"City / Town"}},[_c('el-input',{attrs:{"value":contact.mainMailingCity},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'mainMailingCity',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"State / Province"}},[_c('v-select',{attrs:{"clearable":false,"options":_vm.selectStates,"reduce":function (item) { return item.value; },"value":contact.mainMailingState,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'mainMailingState',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Postal code"}},[_c('el-input',{attrs:{"value":contact.mainMailingZip},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'mainMailingZip', $event)}}})],1)],1)],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),(
            _vm.booking.isFromVietnamToCambodia || _vm.booking.isFromCambodiaToVietnam
          )?_c('section',[_c('h3',{staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n            "+_vm._s(_vm.booking.isFromVietnamToCambodia
                ? "Have you applied your cross-border visa?"
                : "Please upload your cross-border visa.")+"\n          ")]),_vm._v(" "),_c('el-alert',{staticStyle:{"margin-bottom":"14px"},attrs:{"closable":false,"show-icon":"","title":"Important note:","type":"warning"}},[(_vm.booking.isFromVietnamToCambodia)?[_c('div',[_vm._v("\n                We recommend that you apply the cross-border visa on board\n                with us. If you already have a physical visa, please upload a\n                copy here and bring along the physical copy. Online visas will\n                not be accepted.\n              ")]),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.isVisibleDialogVisaRequirement = true}}},[_vm._v("More details")])])]:[_c('div',[_vm._v("\n                Please read our instruction for Vietnam visa\n                "),_c('a',{attrs:{"href":""},on:{"click":function($event){$event.preventDefault();_vm.isVisibleDialogVisaRequirement = true}}},[_vm._v("here")]),_vm._v(".\n              ")])]],2),_vm._v(" "),_c('scope',{attrs:{"visaRequirement":_vm.visaRequirementByContactID(contact.contactID),"tag":"el-row","validateConfigs":_vm.validateConfigs},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var visaRequirement = ref.visaRequirement;
return (visaRequirement)?[_c('el-radio-group',{attrs:{"value":visaRequirement.visaType},on:{"input":function($event){return _vm.onVisaRequirementInputChange(
                    visaRequirement.visaRequirementID,
                    'visaType',
                    $event,
                    contact.contactID
                  )}}},[(_vm.booking.isFromVietnamToCambodia)?_c('el-radio',{attrs:{"label":"Apply Onboard"}},[_c('div',[_vm._v("Apply on board")]),_vm._v(" "),_c('el-popover',{attrs:{"content":"Aqua Expeditions will process the Cambodia single entry tourist visa for you on-board. A US$45 fee will apply, paid in cash or charged to your account on the Aqua Mekong.","placement":"top","trigger":"hover","width":"200"}},[_c('a',{attrs:{"slot":"reference"},slot:"reference"},[_vm._v("Fee applies")])])],1):_vm._e(),_vm._v(" "),(_vm.booking.isFromCambodiaToVietnam)?_c('el-radio',{attrs:{"label":"E Visa"}},[_c('div',[_vm._v("I have an e-visa")])]):_vm._e(),_vm._v(" "),_c('el-radio',{attrs:{"label":"Physical Visa (Cross border)"}},[_c('div',[_vm._v("\n                    I have my\n                    "+_vm._s(_vm.booking.isFromVietnamToCambodia ? "Cambodia" : "Vietnam")+"\n                    Visa on my passport\n                  ")])]),_vm._v(" "),_c('el-radio',{attrs:{"label":"Not required"}},[_c('span',[_vm._v("I do not need a visa to\n                    "+_vm._s(_vm.booking.isFromVietnamToCambodia ? "Cambodia" : "Vietnam"))])])],1),_vm._v(" "),(visaRequirement.visaType === 'E Visa')?_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"is-error":_vm.validateConfigs[contact.contactID].visaImage,"error-message":"Please upload a photo of your visa"},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-upload',{staticClass:"el-upload--visa",attrs:{"action":_vm.uploadFileEndpoint,"auto-upload":true,"before-upload":_vm.beforeUpload,"data":{
                      bookingID: _vm.booking.bookingID,
                      contactID: contact.contactID,
                      visaRequirementID: visaRequirement.visaRequirementID,
                    },"fileList":visaRequirement.visaType === 'E Visa' &&
                      visaRequirement.file
                        ? [visaRequirement.file]
                        : undefined,"headers":_vm.uploadFileHeaders,"limit":1,"multiple":false,"on-error":_vm.onUploadError,"on-remove":_vm.onRemoveUploadVisa,"on-success":_vm.onSuccessUploadVisa,"accept":"image/*","list-type":"picture","name":"visa"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Upload a copy of your e-visa")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                      jpg/png files with a size less than 1Mb\n                    ")])],1)]},proxy:true}],null,true)}):_vm._e(),_vm._v(" "),(
                  visaRequirement.visaType === 'Physical Visa (Cross border)'
                )?_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"is-error":_vm.validateConfigs[contact.contactID].visaImage,"error-message":"Please upload a photo of your visa"},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-upload',{staticClass:"el-upload--visa",staticStyle:{"margin-left":"200px"},attrs:{"action":_vm.uploadFileEndpoint,"auto-upload":true,"before-upload":_vm.beforeUpload,"data":{
                      bookingID: _vm.booking.bookingID,
                      contactID: contact.contactID,
                      visaRequirementID: visaRequirement.visaRequirementID,
                    },"fileList":visaRequirement.visaType ===
                        'Physical Visa (Cross border)' && visaRequirement.file
                        ? [visaRequirement.file]
                        : undefined,"headers":_vm.uploadFileHeaders,"limit":1,"multiple":false,"on-error":_vm.onUploadError,"on-remove":_vm.onRemoveUploadVisa,"on-success":_vm.onSuccessUploadVisa,"accept":"image/*","list-type":"picture","name":"visa"}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("Upload a copy of your visa")]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("\n                      jpg/png files with a size less than 1Mb\n                    ")])],1)]},proxy:true}],null,true)}):_vm._e()]:undefined}}],null,true)})],1):_vm._e(),_vm._v(" "),(
            _vm.booking.isFromVietnamToCambodia || _vm.booking.isFromCambodiaToVietnam
          )?_c('hr'):_vm._e(),_vm._v(" "),_c('section',[_c('div',{staticClass:"form-subheader"},[_vm._v("\n            Have you (or your client, if you're an agent) traveled with us\n            before?\n          ")]),_vm._v(" "),_c('el-checkbox',{attrs:{"value":contact.hasPastGuest},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'hasPastGuest', $event)}}},[_vm._v("\n            Yes, I have traveled with Aqua Expeditions before\n          ")]),_vm._v(" "),(contact.hasPastGuest)?_c('div',{staticStyle:{"margin-top":"24px"}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Previous cruise(s) with us","prop":"pastGuest"}},[_c('v-select',{attrs:{"multiple":"","clearable":false,"options":_vm.selectLastDestinations,"reduce":function (item) { return item.value; },"searchable":false,"value":contact.pastGuest,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(contact.contactID, 'pastGuest', $event)}}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n              Note: To take advantage of\n              "),_c('a',{attrs:{"href":_vm.appendMarketingSiteUrl('/loyalty'),"target":"_blank"}},[_vm._v("our loyalty benefits")]),_vm._v(", please\n              "),_c('a',{attrs:{"href":_vm.appendMarketingSiteUrl('/contact-us'),"target":"_blank"}},[_vm._v("contact")]),_vm._v("\n              our Sales and Reservation team.\n            ")])],1):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('section',[_c('div',{staticClass:"form-subheader"},[_vm._v("\n            Emergency contact\n            "),(contact.contactID !== _vm.primaryContact.contactID)?_c('el-checkbox',{staticClass:"checkbox--samePlan",attrs:{"value":contact.hasSameEmergencyContact},on:{"input":function($event){return _vm.onCheckHasSameEmergencyContact(
                  contact.contactID,
                  'hasSameEmergencyContact',
                  $event
                )}}},[_vm._v("\n              Same as Guest 1\n            ")]):_vm._e()],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"First name","prop":"emergencyContactFirstName"}},[_c('el-input',{attrs:{"value":contact.emergencyContactFirstName},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'emergencyContactFirstName',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-form-item',{attrs:{"label":"Last / Family name","prop":"emergencyContactLastName"}},[_c('el-input',{attrs:{"value":contact.emergencyContactLastName},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'emergencyContactLastName',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Contact number","prop":"emergencyContactPhone"}},[_c('el-input',{attrs:{"value":contact.emergencyContactPhone,"placeholder":"eg: +1-234-457-8900"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'emergencyContactPhone',
                      $event
                    )}}})],1)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Relationship","prop":"emergencyContactRelation"}},[_c('v-select',{ref:'emergencyRelationSelect' + contact.contactID,refInFor:true,staticClass:"v-select-overflow",attrs:{"clearable":false,"options":_vm.selectEmergencyContactRelations,"reduce":function (item) { return item.value; },"searchable":false,"value":contact.emergencyContactRelation,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'emergencyContactRelation',
                      $event
                    )},"search:focus":function($event){return _vm.onEmergencyRelationFocus(contact.contactID)}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Email","prop":"emergencyContactEmail"}},[_c('el-input',{attrs:{"value":contact.emergencyContactEmail,"placeholder":"Enter email address"},on:{"input":function($event){return _vm.onInputChange(
                      contact.contactID,
                      'emergencyContactEmail',
                      $event
                    )}}})],1)],1)],1)],1),_vm._v(" "),(!_vm.isAquaNeraOrAriaAmazon())?_c('section',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-subheader"},[_vm._v("\n            Release of Liability and Assumption of Risk\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Release of Liability","prop":"HasSignedReleaseOfLiability"}},[_c('el-checkbox',{attrs:{"value":contact.HasSignedReleaseOfLiability},on:{"input":function($event){return _vm.onInputChange(
                  contact.contactID,
                  'HasSignedReleaseOfLiability',
                  $event
                )}}},[_vm._v("\n              I understand and agree to the terms of the\n              "),_c('span',{staticClass:"rol-link",on:{"click":_vm.handleClickROL}},[_vm._v("Release of Liability and Assumption of Risk")]),_vm._v(".\n            ")])],1)],1):_vm._e(),_vm._v(" "),(_vm.isAquaNeraOrAriaAmazon())?_c('section',[_c('hr'),_vm._v(" "),_c('div',{staticClass:"form-subheader"},[_vm._v("\n            Release of Liability and Assumption of Risk\n          ")]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Release of Liability","prop":"HasSignedReleaseOfLiability"}},[_c('el-checkbox',{attrs:{"value":contact.HasSignedReleaseOfLiability},on:{"input":function($event){return _vm.onInputChange(
                  contact.contactID,
                  'HasSignedReleaseOfLiability',
                  $event
                )}}},[_vm._v("\n              I understand and agree to the terms of the\n              "),_c('span',{staticClass:"rol-link",on:{"click":_vm.handleClickROL}},[_vm._v("Release of Liability and Assumption of Risk (English)")]),_vm._v("\n              /\n              "),_c('span',{staticClass:"rol-link",on:{"click":_vm.handleClickROLSpanish}},[_vm._v("Release of Liability and Assumption of Risk (Spanish)")]),_vm._v(".\n            ")])],1)],1):_vm._e()])],2)}),1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary",attrs:{"disabled":_vm.isSaving,"type":"secondary"},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary",attrs:{"disabled":_vm.isSaving,"type":"secondary"},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary",attrs:{"disabled":_vm.isSaving,"type":"primary"},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog--visaRequirement",attrs:{"visible":this.isVisibleDialogVisaRequirement,"show-close":""},on:{"close":function($event){_vm.isVisibleDialogVisaRequirement = false}}},[(_vm.booking.isFromCambodiaToVietnam)?_c('div',[_c('h2',[_vm._v("Visa for cruising from CAMBODIA to VIETNAM")]),_vm._v(" "),_c('div',{staticClass:"visa-tag"},[_vm._v("Vietnam Visa")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n        Please check if your country is exempted of entry to Vietnam\n        "),_c('a',{attrs:{"href":"https://lanhsuvietnam.gov.vn/Lists/BaiViet/B%C3%A0i%20vi%E1%BA%BFt/DispForm.aspx?List=dc7c7d75-6a32-4215-afeb-47d4bee70eee&ID=306","target":"_blank"}},[_vm._v("here")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n        If you need a visa, please check the following options:\n      ")]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 1 – E-Visa (Recommended)")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Apply for E-Visa\n          "),_c('a',{attrs:{"href":"https://evisa.gov.vn/","target":"_blank"}},[_vm._v("here")]),_vm._v(", with the\n          "),_c('span',{staticClass:"text--strong"},[_vm._v("same passport")]),_vm._v(" you will be using\n          for entry into Vietnam.\n        ")]),_vm._v(" "),_c('ul',{staticClass:"visa-bullets"},[_c('li',[_vm._v("\n            E-Visa will be processed after the Vietnam Immigration Department\n            receives the completed application and full e-Visa fee.\n          ")]),_vm._v(" "),_c('li',[_vm._v("\n            Ensure that you enter the correct\n            "),_c('span',{staticClass:"text--strong"},[_vm._v("date of entry")]),_vm._v(" into Vietnam as\n            per your itinerary. The border crossing always occurs on a\n            Wednesday. Please note that this is\n            "),_c('span',{staticClass:"text--strong"},[_vm._v("not")]),_vm._v(" the same as your day of\n            embarkation on Aqua Mekong.\n          ")]),_vm._v(" "),_c('li',[_c('span',{staticClass:"text--warning"},[_vm._v("Please send us a copy of your e-visa confirmation")]),_vm._v("\n            and present a printed copy together with your passport upon\n            embarkation of the Aqua Mekong.\n          ")])]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-top":"16px"}},[_c('span',{staticClass:"text--strong"},[_vm._v("Notes: ")]),_vm._v("please list\n          "),_c('span',{staticClass:"text--strong"},[_vm._v("Vinh Xuong Landport, An Giang Province")]),_vm._v("\n          as your port of entry.\n        ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-top":"16px"}},[_c('span',{staticClass:"text--strong"},[_vm._v("E-Visa Processing Time for Vietnam:")])]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Please note that the e-visa process may take 3–5 working days to\n          complete. We recommend applying as early as possible to avoid\n          delays.\n        ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-top":"16px"}},[_c('span',{staticClass:"text--strong"},[_vm._v("Uploading Your E-Visa:")])]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Once you receive your e-visa, please upload it directly to the\n          check-in platform. Alternatively, you may email it to\n          "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com"}},[_vm._v("reservations@aquaexpeditions.com")]),_vm._v(", and we’ll upload it on your behalf.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 2 – Physical Visa from Embassy")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Obtain Visa at the Vietnam embassy in your home country.\n          "),_c('span',{staticClass:"text--strong"},[_vm._v("Physical visa")]),_vm._v(" must be in your\n          passport prior to boarding the Aqua Mekong.\n          "),_c('span',{staticClass:"text--warning"},[_vm._v("Please upload a copy of this Visa.")])])]),_vm._v(" "),_c('div',{staticClass:"note--important no-break-words"},[_c('i',{staticClass:"el-icon-warning"}),_c('b',[_vm._v("IMPORTANT")]),_vm._v(": Please ensure you are\n        using the "),_c('u',[_vm._v("same passport")]),_vm._v(" to enter Vietnam and Cambodia, if you\n        are cruising between both countries with the Aqua Mekong. Otherwise,\n        the port authority may deny your entry during river border crossing,\n        thus affecting your trip. Travelers must submit the Cambodia e-Arrival\n        "),_c('u',[_c('b',[_vm._v("within 7 days")])]),_vm._v(" before their arrival\n        "),_c('a',{attrs:{"href":"https://arrival.gov.kh/","target":"_blank"}},[_vm._v("here")]),_vm._v(".\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"visa-tag"},[_vm._v("Cambodia Visa")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n        We "),_c('span',{staticClass:"text--strong"},[_vm._v("do not require")]),_vm._v(" you to upload your\n        Cambodia visa, however please ensure you hold a valid Cambodia visa,\n        if required.\n      ")]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 1 (Recommended)")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Apply for E-visa at\n          "),_c('a',{attrs:{"href":"https://www.evisa.gov.kh","target":"_blank"}},[_vm._v("www.evisa.gov.kh")]),_vm._v(", a "),_c('span',{staticClass:"text--strong"},[_vm._v("printed copy")]),_vm._v(" of your e-visa\n          must be presented at the airport upon arrival.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 2")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Apply for Visa "),_c('span',{staticClass:"text--strong"},[_vm._v("on arrival")]),_vm._v(" at Phnom\n          Penh or Siem Reap airport at\n          "),_c('span',{staticClass:"text--strong"},[_vm._v("USD $30")]),_vm._v(" in cash. Please bring\n          along a passport size photograph. If you do not bring your\n          photograph, the extra charge is USD $3.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 3")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Obtain visa at the Cambodia embassy in your home country.\n        ")])])]):(_vm.booking.isFromVietnamToCambodia)?_c('div',[_c('h2',[_vm._v("Visa for cruising from VIETNAM to CAMBODIA")]),_vm._v(" "),_c('div',{staticClass:"visa-tag"},[_vm._v("Cambodia Visa")]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 1 - Apply on board")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Aqua Expeditions will process the Cambodia single entry tourist visa\n          for you on-board. A US$45 fee (exclusive of VAT) will apply, paid in\n          cash or charged to your account on the Aqua Mekong.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 2 - Apply via embassy")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Obtain visa at a Cambodia embassy of your home country. Physical\n          visa must be placed inside your passport prior to boarding the Aqua\n          Mekong.\n          "),_c('span',{staticClass:"text--warning"},[_vm._v("Please upload a copy of this visa.")])])]),_vm._v(" "),_c('div',{staticClass:"note--important no-break-words"},[_c('i',{staticClass:"el-icon-warning"}),_vm._v("Note: E-visa is not valid for crossing\n        border via waterways.\n      ")]),_vm._v(" "),_c('div',{staticClass:"note--important no-break-words"},[_c('i',{staticClass:"el-icon-warning"}),_c('b',[_vm._v("IMPORTANT")]),_vm._v(": Please ensure you are\n        using the "),_c('u',[_vm._v("same passport")]),_vm._v(" to enter Vietnam and Cambodia, if you\n        are cruising between both countries with the Aqua Mekong. Otherwise,\n        the port authority may deny your entry during river border crossing,\n        thus affecting your trip.\n      ")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"visa-tag"},[_vm._v("Vietnam Visa")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n        We "),_c('span',{staticClass:"text--strong"},[_vm._v("do not require")]),_vm._v(" you to upload your\n        Vietnam visa, however please ensure you hold a valid Vietnam visa, if\n        required.\n      ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n        Please check if your country is exempted of entry to Vietnam\n        "),_c('a',{attrs:{"href":"https://lanhsuvietnam.gov.vn/Lists/BaiViet/B%C3%A0i%20vi%E1%BA%BFt/DispForm.aspx?List=dc7c7d75-6a32-4215-afeb-47d4bee70eee&ID=306","target":"_blank"}},[_vm._v("here")]),_vm._v(".\n      ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words",staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n        If you need a visa, please check the following options:\n      ")]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 1 – E-Visa (Recommended)")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Apply for E-Visa\n          "),_c('a',{attrs:{"href":"https://evisa.xuatnhapcanh.gov.vn/en_US/web/guest/khai-thi-thuc-dien-tu/cap-thi-thuc-dien-tu","target":"_blank"}},[_vm._v("here")]),_vm._v(".\n        ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          1. E-Visa will be processed after the Vietnam Immigration Department\n          receives the completed application and full e-Visa fee.\n        ")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          2. E-Visa holders must present the printed e-Visa and valid passport\n          at the checkpoint.\n        ")])]),_vm._v(" "),_c('div',{staticClass:"option"},[_c('div',{staticClass:"title"},[_vm._v("OPTION 2 – Physical Visa from Embassy")]),_vm._v(" "),_c('p',{staticClass:"no-break-words"},[_vm._v("\n          Obtain Visa at the Vietnam embassy in your home country.\n        ")])])]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 415 */
/*!*******************************************************************!*\
  !*** ./src/components/DietaryPreferenceAndSpecialRequestPage.vue ***!
  \*******************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DietaryPreferenceAndSpecialRequestPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DietaryPreferenceAndSpecialRequestPage.vue */ 187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0af3c2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DietaryPreferenceAndSpecialRequestPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-ad0af3c2","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DietaryPreferenceAndSpecialRequestPage.vue */ 419);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ad0af3c2","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DietaryPreferenceAndSpecialRequestPage.vue */ 416)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-ad0af3c2","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./DietaryPreferenceAndSpecialRequestPage.vue */ 417)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ad0af3c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DietaryPreferenceAndSpecialRequestPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ad0af3c2_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DietaryPreferenceAndSpecialRequestPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 416 */
/*!***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad0af3c2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DietaryPreferenceAndSpecialRequestPage.vue ***!
  \***********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 417 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ad0af3c2","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/DietaryPreferenceAndSpecialRequestPage.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 418 */
/*!*******************************!*\
  !*** ./src/mixins/booking.js ***!
  \*******************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuex__ = __webpack_require__(/*! vuex */ 6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store_types__ = __webpack_require__(/*! ../store/types */ 1);



/* harmony default export */ __webpack_exports__["a"] = ({
  computed: Object.assign({}, Object(__WEBPACK_IMPORTED_MODULE_0_vuex__["c" /* mapGetters */])([__WEBPACK_IMPORTED_MODULE_1__store_types__["a" /* default */].getters.booking])),
  methods: {}
});

/***/ }),
/* 419 */
/*!*******************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad0af3c2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DietaryPreferenceAndSpecialRequestPage.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formRoot",staticClass:"container main--sticky-bottom"},[_c('el-collapse',{model:{value:(_vm.activeCollapseIndexes),callback:function ($$v) {_vm.activeCollapseIndexes=$$v},expression:"activeCollapseIndexes"}},_vm._l((_vm.contacts),function(contact,index){return _c('el-collapse-item',{key:contact.contactID,staticClass:"el-collapse-item--dietary",attrs:{"name":index}},[_c('template',{staticClass:"title",slot:"title"},[_c('span',{staticClass:"guest-number"},[_vm._v("GUEST "+_vm._s(index + 1)+"/")]),_vm._v(_vm._s(_vm.getFullName(contact))+"\n      ")]),_vm._v(" "),_c('el-form',{ref:'formValidate' + contact.contactID,refInFor:true,attrs:{"model":contact,"rules":_vm.ruleValidate,"label-position":"left","label-width":"204px","hide-required-asterisk":""}},[_c('div',{staticClass:"guest-helper"},[_vm._v("Fields marked with * are mandatory")]),_vm._v(" "),(_vm.dietaryAllergiesLoaded)?_c('el-form-item',{attrs:{"label":"Dietary Allergies*","prop":"dietaryAllergies"}},[_c('v-select',{staticClass:"dietary-select",staticStyle:{"width":"100%"},attrs:{"options":_vm.dietaryAllergies,"reduce":function (item) { return item.value; },"searchable":false,"filterable":"","label":"label","multiple":""},on:{"input":function($event){return _vm.onContactInputChange(
                contact.contactID,
                'dietaryAllergies',
                $event
              )}},model:{value:(_vm.modelSelectedDietaryAllergies[contact.contactID]),callback:function ($$v) {_vm.$set(_vm.modelSelectedDietaryAllergies, contact.contactID, $$v)},expression:"modelSelectedDietaryAllergies[contact.contactID]"}})],1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticStyle:{"margin-bottom":"40px"},attrs:{"label":"Dietary Preference Notes"}},[_c('el-input',{staticStyle:{"height":"94px"},attrs:{"rows":4,"value":contact.dietaryPreferenceNotes,"placeholder":"Dietary Preference Notes","type":"textarea"},on:{"input":function($event){return _vm.onContactInputChange(
                contact.contactID,
                'dietaryPreferenceNotes',
                $event
              )}}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Medical Health Notes*","prop":"medicalNotes"}},[_c('el-input',{attrs:{"rows":6,"value":contact.medicalNotes,"placeholder":"Any medical and health conditions we should be aware of?","type":"textarea"},on:{"input":function($event){return _vm.onContactInputChange(contact.contactID, 'medicalNotes', $event)}}}),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n            Please indicate \"None\" if you do not have any special medical and\n            health requirements.\n          ")])],1)],1)],2)}),1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h1',{staticClass:"h1-title"},[_vm._v("Special Requests")]),_vm._v(" "),_c('div',{staticClass:"special-request"},[_c('el-form',[_c('el-form-item',{attrs:{"label":""}},[_c('el-input',{attrs:{"rows":6,"value":_vm.booking.checkInRemarks,"placeholder":"Please advise of any celebrations or special requests and we will do our best to accommodate these. Our reservations executive will reach out to you to discuss further about your requests, if necessary.","type":"textarea"},on:{"input":function($event){return _vm.onBookingInputChange('checkInRemarks', $event)}}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 420 */
/*!***************************************!*\
  !*** ./src/components/DivingPage.vue ***!
  \***************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DivingPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DivingPage.vue */ 188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11672b5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DivingPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-11672b5d","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DivingPage.vue */ 423);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-11672b5d","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DivingPage.vue */ 421)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-11672b5d","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./DivingPage.vue */ 422)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11672b5d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DivingPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11672b5d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DivingPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 421 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11672b5d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DivingPage.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 422 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-11672b5d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/DivingPage.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 423 */
/*!***************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11672b5d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DivingPage.vue ***!
  \***************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasDiving())?_c('div',{staticClass:"container main__diving main--sticky-bottom"},[_c('el-dialog',{attrs:{"show-close":true,"visible":_vm.wetSuitSizeDialogVisible,"center":"","custom-class":"diving__size-dialog"},on:{"close":function($event){_vm.wetSuitSizeDialogVisible = false}}},[_c('template',{slot:"title"},[_c('h2',{staticClass:"diving__size-dialog-title"},[_vm._v("Wetsuit Size Chart")])]),_vm._v(" "),_c('div',{staticClass:"diving__size-dialog-table-header"},[_vm._v("Adult")]),_vm._v(" "),_c('el-table',{staticStyle:{"margin-bottom":"40px"},attrs:{"data":_vm.adultWetSuitSizeData,"resizable":false,"fit":""}},[_c('el-table-column',{attrs:{"label":"Sizes","prop":"size"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Chest (cm)","prop":"chest"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Waist (cm)","prop":"waist"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hip (cm)","prop":"hip"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (cm)","prop":"height"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (ft)","prop":"heightFt"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Weight (kg)","prop":"weightKg"}})],1),_vm._v(" "),_c('div',{staticClass:"diving__size-dialog-table-header"},[_vm._v("Children")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.childWetSuitSizeData,"resizable":false,"fit":""}},[_c('el-table-column',{attrs:{"label":"Sizes","prop":"size"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Chest (cm)","prop":"chest"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Waist (cm)","prop":"waist"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hip (cm)","prop":"hip"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (cm)","prop":"height"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (ft)","prop":"heightFt"}})],1)],2),_vm._v(" "),_c('el-dialog',{attrs:{"show-close":true,"visible":_vm.finSizeDialogVisible,"center":"","custom-class":"diving__size-dialog diving__size-dialog--large"},on:{"close":function($event){_vm.finSizeDialogVisible = false}}},[_c('template',{slot:"title"},[_c('h2',{staticClass:"diving__size-dialog-title"},[_vm._v("Fin Size Chart")])]),_vm._v(" "),_c('el-table',{staticStyle:{"margin-bottom":"40px"},attrs:{"data":_vm.finSizeData,"resizable":false,"fit":"","header-cell-class-name":"dark"}},[_c('el-table-column',{attrs:{"label":"Sizes","prop":"size"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"US","prop":"us"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"UK","prop":"uk"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Euro","prop":"euro"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Inches","prop":"inches"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"CM","prop":"cm"}})],1)],2),_vm._v(" "),_c('el-alert',{staticClass:"alert",attrs:{"closable":false,"show-icon":"","title":"","type":"warning"}},[_c('div',{staticClass:"alert__title"},[_vm._v("Important note:")]),_vm._v(" "),_c('ul',{staticClass:"alert__list"},[_c('li',[_vm._v("\n        It is mandatory to present your diving certificate (PADI or\n        equivalent) on board.\n      ")]),_vm._v(" "),_c('li',[_vm._v("\n        It is highly recommended that you get a diving insurance or travel\n        insurance that covers diving activity.\n      ")]),_vm._v(" "),(_vm.isAquaLares())?_c('div',[_c('li',[_vm._v("\n          Persons over 55 years of age should be in possession of a medical\n          health clearance.\n        ")]),_vm._v(" "),_c('li',[_vm._v("\n          Diving will be managed by a qualified dive guide for each group\n          (estimated at 5 pax per group).\n        ")])]):_c('div',[_c('li',[_vm._v("\n          Please note that diving is available for 8 guests per session. There\n          are 2 sessions per day.\n        ")])])])]),_vm._v(" "),_c('el-collapse',{ref:"formRoot",model:{value:(_vm.activeCollapseIndexes),callback:function ($$v) {_vm.activeCollapseIndexes=$$v},expression:"activeCollapseIndexes"}},_vm._l((_vm.contactBookings),function(contactBooking,index){return _c('el-collapse-item',{key:contactBooking.contactID,staticClass:"el-collapse-item--diving",attrs:{"name":index}},[_c('template',{staticClass:"title",slot:"title"},[_c('span',{staticClass:"guest-number"},[_vm._v("GUEST "+_vm._s(index + 1)+"/")]),_vm._v(_vm._s(_vm.getFullNameByContactId(contactBooking.contactID))+"\n      ")]),_vm._v(" "),(!_vm.canDive(_vm.getContactByContactId(contactBooking.contactID)))?_c('div',{staticClass:"underage-note"},[_c('div',{staticClass:"underage-note__icon icon-chat"}),_vm._v(" "),_c('div',{staticClass:"underage-note__content"},[_c('div',{staticClass:"underage-note__title"},[_vm._v("\n            Sorry, your child is not eligible to dive.\n          ")]),_vm._v(" "),_c('div',{staticClass:"underage-note__message"},[_vm._v("\n            Guests must be 8 years of age or above to dive.\n          ")])])]):_vm._e(),_vm._v(" "),(_vm.canDive(_vm.contact(contactBooking.contactID)))?_c('el-form',{attrs:{"model":contactBooking,"rules":_vm.ruleValidate,"label-position":"left"}},[_c('el-radio-group',{staticClass:"diving__planning-to-dive",attrs:{"value":contactBooking.planningToDive === true ? true : false},on:{"input":function($event){return _vm.onContactBookingInputChange(
              contactBooking.contactID,
              'planningToDive',
              $event
            )}}},[_c('el-radio',{attrs:{"label":true}},[_c('div',[_vm._v("I am planning to dive.")])]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_c('div',[_vm._v("I am not planning to dive.")])])],1),_vm._v(" "),(
            contactBooking.planningToDive === true ||
            contactBooking.planningToDive === 'true' ||
            false
          )?_c('div',[_c('el-alert',{staticClass:"alert",attrs:{"closable":false,"show-icon":"","title":"","type":"warning"}},[_c('div',{staticClass:"alert__title"},[_vm._v("Are you certified to dive?")]),_vm._v(" "),_c('div',[_vm._v("\n              I declare that the named guest is certified to dive. Guests\n              without a valid diving certificate will not be allowed to dive.\n            ")])]),_vm._v(" "),_c('el-row',{attrs:{"gutter":32}},[_c('el-col',{attrs:{"span":6}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-form-item',{attrs:{"label":"Wetsuit size","prop":"divingWetsuit"}},[_c('v-select',{attrs:{"options":_vm.selectDivingWetsuit,"reduce":function (item) { return item.value; },"searchable":false,"value":contactBooking.divingWetsuit,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingWetsuit',
                        $event
                      )}}})],1)],1),_vm._v(" "),(contactBooking.divingWetsuit === 'Other')?_c('el-row',{attrs:{"gutter":16}},[_c('el-form-item',{attrs:{"label":"Wetsuit size (other)","prop":"divingWetsuitOther"}},[_c('el-input',{attrs:{"rows":6,"value":contactBooking.divingWetsuitOther,"placeholder":""},on:{"input":function($event){return _vm.onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingWetsuitOther',
                        $event
                      )}}})],1)],1):_vm._e()],1),_vm._v(" "),_c('el-col',{attrs:{"span":6}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-form-item',{attrs:{"label":"Fin size","prop":"divingFins"}},[_c('v-select',{attrs:{"options":_vm.selectDivingFins,"reduce":function (item) { return item.value; },"searchable":false,"value":contactBooking.divingFins,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingFins',
                        $event
                      )}}})],1)],1),_vm._v(" "),(contactBooking.divingFins === 'Other')?_c('el-row',{attrs:{"gutter":16}},[_c('el-form-item',{attrs:{"label":"Fin size (other)","prop":"divingFinsOther"}},[_c('el-input',{attrs:{"rows":6,"value":contactBooking.divingFinsOther,"placeholder":""},on:{"input":function($event){return _vm.onContactBookingInputChange(
                        contactBooking.contactID,
                        'divingFinsOther',
                        $event
                      )}}})],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('div',[_c('i',{staticClass:"icon icon-measurement diving__size-icon"}),_vm._v(" "),_c('span',{staticClass:"diving__size-links"},[_vm._v("\n              Size charts:\n              "),_c('a',{on:{"click":function($event){_vm.wetSuitSizeDialogVisible = true}}},[_vm._v("Wetsuit")]),_vm._v(" /\n              "),_c('a',{on:{"click":function($event){_vm.finSizeDialogVisible = true}}},[_vm._v("Fin")])])]),_vm._v(" "),_c('hr',{}),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"0"}},[_vm._v("\n            Please tell us more about your diving experience\n          ")]),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Experience level","prop":"divingExperienceLevel"}},[_c('v-select',{attrs:{"options":_vm.selectDivingExperienceLevel,"reduce":function (item) { return item.value; },"searchable":false,"value":contactBooking.divingExperienceLevel,"filterable":"","label":"label","placeholder":"Please select"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'divingExperienceLevel',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"Date of last dive","prop":"dateOfLastDiveMonth"}},[_c('v-select',{staticClass:"vs--medium-height",attrs:{"clearable":false,"options":_vm.selectDateMonths,"reduce":function (item) { return item.value; },"filterable":"","label":"label","placeholder":"Month"},on:{"input":function($event){return _vm.onInputDateChange(
                      contactBooking.contactID,
                      ' dateOfLastDiveMonth',
                      $event,
                      'dateOfLastDive'
                    )}},model:{value:(
                    _vm.modelDateOfLastDiveMonths[contactBooking.contactID]
                  ),callback:function ($$v) {_vm.$set(_vm.modelDateOfLastDiveMonths, contactBooking.contactID, $$v)},expression:"\n                    modelDateOfLastDiveMonths[contactBooking.contactID]\n                  "}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":4}},[_c('el-form-item',{attrs:{"label":"","prop":"dateOfLastDiveYears"}},[_c('template',{slot:"label"},[_c('div',{staticStyle:{"visibility":"hidden"}},[_vm._v(".")])]),_vm._v(" "),_c('v-select',{staticClass:"vs--medium-height",attrs:{"clearable":false,"options":_vm.selectDateYears,"reduce":function (item) { return item.value; },"filterable":"","label":"label","placeholder":"Year"},on:{"input":function($event){return _vm.onInputDateChange(
                      contactBooking.contactID,
                      ' dateOfLastDiveYear',
                      $event,
                      'dateOfLastDive'
                    )}},model:{value:(_vm.modelDateOfLastDiveYears[contactBooking.contactID]),callback:function ($$v) {_vm.$set(_vm.modelDateOfLastDiveYears, contactBooking.contactID, $$v)},expression:"modelDateOfLastDiveYears[contactBooking.contactID]"}})],2)],1)],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":9}},[_c('el-form-item',{attrs:{"label":"Diving Certification Number","prop":"divingCertificationNumber"}},[_c('el-input',{attrs:{"rows":6,"value":contactBooking.divingCertificationNumber,"placeholder":"E.g 1405AA8733"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'divingCertificationNumber',
                      $event
                    )}}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"span":12}})],1),_vm._v(" "),_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"Diving Association","prop":"divingAssociation"}},[_c('v-select',{ref:'divingAssociationSelect' + contactBooking.contactID,refInFor:true,staticStyle:{"width":"300px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"options":_vm.selectDivingAssociation,"reduce":function (item) { return item.value; },"searchable":false,"value":_vm.retrieveDivingAssociationValue(contactBooking),"filterable":"","label":"label"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'divingAssociation',
                      $event
                    )},"search:focus":function($event){return _vm.onDivingAssociationFocus(contactBooking.contactID)}}})],1)],1),_vm._v(" "),(contactBooking.divingAssociation === 'Other')?_c('el-col',{attrs:{"span":12}},[_c('el-form-item',{attrs:{"label":"Please indicate the Diving Association","prop":"divingAssociationOther"}},[_c('el-input',{attrs:{"rows":6,"value":contactBooking.divingAssociationOther,"placeholder":""},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'divingAssociationOther',
                      $event
                    )}}})],1)],1):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('h3',{staticStyle:{"margin-top":"0"}},[_vm._v("\n            PADI Liability Release and Assumption of Risk\n          ")]),_vm._v(" "),_c('el-checkbox',{attrs:{"value":contactBooking.HasSignedPADIReleaseOfLiability},on:{"input":function($event){return _vm.onContactBookingInputChange(
                contactBooking.contactID,
                'HasSignedPADIReleaseOfLiability',
                $event
              )}}},[_vm._v("\n            I understand and agree to the terms of the\n            "),_c('span',{staticClass:"rol-link",on:{"click":_vm.handleClickROL}},[_vm._v("PADI Liability Release and Assumption of Risk")]),_vm._v(".\n          ")])],1):_vm._e()],1):_vm._e()],2)}),1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving || _vm.checkAllSignedPADI(_vm.contactBookings)},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 424 */
/*!****************************************!*\
  !*** ./src/components/WetsuitPage.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_WetsuitPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./WetsuitPage.vue */ 189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b39d988c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WetsuitPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-b39d988c","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./WetsuitPage.vue */ 427);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b39d988c","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./WetsuitPage.vue */ 425)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-b39d988c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./WetsuitPage.vue */ 426)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b39d988c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_WetsuitPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b39d988c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WetsuitPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 425 */
/*!********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b39d988c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WetsuitPage.vue ***!
  \********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 426 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-b39d988c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/WetsuitPage.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 427 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b39d988c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/WetsuitPage.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasWetsuit())?_c('div',{staticClass:"container main__diving main--sticky-bottom"},[_c('el-dialog',{attrs:{"show-close":true,"visible":_vm.wetSuitSizeDialogVisible,"center":"","custom-class":"diving__size-dialog"},on:{"close":function($event){_vm.wetSuitSizeDialogVisible = false}}},[_c('template',{slot:"title"},[_c('h2',{staticClass:"diving__size-dialog-title"},[_vm._v("Wetsuit Size Chart")])]),_vm._v(" "),_c('div',{staticClass:"diving__size-dialog-table-header"},[_vm._v("Adult")]),_vm._v(" "),_c('el-table',{staticStyle:{"margin-bottom":"40px"},attrs:{"data":_vm.adultWetSuitSizeData,"resizable":false,"fit":""}},[_c('el-table-column',{attrs:{"label":"Sizes","prop":"size"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Chest (cm)","prop":"chest"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Waist (cm)","prop":"waist"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hip (cm)","prop":"hip"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (cm)","prop":"height"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (ft)","prop":"heightFt"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Weight (kg)","prop":"weightKg"}})],1),_vm._v(" "),_c('div',{staticClass:"diving__size-dialog-table-header"},[_vm._v("Children")]),_vm._v(" "),_c('el-table',{attrs:{"data":_vm.childWetSuitSizeData,"resizable":false,"fit":""}},[_c('el-table-column',{attrs:{"label":"Sizes","prop":"size"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Chest (cm)","prop":"chest"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Waist (cm)","prop":"waist"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Hip (cm)","prop":"hip"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (cm)","prop":"height"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Height (ft)","prop":"heightFt"}})],1)],2),_vm._v(" "),_c('el-collapse',{ref:"formRoot",model:{value:(_vm.activeCollapseIndexes),callback:function ($$v) {_vm.activeCollapseIndexes=$$v},expression:"activeCollapseIndexes"}},_vm._l((_vm.contactBookings),function(contactBooking,index){return _c('el-collapse-item',{key:contactBooking.contactID,staticClass:"el-collapse-item--diving",attrs:{"name":index}},[_c('template',{staticClass:"title",slot:"title"},[_c('span',{staticClass:"guest-number"},[_vm._v("GUEST "+_vm._s(index + 1)+"/")]),_vm._v(_vm._s(_vm.getFullNameByContactId(contactBooking.contactID))+"\n      ")]),_vm._v(" "),_c('el-form',{attrs:{"model":contactBooking,"rules":_vm.ruleValidate,"label-position":"left"}},[_c('el-radio-group',{staticClass:"diving__planning-to-dive",attrs:{"value":contactBooking.needAWetsuit === true},on:{"input":function($event){return _vm.onContactBookingInputChange(
              contactBooking.contactID,
              'needAWetsuit',
              $event
            )}}},[_c('el-radio',{attrs:{"label":true}},[_vm._v(" I need a wetsuit. ")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false}},[_vm._v(" I don't need a wetsuit. ")])],1),_vm._v(" "),(
            contactBooking.needAWetsuit === true ||
            contactBooking.needAWetsuit === 'true' ||
            false
          )?_c('div',{staticStyle:{"height":"100%"}},[_c('el-row',{attrs:{"gutter":16}},[_c('el-col',{attrs:{"span":8}},[_c('el-form-item',{attrs:{"label":"Wetsuit size","prop":"wetsuit"}},[_c('v-select',{ref:'wetsuitSelect' + contactBooking.contactID,refInFor:true,attrs:{"options":_vm.selectWetsuit,"reduce":function (item) { return item.value; },"searchable":false,"value":contactBooking.wetsuit,"filterable":"","label":"label"},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'wetsuit',
                      $event
                    )},"search:focus":function($event){return _vm.onWetsuitFocus(contactBooking.contactID)}}})],1)],1),_vm._v(" "),(contactBooking.wetsuit === 'Other')?_c('el-col',{attrs:{"gutter":16}},[_c('el-form-item',{attrs:{"label":"Wetsuit size (other)","prop":"wetsuitOther"}},[_c('el-input',{attrs:{"rows":6,"value":contactBooking.wetsuitOther,"placeholder":""},on:{"input":function($event){return _vm.onContactBookingInputChange(
                      contactBooking.contactID,
                      'wetsuitOther',
                      $event
                    )}}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"diving__size-links"},[_vm._v("\n              Size charts:\n              "),_c('a',{on:{"click":function($event){_vm.wetSuitSizeDialogVisible = true}}},[_vm._v("Wetsuit")])])])],1):_vm._e()],1)],2)}),1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickNext}},[_vm._v("Next")])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 428 */
/*!***************************************************!*\
  !*** ./src/components/PrePostArrangementPage.vue ***!
  \***************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PrePostArrangementPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./PrePostArrangementPage.vue */ 190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e0e6d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrePostArrangementPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-778e0e6d","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./PrePostArrangementPage.vue */ 431);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-778e0e6d","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PrePostArrangementPage.vue */ 429)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-778e0e6d","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./PrePostArrangementPage.vue */ 430)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-778e0e6d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_PrePostArrangementPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_778e0e6d_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PrePostArrangementPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 429 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-778e0e6d","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PrePostArrangementPage.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 430 */
/*!******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-778e0e6d","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/PrePostArrangementPage.vue ***!
  \******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 431 */
/*!***************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-778e0e6d","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrePostArrangementPage.vue ***!
  \***************************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__pre-post-arrangement container main--sticky-bottom"},[_c('el-collapse',{ref:"formRoot",model:{value:(_vm.activeCollapseIndexes),callback:function ($$v) {_vm.activeCollapseIndexes=$$v},expression:"activeCollapseIndexes"}},_vm._l((_vm.contacts),function(contact,index){return _c('el-collapse-item',{key:contact.contactID,staticClass:"el-collapse-item--prePostArrangement",class:{
        'el-collapse-item--prePostArrangement--samePlan':
          contact.hasSamePrePostArrangement,
      },attrs:{"name":index}},[_c('div',{staticClass:"label-mandatory"},[_vm._v("Fields marked with * are mandatory")]),_vm._v(" "),_c('template',{staticClass:"title",slot:"title"},[_c('span',{staticClass:"guest-number"},[_vm._v("GUEST "+_vm._s(index + 1)+" / ")]),_vm._v("\n        "+_vm._s(_vm.getFullName(contact))+"\n\n        "),(contact.contactID !== _vm.primaryContact.contactID)?_c('el-checkbox',{staticClass:"checkbox--samePlan",attrs:{"value":contact.hasSamePrePostArrangement},on:{"input":function($event){return _vm.onCheckHasSamePlan(
              contact.contactID,
              _vm.primaryContact.contactID,
              'hasSamePrePostArrangement',
              $event
            )}}},[_vm._v("\n          Same plan as Guest 1\n        ")]):_vm._e()],1),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"section-title"},[_vm._v("\n            "+_vm._s(_vm.booking.isGalapagosCruise
                ? "Arrival to Galapagos"
                : "Pre-cruise")+"\n          ")])]),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var preArrangement = ref.preArrangement;
return (
              preArrangement &&
              preArrangement.flightBookedByAqua &&
              _vm.booking.facilityCode === 'AQM'
            )?[_c('el-row',[_vm._v("\n              Aqua expeditions has partnered with LATAM Airlines to offer\n              preferential rates on flights from Quito or Guayaquil which\n              arrive on the day of Aqua Mare’s departure. Our Guest Relations\n              Coordinator will reach out to coordinate the details of your\n              flights.\n            ")]),_vm._v(" "),_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n              If you want to make any changes or arrange your own flights,\n              please reach out to\n              "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("reservations@aquaexpeditions.com")])])]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"div","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var preArrangement = ref.preArrangement;
return (preArrangement && !preArrangement.flightBookedByAqua)?[(_vm.booking.recommendedFlight)?_c('el-row',[_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"recommended-flight"},[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements
                        .takingRecommendedFlight},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-checkbox',{staticClass:"check-row",attrs:{"value":preArrangement.takingRecommendedFlight},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'takingRecommendedFlight',
                            !preArrangement.takingRecommendedFlight
                          )}}},[_vm._v("\n                        I am on the recommended flight\n                      ")])]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"recommended-flight__detail",class:{
                      hidden: !preArrangement.takingRecommendedFlight,
                    }},[_c('div',{staticClass:"flight__departure"},[_c('div',{staticClass:"code"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightFrom)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"city"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightFromText)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight
                            .outboundFlightDepartureTime)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__arrival"},[_c('div',{staticClass:"code"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightTo)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"city"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightToText)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightArrivalTime)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__number"},[_c('div',{staticClass:"label"},[_vm._v("Flight")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.outboundFlightCode)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__date"},[_c('div',{staticClass:"label"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.departureDateDisplay)+"\n                      ")])])])],1)])],1):(_vm.booking.isGalapagosCruise)?_c('el-row',{staticClass:"arrive-by__label"},[_vm._v("\n              I will arrive by airplane to Galapagos.\n            ")]):(_vm.booking.isFromTanzania)?_c('el-row',{staticClass:"arrive-by__label"},[_vm._v("\n              I will arrive by airplane into:\n              "),_c('el-form',{attrs:{"model":preArrangement}},[_c('el-radio-group',{staticClass:"tanzania-flight",attrs:{"value":preArrangement.zanzibarAirport === true ? true : false},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                      preArrangement.preArrangementID,
                      'zanzibarAirport',
                      $event
                    )}}},[_c('el-radio',{attrs:{"label":true}},[_c('div',[_vm._v("\n                      Zanzibar (Abeid Amani Karuma International Airport\n                      (ZNZ))\n                    ")])]),_vm._v(" "),_c('el-radio',{staticClass:"tanzania-flight__other-airport",attrs:{"label":false}},[_c('div',{staticClass:"tanzania-flight__other-airport"},[_vm._v("\n                      Tanzania Other airport:\n\n                      "),_c('div',[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements
                              .otherAirport},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto","margin-top":"0px"},attrs:{"value":preArrangement.otherAirport,"placeholder":"other airport name"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                                  preArrangement.preArrangementID,
                                  'otherAirport',
                                  $event
                                )}}})]},proxy:true}],null,true)})],1)])])],1)],1)],1):_c('el-row',[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.notTakingAFlight},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-checkbox',{attrs:{"value":!preArrangement.notTakingAFlight},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'notTakingAFlight',
                        !$event
                      )}}},[_vm._v("\n                    "+_vm._s(_vm.booking.isAmazonCruise
                        ? "I am taking a flight to Iquitos."
                        : _vm.booking.departurePort === "Komodo National Park"
                          ? "I will arrive by airplane to Labuan Bajo"
                          : ("I will arrive by airplane to " + (_vm.booking.departurePort) + "."))+"\n                  ")])]},proxy:true}],null,true)})],1),_vm._v(" "),(
                (_vm.booking.recommendedFlight &&
                  !preArrangement.takingRecommendedFlight) ||
                (!_vm.booking.recommendedFlight &&
                  !preArrangement.notTakingAFlight)
              )?_c('el-row',{staticStyle:{"margin-top":"24px"}},[_vm._v("\n              I will arrive on\n\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.arrivalDate},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-date-picker',{attrs:{"value":preArrangement.arrivalDate,"format":"yyyy-MM-dd","placeholder":"Select date*","type":"date","value-format":"yyyy-MM-dd"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'arrivalDate',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.arrivalTime},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-time-picker',{attrs:{"value":preArrangement.arrivalTime,"format":"HH:mm","placeholder":"Select time*","value-format":"HH:mm"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'arrivalTime',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v("\n\n              on flight number\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please enter your post-cruise flight number.","is-error":_vm.forms[contact.contactID].preArrangements.flightNumber},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":preArrangement.flightNumber,"placeholder":"your flight number*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'flightNumber',
                        $event
                      )}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('div',{staticClass:"info-flight-number-wrapper"},[_c('el-popover',{attrs:{"content":"You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'.","placement":"top","trigger":"hover","width":"200"}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"icon icon-information"})])])],1)]},proxy:true}],null,true)})]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticStyle:{"display":"flex","align-items":"center"}},[_c('br'),_vm._v("coming from\n\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.from},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto","margin-top":"24px"},attrs:{"value":preArrangement.from,"placeholder":"place"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'from',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),(_vm.booking.isAquaLares)?_c('div',[_vm._v("\n                  via\n\n                  "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.airline},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto","margin-top":"24px"},attrs:{"value":preArrangement.airline,"placeholder":"airline"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                            preArrangement.preArrangementID,
                            'airline',
                            $event
                          )}}})]},proxy:true}],null,true)})],1):_vm._e()],1)],1):_vm._e()]:undefined}}],null,true)}),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                          var preArrangement = ref.preArrangement;
return (
              preArrangement &&
              !preArrangement.flightBookedByAqua &&
              ((preArrangement.flightNumber && preArrangement.arrivalDate) ||
                preArrangement.galapagosRouteInfo)
            )?[_c('div',[_vm._v("\n              I will be embarking from\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.galapagosRouteInfo},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{ref:'preArrangementTypeSelect' + contact.contactID,refInFor:true,staticStyle:{"width":"440px","display":"inline-block","vertical-align":"middle","font-size":"18px"},attrs:{"clearable":false,"options":_vm.selectTypeOfRouteToGalapagos,"reduce":function (item) { return item.value; },"searchable":false,"value":preArrangement.galapagosRouteInfo,"placeholder":"your departure and arrival city*","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'galapagosRouteInfo',
                        $event
                      )}}})]},proxy:true}],null,true)})],1)]:undefined}}],null,true)}):_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(
              contact.contactID,
              'Location to port'
            ),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var preArrangement = ref.preArrangement;
return (preArrangement)?[_c('div',[_c('div',{staticClass:"arrangement-field"},[(_vm.booking.isAquaLares)?_c('span',[_vm._v("\n                  I plan to transfer to the meeting point by\n                ")]):_c('span',[_vm._v("I plan to go to the port by")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements
                      .typeOfPreCruiseArrangement},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{ref:'preArrangementTypeSelect' + contact.contactID,refInFor:true,staticStyle:{"width":"440px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"options":_vm.selectTypeOfArrangementsForPreCruise(contact),"reduce":function (item) { return item.value; },"searchable":false,"value":preArrangement.typeOfArrangement,"placeholder":"select option*","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'typeOfArrangement',
                          $event
                        )}}})]},proxy:true}],null,true)})],1)]),_vm._v(" "),(
                preArrangement.typeOfArrangement &&
                preArrangement.typeOfArrangement.indexOf(
                  'AE Private transfer'
                ) === 0 &&
                _vm.booking.preArrangementPrivateTransferNote
              )?_c('div',{staticClass:"note",domProps:{"innerHTML":_vm._s(
                _vm.formatTransferNote(_vm.booking.preArrangementPrivateTransferNote)
              )}}):_vm._e(),_vm._v(" "),(
                preArrangement.typeOfArrangement === 'AE Shared transfer' &&
                _vm.booking.preArrangementSharedTransferNote
              )?_c('div',{staticClass:"note"},[_vm._v("\n              "+_vm._s(_vm.booking.preArrangementSharedTransferNote)+"\n            ")]):_vm._e(),_vm._v(" "),(
                preArrangement.typeOfArrangement &&
                preArrangement.typeOfArrangement.indexOf(
                  'AE Private transfer'
                ) === 0 &&
                _vm.booking.preArrangementPrivateTransferLink
              )?_c('div',{staticClass:"note"},[_vm._v("\n              Please contact us at\n              "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("reservations@aquaexpeditions.com")]),_vm._v("\n              to arrange your private transfer. Kindly note that this service\n              is available at an additional cost.\n            ")]):_vm._e(),_vm._v(" "),(preArrangement.typeOfArrangement === 'By 3rd party')?_c('div',[_c('div',{staticStyle:{"margin-top":"24px","margin-bottom":"16px"}},[_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("Driver contact details")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.localHandler},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":preArrangement.localHandler,"placeholder":"local handler's name*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'localHandler',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.nameOfPerson},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":preArrangement.nameOfPerson,"placeholder":"driver name*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'nameOfPerson',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.contactNo},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":preArrangement.contactNo,"placeholder":"contact number*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'contactNo',
                          $event
                        )}}})]},proxy:true}],null,true)})],1),_vm._v(" "),_c('div',{staticClass:"arrangement-field"},[_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("from")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.from},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"440px"},attrs:{"value":preArrangement.from,"placeholder":"pick up location"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'from',
                          $event
                        )}}})]},proxy:true}],null,true)})],1)]):_vm._e(),_vm._v(" "),(preArrangement.typeOfArrangement === 'Other')?_c('div',{staticClass:"arrangement-field",staticStyle:{"display":"flex","margin-top":"24px"}},[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.otherMode},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"440px"},attrs:{"value":preArrangement.otherMode,"placeholder":"other modes"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'otherMode',
                        $event
                      )}}})]},proxy:true}],null,true)})],1):_vm._e(),_vm._v(" "),(
                (preArrangement.typeOfArrangement === 'By 3rd party' ||
                  preArrangement.typeOfArrangement === 'Taxi' ||
                  preArrangement.typeOfArrangement === 'Other') &&
                _vm.booking.preArrangementOtherTransferNote
              )?_c('div',{staticClass:"note"},[_vm._v("\n              "+_vm._s(_vm.booking.preArrangementOtherTransferNote)+"\n            ")]):_vm._e(),_vm._v(" "),(
                _vm.booking.isAquaLares &&
                _vm.booking.departurePort === 'Madagascar' &&
                _vm.isCurrentDateBefore(2026, 1, 15)
              )?_c('div',{staticClass:"note",staticStyle:{"display":"flex"}},[_vm._v("\n              Please arrive on 14th February, as departure is at 9:00 AM on\n              15th February.\n            ")]):_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.canShowDateOfEntryToPeruField(contact))?_c('div',{staticStyle:{"margin-top":"24px","margin-bottom":"16px"}},[_c('el-row',[_vm._v("\n                Date of entry to Peru\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.dateOfEntryToPeru},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-date-picker',{attrs:{"value":preArrangement.dateOfEntryToPeru,"format":"yyyy-MM-dd","placeholder":"Select date*","type":"date","value-format":"yyyy-MM-dd"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'dateOfEntryToPeru',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v("\n                from\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.entryToPeruFrom},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{staticStyle:{"min-width":"420px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"filter-by":_vm.filterCountry,"options":_vm.selectCountries,"reduce":function (item) { return item.value; },"value":preArrangement.entryToPeruFrom,"placeholder":"select option*","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'entryToPeruFrom',
                          $event
                        )},"visible-change":_vm.resetFilterCountry}})]},proxy:true}],null,true)})],1)],1):_vm._e()]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(
              contact.contactID,
              'Accommodation'
            ),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var preArrangement = ref.preArrangement;
return (preArrangement)?[_c('el-row',[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.arrivePriorToCruise},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-checkbox',{attrs:{"value":preArrangement.arrivePriorToCruise},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                        preArrangement.preArrangementID,
                        'arrivePriorToCruise',
                        $event
                      )}}},[_vm._v("\n                    I plan to arrive the day prior to the cruise.\n                  ")])]},proxy:true}],null,true)})],1),_vm._v(" "),(_vm.canShowPreArrangementAccommodationField(contact))?_c('el-row',{staticStyle:{"margin-top":"24px"}},[(_vm.booking.isAquaLares)?_c('div',{staticClass:"arrangement-field",staticStyle:{"margin-bottom":"24px"}},[_vm._v("\n                I plan to arrive\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.daysBefore},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"200px"},attrs:{"value":preArrangement.daysBefore,"placeholder":"number of days*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'daysBefore',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v("\n                days prior to cruise departure\n              ")],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"arrangement-field"},[_vm._v("\n                I will be staying at\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].preArrangements.accommodationName},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"500px"},attrs:{"value":preArrangement.accommodationName,"placeholder":"name of your accommodation*"},on:{"input":function($event){return _vm.onPreArrangementInputChange(
                          preArrangement.preArrangementID,
                          'accommodationName',
                          $event
                        )}}})]},proxy:true}],null,true)})],1)]):_vm._e()]:undefined}}],null,true)})],1),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n        All transfers to the port will be arranged by Aqua Expeditions and are\n        shared.\n      ")]):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"section-title"},[_vm._v("\n            "+_vm._s(_vm.booking.isGalapagosCruise
                ? "Departure from Galapagos"
                : "Post-cruise")+"\n          ")])]),_vm._v(" "),_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                var postArrangement = ref.postArrangement;
return (
              postArrangement &&
              postArrangement.flightBookedByAqua &&
              _vm.booking.facilityCode === 'AQM'
            )?[_c('el-row',[_vm._v("\n              Aqua expeditions has partnered with LATAM Airlines to offer\n              preferential rates on flights from Quito or Guayaquil which\n              arrive on the day of Aqua Mare’s departure. Our Guest Relations\n              Coordinator will reach out to coordinate the details of your\n              flights.\n            ")]),_vm._v(" "),_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n              If you want to make any changes or arrange your own flights,\n              please reach out to\n              "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("reservations@aquaexpeditions.com")])])]:undefined}}],null,true)}),_vm._v(" "),(!_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Port to location'
            ),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var postArrangement = ref.postArrangement;
return (postArrangement)?[_c('span',{staticClass:"bold",staticStyle:{"vertical-align":"middle"}},[_vm._v("When the cruise ends,")]),_vm._v(" "),_c('span',{staticStyle:{"vertical-align":"middle"}},[_vm._v("I plan to")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please specify your post-cruise transportation details.","is-error":_vm.forms[contact.contactID].postArrangements
                  .postArrangementAction},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{ref:'postArrangementActionSelect' + contact.contactID,refInFor:true,staticStyle:{"width":"540px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"options":_vm.selectPostArrangementActions(),"reduce":function (item) { return item.value; },"searchable":false,"value":postArrangement.postArrangementAction,"placeholder":"select option","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                      postArrangement.postArrangementID,
                      'postArrangementAction',
                      $event
                    )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('br')]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),(
            _vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Port to location'
            ) &&
            (_vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Port to location'
            ).postArrangementAction === 'airport' ||
              _vm.booking.isGalapagosCruise)
          )?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"div","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var postArrangement = ref.postArrangement;
return (postArrangement && !postArrangement.flightBookedByAqua)?[_c('el-row',[(_vm.booking.recommendedFlight)?_c('el-col',{attrs:{"span":16}},[_c('div',{staticClass:"recommended-flight"},[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements
                        .takingRecommendedFlight},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-checkbox',{staticClass:"check-row",attrs:{"value":postArrangement.takingRecommendedFlight},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                            postArrangement.postArrangementID,
                            'takingRecommendedFlight',
                            !postArrangement.takingRecommendedFlight
                          )}}},[_vm._v("\n                        I am on the recommended flight\n                      ")])]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"recommended-flight__detail",class:{
                      hidden: !postArrangement.takingRecommendedFlight,
                    }},[_c('div',{staticClass:"flight__departure"},[_c('div',{staticClass:"code"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightFrom)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"city"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightFromText)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightDepartureTime)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__arrival"},[_c('div',{staticClass:"code"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightTo)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"city"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightToText)+"\n                      ")]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightArrivalTime)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__number"},[_c('div',{staticClass:"label"},[_vm._v("Flight")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.returnFlightCode)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flight__date"},[_c('div',{staticClass:"label"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"value"},[_vm._v("\n                        "+_vm._s(_vm.booking.recommendedFlight.arrivalDateDisplay)+"\n                      ")])])])],1)]):_vm._e(),_vm._v(" "),(postArrangement.takingRecommendedFlight)?_c('el-col',{staticStyle:{"margin-top":"24px"},attrs:{"span":24}},[_vm._v("\n                My flight reference number is\n                "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.referenceNumber},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"240px"},attrs:{"value":postArrangement.referenceNumber,"placeholder":"Flight reference number*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'referenceNumber',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('div',{staticClass:"note",staticStyle:{"margin-top":"16px"}},[_c('div',[_vm._v("\n                    Please provide us with your flight reference number in\n                    order for us to process the flight check-in for you\n                    beforehand.\n                  ")]),_vm._v(" "),_c('div',[_vm._v("\n                    You will find your 6-digit reservation code in the flight\n                    confirmation: eg. XXXXXX\n                  ")])])],1):_vm._e()],1),_vm._v(" "),(
                !_vm.booking.recommendedFlight ||
                !postArrangement.takingRecommendedFlight
              )?_c('el-row',{staticStyle:{"margin-top":"24px"}},[_vm._v("\n              My departure flight is on\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please enter your post-cruise flight number.","is-error":_vm.forms[contact.contactID].postArrangements.flightNumber},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.flightNumber,"placeholder":"your flight number*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'flightNumber',
                        $event
                      )}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('div',{staticClass:"info-flight-number-wrapper"},[_c('el-popover',{attrs:{"content":"You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'.","placement":"top","trigger":"hover","width":"200"}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"icon icon-information"})])])],1)]},proxy:true}],null,true)})]},proxy:true}],null,true)}),_vm._v("\n\n              on\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please enter the date of your post-cruise arrangements.","is-error":_vm.forms[contact.contactID].postArrangements.departureDate},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-date-picker',{attrs:{"value":postArrangement.departureDate,"format":"yyyy-MM-dd","placeholder":"Select date*","type":"date","value-format":"yyyy-MM-dd"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'departureDate',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please provide the time of your post-cruise arrangements.","is-error":_vm.forms[contact.contactID].postArrangements.departureTime},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-time-picker',{attrs:{"value":postArrangement.departureTime,"format":"HH:mm","placeholder":"Select time*","value-format":"HH:mm"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'departureTime',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('br'),_vm._v("heading to\n              "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.to},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto","margin-top":"24px"},attrs:{"value":postArrangement.to,"placeholder":"place"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'to',
                        $event
                      )}}})]},proxy:true}],null,true)})],1):_vm._e()]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),(_vm.canShowPostArrangementAccommodationField(contact))?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Accommodation'
            ),"tag":"el-row","forms":"forms"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var postArrangement = ref.postArrangement;
return (postArrangement)?[_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("I will be staying at")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.accommodationName},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"440px"},attrs:{"value":postArrangement.accommodationName,"placeholder":"name of your accommodation*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                      postArrangement.postArrangementID,
                      'accommodationName',
                      $event
                    )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('br'),_vm._v(" "),(
                _vm.postArrangementByContactIDAndCategory(
                  contact.contactID,
                  'Port to location'
                ) &&
                _vm.postArrangementByContactIDAndCategory(
                  contact.contactID,
                  'Port to location'
                ).postArrangementAction === 'sharedTransfer'
              )?_c('div',{staticClass:"note"},[_vm._v("\n              Please indicate \"None\" if you are not staying in a hotel after\n              the voyage.\n            ")]):_vm._e()]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),(_vm.canShowPostArrangementFlightField(contact))?_c('scope',{attrs:{"postArrangementFlight":_vm.postArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
              var postArrangementFlight = ref.postArrangementFlight;
return (postArrangementFlight)?[_c('span',{staticStyle:{"display":"inline-block"}},[_vm._v("My departure flight is on")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"Please enter your post-cruise flight number.","is-error":_vm.forms[contact.contactID].postArrangements.flightNumber},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangementFlight.flightNumber,"placeholder":"your flight number"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                      postArrangementFlight.postArrangementID,
                      'flightNumber',
                      $event
                    )}},scopedSlots:_vm._u([{key:"suffix",fn:function(){return [_c('div',{staticClass:"info-flight-number-wrapper"},[_c('el-popover',{attrs:{"content":"You will find your flight number in the flight confirmation : eg 'XX 1234' or 'YY 123'.","placement":"top","trigger":"hover","width":"200"}},[_c('span',{attrs:{"slot":"reference"},slot:"reference"},[_c('i',{staticClass:"icon icon-information"})])])],1)]},proxy:true}],null,true)})]},proxy:true}],null,true)}),_vm._v("\n\n            on\n            "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.departureDate},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-date-picker',{attrs:{"value":postArrangementFlight.departureDate,"format":"yyyy-MM-dd","placeholder":"Select date*","type":"date","value-format":"yyyy-MM-dd"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                      postArrangementFlight.postArrangementID,
                      'departureDate',
                      $event
                    )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.departureTime},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-time-picker',{attrs:{"value":postArrangementFlight.departureTime,"format":"HH:mm","placeholder":"Select time*","value-format":"HH:mm"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                      postArrangementFlight.postArrangementID,
                      'departureTime',
                      $event
                    )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('div',[_c('span',{staticStyle:{"display":"inline-block","margin-top":"24px"}},[_c('br'),_vm._v("heading to")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.to},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangementFlight.to,"placeholder":"place"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangementFlight.postArrangementID,
                        'to',
                        $event
                      )}}})]},proxy:true}],null,true)})],1)]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),(_vm.canShowDriverDetailsField(contact))?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Port to location'
            ),"tag":"el-row","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var postArrangement = ref.postArrangement;
return (postArrangement)?[_c('div',{staticStyle:{"margin-top":"24px"}},[_c('span',{staticStyle:{"display":"inline-block"},style:({
                  width: 'auto',
                })},[_vm._v("Driver contact details")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.localHandler},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.localHandler,"placeholder":"local handler's name"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'localHandler',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.nameOfPerson},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.nameOfPerson,"placeholder":"driver name"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'nameOfPerson',
                        $event
                      )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.contactNo},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.contactNo,"placeholder":"contact number"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'contactNo',
                        $event
                      )}}})]},proxy:true}],null,true)})],1)]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                      var postArrangement = ref.postArrangement;
return (
              postArrangement &&
              !postArrangement.flightBookedByAqua &&
              ((postArrangement.flightNumber &&
                postArrangement.departureDate) ||
                postArrangement.galapagosRouteInfo)
            )?[_c('div',[_c('span',[_vm._v(" I will be disembarking from ")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.galapagosRouteInfo},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{ref:'postArrangementTypeSelect' + contact.contactID,refInFor:true,staticStyle:{"width":"440px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"options":_vm.selectTypeOfRouteFromGalapagos,"reduce":function (item) { return item.value; },"searchable":false,"value":postArrangement.galapagosRouteInfo,"placeholder":"your departure and arrival city*","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                        postArrangement.postArrangementID,
                        'galapagosRouteInfo',
                        $event
                      )},"search:focus":function($event){return _vm.onPostArrangementTypeFocus(contact.contactID)}}})]},proxy:true}],null,true)})],1)]:undefined}}],null,true)}):_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
              contact.contactID,
              'Port to location'
            ),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var postArrangement = ref.postArrangement;
return (postArrangement)?[(
                postArrangement.postArrangementAction === 'airport' ||
                postArrangement.postArrangementAction === 'hotel'
              )?_c('div',[_c('div',{staticClass:"arrangement-field"},[(postArrangement.postArrangementAction === 'airport')?_c('span',[_vm._v("\n                  I plan to go to the airport by\n                ")]):(
                    postArrangement.postArrangementAction === 'hotel'
                  )?_c('span',[_vm._v("\n                  I plan to go there by\n                ")]):_vm._e(),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements
                      .typeOfPostCruiseArrangement},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('v-select',{ref:'postArrangementTypeSelect' + contact.contactID,refInFor:true,staticStyle:{"width":"440px","display":"inline-block","vertical-align":"middle"},attrs:{"clearable":false,"options":_vm.selectTypeOfArrangementsForPostCruise(contact),"reduce":function (item) { return item.value; },"searchable":false,"value":postArrangement.typeOfArrangement,"placeholder":"select option*","filterable":"","label":"label"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'typeOfArrangement',
                          $event
                        )},"search:focus":function($event){return _vm.onPostArrangementTypeFocus(contact.contactID)}}})]},proxy:true}],null,true)})],1),_vm._v(" "),(
                  postArrangement.typeOfArrangement &&
                  postArrangement.typeOfArrangement.indexOf(
                    'AE Private transfer'
                  ) === 0 &&
                  _vm.booking.postArrangementPrivateTransferLink
                )?_c('div',[_c('div',{staticClass:"note"},[_vm._v("\n                  Please contact us at\n                  "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("reservations@aquaexpeditions.com")]),_vm._v("\n                  to arrange your private transfer. Kindly note that this\n                  service is available at an additional cost.\n                ")]),_vm._v(" "),_c('div',{staticStyle:{"margin-top":"16px"}},[_vm._v("\n                  Please have the Aqua Expeditions private transfer send me\n                  "+_vm._s(postArrangement.postArrangementAction === "airport"
                      ? "to the airport"
                      : "to my accommodation")+".\n                ")])]):_vm._e(),_vm._v(" "),(postArrangement.typeOfArrangement === 'By 3rd party')?_c('div',{staticStyle:{"margin-top":"24px"}},[_c('span',{staticStyle:{"display":"inline-block"},style:({
                    width: 'auto',
                  })},[_vm._v("Driver contact details")]),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.localHandler},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.localHandler,"placeholder":"local handler's name*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'localHandler',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.nameOfPerson},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.nameOfPerson,"placeholder":"driver name*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'nameOfPerson',
                          $event
                        )}}})]},proxy:true}],null,true)}),_vm._v(" "),_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements.contactNo},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-input',{staticStyle:{"width":"auto"},attrs:{"value":postArrangement.contactNo,"placeholder":"contact number*"},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                          postArrangement.postArrangementID,
                          'contactNo',
                          $event
                        )}}})]},proxy:true}],null,true)})],1):_vm._e(),_vm._v(" "),_c('scope',{attrs:{"postArrangementFlight":_vm.postArrangementByContactIDAndCategory(
                    contact.contactID,
                    'Flight'
                  ),"tag":"div","forms":_vm.forms},scopedSlots:_vm._u([{key:"default",fn:function(ref){
                  var postArrangementFlight = ref.postArrangementFlight;
return (postArrangementFlight)?[(_vm.isSiemReapExtensionBooking())?_c('el-row',{staticStyle:{"margin-top":"16px"}},[_c('ae-error-wrapper',{ref:"ae-error-wrapper-field",refInFor:true,attrs:{"error-message":"This is a required field","is-error":_vm.forms[contact.contactID].postArrangements
                          .optOutSiemReapExtensionFlight},scopedSlots:_vm._u([{key:"form-item",fn:function(){return [_c('el-checkbox',{attrs:{"value":postArrangementFlight.optOutSiemReapExtensionFlight},on:{"input":function($event){return _vm.onPostArrangementInputChange(
                              postArrangementFlight.postArrangementID,
                              'optOutSiemReapExtensionFlight',
                              $event
                            )}}},[_vm._v("\n                          Opt out of Siem Reap flight extension\n                        ")])]},proxy:true}],null,true)})],1):_vm._e()]:undefined}}],null,true)}),_vm._v(" "),(
                  postArrangement.typeOfArrangement &&
                  postArrangement.typeOfArrangement.indexOf(
                    'AE Private transfer'
                  ) === 0 &&
                  _vm.booking.postArrangementPrivateTransferNote
                )?_c('div',{staticClass:"note",domProps:{"innerHTML":_vm._s(
                  _vm.formatTransferNote(
                    _vm.booking.postArrangementPrivateTransferNote
                  )
                )}}):_vm._e(),_vm._v(" "),(
                  (postArrangement.typeOfArrangement === 'By 3rd party' ||
                    postArrangement.typeOfArrangement === 'Taxi') &&
                  _vm.booking.postArrangementOtherTransferNote
                )?_c('div',{staticClass:"note"},[_vm._v("\n                "+_vm._s(_vm.booking.postArrangementOtherTransferNote)+"\n              ")]):_vm._e(),_vm._v(" "),(
                  postArrangement.postArrangementAction === 'airport' &&
                  postArrangement.typeOfArrangement &&
                  postArrangement.typeOfArrangement.indexOf(
                    'AE Private transfer'
                  ) === 0
                )?_c('div',[_c('el-alert',{staticStyle:{"margin-bottom":"14px","margin-top":"24px"},attrs:{"closable":false,"show-icon":"","title":"Important note:","type":"warning"}},[_c('div',[_vm._v("\n                    Please note that Aqua Expeditions only provides airport\n                    transfer immediately after disembarkation.\n                  ")])])],1):_vm._e()],1):_vm._e(),_vm._v(" "),(
                (postArrangement.postArrangementAction === 'sharedTransfer' ||
                  postArrangement.typeOfArrangement ===
                    'AE Shared transfer') &&
                _vm.booking.postArrangementSharedTransferNote
              )?_c('div',{staticClass:"note",staticStyle:{"margin-top":"32px"}},[_vm._v("\n              "+_vm._s(_vm.booking.postArrangementSharedTransferNote)+"\n            ")]):_vm._e()]:undefined}}],null,true)})],1),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n        All transfers to the airport will be arranged by Aqua Expeditions and\n        are shared.\n      ")]):_vm._e()],2)}),1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickBack}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickSaveAndExit(false)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":_vm.onClickNext}},[_vm._v("Proceed to confirmation\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 432 */
/*!*********************************************!*\
  !*** ./src/components/ConfirmationPage.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ConfirmationPage.vue */ 191);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347a9e2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-347a9e2c","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ConfirmationPage.vue */ 440);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-347a9e2c","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ConfirmationPage.vue */ 433)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-347a9e2c","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./ConfirmationPage.vue */ 434)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-347a9e2c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ConfirmationPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_347a9e2c_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConfirmationPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-347a9e2c","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ConfirmationPage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-347a9e2c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/ConfirmationPage.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 435 */,
/* 436 */
/*!*******************************************!*\
  !*** ./src/components/ContactSummary.vue ***!
  \*******************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ContactSummary_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ContactSummary.vue */ 192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0ba6af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactSummary_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-3d0ba6af","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ContactSummary.vue */ 438);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-3d0ba6af","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ContactSummary.vue */ 437)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3d0ba6af"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_ContactSummary_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d0ba6af_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ContactSummary_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 437 */
/*!**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3d0ba6af","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ContactSummary.vue ***!
  \**********************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 438 */
/*!*******************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d0ba6af","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactSummary.vue ***!
  \*******************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact"},[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("Personal details")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-2', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.getFullName(_vm.contact) }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.getFullName(_vm.contact)))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Prefer to be addressed as")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v(_vm._s(_vm._f("formatDisplay")(_vm.contact.nickname)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Date of birth")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.dateOfBirth }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.dateOfBirth))+"\n      ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Email")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v(_vm._s(_vm._f("formatDisplay")(_vm.contact.email)))])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Contact number")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v(_vm._s(_vm._f("formatDisplay")(_vm.contact.phone)))])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Country of residence")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.mainMailingCountry }},[_vm._v("\n        "+_vm._s(_vm._f("formatKeyValueMandatory")(_vm.contact.mainMailingCountry))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Nationality")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.nationality }},[_vm._v("\n        "+_vm._s(_vm._f("formatKeyValueMandatory")(_vm.contact.nationality))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Gender")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.gender }},[_vm._v("\n        "+_vm._s(_vm._f("formatKeyValueMandatory")(_vm.contact.gender))+"\n      ")])])],1),_vm._v(" "),(
      !(this.booking.isAmazonCruise && this.isPeruvianContactBooking(_vm.contact))
    )?_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Passport number")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.passportNumber }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.passportNumber))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Passport issuing country")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.passportIssuingCountry }},[_vm._v("\n        "+_vm._s(_vm._f("formatKeyValueMandatory")(_vm.contact.passportIssuingCountry))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Expiry date")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.passportExpiryDate }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.passportExpiryDate))+"\n      ")])])],1):_vm._e(),_vm._v(" "),(!_vm.booking.isAmazonCruise)?_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Passport issued date")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.passportIssueDate }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.passportIssueDate))+"\n      ")])])],1):_vm._e(),_vm._v(" "),(
      this.booking.isAmazonCruise && this.isPeruvianContactBooking(_vm.contact)
    )?_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Peruvian National ID")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.nationalIdNumber }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.nationalIdNumber))+"\n      ")])])],1):_vm._e(),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('scope',{attrs:{"passport":_vm.passportByContactID(_vm.contact.contactID),"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var passport = ref.passport;
return (passport)?[_c('label',{staticClass:"contact__label"},[_vm._v("Passport image")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[(passport.file && passport.file.url)?_c('img',{staticStyle:{"display":"block","width":"168px","margin-top":"14px"},attrs:{"src":passport.file.url}}):_c('div',{staticClass:"mandatory",staticStyle:{"margin-top":"10px"}},[_vm._v("\n              Please upload your passport image.\n            ")])])]:undefined}}],null,true)})],1),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Residential address")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[(_vm.contact.mainMailingStreet)?_c('div',[_vm._v("\n          "+_vm._s(_vm.contact.mainMailingStreet)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contact.mainMailingCity)?_c('div',[_vm._v("\n          "+_vm._s(_vm.contact.mainMailingCity)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contact.mainMailingZip || _vm.contact.mainMailingState)?_c('div',[_vm._v("\n          "+_vm._s(_vm.contact.mainMailingZip)+"\n          "+_vm._s(_vm._f("formatKeyValue")(_vm.contact.mainMailingState))+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contact.mainMailingCountry)?_c('div',[_vm._v("\n          "+_vm._s(_vm._f("formatKeyValue")(_vm.contact.mainMailingCountry))+"\n        ")]):_vm._e()])])],1),_vm._v(" "),(_vm.visaRequirementByContactID(_vm.contact.contactID))?_c('hr'):_vm._e(),_vm._v(" "),_c('scope',{attrs:{"visaRequirement":_vm.visaRequirementByContactID(_vm.contact.contactID),"tag":"div"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var visaRequirement = ref.visaRequirement;
return (visaRequirement)?[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('h3',{staticStyle:{"margin-top":"0","margin-bottom":"8px"}},[_vm._v("\n          Have you applied for your cross-border visa?\n        ")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-2', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),(visaRequirement.visaType === 'Apply Onboard')?_c('div',[_vm._v("\n        No, I will apply on board\n      ")]):(visaRequirement.visaType === 'Not required')?_c('div',[_vm._v("\n        No, I do not need a visa\n      ")]):(
          visaRequirement.visaType === 'Physical Visa (Cross border)'
        )?_c('div',[_vm._v("\n        Yes, I have\n        "),(visaRequirement.file && visaRequirement.file.url)?_c('img',{staticStyle:{"display":"block","width":"168px","margin-top":"14px"},attrs:{"src":visaRequirement.file.url}}):_c('div',{staticClass:"mandatory",staticStyle:{"margin-top":"10px"}},[_vm._v("\n          Please upload your visa.\n        ")])]):_c('div',{staticClass:"mandatory"},[_vm._v("This is required.")])]:undefined}}],null,true)}),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('h3',{staticClass:"label-bold",staticStyle:{"margin-top":"0","margin-bottom":"8px"}},[_vm._v("\n        Have you (or your client, if you're an agent) traveled with us before?\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-2', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"answer"},[_vm._v("\n        "+_vm._s(_vm.contact.hasPastGuest ? "Yes, I have" : "No")+"\n      ")])]),_vm._v(" "),(_vm.contact.hasPastGuest)?_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Previous cruise(s) with us")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.pastGuest }},[_vm._v("\n          "+_vm._s(_vm._f("formatMultipleDisplayMandatory")(_vm.contact.pastGuest))+"\n        ")])])],1):_vm._e()],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("Emergency contact")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-2', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.getEmergencyFullName(_vm.contact) }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.getEmergencyFullName(_vm.contact)))+"\n      ")]),_vm._v(" "),(
          !_vm.contact.emergencyContactFirstName &&
          _vm.contact.emergencyContactLastName
        )?_c('div',{staticClass:"contact__value mandatory"},[_vm._v("\n        First name is required.\n      ")]):_vm._e(),_vm._v(" "),(
          !_vm.contact.emergencyContactLastName &&
          _vm.contact.emergencyContactFirstName
        )?_c('div',{staticClass:"contact__value mandatory"},[_vm._v("\n        Last name is required.\n      ")]):_vm._e()]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Contact")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.emergencyContactPhone }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.emergencyContactPhone))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Relationship")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.emergencyContactRelation }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.emergencyContactRelation))+"\n      ")])])],1),_vm._v(" "),(_vm.isAquaBlu())?_c('div',[_c('hr'),_vm._v(" "),_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("\n        Release of Liability and Assumption of Risk\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-2', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.HasSignedReleaseOfLiability }},[_vm._v("\n        "+_vm._s(_vm._f("formatSignedROL")(_vm.contact.HasSignedReleaseOfLiability))+"\n      ")])])],1):_vm._e(),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("Dietary and special requests")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-3', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Dietary Allergies")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.dietaryAllergies }},[_vm._v("\n        "+_vm._s(_vm._f("formatMultipleDisplayMandatory")(_vm.contact.dietaryAllergies))+"\n      ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Medical and health notes")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contact.medicalNotes }},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contact.medicalNotes))+"\n      ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Dietary Preferences note")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplay")(_vm.contact.dietaryPreferenceNotes))+"\n      ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Special request")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v("\n        "+_vm._s(_vm._f("formatDisplay")(_vm.booking.checkInRemarks))+"\n      ")])])],1),_vm._v(" "),_c('hr'),_vm._v(" "),(_vm.hasDiving())?[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("Diving information")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-3b', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),(_vm.contactBooking.planningToDive === true && _vm.canDive(_vm.contact))?[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Wetsuit size")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingWetsuit }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingWetsuit))+"\n          ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Fin size")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingFins }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingFins))+"\n          ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Diving experience")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingExperienceLevel }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingExperienceLevel))+"\n          ")])])],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Date of last dive")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.dateOfLastDive }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.dateOfLastDive))+"\n          ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Diving Certification Number")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingCertificationNumber }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingCertificationNumber))+"\n          ")])]),_vm._v(" "),(_vm.contactBooking.divingAssociation !== 'Other')?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Diving Association")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingAssociation }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingAssociation))+"\n          ")])]):_vm._e(),_vm._v(" "),(_vm.contactBooking.divingAssociation === 'Other')?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Diving Association (Other)")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.divingAssociationOther }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.divingAssociationOther))+"\n          ")])]):_vm._e()],1),_vm._v(" "),_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("PADI Release of Liability")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{
              mandatory: !_vm.contactBooking.HasSignedPADIReleaseOfLiability,
            }},[_vm._v("\n            "+_vm._s(_vm._f("formatSignedROL")(_vm.contactBooking.HasSignedPADIReleaseOfLiability))+"\n          ")])])],1),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n        Reminder: Please bring your diving certificate (PADI or equivalent) on\n        board.\n      ")])]:[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Are you diving?")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v("No")])])],1)],_vm._v(" "),_c('hr')]:_vm._e(),_vm._v(" "),(_vm.hasWetsuit())?[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("Wetsuit information")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-3c', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),(_vm.contactBooking.needAWetsuit === true)?[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Wetsuit size")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.wetsuit }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.wetsuit))+"\n          ")])]),_vm._v(" "),(_vm.contactBooking.wetsuit === 'Other')?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Wetsuit size (Other)")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !_vm.contactBooking.wetsuitOther }},[_vm._v("\n            "+_vm._s(_vm._f("formatDisplayMandatory")(_vm.contactBooking.wetsuitOther))+"\n          ")])]):_vm._e()],1),_vm._v(" "),_c('hr')]:[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Do you need a wetsuit?")]),_vm._v(" "),_c('div',{staticClass:"contact__value"},[_vm._v("No")])])],1)]]:_vm._e(),_vm._v(" "),_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"contact__section-title"},[_vm._v("\n      "+_vm._s(_vm.booking.isGalapagosCruise
          ? "Arrival to Galapagos"
          : "Pre-cruise information")+"\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"edit",attrs:{"to":{ name: 'step-4', query: { index: _vm.index } }}},[_vm._v("Edit")])],1),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var preArrangement = ref.preArrangement;
return (
        preArrangement &&
        preArrangement.flightBookedByAqua &&
        _vm.booking.facilityCode === 'AQM'
      )?[_c('div',{staticClass:"contact__value"},[_vm._v("\n        Aqua expeditions has partnered with LATAM Airlines to offer\n        preferential rates on flights from Quito or Guayaquil which arrive on\n        the day of Aqua Mare’s departure. Our Guest Relations Coordinator will\n        reach out to coordinate the details of your flights.\n      ")]),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n        If you want to make any changes or arrange your own flights, please\n        reach out to\n        "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com"}},[_vm._v("reservations@aquaexpeditions.com")])])]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var preArrangement = ref.preArrangement;
return (
        preArrangement &&
        (!preArrangement.notTakingAFlight ||
          preArrangement.takingRecommendedFlight) &&
        !preArrangement.flightBookedByAqua
      )?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Flight number")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.flightNumber }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.flightNumber))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.arrivalDate }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.arrivalDate))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Time")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.arrivalTime }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.arrivalTime))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var preArrangement = ref.preArrangement;
return (preArrangement && !preArrangement.flightBookedByAqua)?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Embarking from")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.galapagosRouteInfo }},[_vm._v("\n          "+_vm._s(_vm._f("formatGalapagosRouteInfo")(preArrangement.galapagosRouteInfo))+"\n        ")])])]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Location to port'
      ),"preArrangementAccommodation":_vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Accommodation'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var preArrangement = ref.preArrangement;
      var preArrangementAccommodation = ref.preArrangementAccommodation;
return (preArrangement)?[(
          _vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight') &&
          !_vm.preArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight')
            .takingRecommendedFlight &&
          preArrangementAccommodation.arrivePriorToCruise
        )?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Accommodation")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{
            mandatory:
              preArrangementAccommodation.arrivePriorToCruise &&
              !preArrangementAccommodation.accommodationName,
          }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")((preArrangementAccommodation &&
              preArrangementAccommodation.accommodationName)))+"\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.booking.isGalapagosCruise)?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Transportation")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.typeOfArrangement }},[_vm._v("\n          "+_vm._s(_vm._f("formatTypeOfArrangement")(preArrangement.typeOfArrangement))+"\n        ")])]):_vm._e()]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Location to port'
      ),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var preArrangement = ref.preArrangement;
return (
        preArrangement &&
        _vm.booking.isAmazonCruise &&
        _vm.contact.mainMailingCountry !== 'PE - Peru'
      )?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Date of entry to Peru")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.dateOfEntryToPeru }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.dateOfEntryToPeru))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("From")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.entryToPeruFrom }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.entryToPeruFrom))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"preArrangement":_vm.preArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Location to port'
      ),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var preArrangement = ref.preArrangement;
return (
        preArrangement && preArrangement.typeOfArrangement === 'By 3rd party'
      )?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Local handler's name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.localHandler }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.localHandler))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Driver name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.nameOfPerson }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.nameOfPerson))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Driver contact")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !preArrangement.contactNo }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(preArrangement.contactNo))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),_c('el-row',[(_vm.booking.isGalapagosCruise)?_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n      All transfers to the port will be arranged by Aqua Expeditions and are\n      shared.\n    ")]):_vm._e()]),_vm._v(" "),_c('el-row',[_c('div',{staticClass:"contact__section-title"},[_vm._v("\n      "+_vm._s(_vm.booking.isGalapagosCruise
          ? "Departure from Galapagos"
          : "Post-cruise information")+"\n    ")])]),_vm._v(" "),_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
          var postArrangement = ref.postArrangement;
return (
        postArrangement &&
        postArrangement.flightBookedByAqua &&
        _vm.booking.facilityCode === 'AQM'
      )?[_c('div',{staticClass:"contact__value"},[_vm._v("\n        Aqua expeditions has partnered with LATAM Airlines to offer\n        preferential rates on flights from Quito or Guayaquil which arrive on\n        the day of Aqua Mare’s departure. Our Guest Relations Coordinator will\n        reach out to coordinate the details of your flights.\n      ")]),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n        If you want to make any changes or arrange your own flights, please\n        reach out to\n        "),_c('a',{attrs:{"href":"mailto:reservations@aquaexpeditions.com"}},[_vm._v("reservations@aquaexpeditions.com")])])]:undefined}}],null,true)}),_vm._v(" "),_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var postArrangement = ref.postArrangement;
return (
        postArrangement &&
        (_vm.postArrangementByContactIDAndCategory(
          _vm.contact.contactID,
          'Port to location'
        ).postArrangementAction === 'airport' ||
          _vm.booking.isGalapagosCruise) &&
        !postArrangement.flightBookedByAqua
      )?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Flight number")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.flightNumber }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.flightNumber))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Date")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.departureDate }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.departureDate))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Time")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.departureTime }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.departureTime))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),(_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var postArrangement = ref.postArrangement;
return (postArrangement && !postArrangement.flightBookedByAqua)?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Disembarking from")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.galapagosRouteInfo }},[_vm._v("\n          "+_vm._s(_vm._f("formatGalapagosRouteInfo")(postArrangement.galapagosRouteInfo))+"\n        ")])])]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(_vm.contact.contactID, 'Flight'),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var postArrangement = ref.postArrangement;
return (postArrangement && postArrangement.takingRecommendedFlight)?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Flight reference number")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.referenceNumber }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.referenceNumber))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),(!_vm.booking.isGalapagosCruise)?_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Port to location'
      ),"postArrangementAccommodation":_vm.postArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Accommodation'
      ),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var postArrangement = ref.postArrangement;
      var postArrangementAccommodation = ref.postArrangementAccommodation;
return (postArrangement)?[(postArrangement.postArrangementAction === 'hotel')?_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Accommodation")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{
            mandatory: !postArrangementAccommodation.accommodationName,
          }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")((postArrangementAccommodation &&
              postArrangementAccommodation.accommodationName)))+"\n        ")])]):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Transportation")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.typeOfArrangement }},[_vm._v("\n          "+_vm._s(_vm._f("formatTypeOfArrangement")(postArrangement.typeOfArrangement))+"\n        ")])])]:undefined}}],null,true)}):_vm._e(),_vm._v(" "),_c('scope',{attrs:{"postArrangement":_vm.postArrangementByContactIDAndCategory(
        _vm.contact.contactID,
        'Port to location'
      ),"tag":"el-row"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
      var postArrangement = ref.postArrangement;
return (
        postArrangement &&
        postArrangement.typeOfArrangement === 'By 3rd party'
      )?[_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Local handler's name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.localHandler }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.localHandler))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Driver name")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.nameOfPerson }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.nameOfPerson))+"\n        ")])]),_vm._v(" "),_c('el-col',{attrs:{"span":8}},[_c('label',{staticClass:"contact__label"},[_vm._v("Driver contact")]),_vm._v(" "),_c('div',{staticClass:"contact__value",class:{ mandatory: !postArrangement.contactNo }},[_vm._v("\n          "+_vm._s(_vm._f("formatDisplayMandatory")(postArrangement.contactNo))+"\n        ")])])]:undefined}}],null,true)}),_vm._v(" "),_c('el-row',[(_vm.booking.isGalapagosCruise)?_c('div',{staticClass:"note",staticStyle:{"margin-top":"0"}},[_vm._v("\n      All transfers to the port will be arranged by Aqua Expeditions and are\n      shared.\n    ")]):_vm._e()]),_vm._v(" "),(!_vm.isLastContact)?_c('hr'):_vm._e(),_vm._v(" "),(!_vm.isLastContact)?_c('el-row',{staticStyle:{"margin-bottom":"0"},attrs:{"justify":"end","type":"flex"}},[_c('a',{staticClass:"link--nextGuest",on:{"click":function($event){return _vm.onClickNextGuest(_vm.contact)}}},[_vm._v("Next Guest")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 439 */,
/* 440 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347a9e2c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ConfirmationPage.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"formRoot",staticClass:"container main__confirmation main--sticky-bottom"},[_c('div',{staticClass:"summary",class:{ additionalPaddingTop: _vm.isStickySelectContainer },attrs:{"id":"confirmation-summary"}},[_c('div',{staticClass:"summary__header"},[_c('img',{attrs:{"src":this.cruiseBannerUrl}}),_vm._v(" "),_c('div',{staticClass:"summary__header__info"},[_c('el-row',{attrs:{"justify":"space-between","type":"flex"}},[_c('div',{staticClass:"summary__cruise-name"},[_vm._v("\n            "+_vm._s(_vm.cabinConfigurations[0] ? _vm.cabinConfigurations[0].ship : "")+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"summary__booking-number"},[_c('div',{staticClass:"summary__booking-number__label"},[_vm._v("Booking number")]),_vm._v(" "),_c('div',{staticClass:"summary__booking-number__value"},[_vm._v("\n              "+_vm._s(_vm.booking.bookingCode)+"\n            ")])])])],1)]),_vm._v(" "),(_vm.contacts.length > 3)?_c('div',[_c('div',{staticClass:"select-container",class:{ sticky: _vm.isStickySelectContainer }},[_c('label',[_vm._v("Select a guest")]),_vm._v(" "),_c('v-select',{staticStyle:{"width":"33%"},attrs:{"clearable":false,"get-option-label":_vm.getFullName,"options":_vm.contacts,"value":_vm.contacts[_vm.activeTabName],"filterable":"","label":"contactID"},on:{"input":function($event){return _vm.onSelectContact($event)}}})],1),_vm._v(" "),_c('contact-summary',{attrs:{"contact":_vm.contacts[_vm.activeTabName],"contactBooking":_vm.contactBooking(_vm.activeContactID),"index":_vm.activeTabName,"isLastContact":_vm.activeTabName === _vm.contacts.length - 1,"onClickNextGuest":_vm.onClickNextGuest}})],1):_c('el-tabs',{attrs:{"value":'' + _vm.activeTabName},on:{"tab-click":_vm.onClickTab}},_vm._l((_vm.contacts),function(contact,index){return _c('el-tab-pane',{key:index,attrs:{"name":'' + index}},[_c('div',{staticClass:"tab-pane__label",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"tab-pane__guest-wrapper"},[_c('div',{staticClass:"tab-pane__guest-index"},[_vm._v("\n              "+_vm._s(("Guest " + (index + 1)))+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"tab-pane__guest-name"},[_vm._v("\n              "+_vm._s(_vm._f("formatDisplay")(_vm.getFullName(contact)))+"\n            ")])])]),_vm._v(" "),_c('contact-summary',{attrs:{"contact":contact,"contactBooking":_vm.contactBooking(_vm.activeContactID),"index":index,"isLastContact":index === _vm.contacts.length - 1,"onClickNextGuest":_vm.onClickNextGuest}})],1)}),1)],1),_vm._v(" "),_c('div',{staticClass:"confirm-details"},[_c('el-form',{ref:"formValidate",attrs:{"id":"confirm-details-radio","model":_vm.booking,"rules":_vm.ruleValidate}},[_c('el-form-item',{attrs:{"prop":"checkedInConfirmedBy"}},[_c('el-radio-group',{attrs:{"value":_vm.booking.checkedInConfirmedBy},on:{"input":function($event){return _vm.onCheckedConfirmedBy($event)}}},[_c('el-radio',{staticStyle:{"display":"block","margin-top":"48px"},attrs:{"label":"Guest"}},[_c('div',{staticClass:"confirm-details__label"},[_vm._v("\n              I confirm that all my/our personal details are correct.\n            ")])]),_vm._v(" "),_c('el-radio',{staticStyle:{"display":"block","margin-left":"0","margin-top":"22px"},attrs:{"label":"Agent"}},[_c('div',{staticClass:"confirm-details__label"},[_vm._v("\n              I am an agent and I confirm that my guests' personal details are\n              correct.\n            ")])])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"termsChecked"}},[_c('el-checkbox',{staticClass:"confirm-details__label",attrs:{"true-label":"true","false-label":"false"},model:{value:(_vm.termsChecked),callback:function ($$v) {_vm.termsChecked=$$v},expression:"termsChecked"}},[_vm._v("\n          I have read and accept the\n          "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.checkGuestOrAgent(_vm.booking.checkedInConfirmedBy))}}),_vm._v(".\n        ")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"sticky-bottom"},[_c('el-row',{staticClass:"bottom-nav",attrs:{"justify":"space-between","type":"flex"}},[_c('el-button',{staticClass:"button--secondary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickBack()}}},[_vm._v("Back")]),_vm._v(" "),_c('autosave-indicator'),_vm._v(" "),_c('el-button',{staticClass:"button--tertiary bottom-nav__secondaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.setIsVisibleDialogSaveAndExit(true)}}},[_vm._v("Save\n      ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",attrs:{"disabled":_vm.isSaving},on:{"click":function($event){return _vm.onClickNext()}}},[_vm._v("Next\n      ")])],1)],1),_vm._v(" "),_c('el-dialog',{staticClass:"dialog--error",attrs:{"visible":this.isVisibleDialogError,"show-close":""},on:{"close":function($event){_vm.isVisibleDialogError = false}}},[_c('div',[_vm._v("\n      Please note that one or more required fields for guest(s) are missing.\n      Please select the guest’s name(s) to fill in all the required\n      information.\n    ")]),_vm._v(" "),_c('el-tree',{staticClass:"summary__missing-field-tree",attrs:{"data":_vm.contactNamesWithEmptyFields,"props":_vm.defaultTreeProps}}),_vm._v(" "),_c('el-button',{staticStyle:{"margin":"0 auto","display":"block"},attrs:{"type":"primary"},on:{"click":function($event){_vm.isVisibleDialogError = false}}},[_vm._v("Go back and edit\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 441 */
/*!*********************************************!*\
  !*** ./src/components/CruiseTicketPage.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CruiseTicketPage_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CruiseTicketPage.vue */ 193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e486803_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CruiseTicketPage_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-4e486803","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CruiseTicketPage.vue */ 444);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4e486803","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CruiseTicketPage.vue */ 442)
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-4e486803","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!./CruiseTicketPage.vue */ 443)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4e486803"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CruiseTicketPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e486803_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CruiseTicketPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 442 */
/*!*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e486803","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CruiseTicketPage.vue ***!
  \*************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4e486803","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/CruiseTicketPage.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 444 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e486803","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CruiseTicketPage.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main__cruise-ticket container"},[_c('div',{staticClass:"summary"},[_c('div',{staticClass:"summary__header"}),_vm._v(" "),_c('div',{staticClass:"summary__content"},[_c('div',{staticClass:"summary__content-title"},[_vm._v("Booking details")]),_vm._v(" "),_c('div',{staticClass:"summary__divider"}),_vm._v(" "),_c('div',{staticClass:"tickets"},_vm._l((_vm.cabinConfigurations),function(cc,index){return _c('el-row',{key:cc.cabinConfigurationID,staticClass:"cabin-configuration",attrs:{"type":"flex"}},[_c('el-col',{attrs:{"span":8}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Guest(s)")]),_vm._v(" "),_vm._l((_vm.getGuestNameList(cc)),function(guestName){return _c('div',{staticClass:"cabin-configuration__guest"},[_vm._v("\n              "+_vm._s(guestName)+"\n            ")])})],2),_vm._v(" "),_c('el-col',{attrs:{"span":12}},[_c('div',{staticClass:"cabin-configuration__label"},[_vm._v("Suite")]),_vm._v(" "),_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-design-suite"}),_vm._v(_vm._s(cc.suite)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-deck"}),_vm._v(_vm._s(cc.deck)+"\n            ")]),_vm._v(" "),(_vm.canShowBalconyType())?_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-balcony"}),_vm._v(_vm._s(cc.hasBalcony ? "Balcony" : "Non-balcony")+"\n            ")]):_vm._e(),_vm._v(" "),(cc.interconnectingCabin)?_c('div',{staticClass:"cabin-configuration__suite"},[_c('i',{staticClass:"icon icon-interconnecting"}),_vm._v("Interconnecting with\n              Suite\n              "+_vm._s(cc.interconnectingCabin)+"\n            ")]):_vm._e()])],1)}),1),_vm._v(" "),_c('div',{staticClass:"loyalty"},[_c('div',{staticClass:"loyalty__note"},[_vm._v("\n          Thank you for being a part of Circolo Aqua — you will receive\n          exclusive onboard benefits during your expedition. We look forward\n          to welcoming you on board!\n        ")]),_vm._v(" "),_c('el-button',{staticClass:"button--primary bottom-nav__primaryButton",on:{"click":_vm.onClickExploreBenefits}},[_vm._v("Explore Benefits")])],1),_vm._v(" "),_c('div',{staticClass:"emergency-contacts"},[_c('el-row',{attrs:{"gutter":40}},[_c('el-col',{attrs:{"span":24}},[_c('h1',{staticClass:"emergency-contacts__title"},[_vm._v("Pre-departure contact")]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational"},[_c('div',{staticClass:"emergency-contacts__operational__title"},[_vm._v("\n                Guest Relations Coordinator for Asia:\n              ")]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational__contact-no"},[_vm._v("\n                Shearly Loilewen (Based in Indonesia)\n                "),_c('br'),_vm._v("\n                +62 853388 19530\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational__contact-no"},[_vm._v("\n                Andy Nguyen (Based in Vietnam)\n                "),_c('br'),_vm._v("\n                +84 377 660 183\n              ")])]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational"},[_c('div',{staticClass:"emergency-contacts__operational__title"},[_vm._v("\n                Guest Relations Coordinator for South America:\n              ")]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational__contact-no"},[_vm._v("\n                Fiorella Salazar (Based in Peru)\n                "),_c('br'),_vm._v("\n                +51 959 891 991\n              ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational__contact-no"},[_vm._v("\n                Jhuliana Villa (Based in Peru)\n                "),_c('br'),_vm._v("\n                +51 961 770 280\n              ")])]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational"},[_c('div',{staticClass:"emergency-contacts__operational__title"},[_vm._v("\n                Guest Relations Coordinator for Africa:\n              ")]),_vm._v(" "),_c('div',{staticClass:"emergency-contacts__operational__contact-no"},[_vm._v("\n                Annabel Mahoune (based in Seychelles)\n                "),_c('br'),_vm._v("\n                +254 208787935\n              ")])])])],1)],1),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"note"},[_vm._v("\n        If you have any further questions, please\n        "),_c('a',{attrs:{"href":_vm.appendMarketingSiteUrl('/contact-us'),"target":"_blank"}},[_vm._v("contact us")]),_vm._v(".\n      ")])]),_vm._v(" "),_c('div',{staticClass:"bottom-nav"}),_vm._v(" "),_c('el-dialog',{staticClass:"dialog-email",attrs:{"visible":_vm.dialogEmailVisible},on:{"update:visible":function($event){_vm.dialogEmailVisible=$event}}},[_c('i',{staticClass:"icon icon-sent"}),_vm._v(" "),_c('h2',[_vm._v("Your cruise ticket will be sent to")]),_vm._v(" "),_c('div',{staticClass:"email"},[_vm._v(_vm._s(_vm.formData.email))])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/*!*********************************************!*\
  !*** ./src/components/CheckinSuspended.vue ***!
  \*********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CheckinSuspended_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./CheckinSuspended.vue */ 194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c0fdb9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckinSuspended_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-59c0fdb9","hasScoped":true,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./CheckinSuspended.vue */ 447);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-59c0fdb9","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./CheckinSuspended.vue */ 446)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-59c0fdb9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_CheckinSuspended_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59c0fdb9_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CheckinSuspended_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/*!************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-59c0fdb9","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/CheckinSuspended.vue ***!
  \************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/*!*********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-59c0fdb9","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckinSuspended.vue ***!
  \*********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-main',[_c('div',{staticClass:"main__cruise-ticket container"},[_c('div',{staticClass:"suspend__card"},[_c('img',{attrs:{"src":__webpack_require__(/*! ../assets/svg/ic-alarm.svg */ 448)}}),_vm._v(" "),_c('div',{staticClass:"suspend__card-body"},[_c('h1',[_vm._v(_vm._s(_vm.suspendedHeaderLabel))]),_vm._v(" "),_c('section',[_vm._v(_vm._s(_vm.suspendedInfoLabel))]),_vm._v(" "),_c('div',{staticClass:"suspend__card-buttons--desktop"},[_c('el-button',{staticClass:"suspend__btns suspend__btns--contact button--tertiary",attrs:{"type":"secondary"},on:{"click":_vm.onClickContact}},[_vm._v("\n            "+_vm._s(_vm.contactUsLabel)+"\n          ")]),_vm._v(" "),_c('el-button',{staticClass:"suspend__btns suspend__btns--newBooking button--primary",attrs:{"type":"primary"},on:{"click":_vm.onClickStartCheckin}},[_vm._v("\n            "+_vm._s(_vm.startCheckingInLabel)+"\n          ")])],1),_vm._v(" "),_c('div',{staticClass:"suspend__card-buttons--mobile"},[_c('el-button',{staticClass:"suspend__btns suspend__btns--newBooking button--primary",on:{"click":_vm.onClickStartCheckin}},[_vm._v("\n            "+_vm._s(_vm.startCheckingInLabel)+"\n          ")]),_vm._v(" "),_c('el-button',{staticClass:"suspend__btns suspend__btns--contact button--tertiary",on:{"click":_vm.onClickContact}},[_vm._v("\n            "+_vm._s(_vm.contactUsLabel)+"\n          ")])],1)])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */
/*!*************************************!*\
  !*** ./src/assets/svg/ic-alarm.svg ***!
  \*************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "assets/images/ic-alarm.3e2b0d4d.svg";

/***/ }),
/* 449 */
/*!*************************************!*\
  !*** ./src/components/NavSteps.vue ***!
  \*************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NavSteps_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./NavSteps.vue */ 195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a154ba4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavSteps_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-0a154ba4","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./NavSteps.vue */ 454);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-0a154ba4","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NavSteps.vue */ 450)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_NavSteps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a154ba4_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NavSteps_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 450 */
/*!*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a154ba4","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/NavSteps.vue ***!
  \*****************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 451 */
/*!****************************************!*\
  !*** ./src/components/ui/Masthead.vue ***!
  \****************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Masthead_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./Masthead.vue */ 196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e25f9f7e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Masthead_vue__ = __webpack_require__(/*! !../../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-e25f9f7e","hasScoped":true,"buble":{"transforms":{}}}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Masthead.vue */ 453);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-e25f9f7e","scoped":true,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./Masthead.vue */ 452)
}
var normalizeComponent = __webpack_require__(/*! ../../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e25f9f7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_Masthead_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e25f9f7e_hasScoped_true_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Masthead_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/*!*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e25f9f7e","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ui/Masthead.vue ***!
  \*******************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/*!****************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e25f9f7e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Masthead.vue ***!
  \****************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"masthead",class:_vm.mastHeadClassName},[_c('div',{staticClass:"masthead__image"},[(_vm.imageUrl)?_c('img',{ref:"mastheadRef",attrs:{"src":_vm.imageUrl,"alt":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"masthead__shade"},[_c('div',{staticClass:"text-container container",class:{
          'text-container--bottom-left': _vm.textAlign === 'bottomLeft',
          'text-container--variant1': _vm.variant === 'variant1',
        }},[(_vm.signature)?_c('div',{staticClass:"masthead__signature"},[_vm._v("\n          "+_vm._s(_vm.signature)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.title)?_c('h1',{staticClass:"masthead__title"},[_vm._v("\n          "+_vm._s(_vm.title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.description)?_c('h2',{staticClass:"masthead__description"},[_vm._v("\n          "+_vm._s(_vm.description)+"\n        ")]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 454 */
/*!**************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a154ba4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavSteps.vue ***!
  \**************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.currentStepIndex >= 0)?_c('div',{staticClass:"nav-steps"},[_c('masthead',{staticClass:"nav-steps__masthead",attrs:{"image-url":_vm.getMasthead(),"mast-head-type":"default"}}),_vm._v(" "),_c('div',{staticClass:"nav-steps__progress",class:{
        suspended: _vm.isSuspended(),
      }},[_c('el-steps',{attrs:{"active":_vm.currentStepIndex,"align-center":""}},[_vm._l((_vm.stepsData()),function(step,index){return [(
              step.routeName !== 'completed' &&
              step.routeName !== 'checkin-suspended'
            )?_c('el-step',{key:index,class:{
              completed: _vm.isCompleted() && index === _vm.currentStepIndex - 1,
            },attrs:{"title":_vm.getStepTitle(index)}}):_vm._e()]})],2)],1),_vm._v(" "),(!_vm.isSuspended())?_c('div',{staticClass:"nav-steps__header container"},[(_vm.currentStepIndex + 1 !== _vm.stepsData().length - 1)?_c('div',{staticClass:"nav-steps__number"},[_vm._v("\n        Step "+_vm._s(_vm.currentStepIndex + 1)+" of "+_vm._s(_vm.stepsData().length - 2)+"\n      ")]):_c('div',{staticClass:"nav-steps__number"},[_vm._v("SUCCESS")]),_vm._v(" "),_c('h1',{staticClass:"nav-steps__title"},[_vm._v("\n        "+_vm._s(_vm.stepsData()[_vm.currentStepIndex].title)+"\n      ")]),_vm._v(" "),(_vm.stepsData()[_vm.currentStepIndex].subtitle)?_c('div',{staticClass:"nav-steps__subtitle"},[_vm._v("\n        "+_vm._s(_vm.stepsData()[_vm.currentStepIndex].subtitle)+"\n      ")]):_vm._e()]):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/*!**********************************************!*\
  !*** ./src/components/DialogSaveAndExit.vue ***!
  \**********************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DialogSaveAndExit_vue__ = __webpack_require__(/*! !babel-loader?{"babelrc":false,"presets":[["/home/staging-checkin/repos/ae-online-check-in-vue/node_modules/babel-preset-poi/index.js",{"jsx":"vue"}]],"cacheDirectory":true}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./DialogSaveAndExit.vue */ 197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a2b731_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogSaveAndExit_vue__ = __webpack_require__(/*! !../../node_modules/vue-loader/lib/template-compiler/index?{"id":"data-v-74a2b731","hasScoped":false,"buble":{"transforms":{}}}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./DialogSaveAndExit.vue */ 457);
function injectStyle (ssrContext) {
  __webpack_require__(/*! !../../node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!vue-style-loader!css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!../../node_modules/vue-loader/lib/style-compiler/index?{"vue":true,"id":"data-v-74a2b731","scoped":false,"hasInlineConfig":true}!sass-loader?{"sourceMap":true}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./DialogSaveAndExit.vue */ 456)
}
var normalizeComponent = __webpack_require__(/*! ../../node_modules/vue-loader/lib/component-normalizer */ 5)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_babelrc_false_presets_home_staging_checkin_repos_ae_online_check_in_vue_node_modules_babel_preset_poi_index_js_jsx_vue_cacheDirectory_true_node_modules_vue_loader_lib_selector_type_script_index_0_DialogSaveAndExit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74a2b731_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DialogSaveAndExit_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/*!**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"autoprefixer":false,"sourceMap":true,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-74a2b731","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/DialogSaveAndExit.vue ***!
  \**************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************************/
/*! dynamic exports provided */
/*! all exports used */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/*!***********************************************************************************************************************************************************************************************************************************!*\
  !*** ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74a2b731","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/DialogSaveAndExit.vue ***!
  \***********************************************************************************************************************************************************************************************************************************/
/*! exports provided: default */
/*! exports used: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"dialog--saveAndExit",attrs:{"visible":this.isVisibleDialogSaveAndExit,"center":""},on:{"close":function($event){return _vm.setIsVisibleDialogSaveAndExit(false)}}},[_c('div',[_c('div',{staticClass:"progress-label"},[_vm._v("Your progress is saved!")]),_vm._v(" "),_c('progress-bar',{attrs:{"hideLabel":true,"percentage":_vm.getTotalProgressPercentage()}}),_vm._v(" "),_c('el-row',{staticClass:"row--actions"},[_c('el-col',{staticClass:"left",attrs:{"span":12}},[(_vm.booking && _vm.booking.isOverCheckInDeadline)?_c('div',[_c('div',{staticClass:"title"},[_vm._v("\n            Please complete your check-in as soon as you can.\n          ")]),_vm._v(" "),_c('div',[_c('p',[_vm._v("\n              We need all guests' details and requests in advance so that we\n              can deliver the greatest possible trip experience for you.\n              Please return to complete all pending information soon.\n            ")])])]):_c('div',[_c('div',{staticClass:"title"},[_vm._v("\n            Unable to complete your check-in process at this time?\n          ")]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v("No problem!")]),_vm._v(" "),_c('p',[_vm._v("You can return to complete your online check-in by")]),_vm._v(" "),(_vm.booking)?_c('p',{staticClass:"date"},[_vm._v("\n              "+_vm._s(_vm.booking.checkInDeadline + ".")+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.onClickLogout}},[_vm._v("Log out")]),_vm._v(" "),_c('a',{staticClass:"link-contact-us",attrs:{"href":_vm.appendMarketingSiteUrl('/contact-us'),"target":"_blank"}},[_vm._v("Contact us")])],1)]),_vm._v(" "),_c('el-col',{staticClass:"right",attrs:{"span":12}},[_c('div',{staticClass:"title"},[_vm._v("I would like to continue to check in.")]),_vm._v(" "),_c('div',{staticClass:"button-container"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.setIsVisibleDialogSaveAndExit(false)}}},[_vm._v("Continue to check in\n          ")])],1)])],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */
/*!*****************************!*\
  !*** ./src/scss/index.scss ***!
  \*****************************/
/*! dynamic exports provided */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[220]);


// WEBPACK FOOTER //
// client.17a1e516.js